export default {
  "termsOfUse": "Podmínky užití",
  "goToHome": "Zpět na hlavní stránku",
  "choose": "Vybrat",
  "close": "Zavřít",
  "yes": "Ano",
  "no": "Ne",
  "moreInfo": "Více informací",
  "send": "Odeslat",
  "sendProcess": "Odesílání",
  "sendSuccess": "Odesláno",
  "actual": "Aktuálně",
  "question": "Poradit se s lékařem",
  "appointment": "Objednat k lékaři",
  "freeDownload": "Stáhněte si zdarma naši aplikaci",
  "downloadAppStore": "Download on the App Store",
  "downloadGooglePlay": "Get it on Google Play",
  "month": "Měsíc",
  "year": "Rok",
  "other": "Jiné",
  "backToStart": "Zpět na úvod",
  "backToOverview": "zpět na přehled služeb",
  "or": "nebo",
  "czechLanguage": "Česky",
  "slovakLanguage": "Slovensky",
  "englishLanguage": "Anglicky",
  "goNext": "Pokračovat",
  "goPrev": "zpět",
  "save": "Uložit",
  "show": "Zobrazit",
  "showMore": "Zobrazit více",
  "showAll": "Ukázat všechny",
  "open": "Rozbalit",
  "saveChanges": "Uložit změny",
  "saveChangesProcess": "Ukládání",
  "saveChangesSuccess": "Uloženo",
  "loginText": "Přihlásit se",
  "contact": "Kontakt",
  "done": "Hotovo",
  "finish": "Dokončit",
  "skip": "Přeskočit",
  "legalDocuments": "Právní dokumenty",
  "new": "Novinka",
  "free": "Zdarma",
  "tryAgain": "Zkusit znovu",
  "until": "do",
  "pilot": "Videohovor",
  "here": "zde",
  "currency": "Kč",
  "subscribe": "Odebírat",
  "agree": "Souhlasím",
  "disagree": "Nesouhlasím",
  "alertInfo": {
    "title": "Služba uLékaře.cz nenahrazuje záchrannou službu.",
    "text": "Při akutních potížích volejte linku 155.",
    "iAgree": "Rozumím",
    "errorText": "Toto pole je povinné."
  },
  "uLekare": {
    "title": "uLékaře.cz"
  },
  "partners": {
    "specialSupport": "Speciální podpora",
    "generalPartners": "Generální partneři",
    "otherPartners": "Partneři",
    "thankYouPartners": "Děkujeme za podporu našim partnerům",
    "info": "Služby Virtuální čekárny \n<strong class='primary--text text-bold'>jsou v období pandemie zdarma</strong> \ndíky partnerům."
  },
  "questionForm": {
    "title": "Váš dotaz lékaři",
    "subtitle": "Co vás trápí, jak dlouho problém trvá, berete nějaké léky, proběhlo již nějaké vyšetření, ...",
    "modalTitle": "Přiložte foto nebo lékařské zprávy",
    "send": "Odeslat lékaři",
    "back": "Zpět k dotazu",
    "sendTitle": "Děkujeme za zaslání dotazu",
    "next": "Pokračovat",
    "sendPerex": "Děkujeme za vaši návštěvu ve Virtuální čekárně.",
    "question": {
      "placeholder": "Sem napište, co vás trápí",
      "errorText": "Prosím vyplňte dotaz pro lékaře, aby vám mohl poradit."
    },
    "firstName": {
      "title": "Jméno",
      "placeholder": "Napište křestní jméno",
      "helpText": "Křestní jméno zobrazíme u dotazu na stránkách.",
      "helpTextNotShowing": "Zdravotní tým s vámi bude komunikovat, proto potřebuje vaše jméno.",
      "errorText": "Jméno je povinný údaj, prosíme o vyplnění.",
      "helpTextRealData": "Zadejte své skutečné jméno pro komunikaci se zdravotnickým zařízením."
    },
    "lastName": {
      "title": "Příjmení",
      "placeholder": "Napište příjmení",
      "helpText": "Zdravotní tým s vámi bude komunikovat, proto potřebuje vaše příjmení.",
      "errorText": "Příjmení je povinný údaj, prosíme o vyplnění.",
      "helpTextRealData": "Zadejte své skutečné příjmení pro komunikaci se zdravotnickým zařízením."
    },
    "email": {
      "title": "E-mail",
      "placeholder": "jmeno@priklad.cz",
      "helpText": "Na tento e-mail vám pošleme informace od zdravotního týmu.",
      "hrbHelpText": "Doporučujeme uvést soukromý e-mail.",
      "errorText": "E-mailová adresa je povinný údaj, prosíme o vyplnění.",
      "errorEmailText": "E-mail nemá správný formát, prosíme o kontrolu.",
      "errorEmailNotExisting": "Tato adresa neexistuje. Prosím vyplňte existující e-mail.",
      "invalidBenefitEmail": "Neplatný e-mail"
    },
    "phone": {
      "title": "Telefon",
      "placeholder": "123 456 789",
      "helpText": "Sestřička vám může nabídnout objednání k lékaři.",
      "errorText": "Telefonní číslo je povinný údaj, prosíme o vyplnění.",
      "errorPhoneText": "Zadejte telefonní číslo ({exampleNumber})."
    },
    "emailphone": {
      "errorEmailText": "E-mailová adresa je povinný údaj, prosíme o vyplnění.",
      "errorPhoneText": "Telefonní číslo je povinný údaj, prosíme o vyplnění."
    },
    "birthYear": {
      "title": "Rok narození",
      "titleRegistered": "Rok narození",
      "helpText": "Vyplňte rok narození osoby, které se problém týká.",
      "errorText": "Rok narození je povinný údaj, prosíme o vyplnění.",
      "errorLengthText": "Rok narození napište ve formátu xxxx (např. 1989).",
      "errorBetweenText": "Napište skutečný rok narození. :)"
    },
    "pastYear": {
      "errorLengthText": "Rok narození napište ve formátu xxxx (např. 1989)",
      "errorBetweenText": "Napište skutečný rok. :)",
      "errorText": "Rok narození je povinný údaj, prosíme o vyplnění."
    },
    "zipCode": {
      "title": "PSČ",
      "helpText": "Podle PSČ vám doporučíme, kam se objednat.",
      "errorText": "PSČ je povinné, prosíme o vyplnění.",
      "errorZipCodeText": "PSČ nemá správný formát."
    },
    "insuranceCompany": {
      "title": "Pojišťovna",
      "errorText": "Pojišťovna je povinný údaj, prosíme o vyplnění.",
      "selectInsuranceCompany": "Vyberte svoji pojišťovnu"
    },
    "timeAvailability": {
      "title": "Vaše časová dostupnost",
      "errorText": "Prosím vyplňte, které dny a časy vám vyhovují.",
      "placeholder": "Prosíme o vaše časové možnosti v dalších dnech, ať se ozveme ve vhodný čas."
    },
    "selectedBranchValue": {
      "title": "Ordinace",
      "selectInsuranceCompany": "Vyberte ordinaci"
    },
    "personalId": {
      "title": "Číslo pojištěnce",
      "helpText": "Slouží k ověření, že patříte k tomuto praktickému lékaři.",
      "errorText": "Číslo pojištěnce je povinný údaj, prosíme o vyplnění."
    },
    "checkedMyDoctor": "Potvrzuji, že jde o mého praktického lékaře",
    "thankYou": {
      "title": "Dotaz byl odeslán.",
      "perex": "Děkujeme za položení dotazu, jakmile bude zodpovězen, dostanete upozornění."
    }
  },
  "fileUpload": {
    "initial": "Kliknutím vyberte soubory nebo je přetáhněte myší.",
    "send": "Odeslat",
    "uploadAgain": "Zkuste to znovu.",
    "addFiles": "Přiložte foto nebo lékařské zprávy.",
    "acceptedTypes": "Povolené typy jsou obrázky (.jpg, .png). Maximální povolená velikost souboru je 20 MB, maximální povolená velikost všech souborů dohromady je 100 MB.",
    "typeError": "Tento typ souboru není podporován. Soubory nahrajte v uvedených formátech .jpg, .png.",
    "sizeError": "Překročena maximální povolená velikost. Maximální povolená velikost souboru je 20 MB, maximální povolená velikost všech souborů dohromady je 100 MB.",
    "totalSizeError": "Maximální velikost všech souborů je 100Mb"
  },
  "results": {
    "title": "Spojte se se svým praktickým lékařem",
    "resultInfoStart": "Na hledaný výraz",
    "resultInfoEnd": "bylo nalezeno {count} výsledků",
    "noResultInfoEnd": "nebyl nalezen žádný lékař",
    "noResultInfoPerex": "Zkontrolujte, že jste jméno lékaře zadali správně, případně můžete zkusit hledat méně konkrétně (např. dle křestního jména) a výsledky můžete v dalším kroku filtrovat podle lokality.",
    "startSearch": "Zadejte hledaný výraz",
    "moreResults": "Zobrazit další lékaře",
    "doctorNotInResults": "Můj praktický lékař není v seznamu",
    "filterInfo": "Výsledky vyhledávání můžete upřesnit zadáním <strong>lokality ordinace svého praktického lékaře</strong>",
    "filterDefaultText": "Celá Česká republika",
    "loadingInfo": "Vyhledávám...",
    "showAll": "Zobrazit všechny výsledky ({totalCount})"
  },
  "iDontHaveDoctor": {
    "title": "Nemáte praktického lékaře? Nevadí!",
    "perex": "Díky našim sponzorům můžete zdarma využít možnost vzdáleně řešit jakýkoli zdravotní problém s jedním z 350 lékařů týmu uLékaře.cz, kteří jsou připraveni vám pomoci.",
    "sendQuestion": "Položit dotaz našim lékařům"
  },
  "doctorIsNotInList": {
    "title": "Nenašli jste svého praktického lékaře v naší čekárně? Nevadí!",
    "sendQuestion": "Položit dotaz našim lékařům"
  },
  "virtualOffice": {
    "info": "Od 1.6. se budete moci podívat do své virtuální ordinace"
  },
  "footer": {
    "copyright": "&copy; 2007-{thisYear} uLékaře.cz, s.r.o.",
    "issn": "ISSN 1802-5544",
    "companyTitle": "Společnost uLékaře.cz",
    "companyList": [
      {
        "title": "Kontakt",
        "link": "contactPage"
      },
      {
        "title": "Kariéra",
        "link": "https://app.ulekare.cz/career",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Inzerce",
        "link": "https://www.ulekare.cz/inzerce",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Zdraví a prevence ve firmě",
        "link": "index",
        "partnerLink": "forCompanies",
        "thematicCounsellingLink": "forCompanies",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Zásady zpracování osobních údajů",
        "link": "personalDataProcessing",
        "partnerLink": "hrbPersonalDataProcessing",
        "thematicCounsellingLink": "thematicCounsellingPersonalDataProcessing",
        "forCompaniesLink": "forCompaniesPersonalDataProcessing",
        "aeskulabLink": "aeskuLabPersonalDataProcessing"
      },
      {
        "title": "Podmínky užití",
        "link": "termsAndConditions",
        "partnerLink": "hrbTermsAndConditions",
        "thematicCounsellingLink": "thematicCounsellingTermsAndConditions",
        "forCompaniesLink": "forCompaniesTermsAndConditions",
        "aeskulabLink": "aeskuLabTermsAndConditions"
      },
      {
        "title": "Prohlášení o cookies",
        "link": "cookies",
        "partnerLink": "hrbCookies",
        "thematicCounsellingLink": "thematicCounsellingCookies",
        "forCompaniesLink": "forCompaniesCookies",
        "aeskulabLink": "aeskuLabCookies"
      },
      {
        "title": "Bezpečnost",
        "link": "security"
      }
    ],
    "perex": {
      "rsAssistant": "Největší česká medicínská online poradna a průkopník v oblasti telemedicíny si klade za cíl zefektivnit a zkvalitnit české zdravotnictví.<br/><br/>CZ2212160829/12/2022",
      "astmaHelp": "Největší česká medicínská online poradna a průkopník v oblasti telemedicíny si klade za cíl zefektivnit a zkvalitnit české zdravotnictví.",
      "default": "V uLékaře.cz věříme, že zdraví je vaše. Prostřednictvím technologie, lidského přístupu a lékařské expertízy pomáháme lidem řídit si své zdraví. Tým více než 350 lékařů všech specializací každý měsíc vyřeší v průměru 15 000 požadavků. Klientská zóna je uživatelům k dispozici 24 hodin, 7 dní v týdnu nejen na webu, ale i přes mobilní aplikaci a nabízí online lékařskou poradnu, odborné články a tipy ke zdraví, pro vybrané uživatele také objednání k lékaři a kalendář preventivních prohlídek a očkování.",
      "forCompanies": "uLékaře.cz věříme, že zdraví je vaše. Prostřednictvím technologie, lidského přístupu a lékařské expertízy pomáháme lidem řídit si své zdraví. Tým 350+ lékařů všech specializací je každý den k dispozici více než  100 tis. zaměstnanců."
    },
    "mottos": [
      "Lidskost",
      "Nadšení",
      "Odbornost",
      "Inovace"
    ]
  },
  "dataProcessing": {
    "iAgree": "Souhlasím se",
    "iAgreeWith": "Souhlasím s",
    "privacyPolicy": "zpracováním osobních údajů",
    "privacyPolicyTitle": "Souhlas se zpracováním osobních údajů včetně zvláštní kategorie osobních údajů",
    "newsletterProcessing": "zasíláním novinek a slev uLékaře.cz.",
    "newsletterText": "Souhlasím se zasíláním marketingových sdělení uLékaře.cz (se zprávami o společnosti a projektu uLékaře.cz, s.r.o., nebo o produktech a službách spolupracujících třetích osob). Souhlas se zasíláním odvoláte volbou ve Zpravodaji nebo na adrese <a href=\"mailto:osobniudaje@ulekare.cz\">osobniudaje@ulekare.cz</a>.",
    "conferenceNewsletterAgreement": "zasíláním sdělení týkajících se předmětu konference",
    "conferenceNewsletterTitle": "Souhlas se zasíláním informačních emailů(newsletterů)",
    "conferenceDataTitle": "Souhlasím se zpracováním osobních údajů",
    "termsConditions": "podmínkami užití",
    "privacyPolicyInAccordance": "Vaše osobní údaje zpracováváme v souladu se"
  },
  "termsAndConditions": {
    "title": "Podmínky užití"
  },
  "personalDataProcessing": {
    "title": "Souhlas se zpracováním osobních údajů"
  },
  "newsletter": {
    "title": "Souhlas se zasíláním marketingových sdělení"
  },
  "days": {
    "monday": "Po",
    "tuesday": "Út",
    "wednesday": "St",
    "thursday": "Čt",
    "friday": "Pá",
    "saturday": "So",
    "sunday": "Ne"
  },
  "error": {
    "400": "Chyba 400",
    "404": "Stránka nenalezena",
    "500": "Chyba 500",
    "universal": "Vyskytla se chyba",
    "sms": "Aktuální prodleva doručení sms je maximálně 5&nbsp;minut. Děkujeme za strpení."
  },
  "errorLayout": {
    "title": "Oops, tato stránka je nemocná!",
    "text": "Omlouváme se, tato stránka už leží na sále. Za chvíli ji opravíme, prosím zkuste to později.",
    "button": "Zpět na hlavní stránku"
  },
  "meta": {
    "partnerNavigation": {
      "title": "Partnerská navigace"
    },
    "cookies": {
      "title": "Prohlášení o cookies"
    },
    "termsAndConditions": {
      "title": "Podmínky užití"
    },
    "personalDataProcessing": {
      "title": "Zásady zpracování osobních údajů"
    },
    "rsasistant": {
      "title": "RS asistent",
      "description": "Program nabízí praktickou podporu v léčbě a doplňkovou péči, různorodé informace k celkové podpoře zdraví a života se závažným autoimunitním onemocněním.",
      "ogTitle": "RS ASISTENT pomáhá pacientům s roztroušenou sklerózou"
    },
    "conference": {
      "title": "Zdravé firmy, zdravé Česko",
      "description": "Zveme vás na konferenci o firemním zdraví a prosperitě, zaměřenou na důležitost pohybu a jeho provázanost s psychickou i fyzickou pohodou. Doplňte své HR vitamíny a rozpohybujte firemní zdraví podporou každodenní prevence."
    },
    "emergency": {
      "title": "Kdy vyhledat pohotovost",
      "description": "Stručný soupis akutních nebo život ohrožujících stavů, na které chceme upozornit pacienty s cílem nasměrovat to nejurgentnější na pohotovost.",
      "ogTitle": "Kdy vyhledat pohotovost – volejte 155"
    },
    "evaluation": {
      "order": {
        "title": "Hodnocení návštěvy lékaře",
        "description": "Hodnocení návštěvy lékaře"
      }
    },
    "companies": {
      "title": "Zdraví a prevence ve firmě",
      "description": "Pomáháme s péčí o zdraví zaměstnanců. V naší online lékařské poradně mohou řešit své zdravotní potíže bezodkladně a odkudkoliv. V případě potřeby fyzické návštěvy lékaře každého objednáme na přesné místo i čas dle požadavků."
    },
    "mastercard": {
      "title": "Mastercard"
    },
    "eon": {
      "title": "E.ON"
    },
    "sporthelp": {
      "title": "SportHelp"
    },
    "overview": {
      "title": "Radíme, objednáváme, pomáháme s prevencí",
      "description": "Zeptejte se našich lékařů na své zdravotní potíže nebo se nechte objednat k lékaři. Pomůžeme vám s péčí o vaše zdraví. Online, zdarma a kdykoliv potřebujete."
    },
    "philips-sonicare": {
      "title": "Philips",
      "description": "Službu můžete mít zdarma jako benefit od svého zaměstnavatele, města, karetní společnosti, neziskové organizace a dalších firem. Pokud si nejste jistí, zkuste vyhledávač v záložce \"Jiný benefit\"."
    },
    "hrbOrderPage": {
      "title": "Objednáme vás k lékaři",
      "description": "Hledáte lékaře, který vás vyšetří? Nevíte, ke kterému specialistovi se objednat? Nechte to na nás. Objednáváme k lékařům po celé ČR. Zdarma a kdykoliv potřebujete."
    },
    "hrbQuestionPage": {
      "title": "Zeptejte se v naší online poradně",
      "description": "Svěřte se našim lékařům, do 6 hodin dostanete odpověď na jakýkoliv váš dotaz týkající se fyzického i duševního zdraví. Online, zdarma a kdykoliv potřebujete."
    },
    "hrbPreventionPage": {
      "title": "Prevence",
      "description": "Pomáháme s prevencí. Poraďte se s našimi lékaři v otázkách péče o zdraví, získejte doporučení týkající se prevence a objednejte se na potřebné preventivní prohlídky."
    },
    "hrbArticlePagePrevention": {
      "title": "Prevence nebolí, prevence pomáhá",
      "description": "Preventivní prohlídky jsou velmi důležité, mohou dokonce zachránit život. Zaregistrujete se do našeho preventivního programu a pečujte tak lépe o své zdraví."
    },
    "hrbArticlePageInsuranceCompanies": {
      "title": "Zdravotní pojišťovny a prevence",
      "description": "Co vám v rámci prevence v letošním roce hradí vaše zdravotní pojišťovna? Máme pro vás přehlednou nabídku všech pojišťoven včetně výše příspěvků."
    },
    "hrbArticlePageVyzkousejteSiNas": {
      "title": "Vyzkoušejte si nás"
    },
    "vozpRegistration": {
      "title": "VoZP",
      "description": "Zaregistrujte se prostřednictvím online formuláře a neomezeně využívejte služby uLékaře.cz: poradnu, objednání k lékaři a pomoc s prevencí. Pro klienty VoZP je služba na 3 měsíce zdarma."
    },
    "migraine": {
      "title": "Linka o migréně"
    },
    "psoriasis": {
      "title": "Jak vyzrát na lupénku"
    },
    "putinSucks": {
      "title": "Bezplatná lékařská poradna pro Ukrajince",
      "description": "Pomáháme Ukrajině. Poradíme a objednáme po celé České republice. Lékaři a sestry hovoří ukrajinsky a rusky."
    },
    "astmaHelp": {
      "title": "Pacientský program AstmaHelp",
      "description": "Registrovaným pacientům AstmaHelp nabízí podporu v léčbě a neomezený přístup do specializované online poradny."
    },
    "login": {
      "title": "Přihlášení",
      "description": "Registrujte se, ať máte lékařskou péči vždycky po ruce. Rádi vám pomůžeme i s objednáním k lékaři po ČR a SR. Zdraví je vaše."
    },
    "aeskulab": {
      "title": "Moje laboratorní výsledky",
      "description": "Získáte interpretaci vyšetření absolvovaného v laboratoři Unilabs"
    },
    "dashboard": {
      "title": "Zdraví online"
    },
    "dashboardQuestions": {
      "title": "Poradna"
    },
    "dashboardAppointments": {
      "title": "Objednání k lékaři"
    },
    "dashboardArticles": {
      "title": "Magazín Objevujte"
    },
    "dashboardConsultations": {
      "title": "Zodpovězeno lékaři"
    },
    "dashboardPrevention": {
      "title": "Moje prevence"
    },
    "dashboardProfile": {
      "title": "Můj profil zdraví"
    },
    "lostPassword": {
      "title": "Zapomenuté heslo"
    },
    "passwordReset": {
      "title": "Obnovení hesla"
    },
    "emailVerification": {
      "title": "Ověření e-mailu"
    },
    "registration": {
      "title": "Registrace"
    },
    "homepage": {
      "title": "uLékaře.cz - Zdraví zaměstnanci. Od hlavy až k patě.",
      "description": "Vytváříme ta nejzdravější pracovní prostředí. Firmám poskytujeme špičkovou péči o zdraví řízenou daty. Dlouhodobě a systematicky pomáháme firmám udržovat zdraví jejich zaměstnanců."
    },
    "servicePage": {
      "title": "Služba uLékaře.cz"
    },
    "healthboxLanding": {
      "title": "Děkujeme za využití healthboxu."
    },
    "contactPage": {
      "title": "Kontakt"
    },
    "careerPage": {
      "title": "Kariéra"
    },
    "ePrescription": {
      "title": "Jak funguje vystavení eReceptu v uLékaře.cz",
      "description": "Pravidla pro e-recept..."
    }
  },
  "rsAssistant": {
    "projectPartner": "Partner projektu",
    "hello": {
      "title": "Váš <strong>RS ASISTENT</strong>",
      "perex": "Vítejte na stránce programu <strong>RS ASISTENT</strong>, který vám nabízí doplňkovou péči a praktickou podporu v nové léčbě Vašeho onemocnění. Program zahrnuje pravidelná SMS a telefonická připomenutí užití léku a možnost objednání u fyzioterapeuta a psychologa. Dále nabízí různorodé informace k celkové podpoře Vašeho zdraví a života s onemocněním na <a href='https://www.zivotvhlavniroli.cz' target='_blank'>pacientském webu</a>.<br/><br/>Registrovat se do programu můžete prostřednictvím online formuláře na této stránce. Pokud s jeho vyplněním potřebujete pomoci nebo máte jakékoliv dotazy související s registrací, pomůžeme vám na tel. <a href='tel:00420227072722'>227 072 722</a> či na e-mailu <a href='mailto:rs-asistent@ulekare.cz'>rs-asistent@ulekare.cz</a>.",
      "imgTitle": "Sestra Novartis"
    },
    "scrollToRegistration": "Přejít na registraci do programu",
    "registerForm": {
      "title": "Registrace do programu",
      "checkTitle": "Jakou léčbou vás budeme provázet? (Výběr léku)",
      "formTitle": "Vyplňte své kontaktní údaje",
      "send": "Odeslat",
      "sendTitle": "Registrace do programu RS ASISTENT proběhla úspěšně",
      "sendPerex": "Těší nás Vaše registrace do podpůrného programu RS ASISTENT.<br/>Vyčkejte na telefonát zdravotní sestřičky, která s vámi domluví podrobnosti související s nastavením programu na míru Vašim potřebám.",
      "sendNextmessage": "Poslat novou zprávu",
      "firstName": {
        "title": "Jméno",
        "errorText": "Jméno je povinné, prosím, vyplňte ho."
      },
      "lastName": {
        "title": "Příjmení",
        "errorText": "Příjmení je povinné, prosím, vyplňte ho."
      },
      "email": {
        "title": "E-mail",
        "errorText": "E-mail je povinný, prosím, vyplňte ho.",
        "errorEmailText": "E-mail nemá správný formát.",
        "errorEmailNotExisting": "Prosím vyplňte existující e-mail."
      },
      "phone": {
        "title": "Telefon",
        "errorText": "Telefonní číslo je povinné, prosím, vyplňte ho.",
        "errorPhoneText": "Zadejte telefonní číslo (+420 123456789)."
      },
      "birthYear": {
        "title": "Rok narození",
        "titleRegistered": "Rok narození pacienta",
        "errorText": "Rok narození je povinný, prosím, vyplňte ho.",
        "errorLengthText": "Rok narození napište v čtyřčíselném formátu.",
        "errorBetweenText": "Napište skutečný rok narození."
      },
      "zipCode": {
        "title": "PSČ",
        "errorText": "PSČ je povinné, prosím, vyplňte ho.",
        "errorZipCodeText": "PSČ nemá správný formát."
      },
      "treatmentCenter": {
        "title": "Ve kterém MS centru pro diagnostiku a léčbu roztroušené sklerózy se aktuálně léčíte?",
        "selectMsCentrum": "Vyberte centrum",
        "errorText": "Tato položka je vyžadována"
      },
      "medication": {
        "mayzent": "Mayzent",
        "gilenya": "Gilenya",
        "kesimpta": "Kesimpta",
        "errorText": "Tato položka je vyžadována"
      },
      "medicationCheckBox": "Potvrzuji, že mě budete provázet léčbou přípravkem Kesimpta"
    },
    "dataProcessing": {
      "iAgree": "Zaškrtnutím tohoto políčka souhlasíte",
      "iAgreePersonal": "Souhlasím se zpracováním mých osobních údajů, a to včetně zvláštní kategorie údajů o zdravotním stavu tak, jak je uvedeno v ",
      "personalDataProcessing": "Zásadách zpracování osobních údajů",
      "personalDataTitle": "Zaškrtnutím tohoto políčka souhlasíte s podmínkami užití služby RS Asistent.",
      "personalDataText": "Správce zpracovává osobní údaje uživatelů, a to včetně údajů zvláštní kategorie, které mu uživatelé sdělí, pro účely využití služby uLékaře.cz (jak je popsána na webu ulekare.cz či v mobilní aplikaci a v souladu s Podmínkami užití, které naleznete zde. \nZpracování osobních údajů uživatelů probíhá vždy a pouze na základě uděleného souhlasu se zpracováním osobních údajů (včetně zpracování údajů zvláštní kategorie), jehož text naleznete zde a který je udělován uživatelem (subjektem údajů) při registraci do služby uLékaře.cz.",
      "conditionsAgreement": "s podmínkami užití služby RS Asistent",
      "modalTitle": "Souhlasím s podmínkami užití služby RS Asistent"
    },
    "personalModal": {
      "modalTitle": "Souhlasím se zpracováním osobních údajů služby RS Asistent"
    },
    "alertInfo": "Vše, co potřebujete vědět o programu RS ASISTENT, se <a href='https://www.ulekare.cz/media/rs_asistent_letak_new_2023.pdf' target='_blank'>dočtete zde</a>.",
    "formInfo": "\"SMS připomínka\" užití léků je služba pouze informačního charakteru. Prosím, berte na vědomí, že pro užívání léků jsou zásadní a rozhodující informace, které jste obdržel od svého lékaře nebo lékárníka. Poskytovatel služby \"SMS připomínka\" nenese odpovědnost za stav vašeho telefonu nebo signálu pro příjem sms zpráv.",
    "willCloseRegistration": "Program “RS Asistent” bude ukončen 31. 12. 2023, od 1.10. se již nebude možné do programu registrovat.",
    "willClose": "Program “RS Asistent” bude ukončen 31. 12. 2023, od 1.10. se již není možné do programu registrovat."
  },
  "astmaHelp": {
    "closed": {
      "title": "Registrace do programu AstmaHelp byla ukončena",
      "text": "Registrace do pacientského programu AstmaHelp byla ukončena k 31.&nbsp;5.&nbsp;2022. Pokud se chcete poradit o svém zdravotním stavu s lékařem, můžete navštívit"
    },
    "projectPartner": "Partner projektu:",
    "hello": {
      "title": "AstmaHelp",
      "subTitle": "Vítejte na stránce programu",
      "perex": "Rádi bychom vám usnadnili léčbu a přispěli k vašemu plnohodnotnému životu s astmatem. Prostřednictvím pravidelných SMS a telefonických připomenutí vám pomůžeme v nastavení léčby. V naší specializované lékařské poradně se můžete zkušených odborníků neomezeně ptát na své zdraví.\nZaregistrovat se do programu můžete prostřednictvím online formuláře na této stránce. Potřebujete-li s registrací pomoci, volejte na tel.&nbsp;<a href='tel:00420800800281'>+420&nbsp;800&nbsp;800&nbsp;281</a> nebo nám napište na <a href='mailto:astmahelp@ulekare.cz'>astmahelp@ulekare.cz</a>.",
      "imgTitle": "Sestra Novartis",
      "bottomText": "Chcete o programu AstmaHelp vědět víc? <a href='https://www.ulekare.cz/media/astmahelp_letak_1.pdf' target='_blank'>Přečtěte si podrobnosti</a>"
    },
    "scrollToRegistration": "Přejít na registraci do programu",
    "registerForm": {
      "title": "Registrace do programu",
      "checkTitle": "Jakou léčbou vás budeme provázet? (Výběr léku)",
      "formTitle": "Vyplňte své kontaktní údaje",
      "send": "Odeslat",
      "sendTitle": "Registrace do programu RS ASISTENT proběhla úspěšně",
      "sendPerex": "Těší nás Vaše registrace do podpůrného programu RS ASISTENT.<br/>Vyčkejte na telefonát zdravotní sestřičky, která s vámi domluví podrobnosti související s nastavením programu na míru Vašim potřebám.",
      "sendNextmessage": "Poslat novou zprávu",
      "firstName": {
        "title": "Jméno",
        "errorText": "Jméno je povinné, prosím, vyplňte ho."
      },
      "lastName": {
        "title": "Příjmení",
        "errorText": "Příjmení je povinné, prosím, vyplňte ho."
      },
      "email": {
        "title": "E-mail",
        "errorText": "E-mail je povinný, prosím, vyplňte ho.",
        "errorEmailText": "E-mail nemá správný formát.",
        "errorEmailNotExisting": "Prosím vyplňte existující e-mail."
      },
      "phone": {
        "title": "Telefon",
        "errorText": "Telefonní číslo je povinné, prosím, vyplňte ho.",
        "errorPhoneText": "Zadejte telefonní číslo (+420 123456789)."
      }
    },
    "dataProcessing": {
      "iAgree": "Zaškrtnutím tohoto políčka souhlasíte",
      "iAgreePersonalPrefix": "Souhlasím se zpracováním mých osobních údajů správcem AstraZeneca Czech Republic s.r.o. za účelem zajištění SMS připomínky a vybraných elektronických informací o ASTMAHELP, a to včetně zvláštní kategorie údajů o zdravotním stavu tak, jak je uvedeno v",
      "personalDataProcessing": "Oznámení o ochraně osobních údajů",
      "iAgreePersonalSuffix": "Souhlasím s předáním osobních údajů společnosti MeDitorial, s.r.o. za účelem zajištění bezplatných konzultací a podpory „uLékaře.cz“. <strong class='text-underline'>Mám právo kdykoliv odvolat souhlas či podat námitky proti provádění přímého marketingu</strong>.",
      "personalDataTitle": "Zaškrtnutím tohoto políčka souhlasíte s podmínkami užití služby RS Asistent.",
      "personalDataText": "Správce zpracovává osobní údaje uživatelů, a to včetně údajů zvláštní kategorie, které mu uživatelé sdělí, pro účely využití služby uLékaře.cz (jak je popsána na webu ulekare.cz či v mobilní aplikaci a v souladu s Podmínkami užití, které naleznete zde. \nZpracování osobních údajů uživatelů probíhá vždy a pouze na základě uděleného souhlasu se zpracováním osobních údajů (včetně zpracování údajů zvláštní kategorie), jehož text naleznete zde a který je udělován uživatelem (subjektem údajů) při registraci do služby uLékaře.cz.",
      "iAgreeConditionsPrefix": "Prohlašuji, že jsem se seznámil(a) se všemi dokumenty a souhlasím s",
      "conditionsAgreement": "Podmínkami",
      "iAgreeConditionsSuffix": "služby „uLékaře.cz“.",
      "modalTitle": "Souhlasím s podmínkami užití služby AstmaHelp"
    },
    "personalModal": {
      "modalTitle": "Oznámení o ochraně osobních údajů AstmaHelp"
    },
    "alertInfo": "Chcete o programu AstmaHelp vědět víc? <a class='text-underline' href='#'>Přečtěte si podrobnosti</a>",
    "formInfo": "\"SMS připomínka\" užití léků je služba pouze informačního charakteru. Prosím, berte na vědomí, že pro užívání léků jsou zásadní a rozhodující informace, které jste obdržel od svého lékaře nebo lékárníka. Poskytovatel služby \"SMS připomínka\" nenese odpovědnost za stav vašeho telefonu nebo signálu pro příjem sms zpráv."
  },
  "companies": {
    "menu": {
      "ourService": "Naše služba",
      "stories": "Říkají o nás",
      "pricing": "Ceník",
      "faq": "FAQ",
      "iWant": "Chci zdraví do firmy"
    },
    "hero": {
      "title": "Zdraví je business každé firmy",
      "subtitle": "Originální služba pro zaměstnance, která vašim kolegům výrazně zjednoduší péči o zdraví, a ušetří tak čas jim i vaší firmě.",
      "buttons": {
        "iWant": "Chci zdraví do firmy",
        "ourService": "Naše služba"
      },
      "items": [
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "Poradíme vašim zaměstnancům v otázkách zdraví."
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "Zařídíme objednání k lékaři, kamkoliv."
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "Pečujeme o váš život ve zdraví - prevencí."
        }
      ]
    },
    "partnersCarousel": {
      "title": "Důvěřují nám malí i velcí",
      "subtitle": "+ více než 150 dalších"
    },
    "companyPresentation": {
      "title": "Naše služba ",
      "benefitList": [
        {
          "icon": "doctor",
          "title": "350+ lékařů všech specializací"
        },
        {
          "icon": "rodina",
          "title": "Péče pro celou rodinu"
        },
        {
          "icon": "clock",
          "title": "Máme více než 14&nbsp;let zkušeností"
        },
        {
          "icon": "phone",
          "title": "Pohodlně i&nbsp;v&nbsp;mobilní aplikaci"
        },
        {
          "icon": "globus",
          "title": "Vše je dostupné i&nbsp;v&nbsp;angličtině"
        }
      ],
      "boxContent": [
        {
          "image": "company_box_2.jpg",
          "text": "Na dotaz zaměstnance odpoví praktický lékař pro dospělé, nebo pediatr."
        },
        {
          "image": "company_box_1.jpg",
          "text": "Zaměstnanci zajistíme také vyjádření specialisty kteréhokoliv oboru, například dermatologie, ortopedie, gynekologie, či psychologie."
        },
        {
          "image": "company_box_3.jpg",
          "text": "Doporučí-li lékař zaměstnanci osobní návštěvu, náš zdravotní tým se o vše potřebné postará. Místo a čas objednání se odvíjí od preference zaměstnance."
        },
        {
          "image": "company_box_4.jpg",
          "text": "V rámci naší služby zajistíme preventivní prohlídky a přednášky ve vaší firmě. Připravíme materiály pro vaši interní komunikaci na téma zdraví."
        }
      ],
      "infoBox": {
        "title": "Věděli jste, že...",
        "text": "Zaměstnanec se s naší službou v téměř 40% případů vyhne cestě k lékaři? Většinu zdravotních otázek vyřeší ve své klientské zóně a o vše ostatní se postaráme."
      }
    },
    "billing": {
      "title": "Přehled balíčků a cena",
      "companySize": "Velikost firmy",
      "employees": "zaměstnanců",
      "star": "*Pro firmy o velikosti 40 - 50 zaměstnanců. Účtováno měsíčně.",
      "content": "Obsah balíčků",
      "tariffsMatrix": {
        "title": "Obsah",
        "pricing": {
          "title": "Ceny",
          "subtitleFirstLine": "Pro firmy o velikosti {companySize}.",
          "subtitleSecondLine": "Účtováno měsíčně.",
          "perEmployee": "za zaměstnance",
          "currency": "Kč"
        },
        "rows": [
          {
            "title": "Platforma uLékaře.cz 24/7",
            "subtitle": "Klientská zóna a péče zdravotního týmu",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Názor praktického lékaře či pediatra",
            "subtitle": "Lékař odpoví do 6h",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Názor specialisty",
            "subtitle": "Specialista odpoví do 48h",
            "basic": "false",
            "premium": "Pouze po vyžádání praktickým lékařem",
            "exclusive": "true"
          },
          {
            "title": "Objednání na doporučení lékaře",
            "subtitle": "Sestřička volá do následujícího pracovního dne",
            "basic": "false",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Objednání na vlastní žádost",
            "subtitle": "Sestřička volá do následujícího pracovního dne",
            "basic": "false",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Kontakty na zdravotnická zařízení",
            "subtitle": "V případě, že se chcete objednat sám",
            "basic": "false",
            "premium": "false",
            "exclusive": "true"
          },
          {
            "title": "Prevence",
            "subtitle": "Preventivní profil, kalendář prohlídek, preventivní tipy e-mailem, tematické preventivní poradny",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Sdílení služby s rodinou",
            "basic": "Dotaz na jinou osobu",
            "premium": "Dotaz na jinou osobu",
            "exclusive": "true"
          },
          {
            "title": "Webchat se zákaznickou péčí",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Dedikovaný corporate care tým",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Implementace služby do firmy",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Pravidelný reporting",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          }
        ]
      },
      "basic": {
        "title": "Basic",
        "subtitle": "Lékař vždy po ruce"
      },
      "premium": {
        "title": "Premium",
        "subtitle": "Specialista a objednání"
      },
      "exclusive": {
        "title": "Exclusive",
        "subtitle": "Kompletní péče uLékaře.cz"
      },
      "individualPricing": {
        "title": "Pro firmu Vaší velikosti máme individuální ceník",
        "perex": "Vše s vámi rád probere náš obchodní konzultant Martin Čuba.",
        "interested": "Mám zájem"
      },
      "try": "Vyzkoušet 30 dní zdarma",
      "tryShort": "Vyzkoušet"
    },
    "faq": {
      "title": "Často kladené otázky",
      "faqList": [
        {
          "title": "Co přinese uLékaře.cz firmě?",
          "bodyText": "Víme, že firmám se péče o zdraví jejich zaměstnanců vyplácí. Šetří čas, zajišťuje přítomnost zaměstnanců na pracovišti a jejich lepší soustředěnost i výkonnost. S naší službou si zaměstnanec může v rámci online lékařské poradny vše vyřídit rychle odkudkoliv, a když potřebuje fyzickou návštěvu, k lékaři ho objednáme na jím vybrané místo i čas. <br/><br/>Zaměstnanci dokážeme poradit na dálku, navíc není mnohdy nutná návštěva lékaře, ani zdlouhavé vyhledávání informací na internetu. Šetříme tak zaměstnavateli náklady, které by musel jinak vynaložit za čas, kdy zaměstnanec nepracuje, nebo z důvodu jeho nepřítomnosti musí být zajištěna jeho náhrada. <br/><br/>Nemocem je nejlepší předcházet, proto zajišťujeme také komplexní preventivní program a Dny zdraví."
        },
        {
          "title": "Co přinese uLékaře.cz zaměstnancům?",
          "bodyText": "Služba uLékaře.cz přináší pro uživatele mnoho benefitů. Registrací získají 350 lékařů všech specializací na dosah ruky, včetně pediatrů a praktických lékařů. Jsou připraveni pomoci s rychlou orientací ve zdravotním problému, který právě řeší zaměstnanec nebo jeho blízcí. V našem týmu máme také 50 zdravotních sestřiček na telefonu pro pomoc s vyhledáním nového lékaře či odborníka ve vyhovujícím čase a lokalitě. V komunikaci se zaměstnanci setkají s profesionálním, diskrétním a lidským přístupem celého zdravotního týmu. Komunikovat mohou v českém, nebo anglickém jazyce."
        },
        {
          "title": "Jak službu uLékaře.cz pro zaměstnance objednat?",
          "bodyText": "Pokud máte méně než 100 zaměstnanců, můžete si službu do firmy objednat online. Pro firmy s větším počtem zaměstnanců je tu naše obchodní oddělení. Rádi vám připravíme cenovou nabídku."
        },
        {
          "title": "Vztahuje se na službu daňové zvýhodnění?",
          "bodyText": "Služba uLékaře.cz je daňově uznatelným nákladem ve smyslu Zákona č. 586/1922 Sb. o daních z příjmů, protože slouží k zajištění a udržení zdanitelných příjmů, a to formou úspory mzdových nákladů za zaměstnance."
        },
        {
          "title": "Jak je zajištěna bezpečnost služby?",
          "bodyText": "Uživatelé služby uLékaře.cz využívají ve své klientské zóně, která je šifrovaná a tedy vše okolo otázek kolem zdraví vidí pouze oni sami a lékař, se kterým konkrétní dotaz řeší. Zároveň splňujeme veškeré legislativní požadavky o Obecném nařízení EU 2016/679 o ochraně osobních údajů (GDPR) a získali jsme certifikaci ISO/IEC 27001 pro oblast řízení bezpečnosti informací. <br/><br/>Všechny požadavky jsou řešeny pouze mezi vámi a příslušnými osobami z týmu uLékaře.cz, případně vámi zvoleným zdravotnickým zařízením. Dokonce i lékař, který vám odpovídá, vidí kromě vašeho dotazu jen vaše křestní jméno a věk. K dalším informacím uvedeným v rámci vašeho požadavku má přístup jenom náš vlastní zdravotnický tým, jenž vám pomáhá s objednáním nebo dalším zpracováním dotazu. Záznamy o vaší péči nejsou dále s nikým sdíleny."
        },
        {
          "title": "Musí zaměstnanci pro registraci do služby uLékaře.cz změnit svého praktického lékaře?",
          "bodyText": "Registrací do naší služby neměníte svého praktického lékaře. Lékaři v naší poradně odpoví na každý požadavek a v případě zájmu zaměstnance k lékaři objednáme."
        },
        {
          "title": "Může služba zkrátit čekací lhůtu vyšetření, které jsou obvykle velmi dlouhé?",
          "bodyText": "Rychlost objednání vždy závisí na vytížení systému zdravotnictví. Záleží na lokalitě a kapacitách lokální lékařské péče. Často jsme schopni požadované vyšetření zařídit v kratší lhůtě než té, kterou byste získali při objednávání vy sami. Objednáváme totiž do všech zdravotních zařízení, státních i soukromých, a máme velmi dobře zmapované aktuální kapacity lékařů a čekací lhůty po celé České republice."
        },
        {
          "title": "Budou zaměstnanci platit lékaři, ke kterému je objednáváte?",
          "bodyText": "Rozhodnutí je na vás. Naše sestřičky vás mohou objednat jak do státních, tak i soukromých zdravotnických zařízení. Snaží se vždy najít toho nejvhodnějšího lékaře s ohledem na termín návštěvy a dostupnost lékařů dané odbornosti, vše podle vašich preferencí. O případné platbě vás informujeme před návštěvou lékaře."
        },
        {
          "title": "Zajišťuje služba uLékaře.cz vystavení eRecept?",
          "bodyText": "Když lékař určí z vašeho dotazu, že je potřeba předepsat léky, zprostředkujeme eRecept. Předtím vám ještě zavolá zdravotní sestřička, která ověří váš aktuální stav a zájem."
        },
        {
          "title": "Můžu službu zařídit i pro výrobní firmu?",
          "bodyText": "Ano, můžete. Naše služba je určena pro všechny zaměstnance, bez rozdílu předmětu podnikání nebo pracovního zařazení. Mezi našimi klienti jsou jak banky, tak výrobní firmy, jako například Continental, Unipetrol, Cemex, Metrans, MND, Ideal Standard, Lasvit, a mnoho dalších."
        },
        {
          "title": "Lze službu nabídnout jen určité skupině zaměstnanců?",
          "bodyText": "Zakládáme si na tom, že naše péče je pro každého. Naší vizí je dostupnost naší péče pro všechny. Víme, že pomáháme všem bez rozdílu, ať už se jedná o manuální pracovníky, nebo kancelářské profese. Proto nabízíme naší službu vždy jen jako benefit pro celou firmu."
        },
        {
          "title": "Jaké množství práce musí personalisté pravidelně vynaložit, aby byla služba zaměstnanci využívaná?",
          "bodyText": "Minimální. Po zakoupení služby je klíčové informování zaměstnanců o dostupnosti služby a navedení k registraci, aby měli službu kdykoliv po ruce. Je možné využít námi připravené komunikační materiály. Se zaměstnanci registrovanými do klientské zóny už komunikujeme napřímo."
        },
        {
          "title": "Jak se dozvím, že zaměstnanci službu využívají?",
          "bodyText": "Z pravidelného reportingu, který od nás obdržíte. Jeho součástí je počet zaměstnanců registrovaných do služby, počet využití jednotlivých služeb, ale i nejčastější specializace nebo regionální využití. Vše je samozřejmě plně anonymizováno."
        },
        {
          "title": "Jak probíhá platba?",
          "bodyText": "Platit za službu začínáte po podpisu smlouvy. Fakturu vám budeme pravidelně zasílat dle domluvené frekvence."
        },
        {
          "title": "Je možné změnit balíček objednaných služeb?",
          "bodyText": "Ano, balíček můžete změnit kdykoliv prostřednictvím <a href=\"mailto:zdravi@ulekare.cz\">zdravi@ulekare.cz</a>. Náš corporate care tým se postará o vše potřebné."
        },
        {
          "title": "Jak je to s výpovědí smlouvy?",
          "bodyText": "Smlouva se uzavírá na dobu neurčitou s výpovědní dobou jeden měsíc."
        }
      ]
    },
    "letsTalk": {
      "title": "Chci zdraví a prevenci do firmy",
      "subtitle": "Zanechte na sebe kontakt, ozveme se vám co nejdříve."
    },
    "contactForm": {
      "title": "Nezávazná poptávka služby uLékaře.cz",
      "thankYou": {
        "title": "Vaši poptávku jsme přijali. Děkujeme.",
        "text": "Velmi nás těší váš zájem o naše služby. Do dvou pracovních dní se vám ozve náš obchodní konzultant a probere s vámi detaily."
      },
      "contact": {
        "name": "Martin Čuba",
        "position": "Head of Sales",
        "email": "partner@ulekare.cz",
        "phone": "+420&nbsp;603&nbsp;841&nbsp;995"
      },
      "companyName": {
        "title": "Název společnosti",
        "errorText": "Název společnosti je povinný, prosím, vyplňte ho."
      },
      "companyEmployees": {
        "title": "Počet zaměstnanců Vaší firmy",
        "errorText": "Počet zaměstnanců je povinný, prosím, vyplňte ho.",
        "badFormatError": "Počet zaměstnanců musí být číslo.",
        "minValueError": "Minimální počet zaměstnanců je 5."
      },
      "send": "Odeslat",
      "sendTitle": "Ozveme se vám co nejdříve.",
      "sendPerex": "Děkujeme vám za projevený zájem o službu Zdraví a prevence ve firmě pro Vaše zaměstnance."
    },
    "orderForm": {
      "title": "Fakturační údaje",
      "sendOrder": "Odeslat objednávku",
      "sendRequest": "Odeslat poptávku",
      "companyName": {
        "title": "Název firmy",
        "placeholder": "Vaše firma s.r.o.",
        "errorText": "Název firmy je povinný, prosím, vyplňte ho."
      },
      "ico": {
        "title": "IČO",
        "placeholder": "1234567890",
        "errorText": "Údaj IČO je povinný, prosím, vyplňte ho."
      },
      "fullName": {
        "title": "Kontaktní osoba",
        "placeholder": "Jan Zdravý",
        "errorText": "Údaj o kontaktní osobě je povinný, prosím, vyplňte ho."
      },
      "email": {
        "label": "Pracovní e-mail",
        "placeholder": "firemni@mail.cz"
      },
      "termsConds": "obchodními podmínkami",
      "thankYou": {
        "title": "Přijali jsme vaši objednávku. Děkujeme.",
        "back": "Zpět na Hlavní stránku",
        "message": {
          "title": "Martin Pospíšil, CEO uLékaře.cz",
          "name": "Martin Pospíšil",
          "welcome": "Vítejte v komunitě zdravých firem!",
          "subtitle": "Od teď můžete všechno ohledně zdraví nechat na nás. Co bude následovat?",
          "items": [
            {
              "icon": "$checkCircle",
              "iconColor": "success",
              "text": "Na e-mail jsme vám zaslali rekapitulaci vaší objednávky"
            },
            {
              "icon": "$checkCircle",
              "iconColor": "success",
              "text": "Nejpozději do dvou pracovních dnů obdržíte smlouvu a autorizační kód spolu s pokyny pro přístup ke službě uLékaře.cz"
            },
            {
              "icon": "$checkCircle",
              "iconColor": "success",
              "text": "Před uplynutím 30 denní zkušební doby vám pošleme fakturu k úhradě služby na další měsíc."
            },
            {
              "imgType": "icon",
              "icon": "$checkCircle",
              "iconColor": "success",
              "text": "Pokud z nějakého důvodu nebudete s naší službou spokojeni, fakturu jednoduše neplaťte. "
            }
          ]
        }
      }
    },
    "disclaimer": "V tomto formuláři není možné položit dotaz nebo se objednat k lékaři.",
    "stories": [
      {
        "name": "Karolína Kašparová",
        "position": "Head of Operations, Bridgewater",
        "image": "karolina_kasparova.jpeg",
        "perex": "uLékaře.cz nám umožňuje kdykoliv se poradit s lékařem o zdravotním problému, a to nejen vlastním, ale kohokoliv z rodiny. Služba funguje 24 hodin denně, může být anonymní a umí rychle propojit s nejbližším lékařem a domluvit osobní konzultaci. Bez zbytečného trápení v čekárně. Děkujeme."
      },
      {
        "name": "Radka Pučelíková",
        "position": "HR manager, Aimtec",
        "image": "radka_pucelikova.png",
        "perex": "Službu jsme zavedli jako benefit 9. 10. 2018 pro všech 185 zaměstnanců. Oceňujeme, že šetří čas, řeší zdravotní komplikace našich zaměstnanců (i v zahraničí), dokáže vyhledat specialistu, učí preventivnímu chování či pečuje o rodiny zaměstnanců. Máme radost, že tuto službu už docenili i mladí lidé, kteří ji zpočátku považovali s ohledem na svůj věk a zdraví nadbytečnou."
      },
      {
        "name": "Scott Marlowe",
        "position": "HR Director, Česká Spořitelna",
        "image": "scott_marlowe.png",
        "perex": "Zdraví našich zaměstnanců je pro nás vždy důležité téma. Od dubna 2020 nabízíme našim zaměstnancům a jejich blízkým služby uLékaře.cz – 24hodinové online lékařské poradny a možnosti objednat se k lékaři bez nutnosti osobní návštěvy a dlouhé čekací doby. Doporučujeme!"
      }
    ]
  },
  "companiesOrder": {
    "headerText": "Krok {currentStep}/2",
    "firstStep": {
      "title": "Výběr balíčku",
      "subtitle": "uLékaře.cz máte 30 dní zdarma a zcela bez závazků.",
      "back": "Zpět na zdraví ve firmě",
      "testimony": {
        "name": "Karolína Kašparová",
        "position": "Head of operations, Bridgewater",
        "text": "“uLékaře.cz nám umožňuje kdykoli se poradit s lékařem o zdravotním problému, a to nejen vlastním, ale i kohokoliv z rodiny. Služba funguje 24 hodin denně, může být anonymní a umí rychle propojit s nejbližším lékařem a domluvit osobní konzultaci. Bez zbytečného trápení v čekárně. Děkujeme.”"
      },
      "orderSummary": {
        "tariff": "Balíček",
        "price": "Cena: <strong>{price} Kč</strong> za zaměstnance na měsíc",
        "finalPrice": "Celkové měsíční náklady pro {companyEmployees} zaměstnanců: {finalPrice} Kč",
        "star": "Ceny jsou uvedeny bez DPH"
      },
      "setup": {
        "companyTitle": "Velikost firmy",
        "tariffTitle": "Zvolte si balíček",
        "tariffSubTitle": "Cena platí pro jednoho zaměstance. Účtováno měsíčně.",
        "familyTitle": "Rodinné sdílení",
        "familySubTitle": "Sdílené účty pro rodinu zaměstnance",
        "nothing": "Nic",
        "family": {
          "title": "Rodinné sdílení",
          "subTitle": "+{price} Kč/zaměstnanec"
        },
        "fastReplyTitle": "Přednostní odpovědi",
        "fastReplySubTitle": "Praktický lékař do 3h",
        "fastReplyPremiumSubTitle": "lékař specialista do 24h",
        "fastReply": {
          "title": "Přednostní odpověď",
          "subTitle": "+{price} Kč/zaměstnanec"
        },
        "nextButton": "Pokračovat k objednání",
        "tariffs": {
          "basic": {
            "title": "Basic",
            "subTitle": "Lékař vždy po ruce"
          },
          "premium": {
            "title": "Premium",
            "subTitle": "Specialista a objednání"
          },
          "exclusive": {
            "title": "Exclusive",
            "subTitle": "Kompletní péče uLékaře.cz "
          }
        }
      },
      "formTitle": "Pro firmu vaší velikosti máme individuální ceník",
      "formPerex": "Vše s vámi rád probere náš obchodní konzultant Martin."
    },
    "secondStep": {
      "title": "Objednávka služby uLékaře.cz",
      "back": "Zpět na Výběr balíčku",
      "summary": {
        "topText": "Vaše cena po 30 denním zkušebním období"
      },
      "disclaimer": {
        "title": "We speak English!",
        "subtitle": "Are you interested in our service but your employees don’t speak Czech? <strong>No worries!</strong> <br/><br/>We offer uLékaře.cz in English as well. Please contact us at <a href=\"mailto:partner@ulekare.cz\" class=\"link--inline\">partner@ulekare.cz</a> for more information."
      }
    }
  },
  "conference": {
    "figureAlt": "HRajeme dál je aktivita, která pomáhá začlenit péči o zdraví a prevenci mezi základní firemní strategie.",
    "hrajemeDal092020": {
      "hello": {
        "title": "HRajeme dál",
        "perex": "Když se daří zaměstnancům, daří se firmě jako celku. Děkujeme za to, že se stáváte ambasadory „zdraví ve vlastních rukou“. Máme radost, že vás téma zajímá, a&nbsp;snad vám, kdo ještě váháte jak, pomůžeme začlenit zdraví a&nbsp;prevenci mezi základní firemní strategie.",
        "companiesText": "Chcete službu Zdraví a prevence do své firmy?",
        "actionButton": "Mám zájem",
        "helloImgName": "hello-conference-main-img"
      },
      "infoBox": {
        "items": [
          "Online",
          "Platforma ZOOM",
          "4. 11. 2020, 15.00–18.00 h."
        ]
      },
      "speakers": {
        "title": "Co zaznělo na konferenci",
        "list": [
          {
            "photo": "speakers/petr_smejkal.png",
            "name": "MUDr. Petr Smejkal",
            "perex": "Zploštění křivky vysvětlil na příkladu kladivo a tanec Petr Smejkal. „Když křivku oploštíme kladivem, musíme tancovat, tedy testovat. Je lepší dobře tancovat, aby se nemuselo použít kladivo, které jsme u nás použili už dvakrát.“",
            "videoUrl": "https://youtu.be/dN5XtBkTZYc"
          },
          {
            "photo": "speakers/daniel_stach.png",
            "name": "Daniel Stach",
            "perex": "Daniel Stach měl za úkol zodpovědět na tři otázky. Nejdůležitější byla, jak zajistit, aby lidé nepanikařili a situaci zvládli: „Řešte jen to, co je klíčové, pro vás důležité, ne drobnosti. Důležitá je jednoznačnost komunikace. Dospělý ve stresu vnímá jako 12letý (Vymětal). Podle toho podávejte informace.“",
            "videoUrl": "https://youtu.be/yeATVGhsE7s"
          },
          {
            "photo": "speakers/tomas_sebek.jpg",
            "name": "MUDr. Tomáš Šebek",
            "perex": "„Řídit si zdraví může každý z nás – snažíme se to propagovat. Máme radost, že toto ve firmách chápete a přidáváte se k nám,“ vyzdvihl etickou otázku tzv. nulté prevence Tomáš Šebek.",
            "videoUrl": "https://youtu.be/U2NFN7XWHtY"
          },
          {
            "photo": "speakers/martin_palicka.png",
            "name": "Martin Palička",
            "perex": "„V dnešní komplikované době je důležité, aby firmy myslely prvně na své zaměstnance a až potom na své marže. Lidé ve firmě by se neměli bát říkat své názory a potřebují dostat odpovědi na své otázky,“ vyzdvihuje Martin Palička přístup, který vidí napříč firemním sektorem.",
            "videoUrl": "https://youtu.be/b5iPAFQwpNM"
          },
          {
            "photo": "speakers/sona_bouskova.png",
            "name": "MUDr. Soňa Boušková",
            "perex": "„Hodně řešíme, jak důležité je nyní neodkládat i běžné zdravotní problémy. Avšak stejně tak důležité je nemocem předcházet. Proto na vás chci apelovat – myslete na prevenci, ta nebolí, za to vás významně ochrání do budoucna. Rádi vám pomůžeme a vždycky si na vás uděláme čas,“ vyzvala Soňa Boušková.",
            "videoUrl": "https://youtu.be/XcaDRji_RWA"
          },
          {
            "photo": "speakers/hana_smidtova.png",
            "name": "Hana Šmidtová",
            "perex": "V Alze došlo během dvou týdnů ke zdvojnásobení počtu zaměstnanců v provozu. „Objevil se přirozeně strach u provozních zaměstnanců, zda nepřijdou o práci z důvodu karantény. Prodávat znamená možnost postarat se o zaměstnance, ale také povinnost postarat se o jejich zdraví,“ připomněla Hana Šmidtová.",
            "videoUrl": "https://youtu.be/63PvjkoSUXM"
          },
          {
            "photo": "speakers/jaroslava_rezlerova.png",
            "name": "Jaroslava Rezlerová",
            "perex": "O podstatě sdílení informací mluvila i Jaroslava Rezlerová: „Poslední průzkum ukázal pozitivnější náladu zaměstnavatelů, než jsme čekali. Viděli jsme to na tisících případů výrobních firem. Je to neuvěřitelné. Ekonomický vývoj politiku předbíhá.“",
            "videoUrl": "https://youtu.be/gLzSV9yulgA"
          },
          {
            "photo": "speakers/tereza_kucerova.png",
            "name": "Tereza Kučerová",
            "perex": "Z 50 na 600 lidí vyrostla firma Prusa Research: „Doba covidová přinesla i dobré věci. Zlepšila se komunikace, firemní kultura. HR má podpůrnou roli a pomáhá stmelovat kolektiv, důležitá je pro nás hrdost - Průša jsme my,“ ukázala Tereza Kučerová.",
            "videoUrl": "https://youtu.be/3lrbuUFao9s"
          },
          {
            "photo": "speakers/pavla_mendlova.jpg",
            "name": "Pavla Mendlová",
            "perex": "Jak v České spořitelně řešili počáteční nedostatek informací? Podle Pavly Mendlové spoluprací od Aše po Jablunkov, třeba tím, že si pomohli s trasováním. „Důležité bylo pro zaměstnance vědět, proč se co dělá. Zapojili jsme se do systému chytré karantény a sami jsme v regionech trasovali kolegy.“",
            "videoUrl": "https://youtu.be/-uFAJ8YBVeY"
          }
        ]
      },
      "disclaimer": {
        "title": "HRajte s námi dál navzdory okolnostem!",
        "subtitle": "Kdo si konferenci nenechá ujít?",
        "text": "Každý personalista, který se nyní stává hlavním hybatelem HR strategie zaměřené na lidi. Právě zaměstnanci, jejich stabilita a schopnost pracovat ať už vzdáleně z domova, nebo za zpřísněných podmínek na pracovišti, jsou nejcennějším kapitálem podniku. Společným cílem je udržení ekonomiky. Proto jsou HR oddělení dnes klíčová pro udržení efektivního fungování firmy, přičemž nároky se stále zvyšují nejen v každodenní agendě, ale zejména v péči a komunikaci."
      },
      "program": {
        "subtitle": "Stáhněte si <a href=\"https://www.ulekare.cz/media/hrajeme_dal_program.pdf\" target=\"_blank\">aktuální program</a>",
        "items": [
          {},
          {
            "icon": "care",
            "time": "16.00–17.00",
            "title": "Role médií a komunikace",
            "speakers": [
              {
                "photo": "speakers/daniel_stach.png",
                "name": "Danies Stach"
              },
              {
                "photo": "speakers/jaroslava_rezlerova.png",
                "name": "Jaroslava Rezlerová"
              },
              {
                "photo": "speakers/tereza_kucerova.png",
                "name": "Tereza Kučerová"
              }
            ]
          },
          {
            "icon": "doctor",
            "time": "17.00–18.00",
            "title": "O zdraví a telemedicíně",
            "speakers": [
              {
                "photo": "speakers/tomas_sebek.jpg",
                "name": "MUDr. Tomáš Šebek"
              },
              {
                "photo": "speakers/petr_smejkal.png",
                "name": "MUDr. Petr Smejkal"
              },
              {
                "photo": "speakers/sona_bouskova.png",
                "name": "MUDr. Soňa Boušková"
              }
            ]
          }
        ]
      },
      "contacts": [
        {
          "name": "Táňa Lálová",
          "email": "tana.lalova@ulekare.cz",
          "phone": "+420 725 826 072"
        },
        {
          "name": "Kateřina Nováková",
          "email": "katerina.novakova@ulekare.cz",
          "phone": "+420 773 107 142"
        },
        {
          "name": "Šimon Šebek",
          "email": "simon.sebek@ulekare.cz",
          "phone": "+420 602 311 867"
        }
      ],
      "logos": {
        "items": [
          {
            "link": "https://www.prusa3d.cz",
            "image": "logos/prusaresearch.png",
            "name": "Prusa Research"
          },
          {
            "link": "https://zasilkovna.cz",
            "image": "logos/zasilkovna.png",
            "name": "Zásilkovna"
          },
          {
            "link": "https://www.manpowergroup.cz",
            "image": "logos/mpg.png",
            "name": "Manpower Group"
          }
        ]
      }
    },
    "hrajemeDal042021": {
      "hello": {
        "title": "HRajeme dál II",
        "perex": "Registrujte se na konferenci, která vás inspiruje v tom, jak realitu dneška přečkat nejen ve zdraví fyzickém, ale i duševním. Návod na perpetuum mobile nemáme, ale poradíme vám, jak si udržet všech pět poHRomadě.",
        "companiesText": "Chcete se stát ve vaší firmě ambasadorem zdraví ve vlastních rukou?",
        "actionButton": "Registrovat se",
        "helloImgName": "hello-conference-main-img"
      },
      "infoBox": {
        "items": [
          "Online",
          "Platforma ZOOM",
          "31. 3. 2021, 14.30-17.30 h."
        ]
      },
      "speakers": {
        "title": "S kým se setkáte?",
        "list": [
          {
            "photo": "speakers/tomas_sebek.jpg",
            "name": "MUDr. Tomáš Šebek",
            "perex": "Vystudoval všeobecné lékařství na 1. lékařské fakultě Univerzity Karlovy. Poté začal pracovat jako chirurg v Nemocnici Hořovice, v irském Dublinu a v současnosti v Nemocnici Na Františku v Praze."
          },
          {
            "photo": "default-avatar.png",
            "name": "MUDr. Tereza Filová",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "doc. MUDr. Rastislav Maďar",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Martin Rozhoň",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Tomáš Ervín Dombrovský",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "zástupce HRB - Johnson & Johnson",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Petr Koubský",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Jana Chudlíková",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Jan Lukačevič",
            "perex": "TBA"
          }
        ]
      },
      "disclaimer": {
        "title": "Prakticky: Jak si udržet všech pět poHRomadě?",
        "text": "Čím vším jsme se za poslední rok stali? Učiteli, vedoucími kroužků pro děti, pečovateli, ekonomy, psychology, zdravotníky, opraváři, řemeslníky, … A vedle toho pečujeme o své rodiny – partnery, prarodiče, děti. HRdiny potkáváme na každém rohu, jenomže nám to trochu zevšednělo. Je v pořádku přiznat si, že život v současnosti je vyčerpávající a oprávněně se ptáme: Jak dlouho ještě?\n<br /><br />Odpovědět neumíme. Můžeme vás ale inspirovat v tom, jak sdílenou realitu přečkat nejen ve zdraví fyzickém, ale i duševním. Abychom s trpělivostí a racionalitou prožili současnost. Abychom s nadějí a optimismem nahlédli do budoucnosti.\n<br /><strong>Proč to děláme? Protože zdraví je naše.</strong>"
      },
      "program": {
        "subtitle": "TBA"
      },
      "contacts": [
        {
          "name": "Táňa Lálová",
          "email": "tana.lalova@ulekare.cz",
          "phone": "+420 725 826 072"
        },
        {
          "name": "Lenka Petrašová",
          "email": "lenka.petrasova@ulekare.cz",
          "phone": "+420 775 854 239"
        },
        {
          "name": "Šimon Šebek",
          "email": "simon.sebek@ulekare.cz",
          "phone": "+420 602 311 867"
        }
      ],
      "conferenceForm": {
        "title": "Registrace zdarma",
        "subtitle": "Nenechte si ujít HR online konferenci, která fakty a daty usměrňuje paniku.",
        "sendTitle": "Jsme rádi, že i vy HRajete dál!",
        "sendPerex": "Potvrzení registrace najdete ve svém e-mailu. Případně prosím zkontrolujte složku nevyžádané pošty."
      }
    },
    "hrajemeDal052022": {
      "notificationBar": "Připojte se na konferenci zde",
      "notificationLink": "https://zoom.us/j/91477678728",
      "hello": {
        "title": "<span>Konference</span><br/><span style=\"color: #3ca091\">Zdravé firmy, zdravé Česko</span>",
        "perex": "Naše stravovací návyky a životní styl jsou klíčové v prevenci civilizačních onemocnění, jejichž dopady se promítají i do pracovního života. Jak tuto realitu mění nové technologie a AI? A jak mohou firmy lépe komunikovat benefity podporující zdraví zaměstnanců? Přijďte se inspirovat na 3. ročník konference.",
        "actionButton": "Registrujte se zdarma",
        "moreInfoLink": "Sledovat záznam",
        "helloImgName": "hero-conference.png"
      },
      "infoBox": {
        "items": [
          "11. 6. 2026",
          "9:00–16:00",
          "<a href=\"https://maps.app.goo.gl/XR5BrJdFYzkAVK6R6\" target=\"_blank\">PernerKarlín, Praha</a>"
        ]
      },
      "speakers": {
        "title": "Řečníci",
        "list": [
          {
            "photo": "speakers/eliska_remesova.webp",
            "name": "Eliška Remešová",
            "perex": "Psycholožka a psychoterapeutka",
            "link": "Vede Institut Mezilidmi – místo pro všechny, kteří chtějí svým vztahům dát smysl, hloubku a pravdivost. Ve firmách pomáhá posilovat psychologické bezpečí, vztahy na pracovišti, emoční resilienci a osobní wellbeing. Přes čtrnáct let je lektorkou v řadě firem, které jsou leadery ve svých oborech. Skrze přednášky, besedy a podcasty zlepšuje sociální zdraví v Česku.",
            "isHidden": "true"
          },
          {
            "photo": "speakers/tomas_sebek.webp",
            "name": "Tomáš Šebek",
            "perex": "Chirurg",
            "link": "Známý propagátor medicíny a chirurg, otec čtyř dětí s pilotní licencí, se v současné době projektem Ministr zdraví intenzivně věnuje problematice prodloužení délky života Čechů ve zdraví. Společně s kolegy již dříve založil projekt uLékaře.cz. Ten dnes mimo jiné pomáhá firmám, které si uvědomují, jak je zdraví zaměstnanců z pohledu zaměstnavatele důležité."
          },
          {
            "photo": "speakers/petr_havlicek.webp",
            "name": "Petr Havlíček",
            "perex": "Výživový specialista",
            "link": "Patří k nejznámějším výživovým specialistům v České republice. Výživě se věnuje více jak 20 let. Začínal s výživou vrcholových sportovců, dnes radí českým osobnostem i klientům, kteří chtějí zhubnout, změnit životní styl nebo zlepšit kondici. Nejlépe ho znáte z televizních pořadů o jídle „Jste to, co jíte\" a „Souboj v těžké váze\", kde působil jako odborný garant a spolumoderátоr.",
            "isCanceled": ""
          },
          {
            "photo": "speakers/lucie_kunesova.webp",
            "name": "Lucia Kunešová",
            "perex": "HR ředitelka Arriva Transport Česká republika",
            "link": "Má za sebou právnické vzdělání a přes 20 let v HR a na manažerských pozicích ve velkých korporacích. Krize ji nezaskočí – ví, co funguje a jak jednat. Mluví napřímo, řeší věci prakticky a s respektem i empatií k lidem. Věří v sílu pozitivního myšlení a sebedůvěry."
          },
          {
            "name": "Martina Klecker Kněžourová",
            "perex": "Výkonná ředitelka řízení lidských zdrojů Letiště Praha, a. s. ",
            "link": "Odbornice na strategické řízení lidských zdrojů v jedné z největších a nejkomplexnějších organizací v ČR. Zaměřuje se na posun HR k partnerství s byznysem s reálným dopadem na výkon a udržitelnost, digitalizaci procesů a práci s daty. Věří v HR, které respektuje rozmanitost lidí a podporuje společný cíl organizace.",
            "photo": "speakers/martina_klecker.webp",
            "type": ""
          },
          {
            "photo": "speakers/jana_ogounova.webp",
            "link": "Manažerka lidských zdrojů s přesvědčením, že personální agenda je jen začátek. Svou kariéru zasvětila budování firemní kultury založené na důvěře, otevřenosti a respektu. Strategicky propojuje vedení se zaměstnanci a dlouhodobě se věnuje vytváření zdravého pracovního prostředí a efektivní interní komunikaci.",
            "perex": "HR Manager Schäfer-Sudex s.r.o",
            "name": "Jana Ogounová",
            "type": ""
          },
          {
            "name": "Zuzana Volková",
            "perex": "Členka think tanku Ministr zdraví, finanční ředitelka Delirest a Primirest CZ & SK",
            "link": "Expertka na finanční management se zkušenostmi z Česka i zahraničí. Pracovala jako auditorka ve společnosti Deloitte a poté 14 let u logistické společnosti TNT Express. Jako finanční ředitelka vedla společnost Xerox a později nastoupila do Compass Group. V nově vzniklých společnostech Delirest a Primirest dnes zastřešuje finance, lidské zdroje a IT.",
            "photo": "speakers/zuzana_volkova.webp",
            "type": ""
          },
          {
            "name": "Veronika Urban",
            "perex": "Head of Sales, JOBka services s.r.o.",
            "link": "Působí jako Head of Sales ve společnosti JOBka, kde vede obchodní tým a podílí se na rozvoji obchodních aktivit. Má více než 6 let zkušeností v B2B obchodě i v oblasti HR a zaměřuje se na business development, vyjednávání a budování vztahů se zákazníky.",
            "photo": "speakers/veronika_urban.webp",
            "type": ""
          },
          {
            "name": "Petr Kuf",
            "perex": "Head of Human Resources, Körber Pharma",
            "link": "Působí jako Head of Human Resources ve společnosti Körber Pharma, kde čerpá z bohatých zkušeností v HR, rozvoji lidí a firemní kultury. Ve své roli propojuje strategii firmy s potřebami zaměstnanců.",
            "photo": "speakers/petr_kuf.webp",
            "type": ""
          },
          {
            "name": "Dalibor Pastucha",
            "perex": "Dětský a tělovýchovný lékař, vysokoškolský pedagog, Klinika rehabilitace a tělovýchovného lékařství, FN Ostrava",
            "link": "Dlouhodobě se věnuje prevenci civilizačních onemocnění, zejména dětské obezitologii a podpoře zdravého životního stylu. Působí jako přednosta Kliniky rehabilitace a tělovýchovného lékařství FN Ostrava a LF Ostravské univerzity, zároveň je ředitelem ReFit Clinic a revizním lékařem VZP. Jako docent preventivní medicíny se podílí na vzdělávání zdravotníků a aktivně působí i v oblasti řízení kvality zdravotnických zařízení.",
            "photo": "speakers/dalibor_pastucha.webp",
            "type": ""
          },
          {
            "name": "Barbora Vágnerová",
            "perex": "Programová manažerka v oblasti zdraví zaměstnanců, vzdělávání a mezinárodní spolupráce, Ministr zdraví",
            "link": "Pomáhá organizacím vytvářet smysluplné programy na podporu zdraví zaměstnanců, vzdělávání a dlouhodobé udržitelnosti lidského kapitálu. Propojuje strategii, data a praktickou implementaci. Zaměřuje se na systémová řešení, včetně budování partnerství a řízení komplexních projektů s mezinárodním přesahem.",
            "photo": "speakers/barbora_vagnerova.webp",
            "type": ""
          },
          {
            "type": "",
            "photo": "speakers/martina_pavlikova.webp",
            "link": "Zaměřuje se především na úspěšnou implementaci změn – procesních i technologických – s důrazem na jejich reálné přijetí a dlouhodobou udržitelnost s ohledem na výkon i spokojenost zaměstnanců. Ve své práci staví na otevřenosti a psychologickém bezpečí, které podporují vznik funkčních týmů i dlouhodobých partnerství.",
            "perex": "Interim projektová manažerka v oblasti lidských zdrojů a organizačního rozvoje",
            "name": "Martina Pavlíková"
          },
          {
            "name": "",
            "perex": "",
            "link": "",
            "type": "",
            "photo": ""
          },
          {
            "name": "",
            "type": "",
            "link": "",
            "perex": "",
            "photo": ""
          },
          {
            "photo": "",
            "perex": "",
            "link": "",
            "type": "",
            "name": ""
          },
          {
            "name": "",
            "type": "",
            "link": "",
            "perex": "",
            "photo": ""
          }
        ],
        "panelists": "Panelisté",
        "description": "Řečníky pravidelně aktualizujeme."
      },
      "program": {
        "subtitle": "Rezervovat vstupenku",
        "moderator": {
          "photo": "martin_cuba.png",
          "text": "Moderuje Martin Čuba"
        },
        "items": [
          {},
          {
            "heading": "Přivítání moderátorem",
            "paragraph": "9:00-9:20",
            "perex": "Přivítání moderátorem <br />"
          },
          {
            "heading": "Přednáška: Z práce rovnou do hrobu? Už ne!",
            "paragraph": "9:20-9:50",
            "perex": "Tomáš Šebek <br />",
            "link": "Češi odcházejí do důchodu ve stále pozdějším věku, jenže v jakém zdravotním a psychickém stavu? České firmy proto začínají intenzivně řešit, jak zaměstnancům prodloužit léta strávená ve zdraví. Přednáška o naději a možných postupech, včetně budoucích, které už fungují u téměř 250 firem v Česku."
          },
          {
            "heading": "Panelová diskuze: Chytrá řešení pro zdraví zaměstnanců",
            "paragraph": "9:50-10:30",
            "perex": "<strong>Hosté:</strong> Vlastimil Hrabal, Lukáš Krčil, Martin Pospíšil, Tomáš Mixa <br />",
            "moderator": "<strong>Moderátor:</strong> Tomáš Šebek <br />",
            "link": "S konkrétními dodavateli produktů a služeb, které inovativním způsobem podporují zdraví zaměstnanců, budeme diskutovat o tom, jak konkrétně lze podporovat zdraví na pracovišti a jaké jsou aktuální trendy v této oblasti."
          },
          {
            "heading": "Přestávka: networking",
            "paragraph": "10:30-11:00",
            "perex": "Coffee break <br />"
          },
          {
            "heading": "Přednáška: V Téčku můžeme být sami sebou",
            "link": "Co to znamená být v korporaci sám sebou, opravdu to lze? A jaký to má vliv na well-being zaměstnanců? Dá se vůbec dopad měřit? Povíme si také, proč nefunguje řešení „one size fits all“ nebo jestli mají zaměstnanecké komunity vliv na well-being.",
            "perex": "Lukáš Ondřej, T-Mobile Czech Republic <br />",
            "paragraph": "11:00-11:30"
          },
          {
            "heading": "Panelová diskuze: Legislativa a zdraví zaměstnanců nejen z pohledu ESG",
            "paragraph": "11:30-12:10",
            "perex": "<strong>Hosté:</strong> Lucie Dryáková, Eva Karásková, Marie Zemanová, Aneta Kovářová, Nikol Michl <br />",
            "moderator": "<strong>Moderátor:</strong> Barbora Dubanská <br />",
            "link": "Tématem diskuse budou aktuality a chystané změny v legislativních normách a regulacích, které souvisí s podporou zdraví zaměstnanců (ESG, daňové aspekty, novela Zákona č. 373 - podpora zdraví zaměstnanců, pracovně lékařské služby)."
          },
          {
            "heading": "Oběd",
            "paragraph": "12:10-13:10",
            "perex": "Catering, networking <br />"
          },
          {
            "heading": "Přednáška: Zdraví není benefit!",
            "paragraph": "13:10-13:40",
            "perex": "Lenka Kučerová, Ministr Zdraví <br />",
            "link": "Zdraví skutečně není pouhý benefit navíc, se kterým je život příjemnější. Zdraví se stává skutečnou investicí do budoucna pro stát, jednotlivce i firmy. Jak efektivní je ale české zdravotnictví? A může se každý z nás stát ministrem vlastního zdraví? V přednášce se zaměříme na klíčové kroky, které firmy potřebují učinit, aby udržely své lidi angažované a zdravé do vysokého věku. Protože zdravé firmy = zdraví zaměstnanci."
          },
          {
            "heading": "Panelová diskuze: Praxí osvědčeno aneb co funguje?",
            "paragraph": "13:40-14:20",
            "perex": "<strong>Hosté:</strong> Pavla Mendlová, Helena Horská, Tomáš Talaš, Klára Černá <br />",
            "moderator": "<strong>Moderátor:</strong> Martin Pospíšil <br />",
            "link": "Cílem diskuze zástupců významných zaměstnavatelů bude sdílet praktické zkušenosti s péčí o zdraví zaměstnanců a hledat odpověď na otázku, proč je téma podpory zdraví v současné době pro zaměstnavatele aktuální a proč by se jím měli aktivně zabývat."
          },
          {
            "heading": "Přestávka: networking",
            "paragraph": "14:20-14:50",
            "perex": "Coffee break <br />"
          },
          {
            "heading": "Přednáška: Podpora duševního zdraví bez stigmatizace",
            "perex": "Dominika Čechová, CorporateSouls.com <br />",
            "link": "Duševní zdraví hraje v pracovním prostředí stále větší roli, protože má přímý dopad na výkon, spokojenost i celkovou atmosféru ve firmě. Jak však může management efektivně podporovat své zaměstnance, aniž by to vedlo ke stigmatizaci? V této přednášce se zaměříme na praktické způsoby, jak vytvořit pracovní prostředí, ve kterém zaměstnanci cítí bezpečí a podporu i v obtížných situacích.",
            "paragraph": "14:50-15:20"
          },
          {
            "heading": "Přednáška: Šance a limity pracovního uplatnění v ČR",
            "paragraph": "15:20-15:50",
            "perex": "Tomáš Ervín Dombrovský, Alma Career <br />",
            "link": "Víte, jaký má vliv prezentismus na vaši práci? Data mluví jasně: vývoj pracovního trhu přináší více změn než „jen“ nedostatek lidí a je potřeba na ně reagovat už teď. Například se umět ptát zaměstnanců, abyste včas a správně změřili zdraví firmy."
          },
          {
            "heading": "Závěr konference",
            "paragraph": "15:50-16:00",
            "perex": "Vyhlášení 3 nejzdravějších firem v rámci „Komunity zdravých firem“ <br />"
          }
        ],
        "progress": "Program pro konferenci 2026 se připravuje..."
      },
      "keepUpdating": {
        "program": "Program pravidelně aktualizujeme",
        "speakers": "Speakery pravidelně aktualizujeme"
      },
      "contacts": [
        {
          "name": "Adéla Wellalage",
          "email": "adela.wellalage@ulekare.cz",
          "photo": "pelu.webp",
          "phone": "+420 778 424 406"
        }
      ],
      "logos": {
        "items": {
          "mainPartner": {
            "name": "Jobka",
            "link": "https://www.jobka.cz/",
            "image": "logos/jobka.png"
          },
          "partners": {
            "bigLogos": [
              {
                "name": "Unicare",
                "link": "https://www.unicare.cz/cs/",
                "image": "logos/unicare.svg"
              },
              {
                "name": "Ministr zdraví",
                "link": "https://www.ministrzdravi.cz/",
                "image": "logos/ministr_zdravi.png"
              },
              {
                "name": "Biomefix",
                "link": "http://www.biomefix.eu",
                "image": "logos/biomefix.png"
              },
              {
                "image": "logos/imi.png",
                "link": "https://www.imi.cz/",
                "name": "Imi"
              },
              {
                "link": "https://www.healthyoffice.eu/",
                "image": "logos/healthy_office.png",
                "name": "Healthy Office"
              },
              {
                "image": "logos/curaprox.png",
                "link": "https://curaproxedu.cz/",
                "name": "Curaprox"
              }
            ]
          },
          "charityPartners": {
            "smallLogos": [
              {
                "name": "Nadace Rodiny vlčkových",
                "link": "http://www.nrv.org/",
                "image": "logos/nrv.png"
              }
            ]
          },
          "medialPartners": {
            "smallLogos": [
              {
                "name": "Idnes.cz Premium",
                "link": "https://www.idnes.cz/premium/clanky",
                "image": "logos/idnes.png"
              }
            ]
          }
        }
      },
      "partnerTypes": {
        "mainPartners": "Hlavní partner:",
        "partners": "Partneři konference",
        "charityPartners": "Charity partner:",
        "medialPartners": "Mediální partner:"
      },
      "conferenceForm": {
        "title": "Registrace zdarma",
        "subtitle": "Registrací na konferenci získáváte jako poděkování uLékaře.cz možnost vyzkoušet naši službu bezplatně do 19. 6. 2022.",
        "sendTitle": "Jsme rádi, že i vy HRajete dál!",
        "sendPerex": "Potvrzení registrace najdete ve svém e-mailu. Případně prosím zkontrolujte složku nevyžádané pošty."
      },
      "gallery": {
        "heading": "Fotogalerie z loňského ročníku"
      },
      "video": {
        "title": "Video z loňského ročníku"
      },
      "settingUp": {
        "title": "Program pro konferenci 2026 připravujeme."
      }
    },
    "infoBox": {
      "titles": [
        "DATUM",
        "ČAS",
        "MÍSTO"
      ]
    },
    "whyPurchaseItems": {
      "sectionTitle": "Proč si koupit vstupenku?",
      "titles": [
        "Inspirativní speakeři",
        "Praktické tipy",
        "Networking",
        "Skvělý catering"
      ]
    },
    "video": "Záznam přednášek",
    "getTicket": "Rezervovat vstupenku",
    "tickets": "Vstupenky",
    "moreInfo": "Více informací",
    "registerForFree": "Registrujte se zdarma",
    "poweredBy": "Powered by:",
    "conference": "Program",
    "logos": {
      "title": "Partneři konference"
    },
    "speakersText": "Řečníci",
    "program": {
      "title": "Program",
      "inMaking": "Program pro konferenci 2026 se připravuje.",
      "ticketsOpenAt": "Prodej vstupenek se spustí 15. dubna - nenechte si ujít early bird ceny!"
    },
    "registration": {
      "title": "Registrace zdarma",
      "subtitle": "Nenechte si ujít HR online konferenci, která fakty a daty usměrňuje paniku."
    },
    "registrationText": "Registrace",
    "contact": "Kontakt",
    "gallery": "Fotogalerie",
    "partners": "Partneři",
    "whyPurchase": {
      "reason": {
        "text": [
          "hodin v inovativním prostředí",
          "zdravotních screeningů",
          "inspirativních řečníků",
          "hodnotných výher",
          "Skvělých cen"
        ],
        "number": [
          "7",
          "7",
          "15"
        ]
      }
    }
  },
  "emergency": {
    "title1": "Kdy vyhledat pohotovost",
    "perex": "Jde o stručný soupis akutních nebo život ohrožujících stavů, na které chceme upozornit pacienty s cílem nasměrovat to nejurgentnější na pohotovost, aby nedošlo k prodlení v ošetření čekáním na odpověď lékaře v poradně. Největší obezřetnost je třeba u dětí.",
    "list": [
      {
        "title": "Úrazy a krvácení",
        "body": [
          "velké krvácení, nebo <strong>jasné červené krvácení, které stříká</strong>",
          "velmi silné krvácení z genitálu mimo menstruační cyklus nebo z konečníku",
          "otevřená či jinak zřejmá zlomenina",
          "<strong>otevřená poranění</strong> v hrudi nebo břiše",
          "<strong>úrazy hlavy</strong> se ztrátou vědomí, změnami chování, bolestmi hlavy, zvracením, různě velkými zornicemi, poruchami řeči, zraku nebo hybnosti",
          "<strong>popáleniny u dětí</strong>, zvláště na hlavě a rukou, genitálií, nebo na větší ploše těla u dospělého",
          "úrazy <strong>elektrickým proudem nebo bleskem</strong>"
        ]
      },
      {
        "title": "Bolest na hrudi a pocity v hrudi",
        "body": [
          "bolest v hrudníku, která <strong>neustává</strong>, nereaguje na běžné léky proti bolesti, či se stupňuje, je <strong>svíravá</strong>",
          "<strong>vystřeluje</strong> do levé paže nebo do krku",
          "bolest či <strong>porucha rytmu provázená změnami vědomí</strong>, mdlobami",
          "pokud máte podobné projevy opakovaně, nebo máte nemoc srdce a oběhového systému",
          "bolest na hrudi s dušností a významnými změnami tlaku"
        ]
      },
      {
        "title": "Dušnost",
        "body": [
          "nemožnost popadnout dech, pocit <strong>nedostatečnosti dechu</strong>",
          "<strong>lapavé dýchání</strong> (jako ryba), sípavé dýchání, hvízdavý výdech",
          "nemožnost dokončit větu bez nádechu, potřeba sedět či opřít se o ruce pro zlepšení dýchání, propadávání jamky na krku a mezi rameny a krkem",
          "<strong>změna barvy</strong> rtů, uší nebo prstů na fialovou"
        ]
      },
      {
        "title": "Bolest hlavy",
        "body": [
          "bolest je <strong>krutá, nezvyklá, náhle</strong> vzniklá, nereaguje na léky",
          "<strong>budí v noci</strong>, případně nastupuje hned po probuzení",
          "náhlé bolesti předcházela velká fyzická námaha včetně sexuálních aktivit",
          "bolest je provázená tuhostí šíje, malátností, spavostí, poruchami vědomí, horečkou",
          "bolest hlavy v nejbližších dnech po úrazech hlavy, zvláště s poruchou vědomí, zvracením, motáním",
          "provázená <strong>poruchami zraku, řeči, hybnosti</strong>"
        ]
      },
      {
        "title": "Bolest břicha a projevy v oblasti trávení",
        "body": [
          "<strong>krutá nebo kolikovitá</strong> bolest břicha",
          "<strong>zástava odchodu stolice</strong> nebo plynů se vzedmutím břicha, bolestí",
          "černá stolice",
          "<strong>zvracení krve</strong>",
          "<strong>boule na břiše</strong>, v tříslech, na varleti, která bolí, nejde zatlačit (nepokoušejte se o to), je barevně změněná oproti okolí"
        ]
      },
      {
        "title": "Mdloby, porucha vědomí, křeče",
        "body": [
          "náhle vzniklá mdloba, pád, po které se dotyčný nebudí nebo nechová jako normálně",
          "stavy s <strong>poruchou vědomí, řeči, vidění, hybnosti končetin</strong>",
          "celkové <strong>křeče těla</strong>"
        ]
      },
      {
        "title": "Infekce a horečky",
        "body": [
          "stavy provázené <strong>horečkou nad 40°C, která nejde snížit váze odpovídající dávkou léku</strong>",
          "<strong>zimnice u dětí, křeče u dětí při horečce</strong>",
          "opakované <strong>neztišitelné zvracení a průjmy u dětí</strong>, nedostatečný příjem tekutin u dětí",
          "infekce provázené celkovými změnami stavu/chování, jako výrazná spavost, nevůle, neschopnost jíst, pít"
        ]
      },
      {
        "title": "Alergie a otoky",
        "body": [
          "<strong>otok obličeje, krku a vevnitř v hrdle, otok jazyka</strong>",
          "<strong>dušnost</strong>",
          "<strong>potíže s polykáním</strong>",
          "celotělové projevy jako vyrážka nebo otok",
          "jednostranný, zejména bolestivý otok končetiny provázený případně dušností nebo suchým kašlem"
        ]
      },
      {
        "title": "Zubní pohotovost",
        "body": [
          "bolest zubů s výraznou bolestí hlavy",
          "bolest zubů s horečkami",
          "otoky tváře a v oblasti zubů postupující na krk nebo provázené potížemi s polykáním"
        ]
      },
      {
        "title": "Trestné činy",
        "body": [
          "v případě, že máte podezření na trestný čin, volejte 112",
          "pokud jde o život vám nebo někomu z blízkých v důsledku trestného činu volejte 112",
          "jde-li o šikanu, ubližování na těle i na duši, volejte 112"
        ]
      },
      {
        "title": "Psychika",
        "body": [
          "pokud jde o náhlý stav zmatenosti, změn chování, agresivitu, volejte sanitku",
          "pokud jde o hrozící sebevraždu, volejte sanitku"
        ]
      }
    ],
    "title2": "Volejte 155",
    "title": "Kdy vyhledat pohotovost"
  },
  "emergencyInfo": {
    "titleQuestion": "Dříve, než položíte dotaz",
    "titleonco-prevention": "Dříve, než položíte dotaz",
    "titleOrder": "Dříve, než položíte objednávku",
    "subtitle": "Služba uLékaře.cz nenahrazuje záchrannou službu.<br /><a href=\"{link}\" target=\"_blank\" class=\"black--text link--inline\">Kdy vyhledat pohotovost?</a>",
    "services": "Při akutních a život ohrožujících stavech vždy <a href=\"tel:155\" class=\"link--inline black--text\">volejte 155 nebo 112</a>.",
    "continueQuestion": "Pokračovat v dotazu",
    "continueOrder": "Pokračovat v objednávce",
    "dynamicForms": {
      "text": "uLékaře.cz nenahrazuje záchrannou službu. Při život ohrožujících stavech vždy volejte 155. {emergencyLink}?",
      "linkText": "Kdy vyhledat pohotovost"
    }
  },
  "evaluation": {
    "title": "Hodnocení návštěvy lékaře",
    "orderInfo": {
      "zz": "Zdravotnické zařízení",
      "orderDate": "Datum objednávky",
      "doctor": "Lékař"
    },
    "error": {
      "title": "Ohodnotit návštěvu lékaře můžete pouze jednou.",
      "perex": "Děkujeme, Vaše hodnocení jsme již obdrželi."
    },
    "form": {
      "sendTitle": "Děkujeme za ohodnocení návštěvy lékaře.",
      "title": "Byl/a jste spokojen/a s návštěvou lékaře?",
      "noVisit": "Lékaře jsem nenavštívil/a.",
      "moreInfo": "Doplňující informace",
      "evaluationError": "Prosíme o zpětnou vazbu.",
      "messageTitle": "Napište cokoliv dalšího, chcete-li nám něco sdělit."
    }
  },
  "partnerb2b": {
    "mastercard": {
      "hello": {
        "title": "Online poradna a&nbsp;objednání k&nbsp;lékaři",
        "perex": "Jako držitel prémiové či firemní karty Mastercard<sup>®</sup> můžete naplno využívat služeb uLékaře, mezi které patří online lékařská poradna, objednání k lékařům po celé ČR a celkově lepší péče o vaše zdraví."
      },
      "question": {
        "perex": "Váš dotaz zodpoví praktický lékař, popřípadě specialista."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Zeptejte se kdykoliv",
            "perex": "Odpověď praktického lékaře či pediatra dostanete do 6 hodin od položení svého dotazu.",
            "footer": "Často jsme rychlejší."
          },
          {
            "icon": "mail",
            "title": "Počkejte na odpověď",
            "perex": "Praktický lékař může požádat o doplnění odpovědi specialistu, například dermatologa, ortopeda&nbsp;aj.",
            "footer": "Pokrýváme všechny specializace."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechte se objednat",
            "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
            "footer": "Objednat se můžete i přímo, bez položení dotazu."
          }
        ]
      }
    },
    "eon": {
      "hello": {
        "title": "Online lékař pro zákazníky E.ONu",
        "perex": "Věrní zákazníci E.ONu teď mají lékařskou poradnu úplně zdarma. Pro sebe i&nbsp;celou rodinu. Ptejte se, konzultujte nebo se rovnou objednejte ke specialistovi po celé republice."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Zeptejte se kdykoliv",
            "perex": "Odpověď praktického lékaře či pediatra dostanete do 6 hodin od položení svého dotazu.",
            "footer": "Často jsme rychlejší."
          },
          {
            "icon": "mail",
            "title": "Počkejte na odpověď",
            "perex": "Praktický lékař může požádat o doplnění odpovědi specialistu, například dermatologa, ortopeda aj.",
            "footer": "Pokrýváme všechny specializace."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechte se objednat",
            "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
            "footer": "Objednat se můžete i přímo, bez položení dotazu."
          }
        ]
      },
      "question": {
        "perex": "Váš dotaz zodpoví praktický lékař, popřípadě specialista."
      },
      "faq": {
        "title": "Časté dotazy a odpovědi ke službě uLékaře.cz",
        "perex": "Možná i&nbsp;vás napadají otázky související s&nbsp;využitím služby lékařské online poradny a&nbsp;objednání k&nbsp;lékaři. Nabízíme vám odpovědi na nejčastější z&nbsp;nich.",
        "items": [
          {
            "title": "Můžu se zeptat na cokoliv?",
            "bodyText": "ANO, na vše, co se týká fyzického a&nbsp;duševního zdraví."
          },
          {
            "title": "Opravdu objednáváte ke všem lékařům?",
            "bodyText": "ANO, sestřičky z&nbsp;uLékaře.cz vás objednají k&nbsp;praktickému lékaři i&nbsp;specialistům všech oborů."
          },
          {
            "title": "Musím změnit svého lékaře?",
            "bodyText": "NEMUSÍTE, službu můžete využít i&nbsp;třeba jen pro získání dalšího lékařského názoru."
          },
          {
            "title": "Dozví se něco můj stávající lékař?",
            "bodyText": "NEDOZVÍ, vaše dotazy s&nbsp;nikým nesdílíme. Vše probíhá online a&nbsp;jen mezi vámi a&nbsp;lékařem z&nbsp;poradny, který na dotaz odpovídá."
          },
          {
            "title": "Budu něco platit za využití služby?",
            "bodyText": "Ne, služba je pro věrné zákazníky dostupná zdarma."
          },
          {
            "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
            "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i&nbsp;nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s&nbsp;ohledem na termín návštěvy a&nbsp;dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O&nbsp;případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
          },
          {
            "title": "Jak je zajištěna diskrétnost?",
            "bodyText": "Váš dotaz, křestní jméno a&nbsp;věk vidí pouze lékař, který vám odpovídá. K&nbsp;dalším informacím uvedeným v&nbsp;rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s&nbsp;objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s&nbsp;nikým sdíleny.<br/><br/> V&nbsp;případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a&nbsp;až poté přílohu nahrát k&nbsp;dotazu, aby byla dodržena naprostá anonymita i&nbsp;z&nbsp;vaší strany."
          },
          {
            "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
            "bodyText": "Nebudou."
          },
          {
            "title": "Je využití služby bezpečné?",
            "bodyText": "ANO, je. Služba je v&nbsp;souladu s&nbsp;obecným nařízením ochrany osobních údajů tzv.&nbsp;GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a&nbsp;určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením."
          }
        ]
      }
    },
    "sporthelp": {
      "hello": {
        "title": "Online poradna a objednání k lékaři",
        "perex": "SportHelp je komplexní služba pro amatérské sportovce. Zaměřuje se primárně na péči o jejich zdraví. Využití služeb online poradny uLékaře.cz je součástí vašeho členství SportHelp."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Zeptejte se kdykoliv",
            "perex": "Odpověď praktického lékaře či pediatra dostanete do 6 hodin od položení svého dotazu.",
            "footer": "Často jsme rychlejší."
          },
          {
            "icon": "mail",
            "title": "Počkejte na odpověď",
            "perex": "Praktický lékař může požádat o doplnění odpovědi specialistu, například dermatologa, ortopeda aj.",
            "footer": "Pokrýváme všechny specializace."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechte se objednat",
            "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
            "footer": "Objednat se můžete i přímo, bez položení dotazu."
          }
        ]
      },
      "question": {
        "perex": "Váš dotaz zodpoví praktický lékař, popřípadě specialista."
      },
      "faq": {
        "title": "Časté dotazy a odpovědi ke službě uLékaře.cz",
        "perex": "Možná i&nbsp;vás napadají otázky související s&nbsp;využitím služby lékařské online poradny a&nbsp;objednání k&nbsp;lékaři. Nabízíme vám odpovědi na nejčastější z&nbsp;nich.",
        "items": [
          {
            "title": "Můžu se zeptat na cokoliv?",
            "bodyText": "ANO, na vše, co se týká fyzického a&nbsp;duševního zdraví."
          },
          {
            "title": "Opravdu objednáváte ke všem lékařům?",
            "bodyText": "ANO, sestřičky z&nbsp;uLékaře.cz vás objednají k&nbsp;praktickému lékaři i&nbsp;specialistům všech oborů."
          },
          {
            "title": "Musím změnit svého lékaře?",
            "bodyText": "NEMUSÍTE, službu můžete využít i&nbsp;třeba jen pro získání dalšího lékařského názoru."
          },
          {
            "title": "Dozví se něco můj stávající lékař?",
            "bodyText": "NEDOZVÍ, vaše dotazy s&nbsp;nikým nesdílíme. Vše probíhá online a&nbsp;jen mezi vámi a&nbsp;lékařem z&nbsp;poradny, který na dotaz odpovídá."
          },
          {
            "title": "Budu něco platit za využití služby?",
            "bodyText": "Ne, využívání služby uLékaře.cz je součástí vašeho členství SportHelp."
          },
          {
            "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
            "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i&nbsp;nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s&nbsp;ohledem na termín návštěvy a&nbsp;dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O&nbsp;případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
          },
          {
            "title": "Jak je zajištěna diskrétnost?",
            "bodyText": "Váš dotaz, křestní jméno a&nbsp;věk vidí pouze lékař, který vám odpovídá. K&nbsp;dalším informacím uvedeným v&nbsp;rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s&nbsp;objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s&nbsp;nikým sdíleny.<br/><br/> V&nbsp;případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a&nbsp;až poté přílohu nahrát k&nbsp;dotazu, aby byla dodržena naprostá anonymita i&nbsp;z&nbsp;vaší strany."
          },
          {
            "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
            "bodyText": "Nebudou."
          },
          {
            "title": "Je využití služby bezpečné?",
            "bodyText": "ANO, je. Služba je v&nbsp;souladu s&nbsp;obecným nařízením ochrany osobních údajů tzv.&nbsp;GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a&nbsp;určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením."
          }
        ]
      }
    },
    "philips-sonicare": {
      "hello": {
        "title": "Online poradna a objednání k lékaři",
        "perex": "Jako předplatitelé hlavic Sonicare můžete kdykoliv naplno využívat online lékařskou poradnu s více jak 350 lékaři různých specializací, vyhledání a objednání k lékařům po celé ČR."
      },
      "question": {
        "perex": "Váš dotaz zodpoví praktický lékař, popřípadě specialista."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Zeptejte se kdykoliv",
            "perex": "Odpověď praktického lékaře či pediatra dostanete do 6 hodin od položení svého dotazu.",
            "footer": "Často jsme rychlejší."
          },
          {
            "icon": "mail",
            "title": "Počkejte na odpověď",
            "perex": "Praktický lékař může požádat o doplnění odpovědi specialistu, například dermatologa, ortopeda aj.",
            "footer": "Pokrýváme všechny specializace."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechte se objednat",
            "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
            "footer": "Objednat se můžete i přímo, bez položení dotazu."
          }
        ]
      },
      "faq": {
        "items": [
          {
            "title": "Můžu se zeptat na cokoliv?",
            "bodyText": "ANO, na vše, co se týká fyzického a duševního zdraví."
          },
          {
            "title": "Opravdu objednáváte ke všem lékařům?",
            "bodyText": "ANO, sestřičky z uLékaře.cz vás objednají k praktickému lékaři i specialistům všech oborů."
          },
          {
            "title": "Musím změnit svého lékaře?",
            "bodyText": "NEMUSÍTE, službu můžete využít i třeba jen pro získání dalšího lékařského názoru."
          },
          {
            "title": "Dozví se něco můj stávající lékař?",
            "bodyText": "NEDOZVÍ, vaše dotazy s nikým nesdílíme. Vše probíhá online a jen mezi vámi a lékařem z poradny, který na dotaz odpovídá."
          },
          {
            "title": "Budu něco platit za využití služby?",
            "bodyText": "NE, za využití lékařské online poradny nebo objednání k lékaři nic neplatíte. Nárok na využití služby zdarma získáte, pokud jste předplatitel výměnných hlavic Philips Sonicare."
          },
          {
            "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
            "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s ohledem na termín návštěvy a dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
          },
          {
            "title": "Jak je zajištěna diskrétnost?",
            "bodyText": "Váš dotaz, křestní jméno a věk vidí pouze lékař, který vám odpovídá. K dalším informacím uvedeným v rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s nikým sdíleny.<br/><br/> V případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a až poté přílohu nahrát k dotazu, aby byla dodržena naprostá anonymita i z vaší strany."
          },
          {
            "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
            "bodyText": "NEBUDOU, dotazy předplatitelů výměnných hlavic Philips Sonicare nejsou na stránkách zveřejňovány."
          },
          {
            "title": "Je využití služby bezpečné?",
            "bodyText": "ANO, je. Služba je v souladu s obecným nařízením ochrany osobních údajů tzv. GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením."
          }
        ]
      }
    }
  },
  "masterCard": {
    "faq": "Často kladené dotazy",
    "useService": "Zaregistrovat se",
    "menu": {
      "question": "Poradit se s lékařem",
      "appointment": "Objednat k lékaři",
      "contact": "Kontakt"
    },
    "howItWorks": {
      "title": "Jsme tu pro vás nonstop",
      "items": [
        {
          "icon": "chat",
          "title": "Zeptejte se kdykoliv",
          "perex": "Odpověď praktického lékaře či pediatra dostanete do 6 hodin od položení svého dotazu.",
          "footer": "Často jsme rychlejší."
        },
        {
          "icon": "mail",
          "title": "Počkejte na odpovědi",
          "perex": "Do 48 hodin obdržíte vyjádření také od specialisty (například dermatologa, ortopeda aj.).",
          "footer": "Pokrýváme všechny specializace."
        },
        {
          "icon": "calendar/date-31",
          "title": "Nechte se objednat",
          "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
          "footer": "Objednat se můžete i přímo, bez položení dotazu."
        }
      ]
    },
    "question": {
      "title": "Poradit se s lékařem",
      "perex": "Váš dotaz zodpoví praktický lékař a specialista."
    },
    "appointment": {
      "title": "Objednat k lékaři",
      "perex": "Sestra vám zavolá, vyhledá lékaře a objedná vás."
    },
    "authorization": {
      "title": "Ověřte si svoji kartu Mastercard<sup>®</sup>",
      "subtitle": {
        "question": "Potřebujeme ověřit prvních 6 čísel vaší karty <strong>Mastercard<sup>®</sup> Premium</strong>. Nejedná se o platbu, po úspěšném zadání budete moci využít služeb uLékaře.cz zdarma.",
        "appointment": "Potřebujeme ověřit prvních 6 čísel vaší karty <strong>Mastercard<sup>®</sup> Premium</strong>. Nejedná se o platbu, po úspěšném zadání budete moci využít služeb uLékaře.cz zdarma."
      },
      "codeLabel": "Prvních 6 čísel vaší karty:",
      "codeError": "Zadané číslo není validní. Zkontrolujte, prosím, že zadáváte 6 čísel své prémiové či firemní karty Mastercard<sup>®</sup>.",
      "sendButton": "Ověřit"
    }
  },
  "reauthorizationDashboard": {
    "heading": "Služba zdarma vám končí za {daysLeft} {dayFormat}.",
    "partnerText": "Službu uLékaře.cz vám doteď hradí {currentPartnerName}.",
    "prolongText": "Prodlužte si výhody služby uLékaře.cz, ať je máte nadále zdarma.",
    "prolongFamilyText": "Připomeňte svému blízkému, že byste chtěli službu prodloužit.",
    "buttonText": "Prodloužit zdarma",
    "inDay": "den",
    "inDaysLow": "dny",
    "inDaysHigh": "dní",
    "selfPayNowHeading": "Teď jste samoplátce. Ale nemusíte být.",
    "selfPayNowPartnerText": "Kdo vám zaplatí uLékaře.cz? Může to být zaměstnavatel, pojišťovna atd.",
    "selfPayNowProlongText": "Prodlužte si své výhody, ať máte službu zdarma. Zase jako dřív.",
    "selfPayNowFamilyPartnerText": "Připomeňte se svému blízkému {currentPartnerName}.",
    "selfPayNowFamilyPartnerInfoText": "Když si službu uLékaře.cz prodlouží, dostanete zpátky všechny výhody zdarma."
  },
  "thematicCounselling": {
    "partnerText": "Partner poradny"
  },
  "migraine": {
    "closed": {
      "title": "Pacientský program byl ukončen",
      "description": "Pacientský program Linka o migréně byl ukončen k 15.&nbsp;1.&nbsp;2022. Pokud se chcete poradit o svém zdravotním stavu s lékařem, můžete navštívit ",
      "link": "online poradnu uLékaře.cz"
    },
    "helloImage": "hello-migraine-figure.svg",
    "helloImageAlt": "Naše specializovaná poradna Linka o migréně vám může pomoci od bolestí hlavy a doprovodných projevů migrenózních záchvatů. Poradíme vám a nasměrujeme vás k účinné léčbě.",
    "partnerLogo": "mluvme-o-migrene",
    "dataProcessing": {
      "privacyPolicyTitle": "Souhlas se zpracováním mých osobních údajů, včetně osobních údajů zvláštní kategorie"
    },
    "menu": {
      "question": "Vyplnit dotazník",
      "helpWith": "S čím pomůžeme",
      "howItWorks": "Jak to funguje",
      "contact": "Kontakt"
    },
    "subTitle": "Linka o migréně",
    "perex": "Bojujete s migrénou, avšak neúspěšně? Díky spolupráci s partnerem Novartis vám nabízíme možnost zdarma a z bezpečí vašeho domova využít specializovanou poradnu. Vyplňte dotazník a zeptejte se na vše, co vás v souvislosti s migrénou a dalšími bolestmi hlavy trápí. Naši odborníci na bolesti hlavy udělají vše pro to, aby vás nasměrovali k účinné pomoci.",
    "infoTitle": "Jak vám pomůžeme?",
    "doctors": {
      "title": "Naši lékaři v poradně",
      "items": [
        "MUDr. Magdaléna Hlavačková",
        "MUDr. Markéta Bartoňová"
      ]
    },
    "infoList": [
      {
        "icon": "check_circle",
        "text": "Vyplňte prosím dotazník pro upřesnění svých potíží."
      },
      {
        "icon": "check_circle",
        "text": "Náš lékař na základě Vašich odpovědí posoudí, o jaký typ bolestí hlavy se jedná, a poradí, jak na ně."
      },
      {
        "icon": "check_circle",
        "text": "Reakci lékaře obdržíte e-mailem do 48 hodin."
      },
      {
        "icon": "check_circle",
        "text": "Nasměrujeme vás dále k léčbě nebo objednání k patřičnému odborníkovi do ambulance či specializovaného centra."
      }
    ],
    "question": "Vyplnit dotazník",
    "rules": "Pravidla poradny \"Linka o migréně\"",
    "howItWorks": {
      "title": "Jak naše služba funguje?",
      "items": [
        {
          "icon": "chat",
          "title": "Tematická poradna je zdarma."
        },
        {
          "icon": "mail",
          "title": "Lékař vám odpoví e-mailem do 48 hodin."
        },
        {
          "icon": "calendar/date-31",
          "title": "Naše sestřičky vám pomohou s objednáním."
        }
      ]
    },
    "form": {
      "title": "Dotazník",
      "thankYou": {
        "title": "Váš dotazník byl úspěšně odeslán",
        "perex": "Vaše odpovědi vyhodnotí lékař a doporučí další postup.",
        "bannerImg": "omigrene-banner.jpg",
        "button": "Pro více informací navštivte web omigrene.cz",
        "buttonLink": "https://omigrene.cz"
      }
    },
    "agreements": {
      "privacyPolicy": "<p>Souhlasím, aby společnost uLékaře.cz, s.r.o., se sídlem Šafaříkova 201/17, 120 00 Praha 5, IČO 05341051 (dále jen „Společnost“), zpracovávala mé osobní údaje pro účely mé registrace a využití služeb v rámci projektu uLékaře.cz, jehož součástí je projekt Linka o migréně. Projekt uLékaře.cz je tvořen zejména specializovanými internetovými stránkami, mobilními aplikacemi a profily na sociálních sítích (dále jen “projekt uLékaře.cz”). Projekt Linka o migréně je potom tvořen obsahem s&nbsp;informacemi a poradenstvím pro uživatele v&nbsp;oblasti uvedeného onemocnění. Projekt uLékaře.cz je provozovaný Společností v souladu se zákonem č. 101/2000 Sb., o ochraně osobních údajů (dále jen „zákon o ochraně osobních údajů“) ve znění pozdějších předpisů a v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů (dále jen „obecné nařízení o ochraně osobních údajů“). Souhlas se zpracováním dávám maximálně na období 10 let od mé poslední aktivity nebo do odvolání tohoto mého souhlasu.</p><p>Současně souhlasím, aby Společnost zpracovávala mé osobní údaje zvláštní kategorie, konkrétně pak o mém zdravotním stavu, a to za účelem:</p><ul><li>vypracování odpovědi odborníka v rámci projektu uLékaře.cz, a/nebo</li><li>předání vhodnému zdravotnickému zařízením za účelem dalších konzultací či spolupráce ve věci mého zdravotnického stavu.</li></ul><p>Výslovně tedy souhlasím, aby Společnost mnou poskytnuté osobní údaje, a to jak jmenné a adresné, tak osobní údaje zvláštní kategorie týkající se mého zdravotního stavu, zpracovávala a dále poskytla spolupracujícím&nbsp;<a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">zdravotnickým zařízením</a>, se kterými má Společnost uzavřená zvláštní ujednání o zárukách při zpracování osobních údajů a zvláštní kategorie osobních údajů. Aktuální seznam spolupracujících zdravotnických zařízení shledávám v rámci uvedeného hyperlinku.</p><p>Dále souhlasím, aby Společnost mnou poskytnuté osobní údaje, a to jak jmenné a adresné, tak osobní údaje zvláštní kategorie týkající se mého zdravotního stavu, zpracovávala a dále poskytla&nbsp;<a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">spolupracujícím odborníkům</a>, kteří se budou zabývat mými dotazy v rámci poradny projektu uLékaře.cz na základě mého výslovného požadavku.</p><p>Dále souhlasím, že v&nbsp;případě, budu-li ze strany Společnosti kontaktován ve věci užití služeb Společnosti telefonicky, budou takovéto telefonáty nahrávány za účelem zajištění informací o uzavírání smlouvy či kvality poskytovaných služeb.</p><p>Potvrzuji, že jsem obeznámen se svými právy související se zpracováním dle výše zmíněných právních předpisů, a to jak ve vztahu k osobním údajům, tak i ke zvláštní kategorii osobních údajů, zejména pak:</p><ul><li>s právem na přístup ke svým osobním údajům, jejich opravu nebo jejich výmaz, popřípadě s omezením zpracování;</li><li>s právem vznést námitku proti zpracování;</li><li>s právem na přenositelnost údajů ve strukturovaném, běžně používaném a strojově čitelném formátu;</li><li>s právem kdykoliv souhlas se zpracováním odvolat;</li><li>a s právem podat stížnost u dozorového úřadu, kterým je Úřad pro ochranu osobních údajů.</li></ul><p>Současně potvrzuji, že jsem obeznámen se způsobem nakládání s mými osobními údaji a jejich zpracováním vč. zvláštní kategorie osobních údajů, zejména že:</p><ul><li>mé osobní údaje jsou zpracovány pouze v rozsahu, ve kterém byly mnou poskytnuty a pouze pro shora uvedené účely;</li><li>Společnost provádí s mými údaji následující úkony: ukládá je do databáze uživatelů, upravuje je v případě, že je doplním nebo se dožádám úpravy, vyhledává je v rámci své databáze, třídí je dle jednotlivých kritérií pro dotazy poradny a likviduje je po uplynutí shora uvedené lhůty pro zpracování nebo po odvolání mého souhlasu.</li><li>mé údaje Společnost poskytuje zpracovatelům z řad <a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">zdravotnických zařízení nebo odborníkům</a> zpracovávajícím mé výslovně položené dotazy.</li><li>partnerem projektu Linka o migréně je společnost Novartis; tato společnost však není zpracovatelem osobních údajů z&nbsp;projektu Linka o migréně, z&nbsp;tohoto projektu jsou jí dostupná pouze anonymizovaná základní data o použití poradny (bez jmenných a adresných údajů uživatelů či bez zvláštní kategorie údajů o zdravotním stavu uživatelů) v&nbsp;podobě přehledu počtu položených dotazů a objednání.</li></ul><p>Současně beru na vědomí, že se v případě jakýchkoliv dotazů ohledně zpracování mých osobních údajů nebo v případě uplatnění výše uvedených práv mohu obrátit na pověřence pro ochranu osobních údajů Společnosti, kontakt <a href=\"mailto:stankova@stankovapartneri.cz\">stankova@stankovapartneri.cz</a>, nebo po další komunikaci ohledně mých osobních údajů, příp. odvolání souhlasu s jejich zpracováním mohu také využít adresu <a href=\"mailto:osobniudaje@ulekare.cz\">osobniudaje@ulekare.cz</a>.</p><p>Potvrzuji, že tímto dávám Společnosti výslovný souhlas a zákonný důvod pro zpracování mých osobních údajů vč. zvláštní kategorie údajů v souladu se zněním zákona o ochraně osobních údajů a obecným nařízením o ochraně osobních údajů.</p>"
    },
    "footer": "Společnost NOVARTIS s.r.o. je prezentována pouze logem na stránce poradny a marketingových materiálech pro uživatele. Získává pouze anonymizovaná, základní data o užití poradny v podobě přehledu počtu položených dotazů a objednání. Téma poradny, výběr lékaře či dalšího zdravotnického personálu a veškerá komunikace s pacienty je plně v režii společnosti uLékaře.cz."
  },
  "psoriasis": {
    "helloImage": "hello-psoriasis-figure.svg",
    "helloImageAlt": "Naše specializovaná poradna Jak vyzrát na lupénku vám může pomoci s léčbou psoriázy. Poradíme vám a nasměrujeme vás k účinné léčbě.",
    "partnerLogo": "novartis",
    "dataProcessing": {
      "personalDataTitle": "Souhlas se zpracováním mých osobních údajů, včetně osobních údajů zvláštní kategorie"
    },
    "closed": {
      "title": "Pacientský program Jak vyzrát na lupénku byl ukončen",
      "description": "Pacientský program Jak vyzrát na lupénku byl ukončen k 15.&nbsp;9.&nbsp;2022. Pokud se chcete poradit o svém zdravotním stavu s lékařem, můžete navštívit"
    },
    "menu": {
      "question": "Poradit se",
      "helpWith": "S čím pomůžeme",
      "howItWorks": "Jak to funguje",
      "contact": "Kontakt"
    },
    "subTitle": "Jak vyzrát na lupénku",
    "perex": "Léčíte se s lupénkou, avšak neúspěšně? Chcete o své nemoci vědět něco dalšího? Nebo máte kožní problémy a podezření, že by mohlo jít o lupénku? Pojďte vyplnit dotazník a zeptat se našich kožních lékařů v poradně uLékaře.cz.",
    "infoTitle": "Poradit se",
    "doctors": {
      "title": "Kdo na dotazy odpovídá?",
      "items": [
        "MUDr. Andrea Vocilková",
        "MUDr. Jitka Dobešová",
        "MUDr. Eva Dogoši"
      ]
    },
    "infoList": [
      {
        "icon": "register",
        "text": "Vyplňte prosím dotazník pro upřesnění svých potíží."
      },
      {
        "icon": "mail",
        "text": "Reakci lékaře obdržíte e-mailem do 48 hodin."
      },
      {
        "icon": "nurse",
        "text": "Nasměrujeme vás dále k léčbě nebo objednání k patřičnému odborníkovi do ambulance či specializovaného centra."
      }
    ],
    "question": "Vyplnit dotazník",
    "rules": "Pravidla poradny \"Linka o migréně\"",
    "howItWorks": {
      "title": "Jak služba funguje?",
      "items": [
        {
          "icon": "chat",
          "title": "Tematická poradna je zdarma, ptát se můžete opakovaně."
        },
        {
          "icon": "mail",
          "title": "Odpověď lékaře na svůj dotaz obdržíte e-mailem do 48 hodin."
        },
        {
          "icon": "calendar/date-31",
          "title": "Doporučí-li náš odborník osobní návštěvu lékaře, objednáme vás."
        }
      ]
    },
    "agreements": {
      "termsConditions": "<p>Tyto podmínky užití upravují práva a povinnosti návštěvníků a uživatelů (dále jen „Vy“ nebo „Uživatel“) webových stránek <a href=\"https://www.ulekare.cz\" target=\"_blank\">www.ulekare.cz</a>, část služba Jak vyzrát na lupénku, provozovaných společností uLékaře.cz, s.r.o., IČO 05341051, sídlem Praha 2, Šafaříkova 201/17, zapsanou v obchodním rejstříku Městského soudu v Praze pod sp. zn. C 262183 (dále jen „Provozovatel“), a dalších platforem (např. mobilní aplikace či stránek na sociálních sítích) provozovaných Provozovatelem, na které se tyto podmínky uplatní přiměřeně (dále společně jen „Web“) a služeb prostřednictvím Webu v rámci služby Jak vyzrát na lupénku poskytovaných (dále jen „Služby“, Web a Služby dále společně jen „uLékaře.cz“). Uživatel užitím služby uLékaře.cz vyjadřuje, že se seznámil s těmito podmínkami a souhlasí s nimi.</p><p><strong>1. Obsah Webu.</strong> Obsahem Webu jsou informace určené pro Uživatele z řad široké veřejnosti. Jedná se zejména o články z oboru zdravotnictví a zdravotnické péče určené pro širokou veřejnost, informace o probíhajících akcích spjatých s tématem zdraví a odkazy na jiné odborné stránky, organizace, odborníky a zdravotnická zařízení a dále informace poskytované na dotazy pokládané ze strany široké veřejnosti. Služba Jak vyzrát na lupénku je potom specializovaná služba v rámci Webu zaměřena na uživatele zajímající se o problém psoriázy, obsahuje dotazník určující potřeby těchto uživatelů, umožňuje objednání uživatelů do specializovaných center k léčbě psoriázy či umožňuje položit dotazy odborníkům v oblasti psoriázy.</p><p><strong>2. Účel uLékaře.cz.</strong> Účelem uLékaře.cz je zvyšovat informovanost široké veřejnosti v oblasti zdraví a zdravotnictví. Obsah uLékaře.cz má informativní charakter a v žádném případě nenahrazuje lékařskou péči; slouží jako alternativní a nezávazný zdroj informací. Provozovatel důrazně doporučuje vyhledat v případě zdravotních obtíží lékařskou či jinou odbornou péči. Užitím uLékaře.cz bere Uživatel na vědomí, že informace poskytnuté prostřednictvím uLékaře.cz mají obecnou platnost, přičemž nezohledňují individuální potřeby a zdravotní stav Uživatele a v případě, že má Uživatel zdravotní potíže, měl by se obrátit na lékaře či jiného odborníka.</p><p><strong>3. Registrace a uživatelský účet.</strong> Pro využívání některých služby Jak vyzrát na lupénku je nutná registrace Uživatele (dále jen „Registrace“), na základě které dochází k vytvoření účtu Uživatele (dále jen „Účet“). Registrace se provádí prostřednictvím formuláře a vyžaduje poskytnutí osobních údajů alespoň v rozsahu nezbytném pro využití dané Služby. Pro úspěšné dokončení registrace je třeba učinit kroky popsané na Webu vč. vyplnění dotazníku.</p><p><strong>4. Práva a povinnosti Uživatele.</strong> Užíváním uLékaře.cz Uživatel vyjadřuje seznámení se s těmito podmínkami a souhlas s nimi. Uživatel výslovně bere na vědomí a souhlasí s tím, že porušení těchto podmínek či právních předpisů může být důvodem pro odepření přístupu k uLékaře.cz a zrušení Účtu. Užíváním uLékaře.cz Uživatel prohlašuje a zaručuje, že je plně svéprávný a veškeré údaje poskytované prostřednictvím uLékaře.cz jsou úplné, pravdivé, přesné a správné. Uživatel je při užívání uLékaře.cz povinen jednat v souladu s těmito podmínkami a právními předpisy, zejména poškozovat či jinak nezasahovat do práva Provozovatele, Uživatelů či třetích osob a nezneužívat, neblokovat, neměnit či jiným způsobem nezasahovat do fungování uLékaře.cz. Uživatel je oprávněn prostřednictvím uLékaře.cz sdělovat informace o jiných osobách než je sám Uživatel pouze se souhlasem těchto osob; v případě, že Uživatel sděluje prostřednictvím uLékaře.cz informace o jiné osobě než je sám Uživatel, prohlašuje a zaručuje vůči Provozovateli, že má od těchto osob předchozí dobrovolný souhlas ke sdělení takových informací, Uživatel odpovídá za jakoukoliv újmu, která by mohla Provozovateli či jiným osobám vzniknout v případě, že by vyšlo najevo, že Uživateli souhlas se sdělením informací nebyl udělen.</p><p><strong>5. Poradna.</strong> Součástí uLékaře.cz je i poradna, v jejímž rámci odpovídají na dotazy Uživatelů lékaři a v případě některých oblastí další pracovníci v oblasti zdravotnictví (např. fyzioterapeuti, lékárníci či výživoví poradci) (dále jen „Spolupracovníci“) spolupracující s Provozovatelem (dále jen „Poradna“). V rámci Poradny jsou zodpovídány dotazy Uživatelů z oblasti zdraví a zdravotnictví, přičemž odpovědi jsou poskytovány na základě informací dostupných zodpovídajícímu Spolupracovníkovi. V rámci Poradny jsou vždy poskytovány obecné informace z oblasti zdraví, nemocí či jiných zdravotních obtíží, přičemž nedochází ke stanovení individuální diagnózy Uživatele, stanovení individuálního léčebného plánu či plánu prevence Uživatele, a to i s ohledem na omezené možnosti online komunikace. Poradna nenahrazuje lékařskou či jinou odbornou péči a nejedná se o individuální konzultaci s lékařem či jiným odborníkem ve zdravotnictví, Poradna slouží jako alternativní a nezávazný zdroj informací. Provozovatel Uživatelům důrazně doporučuje vyhledat v případě zdravotních obtíží lékařskou či jinou odbornou péči. Uživatel nese odpovědnost za následky způsobené nenavštívením lékaře či jiného odborníka.</p><p><strong>6. Využití Poradny.</strong> Pro položení dotazu v rámci Poradny je třeba vyplnit formulář umístěný na Webu a potvrdit seznámení se s těmito podmínkami užití. Pro poskytnutí Služby Poradny je nezbytné zpracovat osobní údaje Uživatele, včetně zvláštní kategorie údajů o zdravotním stavu, z tohoto důvodu potřebuje Provozovatel souhlas Uživatele k takovému zpracování osobních údajů. Se zásadami ochrany osobních údajů uLékaře.cz se můžete seznámit zde.</p><p><strong>7. Placení Poradny.</strong> Využití Poradny je zpoplatněno, nicméně pro uživatele služby Jak vyzrát na lupénku je poradna poskytována bezúplatně.</p><p><strong>8. Rychlost odpovědi.</strong> Odpovědi na dotaz položený v rámci Poradny jsou sdělovány ve standardní době jako v rámci poradny uLékaře.cz.</p><p><strong>9. Objednání.</strong> V rámci uLékaře.cz je poskytována Služba objednání Uživatele k lékaři. Provozovatel pak zprostředkuje kontakt mezi Uživatelem zvoleným poskytovatelem zdravotních služeb a Uživatelem (dále jen „Objednání“). Cena Objednání je zpoplatněna, nicméně pro uživatele v rámci služby Jak vyzrát na lupénku je poskytována bezúplatně. V rámci Objednání pro Uživatele Provozovatel zajistí zprostředkování kontaktu s Uživatelem zvoleným poskytovatelem zdravotních služeb, včetně domluvení vhodného termínu návštěvy poskytovatele zdravotních služeb. Poskytovatel zdravotních služeb z kapacitních či jiných důvodů může odmítnout využití Objednání a poskytnutí následných zdravotních služeb. Pro vyloučení pochybností se uvádí, že Objednání zahrnuje pouze zprostředkování kontaktu mezi Uživatelem a poskytovatelem zdravotních služeb. Následná komunikace mezi Uživatelem a zvoleným poskytovatelem zdravotních služeb, jakož i další poskytování služeb ze strany poskytovatele zdravotních služeb a podmínky poskytování zdravotních služeb je součástí vztahu Uživatele s daným poskytovatelem, do nějž není Provozovatel žádným způsobem zapojen.</p><p><strong>10. Autorský obsah.</strong> Web a jeho obsah jsou chráněny zejména zákonem č. 121/2000 Sb., o právu autorském, ve znění pozdějších předpisů a zákonem č. 89/2012 Sb., občanského zákoníku, ve znění pozdějších předpisů. Zveřejňování či jiné užití obsahu Webu pro komerční účely je možné pouze se souhlasem Provozovatele.</p><p><strong>11. Reklama.</strong> Web může obsahovat obchodní sdělení, která jsou označována v souladu s platnou právní úpravou, zejména pak v souladu se zákonem č. 40/1995. Sb., o regulaci reklamy, ve znění pozdějších předpisů.</p><p><strong>12. Spotřebitel.</strong> V případech, kdy je Uživatel ve vztahu k Provozovateli spotřebitelem a vznikne spotřebitelský spor, který se nepodaří vyřešit vzájemnou dohodou, může takový Uživatel podat návrh na mimosoudní řešení spotřebitelského sporu České obchodní inspekci (Ústřední inspektorát – oddělení ADR, sídlem Štěpánská 15, 120 00 Praha 2, e-mail: adr@coi.cz, web: adr.coi.cz). V těchto případech také může uživatel v postavení spotřebitele využít platformu pro řešení spotřebitelských sporů online, která je zřízena Evropskou komisí a je dostupná na internetové adrese: http://ec.europa.eu/consumers/odr/. Od smlouvy o dodání Služeb a obsahu prostřednictvím Webu dle těchto podmínek není možné odstoupit v souladu s ust. § 1837 písm. l) zákona č. 89/2012 Sb., občanský zákoník, ve znění pozdějších předpisů, podle nějž nemůže spotřebitel odstoupit od smlouvy o dodání digitálního obsahu.</p><p><strong>13. Odlišná ujednání.</strong> Tyto podmínky upravují užívání uLékaře.cz v rozsahu pro užití služby Jak vyzrát na lupénku.</p><p><strong>14. Změna webu.</strong> Provozovatel si vyhrazuje právo na změnu obsahu a přístupu k uLékaře.cz. K plánovaným zásadním změnám obsahu stránek a ke změnám jejich užívání bude vždy připojeno datum změny.</p><p><strong>15. Platnost podmínek užití.</strong> Platnost podmínek užití. Tyto podmínky, jakož i jejich případné změny, nabývají platnosti a účinnosti okamžikem jejich zveřejnění. Provozovatel může obchodní podmínky jednostranně měnit zveřejněním nových obchodních podmínek, přičemž změnou nejsou dotčena nabytá práva Uživatele.</p><p>Datum zveřejnění: 15. června 2021</p><p>uLékaře.cz, s.r.o.</p>",
      "privacyPolicy": "<p>Souhlasím, aby společnost uLékaře.cz, s.r.o., se sídlem Šafaříkova 201/17, 120 00 Praha 5, IČO 05341051 (dále jen „Společnost“), zpracovávala mé osobní údaje pro účely mé registrace a využití služeb v rámci projektu uLékaře.cz, jehož součástí je projekt Jak vyzrát na lupénku. Projekt uLékaře.cz je tvořen zejména specializovanými internetovými stránkami, mobilními aplikacemi a profily na sociálních sítích (dále jen “projekt uLékaře.cz”). Projekt Jak vyzrát na lupénku je potom tvořen obsahem s informacemi a poradenstvím pro uživatele v oblasti uvedeného onemocnění. Projekt uLékaře.cz je provozovaný Společností v souladu se zákonem č. 101/2000 Sb., o ochraně osobních údajů (dále jen „zákon o ochraně osobních údajů“) ve znění pozdějších předpisů a v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů (dále jen „obecné nařízení o ochraně osobních údajů“). Souhlas se zpracováním dávám maximálně na období 10 let od mé poslední aktivity nebo do odvolání tohoto mého souhlasu.</p><p>Současně souhlasím, aby Společnost zpracovávala mé osobní údaje zvláštní kategorie, konkrétně pak o mém zdravotním stavu, a to za účelem:</p><ul><li>vypracování odpovědi odborníka v rámci projektu uLékaře.cz, a/nebo</li><li>předání vhodnému zdravotnickému zařízením za účelem dalších konzultací či spolupráce ve věci mého zdravotnického stavu.</li></ul><p>Výslovně tedy souhlasím, aby Společnost mnou poskytnuté osobní údaje, a to jak jmenné a adresné, tak osobní údaje zvláštní kategorie týkající se mého zdravotního stavu, zpracovávala a dále poskytla spolupracujícím <a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">zdravotnickým zařízením</a>, se kterými má Společnost uzavřená zvláštní ujednání o zárukách při zpracování osobních údajů a zvláštní kategorie osobních údajů. Aktuální seznam spolupracujících zdravotnických zařízení shledávám v rámci uvedeného hyperlinku.</p><p>Dále souhlasím, aby Společnost mnou poskytnuté osobní údaje, a to jak jmenné a adresné, tak osobní údaje zvláštní kategorie týkající se mého zdravotního stavu, zpracovávala a dále poskytla <a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">spolupracujícím odborníkům</a>, kteří se budou zabývat mými dotazy v rámci poradny projektu uLékaře.cz na základě mého výslovného požadavku.</p><p>Dále souhlasím, že v případě, budu-li ze strany Společnosti kontaktován ve věci užití služeb Společnosti telefonicky, budou takovéto telefonáty nahrávány za účelem zajištění informací o uzavírání smlouvy či kvality poskytovaných služeb.</p><p>Potvrzuji, že jsem obeznámen se svými právy související se zpracováním dle výše zmíněných právních předpisů, a to jak ve vztahu k osobním údajům, tak i ke zvláštní kategorii osobních údajů, zejména pak:</p><ul><li>s právem na přístup ke svým osobním údajům, jejich opravu nebo jejich výmaz, popřípadě s omezením zpracování;</li><li>s právem vznést námitku proti zpracování;</li><li>s právem na přenositelnost údajů ve strukturovaném, běžně používaném a strojově čitelném formátu;</li><li>s právem kdykoliv souhlas se zpracováním odvolat;</li><li>a s právem podat stížnost u dozorového úřadu, kterým je Úřad pro ochranu osobních údajů.</li></ul><p>Současně potvrzuji, že jsem obeznámen se způsobem nakládání s mými osobními údaji a jejich zpracováním vč. zvláštní kategorie osobních údajů, zejména že:</p><ul><li>mé osobní údaje jsou zpracovány pouze v rozsahu, ve kterém byly mnou poskytnuty a pouze pro shora uvedené účely;</li><li>Společnost provádí s mými údaji následující úkony: ukládá je do databáze uživatelů, upravuje je v případě, že je doplním nebo se dožádám úpravy, vyhledává je v rámci své databáze, třídí je dle jednotlivých kritérií pro dotazy poradny a likviduje je po uplynutí shora uvedené lhůty pro zpracování nebo po odvolání mého souhlasu.</li><li>mé údaje Společnost poskytuje zpracovatelům z řad <a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">zdravotnických zařízení nebo odborníkům</a> zpracovávajícím mé výslovně položené dotazy.</li><li>partnerem projektu Jak vyzrát na lupénku je společnost Novartis; tato společnost však není zpracovatelem osobních údajů z projektu Jak vyzrát na lupénku, z tohoto projektu jsou jí dostupná pouze anonymizovaná základní data o použití poradny (bez jmenných a adresných údajů uživatelů či bez zvláštní kategorie údajů o zdravotním stavu uživatelů) v podobě přehledu počtu položených dotazů a objednání.</li></ul><p>Současně beru na vědomí, že se v případě jakýchkoliv dotazů ohledně zpracování mých osobních údajů nebo v případě uplatnění výše uvedených práv mohu obrátit na pověřence pro ochranu osobních údajů Společnosti, kontakt <a href=\"mailto:stankova@stankovapartneri.cz\">stankova@stankovapartneri.cz</a>, nebo po další komunikaci ohledně mých osobních údajů, příp. odvolání souhlasu s jejich zpracováním mohu také využít adresu <a href=\"mailto:osobniudaje@ulekare.cz\">osobniudaje@ulekare.cz</a>.</p><p>Potvrzuji, že tímto dávám Společnosti výslovný souhlas a zákonný důvod pro zpracování mých osobních údajů vč. zvláštní kategorie údajů v souladu se zněním zákona o ochraně osobních údajů a obecným nařízením o ochraně osobních údajů.</p>"
    },
    "form": {
      "title": "Dotazník",
      "thankYou": {
        "title": "Program Jak vyzrát na lupénku",
        "perex": "<p>Děkujeme za vyplnění dotazníku. Všechny údaje jsme právě odeslali ke zpracování.</p><p>Reakce lékaře vám bude zaslána na vámi zadaný e-mail do 48 h.</p><p>Dle doporučení lékaře vás bude kontaktovat zdravotní sestra a pomůže vám s objednáním k lékaři.</p>",
        "button": "Pro více informací navštivte web \"kuzeaklouby.cz\"",
        "buttonLink": "https://kuzeaklouby.cz"
      }
    },
    "footer": "Společnost NOVARTIS s.r.o. je prezentována pouze logem na stránce poradny a marketingových materiálech pro uživatele. Získává pouze anonymizovaná, základní data o užití poradny v podobě přehledu počtu položených dotazů a objednání. Téma poradny, výběr lékaře či dalšího zdravotnického personálu a veškerá komunikace s pacienty je plně v režii společnosti uLékaře.cz."
  },
  "hrbPage": {
    "hello": {
      "title": "Jsme vaším průvodcem na cestě za zdravím",
      "items": [
        {
          "text": "Jsme lékaři všech specializací.",
          "icon": "doctor"
        },
        {
          "text": "Jsme dostupní 24 hodin denně, 7 dní v týdnu.",
          "icon": "clock"
        },
        {
          "text": "Jsme tu pro vás i vaši rodinu.",
          "icon": "rodina"
        }
      ],
      "itemsVoZP": [
        {
          "text": "24 hodin denně, 7 dnů v týdnu",
          "icon": "clock"
        },
        {
          "text": "350 lékařů všech specializací",
          "icon": "prakrik"
        },
        {
          "text": "3 měsíce zdarma, dále za zvýhodněné předplatné",
          "icon": "checked"
        }
      ]
    },
    "advisory": "Poradna",
    "order": "Objednání",
    "myHealth": "Na zdraví",
    "infolines": "Infolinky",
    "contact": "Kontakt",
    "registration": "Registrace",
    "notification": {
      "title": "Od 25. - 17. listopadu bude probíhat den zdraví ve vaší firmě"
    },
    "hrbArticles": {
      "title": "Buďte zdraví",
      "items": [
        {
          "icon": "shield",
          "title": "Prevence nebolí",
          "perex": "Mějte svůj život pod kontrolou díky pravidelné péči o vlastní zdraví. Zjistěte si vše o prevenci a jejích možnostech.",
          "linkName": "Zjistit víc",
          "link": "hrbArticles",
          "params": {
            "slug": "prevence"
          },
          "lang": "cs"
        },
        {
          "icon": "umbrella",
          "title": "Pojišťovny pomáhají",
          "perex": "Zmapovali jsme příspěvky a benefity všech 7 zdravotních pojišťoven pro rok 2021. Víte, co nabízejí?",
          "linkName": "Získat přehled",
          "link": "hrbArticles",
          "params": {
            "slug": "pojistovny-pomahaji"
          },
          "lang": "cs"
        },
        {
          "icon": "news",
          "title": "Čtete? Čtěte!",
          "perex": "Bude mě bavit? Dozvím se něco nového? Dá se mu věřit? Třikrát ano. Náš časopis je zdraví prospěšný na všech svých stránkách.",
          "linkName": "Číst časopis",
          "linkType": "external",
          "link": "https://www.ulekare.cz/novy-casopis-ulekare-cz"
        }
      ],
      "itemsVoZP": [
        {
          "icon": "shield",
          "title": "Prevence nebolí",
          "perex": "Mějte svůj život pod kontrolou díky pravidelné péči o vlastní zdraví. Zjistěte si vše o prevenci a jejích možnostech.",
          "linkName": "Zjistit víc",
          "link": "hrbArticles",
          "params": {
            "slug": "prevence"
          },
          "lang": "cs"
        },
        {
          "icon": "umbrella",
          "title": "Vyzkoušejte si nás",
          "perex": "Po dobu 3 měsíců od aktivace služby je tu pro vás uLékaře.cz neomezeně a zdarma. Následně můžete získat zvýhodněné předplatné.",
          "linkName": "Zjistit víc",
          "link": "hrbArticles",
          "params": {
            "slug": "vyzkousejte-si-nas"
          },
          "lang": "cs"
        },
        {
          "icon": "news",
          "title": "Čtete? Čtěte!",
          "perex": "Bude mě bavit? Dozvím se něco nového? Dá se mu věřit? Třikrát ano. Náš časopis je zdraví prospěšný na všech svých stránkách.",
          "linkName": "Číst časopis",
          "linkType": "external",
          "link": "https://www.ulekare.cz/novy-casopis-ulekare-cz"
        }
      ]
    },
    "serviceVideo": {
      "title": "Nikdy nemáme zavřeno a nemusíte klepat",
      "videoUrl": "https://www.youtube.com/embed/NyEOmpO8UVc"
    },
    "counseling": {
      "title": "Poradna",
      "question": "Praktický lékař či pediatr odpoví do 6 hodin od položení dotazu.",
      "specialist": "Vyjádření specialisty získáte do 72 hodin.",
      "specialistVoZP": "Vyjádření specialisty získáte do 48 hodin.",
      "order": "Doporučí-li naši odborníci osobní návštěvu lékaře, objednáme vás.",
      "linkTitle": "Poradit se"
    },
    "ordering": {
      "title": "Objednání",
      "perex": [
        "Popište svůj zdravotní problém nebo uveďte, kterého lékaře hledáte.",
        "Najdeme vhodného odborníka ve vašem okolí.",
        "Objednáme vás na základě vašich časových možností."
      ],
      "linkTitle": "Objednat se"
    },
    "prevention": {
      "title": "Na zdraví",
      "perex": [
        "S naším preventivním programem předcházíte nemocem.",
        "Staráme se, aby vaše tělo i duše byly spokojené.",
        "Nasměrujeme vás, stačí uvést několik základních informací."
      ],
      "linkTitle": "Jdu do toho"
    },
    "faq": {
      "title": "Co vás zajímá?",
      "faqList": [
        {
          "title": "Můžu se zeptat na cokoliv?",
          "bodyText": "ANO, na vše, co se týká fyzického a duševního zdraví."
        },
        {
          "title": "Opravdu objednáváte ke všem lékařům?",
          "bodyText": "ANO, sestřičky z uLékaře.cz vás objednají k praktickému lékaři i specialistům všech oborů."
        },
        {
          "title": "Musím změnit svého lékaře?",
          "bodyText": "NEMUSÍTE, službu můžete využít i třeba jen pro získání dalšího lékařského názoru."
        },
        {
          "title": "Dozví se něco můj stávající lékař?",
          "bodyText": "NEDOZVÍ, vaše dotazy s nikým nesdílíme. Vše probíhá online a jen mezi vámi a lékařem z poradny, který na dotaz odpovídá."
        },
        {
          "title": "Budu něco platit za využití služby?",
          "bodyText": "NE, za využití lékařské online poradny nebo objednání k lékaři nic neplatíte. Službu můžete vy i vaše rodina neomezeně využívat v rámci předplatného svého zaměstnavatele."
        },
        {
          "title": "Budu něco platit lékaři, ke kterému mě objednáte?",
          "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s ohledem na termín návštěvy a dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
        },
        {
          "title": "Jak je zajištěna diskrétnost?",
          "bodyText": "Váš dotaz, křestní jméno a věk vidí pouze lékař, který vám odpovídá. K dalším informacím uvedeným v rámci vašeho požadavku má přístup jenom zdravotnický tým, jenž vám pomáhá s objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s nikým sdíleny. <br/> V případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a až poté nahrát přílohu k dotazu, aby byla dodržena naprostá anonymita i z vaší strany."
        },
        {
          "title": "Na www.ulekare.cz jsou ale dotazy uživatelů zobrazeny. Budou tam i moje?",
          "bodyText": "NE, nebudou. Dotazy osob, které mají službu aktivní díky zaměstnavateli, a to včetně rodinných příslušníků, nejsou na webových stránkách zveřejněny."
        },
        {
          "title": "Je využití služby bezpečné?",
          "bodyText": "ANO, je. Služba je v souladu s obecným nařízením ochrany osobních údajů tzv. GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením."
        }
      ],
      "faqListVoZP": [
        {
          "title": "Můžu se zeptat na cokoliv?",
          "bodyText": "ANO, na vše, co se týká fyzického a duševního zdraví."
        },
        {
          "title": "Opravdu objednáváte ke všem lékařům?",
          "bodyText": "ANO, sestřičky z uLékaře.cz vás objednají k praktickému lékaři i specialistům všech oborů."
        },
        {
          "title": "Musím změnit svého lékaře?",
          "bodyText": "NEMUSÍTE, službu můžete využít i třeba jen pro získání dalšího lékařského názoru."
        },
        {
          "title": "Dozví se něco můj stávající lékař?",
          "bodyText": "NEDOZVÍ, vaše dotazy s nikým nesdílíme. Vše probíhá online a jen mezi vámi a lékařem z poradny, který na dotaz odpovídá."
        },
        {
          "title": "Budu něco platit za využití služby?",
          "bodyText": "Služba je pro vás coby pojištěnce VoZP neomezeně dostupná po dobu 3 měsíců od registrace k využívání služby. Za využití lékařské online poradny nebo objednání k lékaři tedy po tuto dobu nic neplatíte. Pro další využívání služby vám následně bude poskytnuto zvýhodněné předplatné."
        },
        {
          "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
          "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s ohledem na termín návštěvy a dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
        },
        {
          "title": "Jak je zajištěna diskrétnost?",
          "bodyText": "Váš dotaz, křestní jméno a věk vidí pouze lékař, který vám odpovídá. K dalším informacím uvedeným v rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s nikým sdíleny.<br/><br/>V případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a až poté přílohu nahrát k dotazu, aby byla dodržena naprostá anonymita i z vaší strany."
        },
        {
          "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
          "bodyText": "NEBUDOU, dotazy osob, které mají službu aktivní díky tomu, že jsou klienty VoZP, nejsou na stránkách zveřejněny."
        },
        {
          "title": "Je využití služby bezpečné?",
          "bodyText": "ANO, je. Služba je v souladu s obecným nařízením ochrany osobních údajů tzv. GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením. Zaměstnavatel dostává pouze obecný report o celkovém využití služby a kategorie řešených zdravotních problémů."
        }
      ]
    },
    "employeeStories": {
      "title": "Příběhy z naší poradny",
      "stories": [
        {
          "name": "Pomohl druhý lékařský názor",
          "perex": "Maminka 7letého chlapce si v naší poradně ověřovala správnost postupu léčby ošetřující kožní lékařky, k níž docházejí. Jejího syna dlouhodobě trápila urputná vyrážka, na niž nezabírala dosavadní léčba. Byl mu proto předepsán lék na předpis, o kterém se žena při vyzvednutí v lékárně dozvěděla, že je určený dospělým. Díky tomu, že přiložila fotografii postiženého místa, mohla lékařka v naší poradně potvrdit stávající diagnózu i vhodnost zvolené léčby."
        },
        {
          "name": "Spadl jí kámen ze srdce",
          "perex": "Jedné z našich uživatelek její gynekolog sdělil diagnózu v podobě dvou zkratek a bez dalšího vysvětlení ji poslal na další vyšetření. Ženu okamžitě ovládl strach, že se za těmi strašidelně znějícími zkratkami skrývá přízrak rakoviny. Lékaři z naší poradny ji oba shodně uklidnili, že se jedná o přednádorový stav, který je poměrně častý a automaticky neznamená, že trpí onkologickým onemocněním. To by muselo potvrdit další vyšetření. Žena zareagovala s pocity vděčnosti a slovy, že „jí spadl ze srdce velký kámen“."
        },
        {
          "name": "Z naší poradny zamířil rovnou k lékaři",
          "perex": "Mladý muž se na naši poradnu obrátil s dotazem na posouzení znaménka na břiše, které se mu „nepozdávalo“, připojil fotografii daného znaménka a uvedl jeho přibližné rozměry. Specialisté v naší poradně jen ze snímku sice nemohli určit jeho povahu, ale bylo z něj dostatečně zřejmé, že znaménko vykazuje jistou asymetrii a nerovnost okrajů. Na základě bezodkladného doporučení absolvovat specializované vyšetření byl tento muž objednán naší sestřičkou na nejbližší možný termín na dermatologii v místě bydliště."
        }
      ]
    },
    "contactUs": {
      "title": "Zákaznická linka",
      "subTitle": "Nevíte si rady? Potřebujete pomoct s vyplněním formuláře?"
    },
    "covidLink": {
      "title": "Covid infolinka",
      "callUs": "Zavolejte nám",
      "hours": "Po–Pá 8:00–17:00",
      "tooltip": {
        "title": "S čím vám poradíme?",
        "text": [
          "Příznaky onemocnění",
          "Rizikové skupiny",
          "Koronavirus a těhotenství",
          "Testování",
          "Preventivní a hygienická opatření"
        ]
      }
    },
    "asistLink": {
      "title": "SOS psychická pomoc",
      "subtitle": "psychologické, právní a finanční poradenství",
      "email": "info@e-a.cz",
      "phone": "+420 234 768 710"
    }
  },
  "hrbPageInactive": {
    "title": "Litujeme, služba již není dostupná.<br/>Pokud máte zájem službu opět využívat, požádejte své HR/personální oddělení.",
    "subtitle": "Službu uLékaře.cz můžete využívat soukromě.",
    "getHelp": "Poradit se"
  },
  "authorization": {
    "title": "Aktivace služby",
    "subtitle": "Zadejte svůj firemní e-mail nebo kód, který jste obdrželi od zaměstnavatele, a dál postupujte podle pokynů. Službu uLékaře.cz už máte na dosah!",
    "subtitleEmail": "Zadejte svůj firemní e-mail nebo kód, který jste obdrželi od zaměstnavatele, a dál postupujte podle pokynů. Službu uLékaře.cz už máte na dosah!",
    "subtitleCode": "Zadejte svůj firemní e-mail nebo kód, který jste obdrželi od zaměstnavatele, a dál postupujte podle pokynů. Službu uLékaře.cz už máte na dosah!",
    "emailLabel": "E-mail",
    "codeLabel": "Kód",
    "codeHrbError": "Neplatný kód",
    "codeLengthError": "Kód musí obsahovat 2-20 znaků.",
    "or": "nebo",
    "contactTitle": "Nevíte si rady?",
    "sendMessage": "Ve svém e-mailu najdete zprávu od uLékaře.cz. Klikněte na odkaz obsažený uvnitř, tím schválíte přístup ke službě.",
    "changeEmail": "Změnit e-mail",
    "final": {
      "thankYouTitle": "Aktivace služby",
      "thankYouSubtitle": "Vše je nastaveno.",
      "infoHeading": "Skvělé! Aktivace proběhla úspěšně.",
      "infoText": "Užijte si svou službu zdarma\nnaplno už dnes."
    }
  },
  "checkToken": {
    "generateToken": "Zaslat nový odkaz",
    "expired": {
      "title": "Odkazu vypršela platnost",
      "perex": "Z bezpečnostních důvodů mají odkazy omezenou platnost. Zkuste si nechat zaslat odkaz nový."
    },
    "invalid": {
      "title": "Odkaz je již neplatný",
      "perex": "Zadaný odkaz již nefunguje. Může to být jeho použitím, nebo změnou podmínek."
    },
    "tokenCreated": {
      "title": "Odkaz byl odeslán.",
      "perex": "Na váš firemní e-mail jsme vám zaslali nový odkaz. Aktivaci dokončíte kliknutím na tento odkaz v e-mailu."
    }
  },
  "confirmation": {
    "title": "Potvrzení e-mailu",
    "subtitle": "Klikněte na odkaz zaslaný na e-mail <strong class='text-primary'>{email}</strong> a tím potvrdíte e-mail pro komunikaci se službou uLékaře.cz."
  },
  "hrbRegistration": {
    "title": "Registrace do poradny",
    "perex": "Prevence je důležitou součástí péče o vlastní zdraví. Díky ní můžete už dnes předcházet zdravotním potížím a onemocněním. Rádi vám s tím pomůžeme.",
    "firstSection": "Zaregistrujte se prostřednictvím online formuláře a neomezeně využívejte služby uLékaře.cz.<br/><br/>Jako klient VoZP získáte službu na 3 měsíce zdarma.",
    "checkToken": {
      "error": {
        "title": "Litujeme, ale vaši registraci nebylo možné potvrdit.",
        "subtitle": "Odkaz pro potvrzení je neplatný nebo jeho platnost vypršela. Jděte prosím na stránku <a href=\"https://kp.vozp.cz\">kp.vozp.cz</a> a znovu klikněte na registrační odkaz v klientském portálu."
      }
    },
    "success": {
      "header": "Registrace dokončena",
      "title": "Registrace proběhla úspěšně.",
      "subtitle": "Dále je třeba potvrdit odkaz zaslaný na váš e&#8209;mail <strong class=\"text-primary\">{email}</strong>. Dokončete prosím aktivaci kliknutím na tento odkaz v e&#8209;mailu."
    },
    "unfinishedRegistration": {
      "title": "Pro dokončení registrace je nutné ověřit váš e-mail.",
      "subtitle": "Prosíme o ověření e-mailu pro komunikaci se službou uLékaře.cz. Potvrďte odkaz zaslaný na e-mail."
    },
    "header": {
      "registrationForm": "Registrace",
      "faq": "Časté dotazy"
    },
    "infoList": [
      {
        "text": "<strong>Lékařská online poradna</strong><br/>Naši praktičtí lékaři a specialisté vám poradí v otázkách zdraví. Zeptat se můžete na cokoliv, co vás v souvislosti se zdravím trápí. Odpověď praktického lékaře obdržíte do 6 hod. od položení dotazu, návazné vyjádření specialisty do 48 hod.",
        "icon": "checked"
      },
      {
        "text": "<strong>Objednání k lékaři</strong><br/>Doporučí-li vám naši odborníci osobní návštěvu lékaře, náš zdravotní tým se o vše potřebné postará. Službu objednání můžete využít i samostatně (bez položení dotazu). Objednáváme po celé ČR, místo a termín objednání se odvíjí od vašeho přání.",
        "icon": "checked"
      },
      {
        "text": "<strong>Prevence</strong><br/>Prostřednictvím e-mailových zdravotních výzev vás budeme informovat o novinkách v prevenci a posílat vám inspirativní návody, jak o své celkové zdraví co nejlépe pečovat. V rámci využití naší služby připravujeme také speciální preventivní nabídky.",
        "icon": "checked"
      }
    ]
  },
  "hrbForm": {
    "title": "Využijte službu uLékaře.cz",
    "problem": {
      "text": "Napište, jak se zdravotní problém projevuje a jak dlouho trvá.",
      "placeholder": "Čím více informací nám poskytnete, tím přesnější dostanete odpověď lékaře.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "help": {
      "text": "Na co se našich lékařů chcete zeptat?",
      "placeholder": "Položte lékaři otázku.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "medication": {
      "text": "Uveďte další informace týkající se vašeho zdravotního stavu.",
      "placeholder": "Např. s kterými dalšími nemocemi se léčíte, které léky berete pravidelně, jestli máte nějaké alergie a jaké jsou výsledky vyšetření.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "order": {
      "question": {
        "text": "Jaké potíže řešíte? Jak vám můžeme pomoci?",
        "placeholder": "K jakému lékaři potřebujete objednat?",
        "errorText": "Vyplňte, prosím, toto pole."
      }
    },
    "agreements": {
      "iAgree": "Odesláním formuláře souhlasím s ",
      "conditions": "Podmínkami užití",
      "service": "služby uLékaře.cz."
    },
    "thankYou": {
      "question": {
        "title": "Děkujeme. Váš dotaz byl odeslán.",
        "perex": "Dotaz nyní předáme lékaři a ten na něj zareaguje.<br/>Odpověď obdržíte v e-mailu.",
        "button": "Nový dotaz"
      },
      "appointment": {
        "title": "Děkujeme. Vaše objednávka byla přijata.",
        "perex": "Vyčkejte, prosím, na telefonát zdravotní sestry",
        "button": "Nová objednávka"
      },
      "prevention": {
        "title": "Vaše registrace do preventivního programu uLékaře.cz proběhla úspěšně.",
        "content": {
          "start": "Na vašem zdraví nám záleží. Pomůžeme vám o něj lépe pečovat a předcházet tak nemocem a vážným zdravotním potížím.",
          "list": [
            "Prostřednictvím e-mailových preventivních výzev vám budeme pravidelně zasílat tipy, jak posilovat své zdraví či které preventivní prohlídky a příspěvky nabízené vaší zdravotní pojišťovnou si nenechat ujít.",
            "Díky našim zdravotním výzvám a informacím budete vždy mít aktuální přehled, jak se starat o sebe i své blízké. Veškerý obsah přitom připravujeme ve spolupráci s odborníky na daná témata.",
            "V následujících měsících na webu přibude možnost objednání na preventivní prohlídky a vyšetření a tematická poradna, která vám umožní zeptat se na vše, co vás v souvislosti s prevencí zajímá. Zároveň vás k lékaři rádi objednáme.",
            "V přípravě jsou také inspirativní články i videa a zejména kalendář prohlídek a očkování pro vaše osobní využití."
          ],
          "questionnaire": {
            "start": "Chcete zjistit, jak na tom s prevencí ve svém životě jste a zároveň nám tím pomoci v přípravě dalších částí preventivního programu na míru vašim potřebám?",
            "middle": "Stačí vyplnit jednoduchý dotazník s 10 otázkami:",
            "link": "https://www.survio.com/survey/d/X7L8A2K3B4U9R5I0G"
          },
          "thankYou": "Děkujeme.<br/><br/>Tým uLékaře.cz"
        }
      },
      "registrationVoZP": {
        "title": "Vaše registrace k užívání služby uLékaře.cz proběhla úspěšně.",
        "content": {
          "start": "Na vašem zdraví nám záleží. Pomůžeme vám o něj lépe pečovat a předcházet tak nemocem a vážným zdravotním potížím. Jako klient VoZP můžete službu využívat neomezeně po zkušební dobu 3 měsíců, následně vám bude nabídnuto zvýhodněné předplatné.",
          "list": [
            "Nyní můžete v naší poradně položit jakýkoliv dotaz týkající se vašeho zdravotního stavu. Vždy vám odpoví praktický lékař a následně specialista.",
            "Naše zdravotní sestry vám mohou pomoci s vyhledáním lékaře kterékoliv specializace na základě vašeho přání.",
            "Prostřednictvím e-mailových preventivních výzev vám budeme pravidelně zasílat tipy, jak posilovat své zdraví či které preventivní prohlídky si nenechat ujít.",
            "Díky našim zdravotním výzvám a informacím budete vždy mít aktuální přehled, jak se starat o sebe i své blízké. Veškerý obsah přitom připravujeme ve spolupráci s odborníky na daná témata.",
            "V následujících měsících na webu přibude možnost objednání na preventivní prohlídky a vyšetření a také tematická poradna, která vám umožní zeptat se na vše, co vás v souvislosti s prevencí zajímá. Zároveň vás k lékaři rádi objednáme.",
            "V přípravě jsou také inspirativní články i videa a zejména kalendář prohlídek a očkování pro vaše osobní využití."
          ],
          "questionnaire": {
            "start": "Chcete zjistit, jak na tom s prevencí ve svém životě jste a zároveň nám tím pomoci v přípravě dalších částí preventivního programu na míru vašim potřebám?",
            "middle": "Stačí vyplnit jednoduchý dotazník s 10 otázkami:",
            "link": "https://www.survio.com/survey/d/X7L8A2K3B4U9R5I0G"
          },
          "thankYou": "Děkujeme.<br/><br/>Tým uLékaře.cz"
        }
      }
    }
  },
  "masterCardFAQ": {
    "title": "Časté dotazy a odpovědi ke službě uLékaře.cz",
    "perex": "Možná i&nbsp;vás napadají otázky související s&nbsp;využitím služby lékařské online poradny a&nbsp;objednání k&nbsp;lékaři. Nabízíme vám odpovědi na nejčastější z&nbsp;nich.",
    "list": [
      {
        "title": "Můžu se zeptat na cokoliv?",
        "bodyText": "ANO, na vše, co se týká fyzického a&nbsp;duševního zdraví."
      },
      {
        "title": "Opravdu objednáváte ke všem lékařům?",
        "bodyText": "ANO, sestřičky z&nbsp;uLékaře.cz vás objednají k&nbsp;praktickému lékaři i&nbsp;specialistům všech oborů."
      },
      {
        "title": "Musím změnit svého lékaře?",
        "bodyText": "NEMUSÍTE, službu můžete využít i&nbsp;třeba jen pro získání dalšího lékařského názoru."
      },
      {
        "title": "Dozví se něco můj stávající lékař?",
        "bodyText": "NEDOZVÍ, vaše dotazy s&nbsp;nikým nesdílíme. Vše probíhá online a&nbsp;jen mezi vámi a&nbsp;lékařem z&nbsp;poradny, který na dotaz odpovídá."
      },
      {
        "title": "Budu něco platit za využití služby?",
        "bodyText": "NE, za využití lékařské online poradny nebo objednání k&nbsp;lékaři nic neplatíte. Nárok na využití služby zdarma získáte, pokud jste držitelem prémiové či firemní karty Mastercard<sup>®</sup>.<br/><br/><strong>Prémiové karty:</strong><ul><li>Mastercard<sup>®</sup> Gold</li><li>Mastercard<sup>®</sup> Platinum</li><li>Mastercard<sup>®</sup> World</li><li>Mastercard<sup>®</sup> World Elite</li></ul><strong>Firemní karty:</strong><ul><li>Mastercard<sup>®</sup> Business</li><li>Mastercard<sup>®</sup> Corporate</li></ul>"
      },
      {
        "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
        "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i&nbsp;nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s&nbsp;ohledem na termín návštěvy a&nbsp;dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O&nbsp;případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
      },
      {
        "title": "Jak je zajištěna diskrétnost?",
        "bodyText": "Váš dotaz, křestní jméno a&nbsp;věk vidí pouze lékař, který vám odpovídá. K&nbsp;dalším informacím uvedeným v&nbsp;rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s&nbsp;objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s&nbsp;nikým sdíleny.<br/><br/> V&nbsp;případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a&nbsp;až poté přílohu nahrát k&nbsp;dotazu, aby byla dodržena naprostá anonymita i&nbsp;z&nbsp;vaší strany."
      },
      {
        "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
        "bodyText": "NEBUDOU, dotazy držitelů prémiové či firemní karty Mastercard<sup>®</sup> nejsou na stránkách zveřejňovány."
      },
      {
        "title": "Je využití služby bezpečné?",
        "bodyText": "ANO, je. Služba je v&nbsp;souladu s&nbsp;obecným nařízením ochrany osobních údajů tzv.&nbsp;GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a&nbsp;určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením."
      }
    ]
  },
  "preventionForm": {
    "title": "Řekněte nám o sobě více",
    "subtitle": "Pokud by naši lékaři usoudili, že je potřeba váš zdravotní problém řešit návštěvou lékaře, potřebujeme o vás pro objednání znát další informace.",
    "birthDate": {
      "title": "Datum narození",
      "helpText": "Datum narození uveďte ve tvaru den, měsíc, rok, např. 21.1.1999.",
      "errorText": "Vyplňte datum narození.",
      "errorTextDate": "Datum narození není ve správném formátu.",
      "errorTextBirthDateRange": "Uveďte správné datum narození."
    },
    "gender": {
      "title": "Pohlaví",
      "selectGender": "Vyberte pohlaví",
      "errorText": "Vyberte pohlaví.",
      "male": "Muž",
      "female": "Žena",
      "other": "Jiné"
    },
    "language": {
      "title": "Jazyk",
      "selectLanguage": "Vyberte jazyk pro komunikaci",
      "errorText": "Vyberte jazyk pro komunikaci. "
    },
    "preventiveCheckUp": {
      "title": "Preventivní prohlídky a očkování",
      "examinationTitle": "Prosím vyberte <strong>zdravotní prohlídky</strong>, které jste absolvovali (nepovinné):",
      "examinationDate": "Kdy jste vyšetření naposledy absolvoval?",
      "vaccinationDate": "Kdy jste očkování naposledy absolvoval?",
      "examinationsSubtitle": "Byla součástí poslední kontroly tato vyšetření?",
      "vaccinationTitle": "Prosím vyberte <strong>očkování</strong>, které jste absolvovali (nepovinné):",
      "nameExamination": "Název vyšetření",
      "examinationSelectBtn": "Vyberte zdravotní prohlídky ze seznamu",
      "vaccinationSelectBtn": "Vyberte očkování ze seznamu.",
      "dateRange": {
        "range_1": "Letos",
        "range_2": "Loni",
        "range_3": "Předloni",
        "range_4": "Nepamatuji si",
        "range_5": "Nikdy"
      },
      "otherTitle": "Název vyšetření",
      "selectYear": "Zadejte rok",
      "iAmNotSure": "Nepamatuji si"
    },
    "address": {
      "title": "Adresa (nepovinné)",
      "placeholder": "Zadejte polohu"
    },
    "registeredModal": {
      "title": "Děkujeme",
      "subtitle": "Vaše registrace do preventivního programu již proběhla."
    }
  },
  "ulekareContacts": {
    "email": "info@ulekare.cz",
    "phone": " +420&nbsp;227&nbsp;072&nbsp;720",
    "hours": "Po–Pá 8.00–17.00&nbsp;h"
  },
  "authorizationPage": {
    "title": "Ověření proběhlo úspěšně",
    "successText": "Službu zdarma můžete začít používat hned teď.",
    "prevention": {
      "title": "Děkujeme. Autorizace proběhla úspěšně.",
      "subtitle": "Klikněte na odkaz zaslaný na e-mail <strong class=\"text-primary\">{email}</strong>."
    }
  },
  "verification": {
    "title": "Příhlášení k preventivnímu programu proběhlo úspěšně.",
    "subtitle": "Děkujeme za ověření e-mailu. "
  },
  "errorModal": {
    "title": "Ajaj, tahle stránka se teď necítí dobře",
    "subtitle": "<p>Na naší straně došlo k technické chybě.</p>\n\n<p><strong>Co dál?</strong></p>\n<ul>\n  <li>Obnovte stránku pomocí Ctrl + F5 (Windows) nebo Cmd + Shift + R (macOS).</li>\n  <li>Odhlaste se a znovu přihlaste.</li>\n</ul>\n<br/>\n<p>Nepomohlo to? Otevřete stránku v anonymním (soukromém) okně prohlížeče.</p>",
    "errorCodeReference": "V komunikaci, prosím, zmiňte následující chybový kód:"
  },
  "renewPassword": {
    "title": "Obnovení hesla",
    "subtitle": "Vytvořte si nové heslo k účtu. Doporučujeme vytvořit si silnější heslo, které obsahuje alespoň jedno číslo a písmeno.",
    "setPassword": "Zadejte heslo",
    "setPasswordAgain": "Zadejte heslo znovu",
    "newPassword": "Nové heslo",
    "changePassword": "Změnit heslo",
    "minLengthError": "Heslo musí mít minimálně 5 znaků.",
    "requiredErrorText": "Vytvořte heslo (min. 5 znaků).",
    "generatedError": {
      "start": "Heslo musí",
      "minLength": "mít minimální délku {length} znaků",
      "and": "a",
      "require": "obsahovat",
      "oneChar": "písmeno",
      "oneNumber": "číslo",
      "specialChar": "speciální znak"
    },
    "sameAsPasswordErrorText": "Hesla se neshodují.",
    "successMessage": "Heslo bylo úspěšně změněno.",
    "invalidToken": {
      "title": "Odkaz není platný",
      "perex": "Nový odkaz vytvoříte kliknutím na „zapomenuté heslo“ v mobilní aplikaci uLékaře.cz."
    },
    "usedToken": {
      "perex": "Tento odkaz už nefunguje, protože už byl jednou použitý."
    },
    "expiredToken": {
      "title": "Odkazu vypršela platnost.",
      "perex": "Nový odkaz vytvoříte kliknutím na „zapomenuté heslo“ v mobilní aplikaci uLékaře.cz."
    },
    "nextButton": "Přihlaste se do {service}"
  },
  "emailVerification": {
    "successMessage": "E-mail ověřen",
    "successMessagePerex": "Váš e-mail jsme úspěšně ověřili. Můžete se přihlásit.",
    "button": "Pokračujte na {service}",
    "invalidToken": "Odkaz není platný.",
    "usedToken": "Tento odkaz již není platný, protože už byl jednou použitý.",
    "expiredToken": "Odkazu vypršela platnost. "
  },
  "partnerNavigation": {
    "hello": {
      "title": "Jak začít využívat službu uLékaře.cz",
      "items": [
        {
          "icon": "compass",
          "text": "Přihlaste se nebo si založte účet."
        },
        {
          "icon": "glasses",
          "text": "Následně můžete začít využívat naši službu."
        }
      ]
    },
    "helloHrb": {
      "title": "Využijte službu uLékaře.cz.",
      "items": [
        {
          "icon": "compass",
          "text": "Najděte svého zaměstnavatele podle názvu firmy."
        },
        {
          "icon": "glasses",
          "text": "Vyberte službu, kterou chcete využít."
        }
      ]
    },
    "partnerSignpost": {
      "title": "Máte službu zdarma?",
      "subtitle": "Kdo hradí službu?",
      "text": "Službu můžete mít zdarma jako benefit od svého zaměstnavatele, města, karetní společnosti, neziskové organizace a dalších firem. Zaregistrujte se a přejděte do sekce správa benefitu, kde si vyberete svého zaměstnavatele"
    },
    "tabs": [
      "Jiný benefit",
      "Mastercard<sup>®</sup>"
    ],
    "employer": {
      "title": "Najděte svého zaměstnavatele podle názvu.",
      "searchPlaceholder": "Zadejte název firmy"
    },
    "results": {
      "noResultStart": "Váš zaměstnavatel tu není?",
      "noResultContact": "Kontaktujte nás",
      "noResultMiddle": "nebo si",
      "noResultReadMore": "přečtěte o službě více",
      "noResultEnd": "."
    },
    "partnerTypes": [
      {
        "boxTitle": "Mám službu od zaměstnavatele"
      },
      {
        "prominence": "regular",
        "buttonText": "Vybrat",
        "title": "Klikněte na logo své pojišťovny.",
        "boxTitle": "Mám službu od pojišťovny",
        "partnerGtmAction": "Klik Přechod na pojišťovnu",
        "boxes": [
          {
            "gtmLabel": "VoZP",
            "isExternalLink": "true",
            "image": "partner-vozp.png",
            "link": "kp.vozp.cz"
          },
          {
            "gtmLabel": "OZP",
            "isExternalLink": "true",
            "image": "partner-ozp.png",
            "link": "www.ozp.cz/vkol"
          }
        ]
      },
      {
        "prominence": "prominent",
        "buttonText": "Přejít na službu",
        "title": "Klikněte na logo pro využití služby uLékaře.cz.",
        "boxTitle": "Mám službu od Mastercard",
        "partnerGtmAction": "Klik Mastercard box",
        "boxes": [
          {
            "gtmLabel": "Mastercard",
            "isExternalLink": "false",
            "image": "logos/mc_logo.png",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "mastercard"
              }
            }
          }
        ]
      },
      {
        "prominence": "regular",
        "buttonText": "Vybrat",
        "title": "Klikněte na logo svého partnera.",
        "boxTitle": "Mám službu jako benefit",
        "partnerGtmAction": "Klik Přechod na partnera",
        "boxes": [
          {
            "gtmLabel": "Fairsurence",
            "image": "partner-fairsurence.png",
            "isExternalLink": "false",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "spolekpromaterstvi"
              }
            }
          }
        ]
      }
    ],
    "video": {
      "title": "Nemusíte k lékaři, lékař přijde k vám."
    }
  },
  "unsupportedBrowser": {
    "title": "Použijte jiný prohlížeč",
    "perex": "Tento starší prohlížeč, který používáte, už nepodporuje naši službu. Prosím aktualizujte ho nebo použijte jeden z těchto prohlížečů."
  },
  "login": {
    "banner": {
      "title": "Vaše data zůstanou v bezpečí.",
      "subtitle": "Neustále vylepšujeme uLékaře.cz, aby vaše data byla jen vaše."
    },
    "socials": {
      "facebook": "Přihlásit se přes Facebook",
      "google": "Přihlásit se přes Google",
      "apple": "Přihlásit se přes Apple"
    },
    "title": "Přihlásit se",
    "subtitle": "Pro využití služeb uLékaře.cz se přihlaste",
    "loginError": "Možná překlep, možná špatné údaje. Prosím zkuste to znovu.",
    "forgetPassword": "Zapomenuté heslo?",
    "password": {
      "title": "Heslo",
      "requiredError": "Heslo je povinné"
    },
    "remember": "Zapamatovat přihlašovací údaje",
    "login": "Přihlásit se",
    "noAccount": "Ještě nemáte lékaře v kapse?",
    "registration": "Zaregistrujte se.",
    "registrationHeaderButton": "Zaregistrujte se"
  },
  "registration": {
    "title": "Registrace",
    "subtitleFirstStep": "Zaregistrujte se, ať máte přístup k péči uLékaře.cz.",
    "subtitle": "Vaše údaje zná pouze zdravotní tým uLékaře.cz.",
    "addData": {
      "title": "Doplnění údajů",
      "subtitle": "Jste přihlášení! Přidejte ještě osobní údaje, aby s vámi mohl komunikovat zdravotní tým."
    },
    "emailError": "Tento e-mail už máte registrovaný.",
    "email": {
      "errorEmailNotExisting": "Vyplňte existující e-mailovou adresu.",
      "errorInvalidDomain": "Prosím použijte e-mail s povolenou doménou (např. @seznam.cz, @gmail.com...)",
      "errorText": "Doplňte prosím e-mail.",
      "title": "Osobní e-mail"
    },
    "socials": {
      "facebook": "Registrovat se přes Facebook",
      "google": "Registrovat se přes Google",
      "apple": "Registrovat se přes Apple"
    },
    "loginText": {
      "link": "Přihlaste se",
      "suffix": ", prosím",
      "question": "Tento e-mail je už registrovaný."
    },
    "login": {
      "text": "Už máte účet?",
      "link": "Přihlaste se."
    },
    "finishRegistration": "Dokončit registraci",
    "legal": {
      "text": "Souhlasím s {termsAndConds}.",
      "termsConditions": "podmínkami užití",
      "privacyPolicy": "Zásadami ochrany osobních údajů."
    }
  },
  "missingProfileData": {
    "title": "Doplnění údajů",
    "titleLegal": "Potvrzení souhlasů",
    "text": "Z propojeného účtu se nám nepodařilo získat vaši e-mailovou adresu, kterou potřebujeme pro komunikaci s vámi. Doplňte ji prosím níže.",
    "textLegal": "Potvrďte prosím následující:"
  },
  "phoneVerification": {
    "title": "Ověření telefonního čísla",
    "subtitle": "Na vaše telefonní číslo {phone} jsme zaslali ověřovací kód v SMS. Zadejte ho prosím níže.",
    "label": "Kód z SMS",
    "changeNumber": "Změnit číslo",
    "inputError": "Kód je povinný",
    "codeError": "Zadaný kód není platný. Potřebujete poradit?",
    "sendAgain": "Poslat kód znovu",
    "verify": "Ověřit",
    "error": {
      "error_timeout": {
        "title": "Vyčkejte prosím na ověřovací SMS",
        "perex": "Nejspíš jste požádali o změnu telefonního čísla několikrát za sebou. Prosím počkejte, aby vám nepřišlo více zpráv najednou."
      },
      "error_block": {
        "title": "Zablokovali jsme váš účet. Pro jistotu...",
        "perex": "Bezpečnost je pro nás na prvním místě, proto jsme kvůli podezřelé aktivitě dočasně zablokovali váš účet. Naše zákaznická péče vám ráda pomůže.",
        "callUs": "Zavolejte nám",
        "writeUs": "Napište nám"
      }
    }
  },
  "phoneChange": {
    "title": "Změna telefonního čísla",
    "sendCode": "Odeslat kód"
  },
  "lostPassword": {
    "title": "Zapomenuté heslo",
    "subtitle": "Odkaz pro obnovení hesla obdržíte v případě, že jste tímto e-mailem registrovaný na našem webu nebo v mobilní aplikaci.",
    "button": "Obnovit heslo",
    "linkSentTitle": "Odesláno",
    "linkSentPerex": "E-mail pro obnovení hesla byl odeslán na {email}. Pokud jej ve svém e-mailu nenajdete, podívejte se do složky „SPAM“.",
    "sendLinkAgain": "Poslat e-mail znovu",
    "finishRegistration": "Dokončit registraci"
  },
  "profileSection": {
    "menu": {
      "profile": "Můj účet",
      "subscription": "Předplatné",
      "logout": "Odhlásit se"
    },
    "badge": {
      "self": "samoplátce",
      "premium": "hrazeno"
    },
    "freeService": {
      "title": "Služba zdarma",
      "text": "Služba je často hrazena partnery, zaměstnavateli a pojišťovnami.",
      "button": "Mám nárok?"
    },
    "thankYou": "Službu vám hradí {partnerName}.",
    "thankYouPartly": "Na službu vám přispívá {partnerName}",
    "thankYouSelf": "Službu hradíte vy.",
    "thankYouHost": "Službu vám hradí {host}."
  },
  "dashboard": {
    "menu": {
      "home": "Přehled",
      "questions": "Poradna",
      "appointments": "Objednání",
      "prevention": "Prevence",
      "explore": "Objevujte"
    },
    "personalInfoAssurance": {
      "prefix": "Jak s vámi budeme komunikovat?",
      "email": "E-mail",
      "phone": "Telefon"
    },
    "deactivatedUser": "<strong>Váš účet je deaktivovaný.</strong> <span class=\"black--text\">Co se stalo? Kontaktujte nás: <a href=\"mailto:{email}\">{email}</a> nebo tel. {phone}.</span>",
    "title": "Zdravíme vás! 👋",
    "subtitle": "Jak vám můžeme pomoci?",
    "needAdvice": "Napsat dotaz",
    "needAppointment": "Chci objednat",
    "needHelp": "Potřebujete poradit?",
    "supportBox": {
      "openTitle": "Podpora",
      "title": "Zákaznická podpora",
      "boxText": "Jsme tu pro vás, ať už potřebujete pomoct s čímkoli",
      "chat": {
        "title": "Zákaznický chat",
        "textOnline": "Jsme online <br /> Ať už máte jakýkoli nezdravotní dotaz nebo problém. Jsme tu pro vás.",
        "textOffline": "Jsme offline <br /> Jsme online 8:00–17:00 (Po–Pá)",
        "button": "Spustit chat",
        "icon": "chat"
      },
      "customerService": {
        "title": "Zákaznická linka",
        "subtitle": "8:00–17:00 (Po–Pá)",
        "buttonEmail": {
          "text": "info@ulekare.cz",
          "subtitle": "Kontaktní e-mail:"
        },
        "buttonPhone": {
          "text": "+420 227 072 720",
          "subtitle": "Placená linka:"
        },
        "linkEmail": "mailto:info@ulekare.cz",
        "linkPhone": "tel:+420 227 072 720",
        "icon": "care",
        "tescoButtonPhone": {
          "text": "+420 800 100 211",
          "subtitle": "Bezplatná linka:"
        },
        "tescoLinkPhone": "tel:+420 800 100 211",
        "tescoButtonPhonePaid": "Placená linka  +420 227 072 720",
        "tescoLinkPhonePaid": "tel:+420 227 072 720"
      },
      "assistanceService": {
        "title": "SOS psychická pomoc",
        "subtitle": "Psychologická poradna",
        "buttonEmail": "info@e-a.cz",
        "buttonPhone": "+420 234 768 710",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+420 234 768 710",
        "icon": "happy"
      },
      "covidService": {
        "title": "Covid infolinka",
        "subtitle": "8:0017–:00 (Po–Pá)",
        "button": "+420 226 284 227",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+420 226 284 227",
        "icon": "lungs"
      },
      "unavailableOn": "Upozorňujeme, že zákaznická podpora a služba objednání bude dne {date} dostupná v omezeném režimu. Zadané požadavky mohou být vyřízeny s prodlevou. Pro obecné informace nám prosím napište na uvedenou e‑mailovou adresu. \nDěkujeme za pochopení.",
      "outageActive": "false",
      "outageDateISO": "2026-04-09"
    },
    "freeService": "Mám službu zdarma?",
    "requestSent": "Dokončete aktivaci v pracovním e-mailu",
    "hint": {
      "title": "Tomáš Šebek",
      "subtitle": "spoluzakladatel uLékaře.cz, chirurg",
      "text": "Slunce svítí, roste kvítí. Co se stalo? Přišlo jaro!<br/>A&nbsp;s&nbsp;ním alergie, jarní únava, opálená kůže, vystupující znaménka...",
      "linkText": "Chci&nbsp;se&nbsp;poradit"
    },
    "questions": {
      "myQuestions": "Moje dotazy",
      "updated": "Máme pro vás odpověď!",
      "resolvers": "Pečují o vás",
      "sla": "Odpovíme už do <strong class=\"black--text\">{hour}</strong> h."
    },
    "appointments": {
      "myAppointments": "Moje objednání"
    },
    "labTests": {
      "draft": "Vyberte termín a místo odběru",
      "new": "Vaše odběry zpracovává laboratoř.",
      "done": "Máme interpretaci vašich krevních testů!"
    },
    "videoCall": {
      "buttonText": "Naplánovat videohovor",
      "buttonTextMobile": "Videohovor"
    },
    "services": {
      "question": {
        "title": "Poradna (24/7)",
        "subtitle": "s&nbsp;odpovědí do&nbsp;{hours}&nbsp;h",
        "b2cSufix": "za&nbsp;{priceCzk}&nbsp;Kč",
        "text": "Praktičtí lékaři a specialisté na jednom místě. Pro vás ve dne v noci.",
        "button": "Potřebuji poradit"
      },
      "videoCall": {
        "title": "Videohovor",
        "subtitle": "s lékařem",
        "text": "Lékaři se vám věnují na videohovoru až 20 minut v čase, který si vyberete.",
        "button": "Naplánovat videohovor"
      },
      "appointment": {
        "title": "Objednání",
        "subtitle": "po celé ČR",
        "text": "Zdravotní sestřičky vám pomohou najít lékaře, kterého potřebujete.",
        "button": "Chci objednat"
      },
      "prevention": {
        "title": "Prevence",
        "subtitle": "zdraví ve vašich rukou",
        "text": "Zdraví je vaše. A rádi vám pomůžeme se o něj postarat.",
        "existedButton": "Vstoupit do prevence"
      },
      "thematic_counseling": {
        "title": "Tematické poradny",
        "text": "Játra, nebo kůže? Zeptejte se v on-line poradnách, které se zaměřují na konkrétní zdravotní téma.",
        "button": "Vybrat poradnu"
      },
      "hints": {
        "service_not_supported_in_this_language": {
          "text": "Službu není možné využívat v {language}. Prosím zvolte jiný jazyk v nastavení <a href=\"{link}\" class=\"link--inline\">svého profilu</a>.",
          "cs": "češtině",
          "en": "angličtině",
          "sk": "slovenštině"
        }
      },
      "labTest": {
        "title": "Laboratorní testy",
        "subtitle": "zdraví ve vašich rukou",
        "text": "Postarejte se s naší podporou co nejlépe o své zdraví.",
        "button": "Vyplnit dotazník"
      },
      "videoTherapy": {
        "subtitle": "s terapeutem",
        "title": "Videohovor",
        "text": "Promluvte si diskrétně a online. Odborník se vám věnuje 50 minut.",
        "button": "Vybrat termín videohovoru",
        "textUnavailable": "Počet terapií byl vyčerpán. Pro více informací kontaktujte své HR oddělení."
      }
    },
    "news": "Novinky",
    "recomended": "Doporučujeme",
    "errors": {
      "emailNotVerified": "Prosíme o potvrzení e-mailu uvedeného při registraci. Ať máte uLékaře.cz po ruce!",
      "resendEmail": "Zaslat e-mail znovu."
    },
    "family": {
      "title": "Chcete se zeptat na své zdraví?",
      "myHealth": "Ano, na své zdraví",
      "otherHealth": "Ne, na zdraví někoho z rodiny"
    },
    "emailVerification": {
      "title": "Ověření e-mailové adresy",
      "subtitle": "Přejděte do své e-mailové schránky <strong>{email}</strong> a klikněte na ověřovací odkaz v e-mailu, který jsme vám zaslali.",
      "text": [
        {
          "title": "Nedostali jste zprávu?",
          "list": [
            {
              "icon": "check_circle",
              "text": "Možná ji najdete ve složce hromadné nebo nevyžadané pošty (spam)."
            },
            {
              "icon": "check_circle",
              "text": "Může to trvat několik minut. Pořád nic? Zkuste poslat e-mail znovu."
            }
          ]
        },
        {
          "title": "Zadali jste nesprávný e-mail?",
          "text": "Nevadí. Zaregistrujte se znovu."
        }
      ],
      "actions": {
        "right": {
          "type": "resend",
          "baseText": "Poslat e-mail znovu"
        }
      }
    },
    "help": {
      "text": "Nevíte si rady?",
      "hours": "Po–Pá 8:00-17:00"
    }
  },
  "videoCall": {
    "infoStep": {
      "title": "Online sezení s lékařem",
      "perex": "Domluvte si termín videohovoru a proberte s lékařem jakýkoliv zdravotní problém, i bez návštěvy ordinace.",
      "list": {
        "first": "Ujistěte se, že máte vyplněné základní údaje a ověřené telefonní číslo.",
        "second": "Vyberte datum a čas, jak vám vyhovuje. Hovor stihnete i během obědové pauzy.",
        "third": "V domluvený čas se připojíte k videohovoru. Lékař se věnuje 20 minut pouze vám."
      },
      "legal": [
        "Službu Vám zprostředkujeme u poskytovatele zdravotních služeb, kterým je společnost:",
        "uLékaře.cz Health Care, s.r.o.<br/>se sídlem Českomoravská 1a, 190&nbsp;00&nbsp;Praha&nbsp;9 IČO:&nbsp;096&nbsp;64&nbsp;777<br/>vedená u&nbsp;Městského soudu v&nbsp;Praze pod sp.&nbsp;zn.&nbsp;C&nbsp;339989",
        "Zdravotní služba Videohovor s lékařem není hrazena z veřejného zdravotního pojištění. Její cenu hradí Váš zaměstnavatel.",
        "Služba Videohovor s lékařem je zdravotní službou poskytovanou na dálku formou videohovoru s lékařem, a to pouze v oboru vnitřního lékařství. "
      ],
      "button": "Vybrat termín videohovoru"
    },
    "formStep": {
      "title": "Zkontrolujte základní údaje",
      "legal": {
        "termsConditions": {
          "text": "Souhlasím s {legalText} Videohovor s lékařem poskytovatele zdravotních služeb uLékaře.cz Health Care, s.r.o.",
          "legalText": "Podmínkami poskytnutí služby"
        },
        "personalData": {
          "text": "Vaše osobní údaje zpracováváme v souladu se {link}.",
          "legalText": "Zásadami ochrany osobních údajů"
        }
      }
    },
    "iframeStep": {
      "title": "Vyberte si termín"
    }
  },
  "tally": {
    "anxiety": {
      "dashboardBox": {
        "title": "Test míry úzkosti",
        "text": "Dotazník vám ukáže, jak jste na tom s úzkostí",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak jste na tom s úzkostí?",
        "timeApproximation": "2 minuty",
        "perex": "Úzkost je kombinace strachu, zlých předtuch a obav. Jedná se o nepříjemný pocit ohrožení a napětí, a to s různou intenzitou. Může připomínat stres.",
        "list": [
          "Vyplňte krátký dotazník a zjistěte své riziko úzkosti.",
          "Ihned nabídneme doporučení nebo pomocnou ruku."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psychologické poradenství online v uLékaře.cz"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/mZ66ae",
        "b2c": "https://tally.so/r/mOAaJA"
      }
    },
    "nicotine": {
      "dashboardBox": {
        "title": "Závislost na nikotinu",
        "text": "Pár otázek odhalí, jestli jste opravdu závislí na nikotinu.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jste závislí na nikotinu?",
        "timeApproximation": "2 minuty",
        "perex": "Užívání nikotinu není jen zlozvyk – skutečně ohrožuje vaše zdraví. Otestujte se, pokud kouříte cigarety, e-cigarety či iQOS, užíváte VELO apod.",
        "list": [
          "Odpovězte na 6 otázek o nikotinu.",
          "Dozvíte se, jestli trpíte závislostí."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "MUDr. Lenka Dvouletá",
          "specialization": "Pneumologie a ftizeologie",
          "workplace": "Nemocnice Tomáše Bati ve Zlíně"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/nrKQOp",
        "b2c": "https://tally.so/r/mYOALB"
      }
    },
    "wellbeing": {
      "dashboardBox": {
        "title": "Test životní pohody",
        "text": "Jak se skutečně máte? Otestujte svůj wellbeing.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Daří se vám dobře?",
        "timeApproximation": "~2 minuty",
        "perex": "Wellbeing označuje celkový stav fyzického, duševního a emocionálního zdraví. Životní pohodu ovlivňuje zdravotní stav, vztahy a další aspekty.",
        "list": [
          "Odpovězte na 5 krátkých otázek.",
          "Okamžitě dostanete výsledek s tipy, které vám pomohou cítit se lépe."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psycholožka z uLékaře.cz"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/meE4Jq",
        "b2c": "https://tally.so/r/w4jLkd"
      }
    },
    "insomnia": {
      "dashboardBox": {
        "title": "Test nespavosti",
        "text": "Jak jste na tom se spánkem? Otestujte se.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak jste na tom se spánkem?",
        "timeApproximation": "~2 minuty",
        "perex": "Nedaří se vám v poslední době usnout? Nebo se v noci budíte? Dlouhodobá nespavost může ovlivnit životní pohodu i zdraví.",
        "list": [
          "Odpovězte během 2 minut na osm krátkých otázek",
          "Obratem uvidíte svůj výsledek včetně praktických doporučení"
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psycholožka z uLékaře.cz"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/nGDyY2",
        "b2c": "https://tally.so/r/wk7rqJ"
      }
    },
    "healthCheck": {
      "dashboardBox": {
        "title": "Test péče o zdraví",
        "text": "Několik otázek ukáže, jak dobře pečujete o zdraví.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak pečujete o své zdraví?",
        "timeApproximation": "~2 minuty",
        "perex": "Krátký test ukáže, jak se staráte o své tělo a duši a zda potřebujete více sebepéče.\nOvěřeno praktickým lékařem.",
        "list": [
          "Během pár minut vyplníte jednoduchý test s 10 otázkami.",
          "Ihned se dovíte, jak pečujete o zdraví a co lékař doporučuje „na tělo“."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "mjr. MUDr. Denisa Gottvaldová",
          "specialization": "Praktické lékařství pro dospělé",
          "workplace": "Centrum zdravotních služeb Bechyně"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/3E8Pd2",
        "b2c": "https://tally.so/r/wvqNe4"
      }
    },
    "alcohol": {
      "dashboardBox": {
        "title": "Vztah k alkoholu",
        "text": "Jak jste na tom s alkoholem? Otestujte se.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak jste na tom s alkoholem?",
        "timeApproximation": "~2 minuty",
        "perex": "Test vám pomůže posoudit, jestli máte konzumaci alkoholu pod kontrolou...\na nebo pohár brzy přeteče.",
        "list": [
          "U každé otázky vyberte odpověď, která nejlépe vystihuje vaši situaci.",
          "Obratem uvidíte svůj výsledek\nvčetně praktických doporučení."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psycholožka z uLékaře.cz"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/meKPWO",
        "b2c": "https://tally.so/r/3yjkB0"
      }
    },
    "depression": {
      "dashboardBox": {
        "title": "Test rizika deprese",
        "text": "Je to špatná nálada, nebo deprese? Otestujte se.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Špatná nálada, nebo deprese?",
        "timeApproximation": "~2 minuty",
        "perex": "Cítíte se v poslední době vyčerpaní, bez energie a nic vás netěší? Online test rizika deprese vám může pomoci zmapovat vaše pocity.",
        "list": [
          "Vyberte odpovědi, které nejlépe odpovídají vaší aktuální situaci.",
          "Obratem uvidíte svůj výsledek\nvčetně praktických doporučení."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psycholožka z uLékaře.cz"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/npkBG8",
        "b2c": "https://tally.so/r/wdkxgz"
      }
    },
    "liver": {
      "dashboardBox": {
        "title": "Test zdraví jater",
        "text": "Otestujte se, jak dobře se staráte o svá játra.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Staráte se dobře o svá játra?",
        "timeApproximation": "~3 minuty",
        "perex": "Tento krátký test vám prozradí, jak se mají vaše játra a jestli potřebují více péče než doteď.",
        "list": [
          "Vyberte odpovědi, které považujete za správné a sedí k vašemu zdraví.",
          "Obratem uvidíte svůj výsledek včetně praktických doporučení."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "mjr. MUDr. Denisa Gottvaldová",
          "specialization": "Praktické lékařství pro dospělé",
          "workplace": "Centrum zdravotních služeb Bechyně"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/m6MzbO",
        "b2c": "https://tally.so/r/mJMQyJ"
      }
    },
    "heart": {
      "dashboardBox": {
        "title": "Máte zdravé srdce?",
        "text": "Pár otázek prozradí, co si žádá vaše srdce.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak se má vaše srdce?",
        "timeApproximation": "~3 minuty",
        "perex": "Tento test napoví, zda se vaše srdce těší dobrému zdraví, nebo už buší na poplach.",
        "list": [
          "Odpovězte za 3 minuty na deset krátkých otázek.",
          "Obratem uvidíte svůj výsledek včetně praktických doporučení."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Dr. Oleksii Bolotskykh",
          "specialization": "Kardiolog pro dospělé",
          "workplace": "Kardiologie na Bulovce, s.r.o."
        },
        "button": "Vyplnit test"
      },
      "urls": {
        "b2b": "https://tally.so/r/w25kMD",
        "b2c": "https://tally.so/r/wkrgQZ"
      }
    },
    "movement": {
      "urls": {
        "b2c": "https://tally.so/r/wLgKKO",
        "b2b": "https://tally.so/r/mRl4Xj"
      },
      "infoStep": {
        "button": "Vyplnit dotazník",
        "garant": {
          "workplace": "Soukromá praxe YOTAI, Praha",
          "specialization": "Odbornice na taneční a sportovní medicínu",
          "name": "MgA. Klára Lidová, Ph.D.",
          "title": "Garant testu"
        },
        "list": [
          "Odpovězte za 2 minuty na deset krátkých otázek.",
          "Obratem uvidíte svůj výsledek včetně praktických doporučení."
        ],
        "perex": "Rychlý test prozradí, zda se hýbete dostatečně, nebo vaše tělo volá po akci.",
        "timeApproximation": "~2 minuty",
        "title": "Máte dostatek pohybu?"
      },
      "dashboardBox": {
        "button": "Vyplnit test",
        "text": "Otestujte svoji kondici krátkým online testem.",
        "title": "Pohyb a vy"
      }
    },
    "skin": {
      "dashboardBox": {
        "title": "Jak se opalujete?",
        "text": "Zjistěte svůj fototyp pomocí krátkého testu.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak dobře se opalujete?",
        "timeApproximation": "~2 minuty",
        "perex": "Otestujte, zda je vaše kůže v bezpečí, nebo pod slunečními paprsky tiše trpí.",
        "list": [
          "Odpovězte za 2 minuty na osm krátkých otázek.",
          "Obratem uvidíte svůj výsledek včetně praktických tipů."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "MUDr. Tereza Marušiaková",
          "specialization": "Dermatovenerolog",
          "workplace": "Krajská nemocnice Liberec"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/wgxZ6P",
        "b2c": "https://tally.so/r/w2zDKA"
      }
    },
    "adhd": {
      "urls": {
        "b2c": "https://tally.so/r/mZbYNv",
        "b2b": "https://tally.so/r/3j8x56"
      },
      "infoStep": {
        "button": "Vyplnit dotazník",
        "garant": {
          "workplace": "Centrum psychologických služeb, Ostrava",
          "specialization": "psycholog, psychoterapeut",
          "name": "PhDr. Sylvie Navarová",
          "title": "Garantka testu"
        },
        "list": [
          "Odpovězte na 10 otázek. Žádné dlouhé přemýšlení, stačí první pocit.",
          "Na konci testu se dozvíte, co pro sebe udělat."
        ],
        "perex": "Jsou vaše myšlenky jak splašené včely, nebo se soustředíte jako šachista?\nTento krátký test prozradí více.",
        "timeApproximation": "~3 minuty",
        "title": "Jak dobře se soustředíte?"
      },
      "dashboardBox": {
        "button": "Vyplnit test",
        "text": "Otestujte svou pozornost a schopnost soustředění.",
        "title": "Jak se soustředíte?"
      }
    },
    "imunity": {
      "dashboardBox": {
        "title": "Test imunity",
        "text": "Osm otázek ujasní, jak se vaše tělo umí bránit.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Máte silnou imunitu?",
        "timeApproximation": "~2 minuty",
        "perex": "Otestujte, zda vaše imunita funguje jako štít, nebo ji porazí každá nemoc.",
        "list": [
          "Odpovězte za 2 minuty na osm krátkých otázek.",
          "Obratem uvidíte svůj výsledek včetně praktických tipů."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MUDr. Jana Emlerová",
          "specialization": "Alergolog, klinický imunolog",
          "workplace": "Alergologie a klinická imunologie GENNET"
        },
        "button": "Vyplnit test"
      },
      "urls": {
        "b2b": "https://tally.so/r/mVegAN",
        "b2c": "https://tally.so/r/m6lo0A"
      }
    },
    "circulation": {
      "dashboardBox": {
        "title": "Jak se cítí vaše cévy?",
        "text": "Pár otázek prozradí, jak je na tom váš krevní oběh.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak posílit svůj krevní oběh?",
        "timeApproximation": "~2 minuty",
        "perex": "Zjistěte, zda vaše srdce a cévy pracují na plný výkon, nebo potřebují trochu podpory.",
        "list": [
          "Odpovězte na 10 krátkých otázek.",
          "Obratem uvidíte svůj výsledek i praktické tipy, jak oběh zlepšit."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MUDr. Markéta Hadrabová",
          "specialization": "Všeobecný praktický lékař a hematolog",
          "workplace": ""
        },
        "button": "Vyplnit test"
      },
      "urls": {
        "b2b": "https://tally.so/r/w7GqL0",
        "b2c": "https://tally.so/r/w45Q6X"
      }
    },
    "flexibility": {
      "dashboardBox": {
        "title": "Máte pružné tělo?",
        "text": "Otestuje svou flexibilitu pomocí deseti otázek.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak ohebné je vaše tělo?",
        "timeApproximation": "~2 minuty",
        "perex": "Zjistěte, zda je vaše tělo jako pružinka, nebo spíš ztuhlé prkno.",
        "list": [
          "Odpovězte na 10 jednoduchých otázek.",
          "Přečtěte si svůj výsledek a objevte tipy pro lepší pohyblivost."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MgA. Klára Lidová",
          "specialization": "Odbornice na taneční a sportovní medicínu",
          "workplace": "Soukromá praxe YOTAI, Praha"
        },
        "button": "Vyplnit test"
      },
      "urls": {
        "b2b": "https://tally.so/r/wo4Z7V",
        "b2c": "https://tally.so/r/mBPox4"
      }
    },
    "digitalhealth": {
      "dashboardBox": {
        "title": "Vaše digitální zdraví",
        "text": "Zjistěte, jestli vám digitální svět slouží, nebo vládne.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Ovládáte technologie, nebo ony vás?",
        "timeApproximation": "~3 minuty",
        "perex": "Internet, aplikace, sociální sítě... Skvělí pomocníci, nebo neúnavní zloději času?",
        "list": [
          "Odpovězte na 10 otázek a zjistěte, jak si stojíte v digitálním světě.",
          "Výsledek vám napoví, jak případně získat zpět ztracenou rovnováhu."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psycholožka z uLékaře.cz",
          "workplace": "Psychologie"
        },
        "button": "Vyplnit test"
      },
      "urls": {
        "b2b": "https://tally.so/r/xXXPBd",
        "b2c": "https://tally.so/r/PddboV"
      }
    },
    "sleephealth": {
      "dashboardBox": {
        "title": "Spíte zdravě?",
        "text": "Otestujte, jak kvalitně odpočíváte. Postačí 10 vašich odpovědí.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Spíte opravdu dobře?",
        "timeApproximation": "~3 minuty",
        "perex": "Zjistěte, zda během spánku čerpáte energii, nebo jestli vaše tělo funguje jen na autopilota.",
        "list": [
          "Odpovězte na 10 krátkých otázek.",
          "Přečtěte si svůj výsledek a objevte tipy pro lepší odpočinek."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "PhDr. Sylvie Navarová",
          "specialization": "Psycholog, psychoterapeut",
          "workplace": "Centrum psychologických služeb, Ostrava"
        },
        "button": "Vyplnit test"
      },
      "urls": {
        "b2b": "https://tally.so/r/rj54rv",
        "b2c": "https://tally.so/r/MeX4M0"
      }
    },
    "drinkfree": {
      "dashboardBox": {
        "title": "Alkohol a vy",
        "text": "Jak jste na tom s pitím? Náš test napoví.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak jste na tom s alkoholem?",
        "timeApproximation": "~3 minuty",
        "perex": "Osm otázek napoví, jaký máte vztah k alkoholu i co se může změnit, když si od něj dáte pauzu.",
        "list": [
          "Vyberte vždy jednu odpověď, která vás nejvíce vystihuje.",
          "Přečtěte si svůj výsledek. (Upozornění: Tento test není diagnostický nástroj.)"
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MUDr. Barbora Magdolenová",
          "specialization": "Psychiatr",
          "workplace": "Psychiatrická nemocnice Brno"
        },
        "button": "Vyplnit test"
      },
      "urls": {
        "b2b": "https://tally.so/r/7RKkrz",
        "b2c": "https://tally.so/r/yP4Qe6"
      }
    },
    "intimateHealth": {
      "dashboardBox": {
        "button": "Vyplnit test",
        "text": "10 otázek odhalí, jak dobře se o sebe staráte.",
        "title": "Vaše intimní zdraví"
      },
      "infoStep": {
        "button": "Vyplnit test",
        "garant": {
          "name": "MUDr. Petra Polášková",
          "specialization": "Gynekoložka",
          "title": "Garantka testu",
          "workplace": "FertilityPort Prague s.r.o."
        },
        "list": [
          "Vyberte vždy jednu odpověď, která vás nejvíce vystihuje.",
          "Obratem uvidíte svůj výsledek včetně praktických doporučení."
        ],
        "perex": "Deset otázek vám napoví, jak se staráte o své intimní zdraví – co už zvládáte a kde by stálo za to věnovat více pozornosti.",
        "timeApproximation": "~3 minuty",
        "title": "Jak pečujete o své intimní zdraví?"
      },
      "urls": {
        "b2b": "https://tally.so/r/ODzD8R",
        "b2c": "https://tally.so/r/J96Eko"
      }
    },
    "workbalance": {
      "dashboardBox": {
        "button": "Vyplnit test",
        "text": "10 otázek odhalí, zda máte našlápnuto k vyhoření.",
        "title": "Práce, stres  a vy"
      },
      "infoStep": {
        "button": "Vyplnit test",
        "garant": {
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "title": "Garantka testu",
          "workplace": "Psycholožka z uLékaře.cz"
        },
        "list": [
          "Vyberte vždy jednu odpověď, která vás nejvíce vystihuje.",
          "Obratem uvidíte svůj výsledek včetně praktických doporučení."
        ],
        "perex": "Krátký test ukáže, jak na tom jste s pracovní zátěží, stresem a energií. Není to diagnostický nástroj, slouží pouze k sebereflexi.",
        "timeApproximation": "~3 minuty",
        "title": "Jak zvládáte pracovní nápor?"
      },
      "urls": {
        "b2b": "https://tally.so/r/Y5rDdN",
        "b2c": "https://tally.so/r/9qOG4Y"
      }
    },
    "foodstyle": {
      "dashboardBox": {
        "button": "Vyplnit test",
        "text": "Co o vás prozradí složení vašeho talíře?",
        "title": "Talíř pod lupou"
      },
      "infoStep": {
        "button": "Vyplnit test",
        "garant": {
          "name": "Mgr. Lucie Burdová",
          "specialization": "Poradenství",
          "title": "Garantka testu",
          "workplace": "Nutriční terapeutka"
        },
        "list": [
          "Neodpovídejte podle ideálu. Odpovídejte podle reality.",
          "Přečtěte si svůj výsledek včetně praktických doporučení."
        ],
        "perex": "Krátký test vám ukáže, jestli vaše stravování funguje jako palivo, nebo spíš jako nouzová náplast hladu.",
        "timeApproximation": "~3 minuty",
        "title": "Jíte opravdu zdravě?"
      },
      "urls": {
        "b2b": "https://tally.so/r/vGxgr8",
        "b2c": "https://tally.so/r/ZjRgL0"
      }
    },
    "longevity": {
      "dashboardBox": {
        "button": "Vyplnit test",
        "text": "Ověřte si, zda vaše návyky prospívají tělu i mysli.",
        "title": "Stárnete zdravě?"
      },
      "infoStep": {
        "button": "Vyplnit test",
        "garant": {
          "name": "MUDr. Markéta Hadrabov",
          "specialization": "",
          "title": "Garantka testu",
          "workplace": "Všeobecný praktický lékař a hematolog"
        },
        "list": [
          "Vyberte vždy jednu odpověď, která vás nejvíce vystihuje.",
          "Test neslouží k diagnóze. Výsledek berte jako přehled a inspiraci."
        ],
        "perex": "Deset otázek vám napoví, jak máte našlápnuto k dlouhověkosti.",
        "timeApproximation": "~3 minuty",
        "title": "Jak pečujete o své budoucí já?"
      },
      "urls": {
        "b2b": "https://tally.so/r/vGxgr8",
        "b2c": "https://tally.so/r/vGxgr8"
      }
    }
  },
  "profileAuthorization": {
    "chooseSubscription": "Vybrat předplatné",
    "language": {
      "title": "Nastavení služby",
      "text": "Vyberte si, v kterém jazyce chcete službu využívat.",
      "errorText": "Váš plátce služby nepodporuje tento jazyk, prosím vyberte jiný."
    },
    "final": {
      "title": "Děkujeme za registraci!",
      "text": "Od teď máte službu uLékaře.cz v kapse! Naši lékaři a zdravotní sestřičky vám rádi pomohou."
    },
    "possiblePartners": {
      "title": "Dobrá zpráva! Nejspíš máte nárok na službu zdarma.",
      "textHrb": "Potvrďte, kdo vám hradí službu a pomůže vám na cestě ke zdraví. Nemůžete si vybrat? Podívejte se do seznamu našich partnerů.",
      "changePartner": "Vybrat ze seznamu"
    },
    "hrbPartner": {
      "title": "Nastartujte službu zdarma",
      "textBoth": "Zadejte firemní e-mail nebo kód, který jste obdrželi od {partner}.",
      "textEmail": "Zadejte firemní e-mail.",
      "textCode": "Zadejte aktivační kód, který jste obdrželi od {partner}.",
      "tabs": [
        "E-mailem",
        "Kódem"
      ],
      "email": "Firemní e-mail",
      "code": "Aktivační kód",
      "codeError": "<strong>Tento kód je bohužel neplatný.</strong><br>Prosím zkontrolujte správnost kódu se svým HR oddělením.<br>Pokud je kód správný, rádi vám pomůžeme na",
      "emailError": "Neplatný e-mail. Nevíte, co s tím? Napište nám na <a href=\"mailto:info@ulekare.cz\">info@ulekare.cz</a>.",
      "invalidEmployeeEmail": "Zaměstnavatel/partner nepovolil službu zdarma pro tento e-mail.",
      "benefitBlocked": "Tento e-mail je už spojený s jiným zaměstnavatelem/partnerem, proto zde nemůžete aktivovat službu zdarma.",
      "clientSupport": "klientské podpoře.",
      "startTitle": "Nastartujte službu zdarma",
      "formTitle": "Zadejte firemní e-mail nebo kód",
      "startUsing": "Zadejte firemní e-mail nebo kód",
      "formDescription": "Vyplňte prosím následující údaje pro ověření nároku na službu zdarma.",
      "description": {
        "code": "Aktivační kód",
        "email": "Aktivační email"
      }
    },
    "emailAuthorization": {
      "title": "Děkujeme za zájem o aktivaci služby zdarma!",
      "subtitle": "Na <strong class=\"black--text\">{email}</strong> jsme poslali aktivační e-mail. Kliknutím na odkaz v e-mailu službu zdarma aktivujete.",
      "text": [
        {
          "title": "Nepřišel e-mail?",
          "list": [
            {
              "text": "Podívejte se do složky spam nebo hromadná pošta."
            },
            {
              "text": "Doručení může chvíli trvat.",
              "text ": "Doručení může chvíli trvat."
            }
          ]
        },
        {
          "title": "Zadali jste špatný e-mail?",
          "link": {
            "type": "router",
            "routerAction": "replace",
            "name": "dashboard",
            "query": {
              "a_step": "authorization"
            },
            "textBefore": "Změňte ho",
            "text": "zde"
          }
        }
      ],
      "actions": {
        "left": {
          "type": "resend",
          "class": "light",
          "baseText": "Poslat e-mail znovu"
        },
        "right": {
          "type": "continue"
        }
      }
    },
    "authorizationSignpost": {
      "title": "Kdo hradí službu?",
      "text": "Mějte služby uLékaře.cz zdarma! Možná vám ji hradí zaměstnavatel nebo někdo z našich partnerů (pojišťovny, karetní společnosti atd.).",
      "employees": "Zaměstnavatel",
      "search": "Najděte zaměstnavatele podle názvu",
      "searchSignText": "Začněte psát název firmy, ve které pracujete. Společně ji najdeme.",
      "searchEmpty": {
        "title": "Pod výrazem “{text}” se nám nepovedlo nic najít",
        "text": "Chtěli byste, aby se objevil v našem seznamu? Můžete nám ho {email}.",
        "emailText": "doporučit"
      },
      "otherBenefit": "Partneři",
      "selfPay": "Službu hradím sám"
    },
    "selfPay": {
      "title": "Službu hradím sám",
      "text": "Zařídíme pro vás:",
      "price": "{priceCzk} Kč",
      "priceSufix": "/dotaz",
      "list": [
        {
          "icon": "doctor",
          "text": "Spojení s lékařem do 8 hodin"
        },
        {
          "icon": "shield",
          "text": "Preventivní program přímo vám na tělo"
        },
        {
          "icon": "news",
          "text": "Praktické zdravotní tipy od lékařů"
        }
      ]
    },
    "mastercard": {
      "title": "Ověřte si svoji kartu Mastercard<sup>®</sup>",
      "codeInvalidError": "Zadané číslo není platné. Zkontrolujte, že zadáváte 6 čísel své prémiové či firemní karty Mastercard<sup>®</sup>.",
      "label": "Prvních 6 číslic z karty"
    },
    "external": {
      "titleSlot": "Neplatné ověření služby zdarma",
      "vozpText": "Jako klient VoZP se přihlaste do klientského portálu VoZP a klikněte na logo uLékaře.cz. Po prvním přihlášení se vám otevřou všechny naše služby.",
      "ozpText": "Klientům OZP je služba uLékaře.cz přístupná 24/7 přes VITAKARTU. Přihlaste se do svého účtu VITAKARTY.",
      "drmaxText": "Jako klient Dr. Max se přihlaste do Karty výhod a klikněte na logo uLékaře.cz.",
      "mcText": "Potřebujeme ověřit prvních 6 čísel vaší karty Mastercard<sup>®</sup> Premium. Nejedná se o platbu, po úspěšném zadání budete moci využít služeb uLékaře.cz zdarma.",
      "fairsuranceText": "Pro aktivaci služby zdarma zadejte autorizační kód, který jste obdrželi z Fairsurance.",
      "eonText": "Služba zdarma pro věrné zákazníky společnosti E.ON už bohužel skončila. Službu uLékaře.cz můžete i nadále využívat po přihlášení do svého profilu.",
      "sporthelpText": "{title}Pro aktivaci služby zdarma pro členy sportovního pojištění SportHelp klikněte na odkaz pro využití služby, který najdete ve své digitální členské kartě v sekci Lékařská poradna uLékaře.cz nebo Objednání uLékaře.cz.",
      "defaultErrorText": "Autorizační odkaz již nelze využít, jelikož mu vypršela platnost. Děkujeme za pochopení."
    },
    "chooseDifferentCompany": "Vybrat jinou firmu"
  },
  "profile": {
    "title": "Můj účet",
    "titleMobile": "Nastavení",
    "subtitle": "Spravujte své údaje.",
    "basicData": "Základní údaje",
    "emailNote": "Změna e-mailové adresy není možná.",
    "phoneNote": "Na tomto čísle vás mohou kontaktovat naše sestřičky při řešení Vašich požadavků.",
    "security": "Zabezpečení",
    "currentPassword": "Původní heslo",
    "invalidCurrentPassword": "Neplatné původní heslo",
    "currentPasswordUsedInHistory": "Nové heslo nesmí být stejné jako to staré.",
    "newPassword": "Nové heslo",
    "additionalInfo": "Doplňující údaje",
    "birthDateNote": "Podle vašeho věku se lékař lépe vyjádří.",
    "address": "Adresa",
    "addressNote": "Podle adresy vám můžeme vyhledat vhodného lékaře.",
    "family": "Moje rodina",
    "aboutApp": {
      "title": "O aplikaci",
      "appVersion": "Verze aplikace",
      "webVersion": "Verze obsahu",
      "updates": {
        "title": "Dostupnost aktualizace",
        "webAvailable": "Je k dispozici aktualizace obsahu: {newVersion}",
        "apply": "Aktualizovat",
        "upToDate": "Vaše aplikace i obsah jsou aktuální.",
        "checking": "Kontroluji dostupnost aktualizací...",
        "error": "Něco se nepovedlo. Zkuste aplikaci spustit znovu."
      }
    },
    "applicationLock": "Zámek aplikace",
    "moreOptions": "Další možnosti",
    "healthInsuranceProvider": {
      "title": "Zdravotní pojišťovna",
      "note": "Hledáme lékaře spolupracujícího s vaší pojišťovnou."
    },
    "applicationLanguage": {
      "title": "Jazyk aplikace",
      "message": "V tomto jazyce se bude zobrazovat web"
    },
    "serviceLanguage": {
      "title": "Jazyk služby",
      "message": "V tomto jazyce vám bude odpovídat lékař"
    },
    "changeLanguageNotification": {
      "text": "Po uložení změn se jazyk webu změní na",
      "cs": "češtinu",
      "en": "angličtinu",
      "sk": "slovenštinu",
      "uk": "ukrajinštinu",
      "ru": "ruštinu"
    },
    "storeMessage": {
      "success": "Změny jsou uloženy.",
      "error": "Změny se neuložily. Zkontrolujte správnost uvedených údajů.",
      "passwordError": "Změny se neuložily z důvodu špatně zadaného původního hesla."
    },
    "ucb": {
      "title": "Právní dokumenty a sdělení",
      "text": "Vezměte prosím na vědomí, že UniCredit Bank Czech Republic and Slovakia, a.s. nepřebírá žádnou odpovědnost za obsah a průběh služby, která je zaměstnanci poskytnuta. Využití této služby zaměstnancem je dobrovolné a odpovědnost za dodání služby ve formě lékařské rady nese poskytovatel služby společnost uLékaře.cz, s.r.o., která odpovídá za to, že lékařskou radu poskytuje výhradně osoba k tomu způsobilá dle platných právních předpisů České republiky. Zaměstnanci se doporučuje před využitím služby lékařské poradny řádně se seznámit s {terms_and_conditions}.",
      "termsAndConditions": "podmínkami užití služby"
    },
    "removeSection": {
      "title": "Zrušení účtu",
      "text": "Váš účet bude deaktivován. Pokud si to rozmyslíte, můžete deaktivaci zrušit přihlášením do svého účtu. Po 30 dnech už nebude možné se k účtu vrátit.",
      "button": "Zrušit účet"
    },
    "removeDialog": {
      "title": "Jste si opravdu jistí?",
      "areYouSure": {
        "text": "Váš účet bude deaktivován. Pokud si to rozmyslíte, můžete deaktivaci zrušit přihlášením do svého účtu. Po 30 dnech už nebude možné se k účtu vrátit.",
        "yes": "Zrušit účet",
        "no": "Zůstat ve zdraví",
        "title": "Opravdu chcete zrušit svůj účet?"
      },
      "list": [
        {
          "icon": "chat-empty",
          "text": "Přijdete o svého průvodce prevencí. Péče o zdraví teď bude složitější."
        },
        {
          "icon": "surgeon",
          "text": "Rozloučíte se s více než 350 lékaři a sestřičkami, kteří vám pomáhají."
        },
        {
          "icon": "person-sad",
          "text": "Ztratíte cenné odpovědi lékařů a přehled o svém zdraví."
        }
      ],
      "footer": "Máte otázky nebo potřebujete poradit? Náš tým zákaznické péče je tu pro vás na na {email} nebo {phone}.",
      "cancelButton": "Zůstat ve zdraví",
      "deleteButton": "Zrušit účet",
      "confirmTitle": "Váš účet bude zrušen.",
      "confirmText": "Pokud si to rozmyslíte, můžete účet obnovit přihlášením během následujících 30 dnů pomocí svých aktuálních přihlašovacích údajů. <br/>Máte-li jakékoliv otázky, kontaktujte naši zákaznickou podporu na <a href=\"mailto: info@ulekare.cz\">info@ulekare.cz</a> nebo <a href=\"tel:00420227072720\">+420 227 072 720</a>.",
      "feedback": {
        "title": "Proč odcházíte?",
        "checkboxes": {
          "no_or_low_use": "Službu už nepotřebuji nebo ji využívám málo",
          "disappointed": "Služby nesplnily moje očekávání",
          "technical_issues": "Technické potíže se systémem",
          "price_too_high": "Cena je pro mě vysoká",
          "better_alternative": "Používám jinou službu",
          "other": "Jiný důvod / nechci uvádět"
        },
        "detailsLabel": "Řekněte nám více",
        "confirm": "Zrušit účet",
        "cancel": "Zůstat ve zdraví"
      }
    },
    "benefits": {
      "consultation_forum": {
        "chip": "Poradna",
        "tooltip": "Napište lékaři svůj dotaz. Odpoví vám online."
      },
      "booking": {
        "chip": "Objednání",
        "tooltip": "Naše sestřičky vás objednají k lékaři."
      },
      "prevention_plan": {
        "chip": "Plán prevence",
        "tooltip": "Prohlídky a očkování vám na míru."
      },
      "insurance_contributions": {
        "chip": "Příspěvky pojišťoven",
        "tooltip": "Zjistěte, na jaké příspěvky od pojišťovny máte nárok."
      },
      "health_tests": {
        "chip": "Zdravotní testy",
        "tooltip": "Vyplňte krátký test a zjistěte víc o svém zdraví."
      },
      "video_call_therapist": {
        "chip": "Videohovor: terapeut",
        "tooltip": "Objednejte si online sezení s terapeutem."
      },
      "content_explore": {
        "chip": "Objevujte",
        "tooltip": "Články, podcasty, testy i tipy pro zdravější život."
      },
      "helpline_free": {
        "chip": "Bezplatná linka",
        "tooltip": "Jsme tu pro vás v pracovní dny od 8:00 do 17:00."
      },
      "video_call_doctor": {
        "chip": "Videohovor: lékař",
        "tooltip": "Zarezervujte si videohovor s lékařem."
      },
      "assistance_line": {
        "chip": "Asistenční linka",
        "tooltip": "V případě potřeby je tu pro vás psycholog."
      },
      "blood_tests_review": {
        "chip": "Krevní testy + vysvětlení",
        "tooltip": "Objednejte se na odběr. Výsledky vám vysvětlí lékař."
      }
    },
    "benefit": {
      "validTo": "Platnost do",
      "availableServices": "Dostupné pro vás",
      "title": "Správa služby",
      "subtitle": "Vaše aktuální nastavení služby zdarma",
      "card": {
        "authorize": "Aktivní",
        "prolong": "Platnost brzy končí",
        "pending": "Čeká na dokončení aktivace služby",
        "ended": "Platnost skončila",
        "family": "Aktivní (člen rodiny)",
        "familyExpired": "Zeptejte se svého blízkého na prodloužení služby zdarma"
      },
      "partnerSuggestions": {
        "title": "Změna firmy/partnera, díky kterému máte službu zdarma",
        "subtitle": "Službu zdarma můžete mít hrazenou jen jednou firmou nebo partnerem.",
        "nosearch": {
          "title": "Nechce se vám hledat? Nevadí.",
          "subtitle": "Možná můžete mít službu zdarma díky některému z našich 6 partnerů."
        }
      },
      "searchPlaceholder": "Zadejte název firmy nebo partnera",
      "selectPartner": "Aktivovat službu zdarma",
      "serviceNotActive": "Služba zdarma není aktivní",
      "b2c": {
        "title": "Nemáte přiřazenou firmu ani partnera, který vám službu hradí.",
        "subtitle": "Zadejte název firmy nebo partnera a získejte bezplatný přístup ke službě. Partnerem může být vaše pojišťovna, vydavatel platební či kreditní karty atd."
      },
      "authorization": {
        "none": "Jiná forma aktivace",
        "email": "Aktivace pomocí e-mailu",
        "codeOnly": "Aktivace pomocí kódu",
        "codeAndEmail": "Aktivace pomocí kódu i e-mailu",
        "code": {
          "finished": {
            "buttonText": "Hotovo"
          }
        }
      },
      "prolong": {
        "buttonText": "Prodlužte si službu zdarma"
      },
      "authorize": {
        "buttonText": "Aktivujte si službu zdarma"
      },
      "goback": "Zpět",
      "partnerDetected": {
        "title": "Zřejmě máte nárok na službu zdarma. Platí to?",
        "subtitle": "Pokud ano, aktivujte si službu zdarma."
      },
      "family": {
        "buttonText": "Aktuální nastavení"
      },
      "ended": {
        "buttonText": "Prodlužte si službu zdarma"
      },
      "info": {
        "ended": "Znovu aktivujte službu zdarma",
        "authorize": "Služba zdarma je aktivní",
        "prolong": "Platnost služby zdarma brzy skončí",
        "family": "Služba zdarma je aktivní díky rodinnému sdílení"
      },
      "manage": {
        "buttonText": "Spravovat nastavení služby"
      },
      "reauthorize": {
        "buttonText": "Prodlužte si službu zdarma"
      },
      "showMore": "Zobrazit více",
      "showLess": "Zobrazit méně"
    },
    "multifactor": {
      "label": "Dvoufaktorové ověření",
      "off": "Vypnuto",
      "offInfo": "Vypnuté dvoufaktorové ověření",
      "sms": "Ověření pomocí SMS",
      "smsInfo": "Na váš telefon bude při přihlášení zaslán ověřovací kód.",
      "email": "Ověření e-mailem",
      "emailInfo": "Na e-mail vám při pokusu o přihlášení přijde ověřovací kód."
    },
    "appSecurity": "Zabezpečení aplikace",
    "cAppSecurity": {
      "biometry": {
        "description": "Chraňte přístup do aplikace otiskem prstu nebo skenem obličeje",
        "title": "Biometrický zámek"
      },
      "title": "Zabezpečení aplikace",
      "pin": {
        "title": "PIN kód",
        "description": "Chraňte přístup do aplikace šestimístným PINem",
        "setup": {
          "enterTitle": "Nastavení PIN",
          "enterSubtitle": "Zadejte šestimístný PIN",
          "confirmTitle": "Potvrďte PIN",
          "confirmSubtitle": "Zadejte PIN znovu pro potvrzení",
          "mismatch": "PINy se neshodují, zkuste to znovu",
          "cancel": "Zrušit"
        },
        "verify": {
          "title": "Ověření PIN",
          "subtitle": "Zadejte svůj PIN pro pokračování",
          "incorrect": "Nesprávný PIN, zkuste to znovu"
        }
      },
      "lock": {
        "title": "Aplikace je uzamčena",
        "subtitle": "Ověřte svou totožnost pro pokračování",
        "biometricButton": "Odemknout obličejem/otiskem prstu",
        "wrongPin": "Nesprávný PIN, zkuste to znovu"
      }
    }
  },
  "passwordRenewal": {
    "title": "Aktualizujte si heslo.",
    "subtitle": "Je potřeba, abyste si aktualizovali heslo, protože platnost vašeho hesla vypršela.",
    "currentPassword": "Aktuální heslo:",
    "newPassword": "Nové heslo:",
    "passwordRules": "Heslo musí mít alespoň 12 znaků a obsahovat alespoň jedno písmeno, číslici a speciální znak (-=%*+./![]@#$^&()?;) a nesmí být použito stejné heslo, které jste použili v minulosti.",
    "confirmation": "Potvrďte své nové heslo",
    "passwordsDontMatch": "Hesla se neshodují",
    "button": "Změnit heslo",
    "thankYouTitle": "Heslo bylo změněno",
    "thankYouSubtitle": "Vaše heslo bylo úspěšně změněno. Děkujeme za spolupráci!"
  },
  "subscription": {
    "signpost": {
      "title": "Kdo mi službu hradí?",
      "b2cButton": "Budu si hradit sám",
      "b2bButton": "Zaměstnavatel nebo jiná společnost"
    }
  },
  "questions": {
    "answerDisclaimer": "Vezměte, prosím, na vědomí, že výše uvedená odpověď má pouze informativní charakter. Jedná se o&nbsp;obecné rady a informace z&nbsp;oblasti zdraví, nemocí či jiných zdravotních obtíží. Výše uvedené informace nemohou být považovány za určení individuální diagnózy, stanovení léčebného plánu či plánu prevence, a to zejména s&nbsp;ohledem na omezené možnosti online komunikace. Vzhledem k&nbsp;tomu, že informace od uživatele nemohou být úplné a tělesné vyšetření není možné, odpovědi jednotlivých lékařů se mohou v&nbsp;detailech lišit v&nbsp;závislosti na jejich zkušenostech a klinické praxi. Využití služby v&nbsp;žádném případě nenahrazuje osobní vyšetření lékařem. V případě zdravotních obtíží Vám doporučujeme vyhledat lékařskou či jinou odbornou péči podle povahy Vašich potíží. Odpověď lékaře mohla být přeložena pomocí překladače, poté ji vždy důkladně ověřuje zdravotník.",
    "title": "Poradna",
    "subtitle": "Zeptejte se našich lékařů. Odpovídají ve dne v noci.",
    "noQuestion": {
      "title": "Ještě čekáme na váš první dotaz.",
      "subtitle": "S čím vám pomůžeme?",
      "infoList": [
        {
          "text": "Obratem poradíme, jestli náhlý zdravotní problém zvládnete sami, nebo je potřeba lékařská pomoc.",
          "icon": "suitcase"
        },
        {
          "text": "Lékař z poradny vás nasměruje na vhodné vyšetření či ke správnému specialistovi.",
          "icon": "surgeon-question"
        },
        {
          "text": "Nerozumíte lékařské zprávě nebo laboratorním výsledkům? Naši odborníci je rádi vysvětlí.",
          "icon": "stop"
        },
        {
          "text": "Beze studu on-line. Lékaři ochotně poradí se zdravotním problémem – vám i vašim blízkým.",
          "icon": "temperature"
        }
      ]
    },
    "newQuestion": "Nový dotaz",
    "newSolved": "Přečtěte si odpověď",
    "waitingForAnswer": "Čeká na odpověď",
    "history": "Zodpovězené dotazy",
    "detail": {
      "title": "Detail dotazu",
      "sent": "Odeslaný dotaz",
      "questionFormTitle": "Popis zdravotního problému",
      "healthFormTitle": "Zdravotní stav",
      "attachments": "Přílohy",
      "helped": "Pomohla vám odpověď?"
    },
    "evaluation": {
      "title": "Děkujeme za vaši reakci",
      "text": "Pomáháte nám zlepšovat naše služby. Chcete nám sdělit něco dalšího?",
      "label": "Další komentáře a připomínky",
      "placeholder": "Jak můžeme službu vylepšit?",
      "ok": "Odpověď mi pomohla",
      "nok": "Odpověď mi nepomohla"
    },
    "thankYou": {
      "title": "Děkujeme za zaslání dotazu.",
      "subtitle": "(Komunikovat budeme v {language} jazyce)",
      "cs": "českém",
      "en": "anglickém",
      "sk": "slovenském",
      "text": "Praktický lékař se právě věnuje vašemu dotazu. Jakmile odpoví, dáme vám vědět e-mailem."
    },
    "status": {
      "waitingGpAnswer": "Váš dotaz čeká na odpověď praktického lékaře.",
      "waitingSpecialistAnswer": "Váš dotaz čeká na odpověď specialisty.",
      "answered": "Lékař odpověděl na váš dotaz.",
      "transferToAppointment": "Váš dotaz jsme změnili na objednávku, brzy se ozveme.",
      "declined": "Dotaz jsme museli odmítnout.",
      "emergency": "Lékař odpověděl a vzkazuje: Ihned vyhledejte nejbližší lékařskou pohotovost. Může se jednat o život ohrožující stav."
    },
    "askedQuestions": "Položené dotazy"
  },
  "appointments": {
    "title": "Moje objednání",
    "subtitle": "Naše sestřičky vám rády pomohou najít vhodného lékaře/specialistu nebo se dovolat ke stávajímu lékaři.",
    "statuses": {
      "newDoctor": "Lékaře jsme našli!",
      "newZZ": "Našli jsme, kde vám pomohou!"
    },
    "noAppointments": {
      "title": "Ještě jste nezkusili objednání přes uLékaře.cz.",
      "subtitle": "Jak funguje objednání přes uLékaře.cz?",
      "infoList": [
        {
          "text": "Pomáháme s objednáním po celém Česku a Slovensku.",
          "icon": "hospital"
        },
        {
          "text": "Sestřička se vám ozve další pracovní den a domluvíte spolu vše potřebné, abyste se brzy dostali ke správnému lékaři.",
          "icon": "nurse"
        },
        {
          "text": "Hledání doktorů a obvolávání ordinací nechte na nás.",
          "icon": "clock"
        }
      ]
    },
    "newAppointment": "Nové objednání",
    "activeAppointments": "Vyřizujeme",
    "visitAppointments": "Nezapomeňte navštívit lékaře",
    "evaluateAppointments": "Ohodnoťte návštěvu lékaře",
    "history": "Dokončená objednání",
    "evaluation": {
      "ok": "Spokojenost s návštěvou",
      "nok": "Nespokojenost s návštěvou",
      "noVisit": "Návštěva lékaře neproběhla"
    },
    "detail": {
      "title": "Detail objednávky",
      "sent": "Odeslána",
      "date": "Termín objednání: ",
      "visitAt": "Kdy se dostavit: ",
      "facility": "Zdravotnické zařízení: ",
      "address": "Adresa: ",
      "doctor": "Lékař: ",
      "phone": "Telefon: ",
      "note": "Poznámka: ",
      "dateMandatory": "Výše uvedený termín je závazný!",
      "unableToVisitInfo": "Pokud se na domluvenou návštěvu lékaře nemůžete dostavit, volejte prosím {phone} nebo pište na <a href=\"mailto:{email}\">{email}</a>.",
      "thankYou": "Věříme, že vám námi doporučený lékař pomůže v řešení vašich zdravotních problémů. Dejte nám prosím vědět, zda vše dobře dopadlo. Děkujeme!",
      "additionalQuestion": "Mám doplňující dotaz",
      "changeDate": "Změnit termín",
      "cancelAppointment": "Zrušit objednání",
      "website": "Web: ",
      "helped": "Jak hodnotíte objednání?",
      "noVisit": "Neproběhla"
    },
    "thankYou": {
      "title": "Děkujeme za objednání.",
      "subtitle": "Vyčkejte.",
      "cs": "českém",
      "en": "anglickém",
      "sk": "slovenském",
      "text": "Naše sestřička se vám ozve další pracovní den z čísla +420 227 072 720.",
      "others": {
        "text": "Sestřička se bude ptát na tyto informace o člověku, kterého se objednání týká:",
        "items": [
          {
            "icon": "register",
            "text": "rodné číslo a pojišťovna"
          },
          {
            "icon": "person-happy",
            "text": "aktuální zdravotní stav"
          },
          {
            "icon": "news",
            "text": "absolvovaná vyšetření a žádanky"
          },
          {
            "icon": "clock",
            "text": "časová dostupnost"
          }
        ]
      }
    },
    "status": {
      "waiting": "Sestřička se bude brzy věnovat vašemu objednání, už brzy se ozve.",
      "lookingForDoctor": "Právě pro vás hledáme vhodného lékaře.",
      "orderedForTime": "Máte domluvenou návštěvu na {datetime}.",
      "orderedForOpeningHours": "Domluveno! V ordinaci vás přijmou podle ordinační doby.",
      "sendContact": "Poslali jsme vám kontakt na lékaře.",
      "done": "Uzavřeno",
      "cancelled": "Objednávka se zrušila."
    },
    "previousAppointments": "Historie objednávek"
  },
  "prevention": {
    "title": "Začněte s prevencí. Zdraví je vaše.",
    "subtitle": "Stačí pár osobních údajů a připravíme vám prevenci na tělo. Předcházet zdravotním potížím pak bude o tolik snazší.",
    "birthDateNote": "Věk je jen číslo. My ho potřebujeme vědět, abychom vám poskytli správnou péči.",
    "healthInsuranceProviderNote": "Uvidíte příspěvky své pojišťovny a také vám pomůžeme s objednáním ke spolupracujícím lékařům.",
    "personalization": {
      "banner": {
        "title": "Prevence šitá na míru",
        "subtitle": "Doplňte o sobě pár údajů a&nbsp;prevenci vám ihned přizpůsobíme.",
        "button": "Získat prevenci na míru"
      },
      "title": "Vaše prohlídky podle věku",
      "text": "Při vypnutí uvidíte i preventivní prohlídky, na které se obvykle chodí v pozdějším věku."
    },
    "start": "Začít s prevencí",
    "thankYou": {
      "title": "A je to! Děkujeme za vyplnění všech údajů.",
      "text": "Díky preventivní péči předejdete zdravotním potížím a onemocněním. Tipy a novinky týkající se péče o zdraví najdete pravidelně ve svém e-mailu."
    },
    "summary": {
      "title": "Prevence",
      "subtitleDesktop": "Pomůžeme vám být před nemocemi o krok napřed.",
      "subtitleMobile": "Před nemocemi o krok napřed.",
      "showAll": "Ukázat vše",
      "intervalEnds": "Brzy se objednejte",
      "planned": "Naplánováno",
      "plannedOn": "Naplánováno na {time}",
      "timeline": {
        "title": "Následuje",
        "tooltip": "Tady uvidíte nejbližší prohlídky a očkování – jste už objednaní?"
      },
      "examinations": {
        "title": "Preventivní prohlídky",
        "tooltip": "Tady najdete termíny prohlídek a všechny informace, co vás čeká."
      },
      "vaccinations": {
        "title": "Očkování",
        "tooltip": "Tady najdete termíny očkování a všechny informace, co vás čeká."
      },
      "others": {
        "title": "Ostatní"
      },
      "tallyTests": {
        "title": "Tematické zdravotní testy"
      }
    },
    "list": {
      "examinations": {
        "recommended": "Povinné prohlídky",
        "optional": "Dobrovolné prohlídky"
      },
      "vaccinations": {
        "recommended": "Povinná očkování",
        "optional": "Dobrovolná očkování"
      }
    }
  },
  "payment": {
    "title": "Zvolte platbu",
    "priceSum": "Celkem: {price} Kč",
    "priceAfterDiscount": "Cena služby po slevě: {price} Kč",
    "priceWithPartnerDiscount": "Cena se slevou {discountPercent} % {partnerName}: {price} Kč",
    "voucher": "Kód vašeho voucheru",
    "voucherGroup": "Poukázkou {region}",
    "voucherApply": "Aplikovat",
    "pay": "Zaplatit ({price} Kč)",
    "payment_created": "Platbu jsme zatím neobdrželi.",
    "payment_confirmed": {
      "title": "Děkujeme za dotaz!",
      "subtitle": "Dotaz už putuje k praktickému lékaři, který se mu vzápětí začne věnovat. Jakmile odpoví, dáme vám vědět e-mailem."
    },
    "payment_canceled": "Platba byla zrušena.",
    "payment_rejected": "Vaše platba byla zamítnuta.",
    "payment_create_error": "Platba se nezdařila. Zkuste to znovu.",
    "payment_timeouted": "Platba se nezdařila. Zkuste to znovu.",
    "payment_in_progress": "Čekáme na uhrazení vaší platby.",
    "payment_wait": {
      "title": "Čekáme na ověření platby.",
      "subtitle": "Jakmile bude platba ověřená, předáme dotaz lékařům."
    },
    "chooseDifferent": "Vybrat jinou metodu",
    "payment_refunded": "Vaše platba byla vrácena."
  },
  "labTests": {
    "rowTitle": "Vaše krevní testy",
    "answerDisclaimer": "Vezměte, prosím, na vědomí, že výše uvedená odpověď má pouze informativní charakter. Jedná se o&nbsp;obecné rady a informace z&nbsp;oblasti zdraví, nemocí či jiných zdravotních obtíží. Výše uvedené informace nemohou být považovány za určení individuální diagnózy, stanovení léčebného plánu či plánu prevence, a to zejména s&nbsp;ohledem na omezené možnosti online komunikace. Vzhledem k&nbsp;tomu, že informace od uživatele nemohou být úplné a tělesné vyšetření není možné, odpovědi jednotlivých lékařů se mohou v&nbsp;detailech lišit v&nbsp;závislosti na jejich zkušenostech a klinické praxi. Využití služby v&nbsp;žádném případě nenahrazuje osobní vyšetření lékařem. V případě zdravotních obtíží Vám doporučujeme vyhledat lékařskou či jinou odbornou péči podle povahy Vašich potíží. Odpověď lékaře mohla být přeložena pomocí překladače, poté ji vždy důkladně ověřuje zdravotník.",
    "detail": {
      "title": "Detail laboratorního testu",
      "sent": "Položeno",
      "questionFormTitle": "Popis zdravotního problému",
      "healthFormTitle": "Zdravotní stav",
      "attachments": "Přílohy",
      "helped": "Pomohla vám odpověď?"
    },
    "status": {
      "draft": {
        "title": "Absolvujte odběr v laboratoři",
        "text": "Náš lékař obdrží z odběrového místa výsledky vašich testů.",
        "actionText": "Přejít do Unilabs"
      },
      "new": "Čekáme na výsledky laboratorních testů.",
      "answered": "Hotovo! Přečtěte si výsledky s vysvětlením."
    }
  },
  "loginBanner": {
    "title": "Jsme vaším průvodcem na cestě za zdravím.",
    "infoList": [
      {
        "icon": "doctor",
        "text": "Praktičtí lékaři a specialisté odpovídají na dotazy."
      },
      {
        "icon": "nurse",
        "text": "Zdravotní sestry pomohou s objednáním k lékaři."
      },
      {
        "icon": "shield",
        "text": "Zabezpečené prostředí máte plně ve svých rukou."
      }
    ],
    "show": "Jak služba funguje?",
    "hide": "Zavřít"
  },
  "cookiesConsent": {
    "acceptAll": "Přijmout vše",
    "basic": {
      "title": "Náš web funguje jako lékař",
      "perex": "Náš web využívá soubory cookies, a funguje tak jako lékař, který se dotazuje, aby vám mohl co nejlépe pomoci. My takto sbíráme {technical}, {analytical} a {marketing} informace, abychom se mohli neustále zlepšovat a tím vám lépe pomohli. Souhlasíte?",
      "technical": "technické",
      "analytical": "analytické",
      "marketing": "obchodní",
      "customize": "Nastavení"
    },
    "settings": {
      "title": "Nastavení souborů cookies",
      "description": "Při návštěvě naší webové stránky www.ulekare.cz stránka získá nebo uloží informace na vašem prohlížeči, a to většinou ve formě souborů cookies. Můžou to být informace týkající se vás, vašich preferencí a zařízení, které používáte. Většinou to slouží k vylepšování stránky, aby fungovala podle vašich očekávání. Informace vás zpravidla neidentifikují jako jednotlivce, ale celkově mohou pomoci přizpůsobovat prostředí vašim potřebám. Respektujeme vaše právo na soukromí, a proto se můžete rozhodnout, že některé soubory cookies nebudete akceptovat, a to dle volby níže. Mějte na paměti, že zablokováním některých souborů cookies můžete ovlivnit, jak stránka funguje a jaké služby vám budou zobrazovány.",
      "link": "Prohlášení o cookies najdete {hereLink}.",
      "items": {
        "technical": {
          "title": "Technické cookies",
          "bodyText": "Jsou nezbytné k tomu, aby naše stránky fungovaly, takže není možné je vypnout. Většinou jsou nastavené jako odezva na akce, které jste provedli, jako je požadavek služeb týkajících se bezpečnostních nastavení, přihlašování, vyplňování formulářů atp. Prohlížeč můžete nastavit tak, aby blokoval soubory cookies nebo o nich posílal upozornění. Tyto soubory cookies neukládají žádné identifikovatelné informace."
        },
        "functional": {
          "title": "Funkční cookies",
          "bodyText": "S těmito soubory cookies je stránka výkonnější a osobnější. Můžeme je nastavovat my nebo poskytovatelé třetích stran, jejichž služby na stránkách používáme. Pokud tyto soubory cookies nepovolíte, je možné, že některé nebo všechny tyto služby nebudou fungovat správně."
        },
        "analytics": {
          "title": "Analytické cookies",
          "bodyText": "Tyto soubory cookies slouží ke zlepšení fungování webových stránek. Umožňují nám rozpoznat a zjišťovat počet návštěvníků a sledovat, jak používají webové stránky. Pomáhají nám zlepšovat způsob, jakým webové stránky fungují. Tyto cookies neshromažďují informace, které by identifikovaly vaši osobu."
        },
        "marketing": {
          "title": "Marketingové cookies",
          "bodyText": "Používají se ke sledování preferencí uživatele webových stránek za účelem cílení reklamy, tj. zobrazení marketingových a reklamních sdělení (i na stránkách třetích stran) v souladu s těmito preferencemi. <strong>Marketingové soubory cookies využívají nástrojů externích společností. Tyto marketingové cookies budou použity pouze na základě vašeho souhlasu.</strong>"
        }
      },
      "save": "Uložit nastavení"
    },
    "youtube": {
      "text": "Pro zobrazení videa potřebujeme potvrdit využití cookies. Více informací najdete v {cookiePolicyLink}.",
      "cookiePolicyLinkText": "zásadách používání cookies",
      "accept": "Souhlasím"
    }
  },
  "thematic_counselling": {
    "dashboard": {
      "title": "Zaostřeno na prevenci",
      "hint": {
        "b2b": "Jak předejít nádorovým onemocněním? {desktopBreakline}Která vyšetření jsou vhodná? Poraďte se s odborníky.",
        "b2c": "Jak předejít nádorovým onemocněním? {desktopBreakline}Která preventivní vyšetření jsou vhodná? Poraďte se zdarma."
      },
      "mobileBannerButton": "Vstoupit do tematické poradny",
      "onco-prevention": {
        "title": "Jak na onkologickou prevenci?",
        "short": "Chceme vám pomoci s obavami z vážné nemoci. S našimi lékaři je cesta k informacím snadná.",
        "long": "Bojíte se, že máte v rodině zvýšené riziko vzniku rakoviny?<br>Která preventivní vyšetření jsou vhodná a jak probíhají?<br>Co vše se dá zjistit z různých testů?<br>Naši lékaři vám s tím rádi pomůžou.",
        "footer": "⏱ Specialisté v této poradně vám odpoví do 48h",
        "button": "Zeptat se lékaře",
        "profileSectionButton": "Poradit se"
      },
      "final": {
        "title": "Váš dotaz byl úspěšně odeslán",
        "text": "Nyní se mu věnuje náš odborník a jakmile odpoví na vaše otázky, upozorníme vás e-mailem.",
        "button": "Hotovo"
      },
      "doctors": [
        {
          "name": "MUDr. František Rolinek",
          "specializations": [
            "Praktické lékařství pro dospělé"
          ],
          "institution": "MUDr. František Rolinek - ordinace, Brno",
          "image": "TMP/mudr_frantisek_rolinek.jpeg"
        },
        {
          "name": "MUDr. Lenka Rudolfová",
          "specializations": [
            "Praktické lékařství pro dospělé"
          ],
          "institution": "Poliklinika AGEL, Praha",
          "image": "TMP/mudr_lenka_rudolfova.jpeg"
        }
      ]
    }
  },
  "TMP": {
    "fb": {
      "error": "Omlouváme se za nepříjemnosti, nyní se nelze přihlásit přes účet na Facebooku. Vzniklé technické potíže řešíme s uživatelskou podporou Facebooku a pracujeme na jejich odstranění. Zkuste se prosím znovu přihlásit zítra nebo zvolte jinou metodu pro přihlášení/registraci. Děkujeme za pochopení."
    }
  },
  "placeholders": {
    "date": {
      "year": "RRRR",
      "month": "MM",
      "date": "DD"
    },
    "time": {
      "hour": "hh",
      "minute": "mm"
    }
  },
  "putinSucks": {
    "helloImage": "hello-ua-tp-figure.svg",
    "helloImageAlt": "Lékařská poradna pro občany Ukrajiny",
    "dataProcessing": {
      "personalDataTitle": "Souhlas se zpracováním mých osobních údajů, včetně osobních údajů zvláštní kategorie"
    },
    "menu": {
      "question": "Poradit se",
      "helpWith": "Jak služba funguje?",
      "logoText": "Stojíme za Ukrajinou"
    },
    "subTitle": "Lékařská poradna pro občany Ukrajiny",
    "perex": "Léčíte se s lupénkou, avšak neúspěšně? Chcete o své nemoci vědět něco dalšího? Nebo máte kožní problémy a podezření, že by mohlo jít o lupénku? Pojďte vyplnit dotazník a zeptat se našich kožních lékařů v poradně uLékaře.cz.",
    "doctorInfo": {
      "text": "“Bez obav se na nás obraťte s jakýmkoliv zdravotním problémem, který potřebujete v České republice řešit. Velmi rádi vám poradí naši lékaři a sestry, kteří hovoří ukrajinsky a rusky. Uděláme vše, co bude v našich silách, abychom pomohli vám a vašim rodinám.“",
      "name": "MUDr. Soňa Boušková",
      "position": "Chief Medical Officer uLékaře.cz"
    },
    "infoTitle": "Jak služba funguje?",
    "infoListHeader": [
      {
        "icon": "check_circle",
        "text": "Zdarma poradíme a objednáme po celé České republice."
      },
      {
        "icon": "check_circle",
        "text": "Lékaři a sestry se o vás postarají ve vašem rodném jazyce."
      },
      {
        "icon": "check_circle",
        "text": "Službu jsme pro vás zjednodušili, stačí vám e-mail a telefon."
      }
    ],
    "infoList": [
      {
        "icon": "ua/register",
        "text": "popište vaši potřebu do formuláře níže"
      },
      {
        "icon": "ua/mail",
        "text": "lékař vám odpoví e-mailem"
      },
      {
        "icon": "ua/objednavky",
        "text": "s objednáním vám pomůžou sestry"
      }
    ],
    "question": "Vyplnit dotazník",
    "rules": "Pravidla poradny \"Linka o migréně\"",
    "form": {
      "title": "Dotazník",
      "thankYou": {
        "title": "Jsme rádi, že vám můžeme pomoci",
        "perex": "<p>Lékař se vám ozve prostřednictvím e-mailu, v případě potřeby objednání vás bude kontaktovat sestra.</p>"
      }
    },
    "footer": {
      "perex": "V uLékaře.cz věříme, že zdraví je vaše. Prostřednictvím technologie, lidského přístupu a lékařské expertízy pomáháme lidem řídit si své zdraví."
    },
    "alertInfo": "Služba uLékaře.cz nenahrazuje záchrannou službu. <strong class='text-primary'>Při akutních potížích <a href='tel:155'>volejte linku 155</a>.</strong>"
  },
  "unavailableClinics": {
    "title": "Malý moment, právě aktualizujeme!",
    "description": "Omlouváme se za krátkodobý výpadek. Za chvíli bude služba zpět... a ještě lepší než dosud."
  },
  "releaseNotes": {
    "title": "Vítejte ve své zóně<br>zdraví uLékaře.cz",
    "perex": "Dlouhý život ve zdraví máte na dosah, stačí jen udělat první krok. S námi se prevence stane přirozenou součástí vašeho dne, jednoduše a přehledně. Jdeme na to?",
    "content": [
      {
        "icon": "date-question",
        "text": "Kdy naposledy jste byli u praktika a kdy tam máte jít znovu? Vyplňte termín a my se postaráme, aby vám nic neuteklo."
      },
      {
        "icon": "payment",
        "text": "Věděli jste, že na prevenci můžete ušetřit za každého člena rodiny? Máme přehled všeho, co vám proplatí vaše zdravotní pojišťovna."
      },
      {
        "text": "Rychlá kontrola zdraví s doporučením na závěr. Spíte dobře? Jak pečujete o své tělo a duši? Krátký test vám napoví.",
        "icon": "report"
      }
    ],
    "primaryButtonText": "Začít s prevencí",
    "secondaryButtonText": "Otestovat se",
    "csas": {
      "title": "Co je v domě, to je pro mě!",
      "perex": "Na pražské centrální pobočce jsme otevřeli ordinaci praktického lékaře v Centru zdraví. Vítáme všechny zaměstnance České spořitelny a jejich rodiny.",
      "content": [
        "Klientský přístup, diskrétnost a milí lékaři, kteří vás skutečně vyslechnou. A pomohou.",
        "Postaráme se i o vaše blízké. Péče všem zůstává bez ohledu na vaše zaměstnání.",
        "Za dobrým praktikem se vyplatí dojet. Ordinaci najdete přímo u metra Budějovická."
      ],
      "primaryButtonText": "Chci se registrovat"
    }
  },
  "healthInsuranceProviderBenefits": {
    "dashboard": {
      "title": "Příspěvky pojišťovny",
      "text": "Zjistěte, jaké benefity má pro vás vaše pojišťovna."
    },
    "title": "Vyberte svou pojišťovnu",
    "privateInsuranceProviders": "Soukromé pojišťovny",
    "publicInsuranceProviders": "Veřejné pojišťovny",
    "showDetail": "Zobrazit podrobnosti",
    "hideDetail": "Skrýt podrobnosti",
    "buttonText": "Uložit pojišťovnu a zobrazit",
    "empty": {
      "title": "Žádné příspěvky",
      "text": "Vybraná pojišťovna bohužel příspěvky&nbsp;nenabízí"
    },
    "fullInfo": {
      "base": "Kompletní nabídku a podmínky bonusů najdete na {link}.",
      "linkText": "stránkách pojišťovny"
    },
    "footer": {
      "updated": "Aktualizováno {date}",
      "changeCompanyInSettings": "Změnit pojišťovnu v nastavení",
      "changeCompany": "Změnit pojišťovnu"
    }
  },
  "explore": {
    "title": "Objevujte",
    "searchTitle": "Zpět na Objevujte",
    "subtitle": "Zdraví očima i ušima: Tipy, podcasty, slevy a mnohem více",
    "stories": {
      "title": "Rychlé tipy"
    },
    "articles": {
      "title": "Chytrý magazín",
      "searchTitle": "Články o tématu",
      "titleDetail": "Detail článku",
      "allChip": "Vše",
      "shareText": "Posílám zajímavý článek od uLékaře.cz",
      "footer": {
        "title": "Napadla vás při čtení otázka, kterou chcete položit lékaři?",
        "textQuestion": "Rádi zodpovíme jakýkoliv dotaz ohledně vašeho zdraví, zdraví vašeho blízkého či tohoto článku.",
        "textQuestionOrder": "Rádi zodpovíme jakýkoliv dotaz ohledně vašeho zdraví, zdraví vašeho blízkého či tohoto článku. A pokud je potřeba, objednáme vás k lékařům po celé ČR."
      }
    },
    "consultations": {
      "title": "Odpovědi lékařů",
      "titleNoTags": "Podobné dotazy",
      "searchTitle": "Dotazy o tématu",
      "titleDetail": "Detail dotazu",
      "allChip": "Aktuálně",
      "answering": "Odpovídá",
      "answeringDoctor": "Odpovídá lékař",
      "more": "Další",
      "answers": "Odpovědi",
      "disclaimer": {
        "title": "Nebojte, vaše dotazy nezveřejníme.",
        "subtitle": "Tato databáze obsahuje pouze dotazy uživatelů, kteří se zeptali mimo klientskou zónu a souhlasili se zveřejněním."
      }
    },
    "search": {
      "emptyTitle": "Pod výrazem “{query}” se nám nepovedlo nic najít",
      "placeholder": "Hledejte články, témata..."
    },
    "podcasts": {
      "title": "Podcasty"
    }
  },
  "invitation": {
    "dashboard": {
      "title": "Pozvěte rodinu",
      "text": "Služba uLékaře.cz pro vaše blízké. Úplně zdarma.",
      "buttonText": "Sdílet pozvánku"
    },
    "title": "Zdraví pro celou rodinu",
    "text": "Pozvěte až 5 svých nejbližších. Díky vám mají zdarma on-line péči lékařů i sestřiček neustále po ruce.",
    "list": [
      {
        "icon": "link",
        "text": "Zkopírujte váš unikátní odkaz ke sdílení s rodinou."
      },
      {
        "icon": "rodina",
        "text": "Pošlete ho svým blízkým."
      },
      {
        "icon": "confetti",
        "text": "Po registraci se aktivuje služba zdarma."
      }
    ],
    "shareLink": "Odkaz pro sdílení",
    "copyCode": "Zkopírovat odkaz",
    "codeCopied": "Zkopírováno",
    "familyTitle": "Komu pomáhám",
    "remove": "Odebrat",
    "shareTitle": "Služba uLékaře.cz zdarma",
    "shareText": "{personName} s vámi sdílí službu uLékaře.cz v rámci rodiny. Stačí se zaregistrovat přes odkaz a máte ji zdarma.",
    "emptyMemberName": "Člen rodiny"
  },
  "languageSwitcher": {
    "cz": "Čeština",
    "sk": "Slovenčina",
    "en": "English",
    "uk": "Українська",
    "ru": "Русский язык",
    "hu": "Magyar"
  },
  "medicalProcedure": {
    "editReport": "Upravit",
    "markAsDone": "Označit za splňené",
    "notes": "Vaše poznámky",
    "notesPlaceholder": "Přidejte své osobní poznámky ...",
    "uploadFiles": "Nahrajte soubory",
    "information": "Informace",
    "content": {
      "content1": "Co mě čeká?",
      "content2": "Jak se mám připravit?",
      "content3": "Je prohlídka hrazena?",
      "content4": "Jak na to?",
      "content5": "Kdy vyšetření provádět?",
      "content6": "Co když najdu něco znepokojivého?",
      "content7": "Jak se přenáší?",
      "content8": "Existuje nějaká prevence?",
      "content9": "Jakou vakcínu mám zvolit?"
    },
    "boxes": {
      "recommended": "Doporučeno",
      "male": "Mužům",
      "female": "Ženám",
      "from": "od",
      "interval": "Interval",
      "showDetail": "Zobrazit detail",
      "letsStart": "Pojďme začít",
      "noRecords": "Nevyplněno",
      "fromAge": "od věku"
    },
    "examination": {
      "title": "Detail prohlídky",
      "add": "Zaznamenat prohlídku",
      "listTitle": "Moje prohlídky",
      "newFormPerex": "Zapište si datum prohlídky. Můžete si také uložit poznámky a soubory (foto, lékařské zprávy atd.).",
      "editFormPerex": "Zde si můžete upravit datum, poznámky a spravovat související soubory.",
      "optional": "Dobrovolná prohlídka",
      "recommended": "Povinná prohlídka",
      "type": "Prohlídka",
      "nextBy": "Další prohlídka do",
      "next": "Další prohlídka",
      "last": "Poslední prohlídka",
      "new": "Nová prohlídka",
      "date": "Datum prohlídky",
      "time": "Čas prohlídky",
      "past": "Absolvovaná",
      "pastMulti": "Absolvované",
      "future": "Nadcházející",
      "missedNotification": "Byl překročen předepsaný interval prohlídky.",
      "emptyNotification": "Zde si můžete zapisovat a spravovat své prohlídky.",
      "errorDateEmpty": "Vyplňte prosím datum prohlídky.",
      "errorDateBoundsPast": "Vyplňte prosím datum již absolvované prohlídky.",
      "errorDateBoundsFuture": "Termín musí být v budoucnosti.",
      "todayDateCheckboxLabel": "Prohlídka proběhla dnes",
      "errorTimeRequired": "Vyplňte prosím čas prohlídky",
      "manageReports": "Moje prohlídky",
      "emptyPlaceholder": {
        "title": "Zaznamenejte si první prohlídku",
        "perex": "Udržet si přehled ve svých prohlídkách nebylo nikdy snažší"
      }
    },
    "vaccination": {
      "title": "Detail očkování",
      "add": "Zaznamenat očkování",
      "listTitle": "Moje očkování",
      "newFormPerex": "Zapište si datum očkování. Můžete si také uložit poznámky a soubory (foto, lékařské zprávy atd.).",
      "editFormPerex": "Zde si můžete upravit datum, poznámky a spravovat související soubory.",
      "optional": "Dobrovolné očkování",
      "recommended": "Povinné očkování",
      "type": "Očkování",
      "nextBy": "Další očkování do",
      "next": "Další očkování",
      "last": "Poslední očkování",
      "new": "Nové očkování",
      "date": "Datum očkování",
      "time": "Čas očkování",
      "past": "Absolvované",
      "pastMulti": "Absolvovaná",
      "future": "Nadcházející",
      "missedNotification": "Byl překročen předepsaný interval očkování.",
      "emptyNotification": "Zde si můžete zapisovat a spravovat svá očkování.",
      "errorDateEmpty": "Vyplňte prosím datum očkování.",
      "errorDateBoundsPast": "Vyplňte prosím datum již absolvovaného očkování.",
      "errorDateBoundsFuture": "Termín musí být v budoucnosti.",
      "todayDateCheckboxLabel": "Očkování proběhlo dnes",
      "errorTimeRequired": "Vyplňte prosím čas očkování",
      "manageReports": "Moje očkování",
      "emptyPlaceholder": {
        "title": "Zaznamenejte si první očkování",
        "perex": "Udržet si přehled ve svých očkováních nebylo nikdy snažší"
      }
    },
    "trash": {
      "title": "Opravdu chcete záznam smazat?",
      "text": "Záznam včetně případných poznámek a příloh nenávratně smažete.",
      "keep": "Ponechat",
      "delete": "Smazat záznam"
    }
  },
  "intervals": {
    "months": {
      "single": "měsíc",
      "plural": "měsíců",
      "semi": "měsíce"
    },
    "years": {
      "single": "rok",
      "plural": "let",
      "semi": "roky"
    }
  },
  "aeskulab": {
    "title": "Žádost o vysvětlení výsledků laboratorních testů",
    "text": "Jednoduchou cestou získáte od lékaře písemnou interpretaci výsledků svého vyšetření, které proběhlo v laboratoři Unilabs. Vaše výsledky posoudí buď interní lékař, nebo klinický genetik. K výsledkům v rámci jedné zakoupené interpretace se vyjádří pouze jeden lékař.",
    "buttonText": "Vyplnit  žádost",
    "howItWorks": {
      "title": "Jak to funguje?",
      "items": [
        {
          "icon": "chat",
          "perex": "Odešlete žádost s přiloženým pdf dokumentem s laboratorními výsledky."
        },
        {
          "icon": "mail",
          "perex": "Do 24 hodin vám pošleme vysvětlení laboratorních hodnot na váš e-mail"
        },
        {
          "icon": "calendar/date-31",
          "perex": "Pokud bude třeba, můžete si následně domluvit hovor se zdravotní sestrou."
        }
      ]
    },
    "form": {
      "thankYou": {
        "title": "Děkujeme za zaslání žádosti.",
        "perex": "Vaše laboratorní výsledky a všechny údaje jsme právě odeslali ke zpracování.\nOdpověď lékaře obdržíte do 24 hodin na svůj e-mail."
      },
      "personalData": {
        "text": "Seznámil jsem se se {link} poskytovatele zdravotních služeb uLékaře.cz Health Care.",
        "link": "zásadami zpracování osobních údajů"
      },
      "termsConds": {
        "text": "Seznámil jsem se s {link} a se {cookies} a souhlasím s nimi.",
        "link": "podmínkami užití platformy uLékaře.cz",
        "cookies": "zásadami užívání cookies platformy uLékaře.cz"
      }
    },
    "formTitle": "Formulář žádosti",
    "email": "health.care@ulekare.cz",
    "phone": "+420&nbsp;253&nbsp;253&nbsp;155",
    "errorAuthorization": "Váš odkaz je neplatný, prosím kontaktujte zákaznickou péči <a href=\"https://cz.unilabs.online/\" target=_blank\">cz.unilabs.online</a>.",
    "formButtons": {
      "text": "Použijeme údaje z webu cz.unilabs.online",
      "others": "Ptám se na jinou osobu"
    },
    "emergency": "Služba uLékaře.cz nenahrazuje záchrannou službu. Při akutních potížích <a href=\"tel:155\" class=\"link--inline black--text\">volejte linku 155</a>.",
    "footer": {
      "copyright": "&copy; {thisYear} uLékaře.cz Health Care, s.r.o.",
      "leftText": "Poskytovatel zdravotních služeb uLékaře.cz Health Care, s.r.o. Provoz webových stránek zajišťuje společnost uLékaře.cz, s.r.o.",
      "rightText": "Unilabs je provozovatel služby cz.unilabs.online a největší poskytovatel laboratorních služeb a diagnostiky v České republice."
    }
  },
  "dateInput": {
    "errors": {
      "invalidFormatDate": "Vyplňte prosím datum ve správném formátu mezi {min} a {max}",
      "invalidFormatMonth": "Vyplňte prosím měsíc ve správném formátu mezi {min} a {max}",
      "labTests": {
        "errorUnder18": "Nelze zadat žádost o interpretaci laboratorních výsledků u dětí. Interpretaci poskytujeme u dospělých starších 18 let v oborech interní lékařství a klinická genetika."
      }
    }
  },
  "timeInput": {
    "errors": {
      "invalidFormat": "Vyplňte prosím čas ve správném formátu mezi 0:00 a 23:59",
      "required": "Vyplňte prosím čas"
    }
  },
  "feedback": {
    "title": "Jak se vám líbí uLékaře.cz?",
    "text": "Vaše hodnocení je náš vitamín. Zlepšujeme zdraví této aplikace i&nbsp;díky vám.",
    "label": "Máte nějaké nápady na zlepšení?",
    "placeholder": "Tady nám je můžete prozradit...",
    "thankYou": {
      "title": "Děkujeme za zpětnou vazbu",
      "text": "Uděláme maximum, abychom vám ulehčili péči o&nbsp;zdraví."
    },
    "menu": "Zpětná vazba",
    "panelButton": "Vyplnit zpětnou vazbu"
  },
  "newsletterAgreement": {
    "dashboard": {
      "title": "Zdravé zprávy",
      "text": "Novinky a slevy vám pošleme do e-mailu."
    },
    "title": "Pošleme vám zdraví do schránky",
    "perex": "Tady začíná vaše cesta k dlouhodobému zdraví.",
    "content": [
      {
        "icon": "confetti",
        "text": "Pravidelné tipy, jak si udržet životní pohodu."
      },
      {
        "icon": "care",
        "text": "Zajímavé slevy na pomocníky, kteří utužují zdraví."
      },
      {
        "icon": "news",
        "text": "Upozornění na nové články, které vás baví číst."
      }
    ],
    "footer": {
      "text": "Kliknutím na tlačítko “Odebírat” souhlasíte se {link}.",
      "linkText": "zasíláním marketingových sdělení"
    }
  },
  "bloodReport": {
    "infoStep": {
      "title": "Vaše zdraví s vysvětlivkami",
      "perex": "Posviťte si na své zdraví. Krevní testy a podrobný komentář lékaře vám pomohou porozumět vašemu tělu.",
      "list": [
        {
          "icon": "register",
          "text": "Popíšete svůj aktuální zdravotní stav, aby doporučení lékařů sedělo přímo na tělo."
        },
        {
          "icon": "calendar/date-31",
          "text": "Doporučíme vám vhodný test. Čas a místo odběru si vyberete podle sebe."
        },
        {
          "icon": "doctor",
          "text": "Výsledky dorazí z v laboratoře. Náš lékař vám je srozumitelně vysvětlí."
        }
      ],
      "legal": [
        "Služba Interpretace laboratorních výsledků je zdravotní službou poskytovanou {link} na dálku, a to pouze v oboru vnitřního lékařství.",
        "Zdravotní služba Interpretace laboratorních výsledků není hrazena z veřejného zdravotního pojištění.",
        "Vaše osobní údaje zpracováváme v souladu se {link}."
      ],
      "legalLinkTexts": [
        "nezávislými poskytovateli zdravotních služeb",
        {},
        "Zásadami ochrany osobních údajů"
      ],
      "serviceText": "\n      Službu Vám zprostředkujeme u následujících poskytovatelů zdravotních služeb:<br/>\n      <br/>\n      provedení odběru krve a zhotovení laboratorních výsledků:<br/>\n      Unilabs Diagnostics k.s.<br/>\n      se sídlem Evropská 2589/33b, Dejvice, 160&nbsp;00&nbsp;Praha&nbsp;6<br/>\n      IČO: 604&nbsp;70&nbsp;488<br/>\n      vedená u&nbsp;Městského soudu v&nbsp;Praze pod sp.&nbsp;zn.&nbsp;A&nbsp;76193<br/>\n      <br/>\n      interpretace laboratorních výsledků:<br/>\n      uLékaře.cz Health Care, s.r.o.<br/>\n      se sídlem Českomoravská 2408/1a, Libeň, 190&nbsp;00&nbsp;Praha&nbsp;9<br/>\n      IČO: 096&nbsp;64&nbsp;777<br/>\n      vedená u Městského soudu v Praze pod sp.&nbsp;zn.&nbsp;C&nbsp;339989\n      ",
      "agreements": {
        "termsAndConditions": {
          "text": "Souhlasím s {link} poskytovatele zdravotních služeb uLékaře.cz Health Care, s.r.o.",
          "linkText": "Podmínkami poskytnutí služby Interpretace laboratorních výsledků"
        }
      }
    },
    "finalStep": {
      "title": "Co vás čeká dál?",
      "text": "Děkujeme za informace. Pomohou lékařům správně vyhodnotit výsledky vašich testů. Nyní vás předáme do rukou Unilabs – naší partnerské laboratoře.",
      "button": "Přejít do Unilabs",
      "list": [
        {
          "title": "Krok 1",
          "text": "Vyberete si laboratorní test"
        },
        {
          "title": "Krok 2",
          "text": "Rezervujete místo a termín, přijdete na odběr"
        },
        {
          "title": "Krok 3",
          "text": "Doručíme vám výsledky s vysvětlením lékaře"
        }
      ]
    }
  },
  "addressInput": {
    "country": "Stát",
    "postcode": "PSČ",
    "street": "Ulice a číslo popisné"
  },
  "videocall": {
    "chooseDate": "Vyberte si datum",
    "confirmReservation": "Potvrdit rezervaci",
    "reservationProgressing": "Probíhá potvrzování",
    "dayOfWeek": [
      "Ne",
      "Po",
      "Út",
      "St",
      "Čt",
      "Pá",
      "So"
    ],
    "month": [
      "Leden",
      "Únor",
      "Březen",
      "Duben",
      "Květen",
      "Červen",
      "Červenec",
      "Srpen",
      "Září",
      "Říjen",
      "Listopad",
      "Prosinec"
    ],
    "thankYou": {
      "info": "Všechny potřebné informace jsme vám zaslali e-mailem.",
      "success": "Videohovor byl úspěšně naplánován 🎉",
      "close": "Zavřít"
    }
  },
  "videoTherapy": {
    "infoStep": {
      "perex": "Pracovní, partnerské či psychické problémy můžete probrat v soukromí během 50minutového online sezení.",
      "title": "Není vám dobře na duši?",
      "list": {
        "third": "Potvrzeno? V e-mailu najdete odkaz, přes který se připojíte \ns terapeutem k videohovoru.",
        "second": "Vyberte den a čas, kdy byste se rádi setkali s terapeutem online.",
        "first": "Nejprve zkontrolujete své osobní a kontaktní údaje."
      },
      "legal": [
        "Službu Vám zprostředkuje poskytovatel nezdravotních služeb, kterým je společnost:",
        "uLékaře.cz,\nse sídlem Českomoravská 1a, 190 00 Praha 9, IČO: 05341051,\nvedená u Městského soudu v Praze pod sp. zn. C 262183",
        "Službu Videohovor s terapeutem hradí Váš zaměstnavatel.",
        "Služba Videohovor s terapeutem je nezdravotní službou poskytovanou na dálku formou videohovoru."
      ],
      "therapist": {
        "image": "mgr_michaela_stepanova.png",
        "name": "Mgr. Michaela Štěpánová",
        "specialization": "Psycholožka z uLékaře.cz",
        "title": "Kdo vás vyslechne?",
        "workplace": "Psychologie"
      }
    },
    "formStep": {
      "legal": {
        "termsConditions": {
          "text": "Souhlasím s {legalText} Videohovor s terapeutem poskytovaného službou uLékaře.cz"
        }
      }
    },
    "pilot": "Videohovor s terapeutem"
  },
  "program": {
    "title": "Program konference",
    "keepUpdating": "Změna programu vyhrazena.",
    "items": [
      {
        "time": "8:30 - 9:00",
        "heading": "Ranní káva a občerstvení, Zóna zdraví",
        "type": "Registrace",
        "icon": "coffee",
        "color": "deep-purple lighten-2",
        "annotation": "Tentokrát přestávka není jen o kávě. Jako letošní novinka v ceně vstupenky přibyde Zóna zdraví, kde si během každé přestávky můžete zajít na zdravotní screening a udělat něco dobrého pro sebe.\n\nTěšit se můžete na kontrolu zraku nebo krevního tlaku a před létem se navíc hodí i kontrola znamének u dermatologa. Pokud vás unaví sezení, zastavte se na masáž a dopřejte tělu zasloužené uvolnění. "
      },
      {
        "time": "9:00 - 9:15",
        "heading": "Zahájení konference",
        "type": "Přivítání moderátorem",
        "moderator": "",
        "icon": "microphone",
        "color": "white"
      },
      {
        "time": "9:15 - 9:45",
        "heading": "Zdravé stravování jako firemní strategie",
        "annotation": "Ne nadarmo se říká, že jídlo je palivo. Jeho kvalita přímo ovlivňuje, jak váš tým myslí, funguje a podává výkon. Ukážeme si, jak mohou firmy systémově podpořit zdravé stravování, a tím dlouhodobě posilovat vitalitu zaměstnanců i motivovat je předcházet civilizačním nemocem, jako je obezita.",
        "speaker": "Zuzana Volková",
        "type": "Přednáška",
        "icon": "nutrition",
        "color": "green lighten-1"
      },
      {
        "time": "9:45 - 10:15",
        "heading": "Méně chaosu, více informací: Jak JOBka funguje v praxi",
        "moderator": "",
        "guests": "Veronika Urban a Petr Kuf",
        "type": "Přednáška",
        "icon": "dizzy",
        "color": "green",
        "annotation": "Méně hledání, více informací. Ukážeme si, jak JOBka pomáhá firmám udělat pořádek v komunikaci, dostat důležité informace ke všem zaměstnancům a zjednodušit každodenní fungování – doplněno o zkušenosti z praxe."
      },
      {
        "time": "10:15 - 11:00",
        "heading": "Coffee break a networking, Zóna zdraví",
        "type": "Přestávka",
        "icon": "coffee",
        "color": "orange lighten-2",
        "annotation": "<strong>Kontrola znamének a kůže zblízka</strong><br/>\nDermatolog se podívá na vaše mateřská znaménka, pigmentové skvrny i další kožní projevy a poradí vám, na co si dát pozor a co dál řešit.\n<br/>\n<br/>\n<strong>Zdravá chodidla: přístrojová péče o plosky</strong><br/>\nPomocí podoskopu vyhodnotíme zatížení vašich chodidel a odhalíme případné rozdíly ve stoji i chůzi.\n<br/>\n<br/>\n<strong>Měření zraku a prohlídka očí</strong><br/>\nNechte si změřit orientační zrakovou ostrost na dálku i na blízko  a zjistěte, zda vaše oči nepotřebují trochu více péče.\n<br/>\n<br/>\n<strong>VR Flow: Nasaďte brýle a protáhněte se v jiném světě</strong><br/>\nCelodenní sezení dá tělu zabrat. VR technologie vás provede sérií relaxačních a protahovacích cviků ve virtuálním prostředí. Stačí 5 minut, abyste ulevili svým zádům a vrátili se do sálu s novou energií a čistou hlavou.\n<br/>\n<br/>\n<strong>Měření krevního tlaku a srdeční frekvence</strong><br/>\nMonitor srdečního tepu Heart Monitor vám pomůže lépe porozumět zdraví vašeho srdce pomocí skenování obličeje. Inovativní technologie fotopletysmografie (PPG) vyhodnotí mikropohyby a změny prokrvení kůže v obličeji a poskytne údaje o srdeční frekvenci.\n<br/>\n<br/>\n<strong>Masáže Healthy office: Úleva pro tělo i mysl</strong></br>\nBolesti, ztuhlost nebo jen potřeba dobít energii? Profesionálové z Healthy office se specializují na masáže pro lidi, kteří dlouhodobě sedí u počítače.",
        "isHtml": "true"
      },
      {
        "time": "11:00 - 11:40",
        "heading": "Pečujete o své zaměstnance. Ví o tom?",
        "annotation": "Zaměstnanecké programy, o kterých nikdo neví, jako by neexistovaly. Jak tedy zaměstnance skutečně motivovat k tomu, aby programy, které pro ně chystáte, aktivně využívali? Dozvíte se, co v praxi opravdu funguje a proč nestačí jen informovat, ale inspirovat.",
        "speaker": "Hosté: Jana Ogounová, Martina Klecker Kněžourová, Lucia Kunešová",
        "type": "Panel",
        "icon": "care",
        "color": "blue lighten-2",
        "moderator": "Moderátorka: Martina Pavlíková"
      },
      {
        "time": "11:40 - 12:10",
        "heading": "Psychická odolnost lídrů jako základ výkonu týmu",
        "moderator": "",
        "guests": "",
        "type": "Přednáška",
        "icon": "brain",
        "color": "blue",
        "annotation": ""
      },
      {
        "time": "12:10 - 13:10",
        "heading": "Oběd a networking, Zóna zdraví",
        "type": "Oběd",
        "icon": "raut",
        "color": "amber",
        "annotation": "<strong>Kontrola znamének a kůže zblízka</strong><br/>\nDermatolog se podívá na vaše mateřská znaménka, pigmentové skvrny i další kožní projevy a poradí vám, na co si dát pozor a co dál řešit.\n<br/>\n<br/>\n<strong>Zdravá chodidla: přístrojová péče o plosky</strong><br/>\nPomocí podoskopu vyhodnotíme zatížení vašich chodidel a odhalíme případné rozdíly ve stoji i chůzi.\n<br/>\n<br/>\n<strong>Měření zraku a prohlídka očí</strong><br/>\nNechte si změřit orientační zrakovou ostrost na dálku i na blízko  a zjistěte, zda vaše oči nepotřebují trochu více péče.\n<br/>\n<br/>\n<strong>VR Flow: Nasaďte brýle a protáhněte se v jiném světě</strong><br/>\nCelodenní sezení dá tělu zabrat. VR technologie vás provede sérií relaxačních a protahovacích cviků ve virtuálním prostředí. Stačí 5 minut, abyste ulevili svým zádům a vrátili se do sálu s novou energií a čistou hlavou.\n<br/>\n<br/>\n<strong>Měření krevního tlaku a srdeční frekvence</strong><br/>\nMonitor srdečního tepu Heart Monitor vám pomůže lépe porozumět zdraví vašeho srdce pomocí skenování obličeje. Inovativní technologie fotopletysmografie (PPG) vyhodnotí mikropohyby a změny prokrvení kůže v obličeji a poskytne údaje o srdeční frekvenci.\n<br/>\n<br/>\n<strong>Masáže Healthy office: Úleva pro tělo i mysl</strong></br>\nBolesti, ztuhlost nebo jen potřeba dobít energii? Profesionálové z Healthy office se specializují na masáže pro lidi, kteří dlouhodobě sedí u počítače.",
        "isHtml": "true"
      },
      {
        "time": "13:10 - 13:40",
        "heading": "Systémové řízení benefitů",
        "annotation": "Zdraví zaměstnanců je strategická investice, která se nesmí omezovat jen na nahodilé nízkonákladové benefity a jednorázové akce. Z průzkumu Ministra zdraví mezi českými firmami vyplývá, že české podniky často investují „naslepo“– neznají reálné náklady a nedokážou změřit návratnost svých programů. Data jsou totiž naprostým základem pro efektivní rozhodování. Proto se dozvíte proč udržitelný úspěch nezávisí jen na výši rozpočtu a jak přejít od nahodilých kroků ke skutečnému systému s měřitelnými cíli.",
        "speaker": "Barbora Vágnerová",
        "type": "Přednáška",
        "icon": "cash",
        "color": "pink lighten-3"
      },
      {
        "time": "13:40 - 14:20",
        "heading": "Srdce české firmy: Jak na prevenci nemocí srdce a cév",
        "moderator": "",
        "guests": "Petr Havlíček, Tomáš Šebek, Dalibor Pastucha",
        "type": "Panel",
        "icon": "heart",
        "color": "pink",
        "annotation": "Nemoci srdce a cév jsou v České republice zdravotním problémem číslo jedna, přitom se většině z nich dá předejít. Jakou roli hraje strava, životní styl nebo každodenní pracovní nápor? Kdy je čas zajít k lékaři? Co dělat, když prevence nestačí? Odborníci se podělí o praktické tipy, jak žít déle a zdravěji – a co pro to mohou udělat nejen jednotlivci, ale i firmy."
      },
      {
        "type": "Přestávka",
        "time": "14:20 - 15:00",
        "heading": "Coffee break a networking, Zóna zdraví",
        "icon": "coffee",
        "color": "gold",
        "isHtml": "true",
        "annotation": "<strong>Kontrola znamének a kůže zblízka</strong><br/>\nDermatolog se podívá na vaše mateřská znaménka, pigmentové skvrny i další kožní projevy a poradí vám, na co si dát pozor a co dál řešit.\n<br/>\n<br/>\n<strong>Zdravá chodidla: přístrojová péče o plosky</strong><br/>\nPomocí podoskopu vyhodnotíme zatížení vašich chodidel a odhalíme případné rozdíly ve stoji i chůzi.\n<br/>\n<br/>\n<strong>Měření zraku a prohlídka očí</strong><br/>\nNechte si změřit orientační zrakovou ostrost na dálku i na blízko  a zjistěte, zda vaše oči nepotřebují trochu více péče.\n<br/>\n<br/>\n<strong>VR Flow: Nasaďte brýle a protáhněte se v jiném světě</strong><br/>\nCelodenní sezení dá tělu zabrat. VR technologie vás provede sérií relaxačních a protahovacích cviků ve virtuálním prostředí. Stačí 5 minut, abyste ulevili svým zádům a vrátili se do sálu s novou energií a čistou hlavou.\n<br/>\n<br/>\n<strong>Měření krevního tlaku a srdeční frekvence</strong><br/>\nMonitor srdečního tepu Heart Monitor vám pomůže lépe porozumět zdraví vašeho srdce pomocí skenování obličeje. Inovativní technologie fotopletysmografie (PPG) vyhodnotí mikropohyby a změny prokrvení kůže v obličeji a poskytne údaje o srdeční frekvenci.\n<br/>\n<br/>\n<strong>Masáže Healthy office: Úleva pro tělo i mysl</strong></br>\nBolesti, ztuhlost nebo jen potřeba dobít energii? Profesionálové z Healthy office se specializují na masáže pro lidi, kteří dlouhodobě sedí u počítače.",
        "speaker": ""
      },
      {
        "time": "15:00 - 15:30",
        "heading": "Jak umělá inteligence mění medicínu",
        "annotation": "Co ještě nedávno znělo jako sci-fi, je dnes běžná praxe. Umělá inteligence mění způsob, jakým lékaři diagnostikují, léčí a pečují o své pacienty. Které technologie se u nás skutečně používají, kde pomáhají nejvíc a co to znamená pro budoucnost zdravotní péče? ",
        "speaker": "Tomáš Šebek",
        "icon": "briefcase",
        "color": "white",
        "moderator": "",
        "isHtml": "true",
        "type": "Přednáška"
      },
      {
        "time": "15:30 - 16:00",
        "heading": "Vyhlášení 3 nejzdravějších firem",
        "moderator": "",
        "type": "Rozloučení moderátorem",
        "icon": "trophy",
        "color": "gold",
        "isHtml": "true",
        "annotation": "<div>\n  <p>Za péči o zaměstnance rozdáme hodnotné ceny od našich partnerů.</p>\n  <ul>\n    <li>Dárkové koše s vlastním merchem od JOBka.</li>\n    <li>Balíčky probiotik BIOMEFIX.</li>\n    <li>Sadu cestovního kabinového batohu značky Schwarzwolf od partnera iMi.</li>\n    <li>Vouchery na dentální hygienu a dermatologické vyšetření od společnosti Unicare.</li>\n    <li>Vouchery na profesionální masáže přímo do kanceláře od Healthy office.</li>\n    <li>Hodinový webinář na libovolné téma od uLékaře.cz.</li>\n  </ul>\n  <br/>\n</div>Vyplňte před konferencí krátký dotazník a zapojte svou firmu do hodnocení o titul jedné ze 3 nejzdravějších firem. Zaměříme se na péči o zaměstnance i celkové firemní zdraví. Dotazník rozešleme registrovaným účastníkům přibližně týden před akcí a výsledky vyhlásíme přímo na akci.",
        "type_copy": "Rozloučení moderátorem"
      }
    ],
    "description": "Moderuje Martin Čuba"
  },
  "homepage": {
    "hero": {
      "title": "<span>Zdraví</span><br/><span>zaměstnanci.</span><br/><span style=\"opacity: .6\">Od&nbsp;hlavy&nbsp;k patě.</span>",
      "bottomText": "<div><span>Pomáháme vašim zaměstnancům</span><br/>\n<span>prodloužit život ve zdraví. Tím zvyšujeme produktivitu</span><br/>\n<span>a snižujeme náklady vaší firmy.<span/></div>"
    },
    "header": {
      "nav": {
        "login": "Přihlásit se",
        "link": [
          "Co děláme",
          "Proč uLékaře.cz",
          "References",
          "Naše služba",
          "Kariéra",
          "Kontakt"
        ]
      }
    },
    "data": {
      "title": "<span class=\"translucent\">Zdraví je byznys</span><br />\n      každé firmy.",
      "card": [
        {
          "animationData": "data_01.json",
          "caption": "Kalkulačka úspor",
          "header": "Spořte čas, snižte náklady.",
          "paragraph": [
            "Hledání lékaře v pracovní době nebo volání do ordinací zvyšují náklady a přispívají k prezentismu.",
            "Díky službě uLékaře.cz vyřeší zaměstnanci řadu svých potíží rychle, online a včas, aby případně předešli vážnějším následkům.",
            "*Data vycházejí z průměrného platu v ČR v červnu 2023."
          ]
        },
        {
          "animationData": "data_02.json",
          "caption": "Život ve zdraví",
          "header": "Zaměstnanci stárnou.",
          "paragraph": [
            "Po 50. roce věku tráví zaměstnanci více času v čekárnách a ordinacích.",
            "Firmy však potřebují zaměstnance fyzicky i duševně zdravé do vysokého věku.",
            "Službou uLékaře.cz pomůžete svým lidem oddálit nástup nemoci nebo zachytit nemoc včas."
          ]
        },
        {
          "animationData": "data_03.json",
          "caption": "Vlivy na naše zdraví",
          "header": "Zdraví není náhoda.",
          "paragraph": [
            "Zdraví nejvíc ovlivňují naše návyky a chování, mnohem více než zdravotní péče.",
            "Roli hrají také pracovní a životní prostředí, genetika, socioekonomické faktory např. vzdělání, zaměstnání, vztahy.",
            "Se službou uLékaře.cz máte účinný nástroj, který zaměstnance motivuje ke zdravějšímu životu."
          ]
        }
      ]
    },
    "circle": {
      "card": [
        {
          "icon": "circle-placeholder-first.svg",
          "title": "Měříme data",
          "desktop": [
            "Zdraví neodhadujeme, zdraví měříme.",
            "Podnikům pomáháme naplňovat cíle sociální odpovědnosti v rámci ESG a ulehčíme přípravu reportingu."
          ],
          "mobile": [
            "Zdraví neodhadujeme, zdraví měříme."
          ],
          "cta": {
            "href": "https://sites.google.com/ulekare.cz/zdravijevase/v%C5%A1e-o-esg",
            "label": "Více o ESG"
          }
        },
        {
          "icon": "circle-placeholder-second.svg",
          "title": "Edukujeme",
          "desktop": [
            "Posilujeme znalosti HR oddělení a managementu o důležitosti zdraví a pohody zaměstnanců. Odborným poradenstvím pomáháme k vytvoření zdravého pracovního prostředí a účinné strategie péče o zdraví.",
            "Komunita zdravých firem otevírá dveře všem HR, kteří hledají podporu nejen při péči o firemní zdraví."
          ],
          "mobile": [
            "Posilujeme znalosti HR oddělení a managementu o důležitosti zdraví a pohody zaměstnanců. Komunita zdravých firem otevírá dveře všem HR, kteří hledají v této oblasti podporu."
          ],
          "cta": {
            "href": "https://app.ulekare.cz/konference",
            "label": "Více o Komunitě"
          }
        },
        {
          "icon": "circle-placeholder-third.svg",
          "title": "Aktivně řešíme",
          "desktop": [
            "Na základě dat a potřeb vaší firmy se postaráme o praktické kroky, které vás přiblíží k lepšímu firemnímu zdraví. Sestavíme vám balíček služeb od online poradny, přes objednávání, videohovoru s lékařem po Dny zdraví.",
            "Také následná edukace v oblasti prevence zdraví se opírá o data, která získáte z pravidelného reportingu."
          ],
          "mobile": [
            "Na základě dat a potřeb vaší firmy se postaráme o praktické kroky, které vás přiblíží k lepšímu firemnímu zdraví. Sestavíme vám balíček služeb od online poradny po Dny zdraví."
          ],
          "cta": {
            "href": "https://www.ulekare.cz/sluzba",
            "label": "Více o Službě"
          }
        }
      ],
      "altText": "Kruh zdraví"
    },
    "community": {
      "main": {
        "header": {
          "caption": "Komunita zdravých firem",
          "heading": "Nový level HR:",
          "description": "experti na zdraví."
        }
      },
      "card": [
        {
          "img": "hobzova.png",
          "name": "Lucie Hobžová, Asahi Europe & International",
          "position": "HR Operations Lead"
        },
        {
          "img": "solcova.png",
          "name": "Šárka Šolcová, ZF Automotive Czech",
          "position": "Country LTOR Expert"
        },
        {
          "img": "svobodova.png",
          "name": "Jiřina Svobodová, J&T Banka",
          "position": "Specialista na benefity"
        },
        {
          "img": "ryskova.png",
          "name": "Petra Ryšková, Axa",
          "position": "Senior HR Business Partner CEE"
        },
        {
          "img": "valtera.png",
          "name": "Jan Valtera, AB InBev",
          "position": "Health and Wellbeing Project Manager"
        },
        {
          "img": "volfova.png",
          "name": "Lenka Volfová, Institut biostatistiky\na analýz, s.r.o.",
          "position": "HR Manager a Business Partner"
        },
        {
          "img": "kruzikova.png",
          "name": "Lenka Kružíková, Innogy Česká republika a.s.",
          "position": "Senior Manager, Human Resources"
        }
      ],
      "more": "Více o Komunitě"
    },
    "service": {
      "card": [
        {
          "heading": "Nástroj pro zaměstnance",
          "text": "Lékařská poradna online, pomoc sestřiček s objednáním k lékaři, chytrý kalendář prevence a další služby – péči o zdraví mají zaměstnanci po ruce.",
          "cta": {
            "href": "https://www.ulekare.cz/sluzba",
            "label": "Více o Službě"
          }
        },
        {
          "heading": "Cenná data pro HR",
          "text": "Díky využívání služby uLékaře.cz zjistíte, s čím vaši lidé potřebují pomoct. Na základě získaných informací připravíme firmě řešení přímo na tělo.",
          "cta": {
            "href": "/sluzba",
            "label": "Více o Službě"
          }
        }
      ]
    },
    "reference": {
      "item": [
        {
          "name": "Lenka Volfová",
          "position": "HR Manager a Business Partner, Institut biostatistiky a analýz, s.r.o.",
          "text": [
            "Se službou uLékaře.cz jsme spokojení.",
            "Pomáhá našim zaměstnancům s péčí o zdraví. Vše je snadné, rychlé a odborné. Protože zdraví našich zaměstnanců je pro nás prioritou.",
            "Zdraví všech našich 50 zaměstnanců na jednom místě."
          ],
          "video": "references_lenka-volfova"
        },
        {
          "name": "Lenka Kružíková",
          "position": "Senior Manager, Human Resources, Innogy ČR a.s.",
          "text": [
            "uLékaře.cz má vše potřebné.",
            "Služba nám pomáhá s péči o firemní zdraví. Nabízené služby pokrývají vše, na co se ve firmě chceme zaměřit. Navíc je dostupná kdykoliv.",
            "Zdraví všech našich 1 500 zaměstnanců na jednom místě."
          ],
          "video": "references_lenka-kruzikova"
        }
      ],
      "title": "<span class=\"translucent\">Jak jsou se službou</span><br />\n        spokojené firmy?"
    },
    "claim": [
      {
        "text": [
          "Snižujeme <span class=\"text--black translucent\">absenci</span>",
          "<span class=\"text--black translucent\"> a firemní náklady.</span>"
        ]
      },
      {
        "text": [
          "<span class=\"text--black translucent\">Zvyšujeme</span> skóre ESG",
          "<span>a produktivitu práce.</span>"
        ]
      },
      {
        "text": [
          "<span class=\"text--black translucent\">Zlepšujeme pohodu</span>",
          "<span>a zdraví zaměstnanců.</span>"
        ]
      }
    ],
    "vision": {
      "people": [
        {
          "name": "Martin Pospíšil",
          "position": "CEO",
          "blurb": "Ať je ve vaší firmě dvacet či 20 tisíc zaměstnanců, ať pracujete hlavou nebo rukama, služba uLékaře.cz vám pomáhá s plánováním zdraví zaměstnanců. Staráme se o firmy už od roku 2018.",
          "video": "vision_martin"
        },
        {
          "name": "Magda Blažková",
          "position": "B2B manager",
          "blurb": "Ať je ve vaší firmě dvacet či 20 tisíc zaměstnanců, ať pracujete hlavou nebo rukama, služba uLékaře.cz vám pomáhá s plánováním zdraví zaměstnanců. Staráme se o firmy už od roku 2018.",
          "video": "vision_magda"
        },
        {
          "name": "Tomáš Šebek",
          "position": "Co-founder",
          "blurb": "Ať je ve vaší firmě dvacet či 20 tisíc zaměstnanců, ať pracujete hlavou nebo rukama, služba uLékaře.cz vám pomáhá s plánováním zdraví zaměstnanců. Staráme se o firmy už od roku 2018.",
          "video": "vision_tomas"
        },
        {
          "name": "Tereza Čiháková",
          "position": "HR generalist",
          "blurb": "Ať je ve vaší firmě dvacet či 20 tisíc zaměstnanců, ať pracujete hlavou nebo rukama, služba uLékaře.cz vám pomáhá s plánováním zdraví zaměstnanců. Staráme se o firmy už od roku 2018.",
          "video": "vision_tereza"
        },
        {
          "name": "Danica Fričová",
          "position": "Praktický lékař",
          "blurb": "Ať je ve vaší firmě dvacet či 20 tisíc zaměstnanců, ať pracujete hlavou nebo rukama, služba uLékaře.cz vám pomáhá s plánováním zdraví zaměstnanců. Staráme se o firmy už od roku 2018.",
          "video": "vision_danica"
        }
      ]
    },
    "contact": {
      "title": "<span class=\"translucent\">Pojďme probrat</span><br />\n        zdraví vaší firmy.",
      "persona": {
        "img": "martin-cuba.png",
        "name": "Martin Čuba",
        "subtitle": "Zdravím, tady Martin.",
        "text": "Domluvíme si nezávaznou konzultaci,<br />\n        kde vám rádi zdarma poradíme<br />\n        s měřením firemního zdraví<br />\n        a zvýšením produktivity."
      },
      "email": "partner@ulekare.cz",
      "phone": "tel:+420603841995",
      "phoneDisplay": "+420 603 841 995",
      "form": {
        "companyName": {
          "label": "Název firmy",
          "placeholder": "Vaše firma s.r.o.",
          "error": "Uveďte název firmy."
        },
        "contactName": {
          "label": "Kontaktní osoba",
          "placeholder": "Jan Zdravý",
          "errorDigits": "Jméno nesmí obsahovat jiné znaky než písmena.",
          "error": "Uveďte prosím jméno i příjmení."
        },
        "email": {
          "label": "Pracovní e-mail",
          "placeholder": "firemni@mail.cz",
          "error": "Uveďte e-mail ve správném formátu."
        },
        "phoneNumber": {
          "label": "Telefonní číslo",
          "placeholder": "123 456 789",
          "error": "Číslo nesmí obsahovat jiné znaky než číslice."
        },
        "consentLabel": "Souhlasím se <a class=\"text--primary\" style=\"color: #3ca091 !important;\" href=\"https://www.ulekare.cz/souhlas-se-zpracovanim-osobnich-udaju-pro-ucely-hr-informaci\" target=\"_blank\">zpracováním osobních údajů</a> pro účely HR informací.",
        "submit": "Odeslat",
        "footer": "Kliknutím na 'Odeslat' souhlasíte, že se můžeme ozvat v následujících 6 měsících s nabídkami\n        vhodnými pro vaši firmu.\n        <a\n          href=\"https://www.ulekare.cz/zasady-zpracovani-osobnich-udaju\"\n          class=\"text--primary\"\n          style=\"color: #3ca091 !important;\"\n          data-section=\"kontakt\"\n          >Více o ochraně soukromí.</a>",
        "thankYou": "Děkujeme, že zdraví svých zaměstnanců berete vážně.",
        "thankYouSubtext": "Ozveme se vám během příštích pracovních dní.",
        "mobile": {
          "thankYou": "Děkujeme za váš zájem.",
          "thankYouSubtext": "Ozveme se vám nejpozději následující pracovní den.",
          "backToForm": "Zpět na formulář"
        }
      },
      "letsTalk": {
        "heading": "Zajímá vás, co umíme? \nZavolejte mi nebo napište.",
        "link": "Kontakty"
      },
      "mail": {
        "subject": "Na zdraví Vašich zaměstnanců nám záleží, brzy se ozveme",
        "content": "Hezký den,<br/><br/>\nděkujeme za Váš zájem o službu Zdraví a prevence ve firmě. Jsme rádi, že pečujete o zdraví svých zaměstnanců. Ozveme se Vám nejpozději následující pracovní den.<br/><br/>\nZdraví<br/><br/>\nMartin Čuba, Business Development Manager<br/>\ne-mail: <a href=\"mailto:partner@ulekare.cz\">partner@ulekare.cz</a><br/>\ntel.: <a href=\"tel:00420602413933\">+420 603 841 995</a>",
        "footer": {
          "copyright": "uLékaře.cz"
        }
      }
    },
    "iso": {
      "header": {
        "text": "více než 200 dalších"
      },
      "point": [
        "Procházíme pravidelným externím auditem na bezpečnost dat",
        "Data jsou šifrovaná a pravidelně zálohovaná",
        "Řídíme přístup k citlivým informacím a používáme dvoufázové ověření",
        "Pravidelně absolvujeme školení na GDPR a bezpečnost informací"
      ],
      "partner": [
        {
          "img": "cs.svg",
          "alt": "Česká spořitelna"
        },
        {
          "img": "aimtec.svg",
          "alt": "Aimtec"
        },
        {
          "img": "ikea.svg",
          "alt": "Ikea"
        },
        {
          "img": "tmobile.svg",
          "alt": "T-Mobile",
          "id": "tmobile"
        },
        {
          "img": "etnetera.svg",
          "alt": "Etnetera",
          "hideOnMobileSecond": "1"
        }
      ],
      "badge": [
        {
          "img": "isofirst.svg",
          "alt": "ISO 9001"
        },
        {
          "img": "isosecond.svg",
          "alt": "ISO/IEC 27001"
        }
      ]
    },
    "footer": {
      "value": [
        "Lidskost.",
        "Nadšení.",
        "Odbornost.",
        "Inovace."
      ],
      "about": "Vytváříme po světě ta nejzdravější pracovní prostředí a poskytujeme špičkovou péči o zdraví řízenou daty.\n        Dlouhodobě a systematicky pomáháme firmám udržovat zdraví jejich zaměstnanců.",
      "copyright": "uLékaře.cz, s.r.o.",
      "nav": {
        "link": [
          {
            "href": "https://app.ulekare.cz/podminky-uziti",
            "label": "Podmínky užití"
          },
          {
            "href": "https://app.ulekare.cz/zasady-zpracovani-osobnich-udaju",
            "label": "Zásady zpracování osobních údajů"
          },
          {
            "href": "https://app.ulekare.cz/cookies",
            "label": "Prohlášení o Cookies"
          },
          {
            "href": "https://www.ulekare.cz/ochrana-oznamovatelu",
            "label": "Ochrana oznamovatelů"
          },
          {
            "label": "Bezpečnost",
            "href": "https://app.ulekare.cz/security"
          },
          {
            "href": "https://app.ulekare.cz/career",
            "label": "Kariéra"
          },
          {
            "href": "https://app.ulekare.cz/kontakt",
            "label": "Kontakt"
          }
        ]
      },
      "aside": {
        "link": [
          {
            "href": "https://www.facebook.com/uLekare/",
            "label": "Facebook",
            "img": "facebook.svg"
          },
          {
            "href": "https://www.instagram.com/ulekare_cz/",
            "label": "Instagram",
            "img": "instagram.svg"
          },
          {
            "href": "https://cz.linkedin.com/company/ulekarecz",
            "label": "LinkedIn",
            "img": "linkedin.svg"
          },
          {
            "href": "https://www.youtube.com/@ulekarecz397",
            "label": "YouTube",
            "img": "youtube.svg"
          }
        ]
      },
      "logo": {
        "alt": "uLékaře.cz"
      }
    }
  },
  " profile": {
    "benefits": {
      "content_explore": {
        "chip": "Objevujte"
      }
    }
  },
  "profil": {
    "benefit": {
      "card": {
        "family": "Aktivní (člen rodiny)"
      }
    }
  },
  "servicePage": {
    "header": {
      "consultation": "Co děláme",
      "forCompanies": "Pro firmy",
      "articles": "Články",
      "references": "Říkají o nás",
      "submenu": {
        "consultations": "Odpovědi lékařů",
        "thematicCounselling": "Tematické poradny",
        "topics": "Aktuální témata",
        "diseases": "Nemoci",
        "firstAid": "První pomoc",
        "contact": "Kontakt",
        "career": "Kariéra"
      },
      "login": "Přihlásit se",
      "more": "Další"
    },
    "hero": {
      "title": "Péče o zdraví online, rychle a s úsměvem",
      "subtitle": "Lékařský názor nonstop a péče o vaše zdraví, jakou si zasloužíte. Protože zdraví je vaše.",
      "registerButton": "Zaregistrujte se zdarma",
      "whatWeHelpWithButton": "S čím pomůžeme?"
    },
    "signpost": {
      "boxes": [
        {
          "title": "Online lékaři pro vaše zdraví",
          "perex": "Empatické lékaře a milé sestřičky máte na dosah. Služba uLékaře.cz ulehčuje péči o zdraví celé vaší rodiny. Odkudkoliv a kdykoliv.",
          "actionText": "Co děláme"
        },
        {
          "title": "Podpora zdraví ve firmách",
          "perex": "Řada společností hradí službu uLékaře.cz svým zaměstnancům. Přidejte se k nám také a prodlužte život svých kolegů i celé firmě.",
          "actionText": "Pro firmy"
        },
        {
          "title": "Chytrý magazín o zdraví",
          "perex": "Aktuální články s ověřenými informacemi, napsané přímo lékaři a specialisty – prakticky a jasně, aby každý porozuměl svému tělu a zdraví.",
          "actionText": "Články"
        }
      ]
    },
    "consultation": {
      "title": "Lékařská poradna online",
      "opinionCard": {
        "title": "Názor lékaře bez klepání na ordinaci",
        "subtitle": "Dobře, že se ptáte...",
        "perex": "Od vyrážky po závažnou nemoc, od praktika po specialistu kteréhokoliv oboru. Tým 350+ lékařů a specialistů nonstop po ruce. Žádný problém pro nás není banalita.",
        "button": "Položte první dotaz"
      },
      "videocallCard": {
        "title": "Videohovor s lékařem, když pár řádků nestačí",
        "subtitle": "Už brzy v aplikaci",
        "perex": "Žádné dojíždění a čekání na termín, stačí si domluvit videohovor. Naši lékaři se těší na schůzku s vámi."
      },
      "specialistCard": {
        "title": "Druhá odpověď přímo od specialisty",
        "perex": "Vaší otázce se hned věnuje praktický lékař nebo pediatr, případně se vyjádří také specialista. Odpovídají lékaři ze všech oborů."
      }
    },
    "prevention": {
      "title": "Preventivní péče o zdraví",
      "calendarCard": {
        "title": "Přehledný kalendář vašeho zdraví",
        "subtitle": "Kdy máte další prohlídku?",
        "perex": "S kalendářem uLékaře.cz máte své zdraví pod kontrolou. Všechny prohlídky a očkování najdete na jednom místě, další termín vyšetření pohlídáme. Nebo vás na něj rovnou objednáme.",
        "button": "Přidejte prohlídky do kalendáře"
      },
      "savingsCard": {
        "title": "Prevence i pro vaši peněženku",
        "perex": "Co vše proplácí vaše pojišťovna? Zjistěte, na jaké příspěvky máte nárok, a zůstaňte před nemocemi o krok napřed."
      },
      "googleCard": {
        "title": "Konec googlení, vše na jednom místě",
        "perex": "Stavte se pro dávku ověřených informací, které vám vlijí zdraví do žil. Napsáno lékaři, srozumitelně a prakticky pro každý den."
      }
    },
    "order": {
      "title": "Objednání k lékaři",
      "subtitle": "Zatím pouze pro firmy",
      "dateCard": {
        "title": "Termín prohlídky rychle a s úsměvem",
        "subtitle": "Obvoláme lékaře za vás.",
        "perex": "Hledání lékaře a telefonování do ordinací nechte na nás. Zdravotní sestřičky z uLékaře.cz vám pomohou najít vhodného odborníka a případně domluvit termín.",
        "button": "Vyzkoušejte objednání k lékaři"
      },
      "mapCard": {
        "title": "Zkušení a milí lékaři po celé ČR a Slovensku",
        "perex": "Sehnat pediatra v Praze? Objednat rodiče k ortopedovi v Košicích? Pomůžeme s termínem prohlídky, ať bydlíte kdekoliv."
      },
      "nurseCard": {
        "title": "Příjemná sestřička na telefonu",
        "perex": "Stačí vyplnit jednoduchý formulář k objednání. Naše sestra zavolá vašemu zaměstnanci a domluví s ním vše podstatné."
      }
    },
    "whatWeHelpWith": {
      "title": "S čím vám rádi pomůžeme?",
      "list": [
        "Mám divnou skvrnu na kůži, vyfotil jsem ji a chci, aby mi někdo řekl, co to je.",
        "Nemám čas čekat kvůli jedné maličkosti. A ještě jsou na mě často nepříjemní.",
        "Dcera má horečky a červené pupínky. Jsou to neštovice nebo šestá nemoc?",
        "Můj lékař mi to pořádně nevysvětlil a předal mi zprávu, které nerozumím.",
        "Byl jsem u tří lékařů a každý mi říká něco jiného. Potřebuji v tom mít jasno.",
        "V novém městě potřebuju najít praktika a zubaře. Nechci je hledat sám."
      ]
    },
    "howItWorks": {
      "title": "Jak to funguje?",
      "items": [
        "Praktický lékař nebo pediatr odpoví na váš zdravotní dotaz. Týkat se může vás nebo vašeho blízkého.",
        "Je třeba názor specialisty? Odpoví odborník z jakéhokoliv oboru.",
        "Měl by vás vidět odborník? Dostaneme vás do ordinace v nejbližším možném termínu.",
        "Služba uLékaře.cz nadále zůstává vaším průvodcem v preventivní péči o zdraví. Máte ji kdykoliv po ruce."
      ]
    },
    "video": {
      "title": "Prevence je naše srdeční záležitost",
      "subtitle": "Aby u lékaře bylo dobře.",
      "perex": "Pomáháme lidem řídit své zdraví a dožít se ve zdraví co nejvyššího věku. Propojujeme odbornost lékařů s lidským přístupem a technologiemi, abyste měli své zdraví ve svých rukou. Doslova.",
      "button": "Připojte se k nám",
      "videoLink": "https://www.youtube.com/watch?v=t_iVRLx0Rrs"
    },
    "stories": {
      "title": "Příběhy z naší poradny",
      "items": [
        {
          "name": "Tereza",
          "position": "učitelka",
          "story": "“Máte úžasný systém, super notifikace. Opravdu vypiplané procesy.<br />A ještě k tomu příjemní lidé na telefonu!<br />Moc děkuji za tuto krásnou klientskou zkušenost.♡<br />Držím pěsti, ať se vám daří!”"
        },
        {
          "name": "Martin",
          "position": "podnikatel",
          "story": "“Dobrý den, mnohokrát děkuji za zprostředkování vyšetření. Tato služba je něco úžasného. Ale co je důležité, služba perfektně funguje, rychle a spolehlivě. Již jsem ji využil několikrát a i moji rodinní příslušníci také. Přeji všem, kteří se na službě podílejí, aby se jim práce stále dařila alespoň tak, jako doposud. Ještě jednou děkuji.”"
        },
        {
          "name": "Alena",
          "position": "asistentka",
          "story": "“Dobrý den, moc děkuji paním doktorkám za rychlé, ale i vstřícné a krásně vysvětlující profesionální odpovědi, které jasně vidím, že reflektují i jejich vysokou kvalifikaci a zkušenosti. Předejte jim prosím mé díky i s odpovědí, která snad potěší a přáním hezkého víkendu. Děkuji moc!”"
        },
        {
          "name": "Roman",
          "position": "řemeslník",
          "story": "“Děkuji moc za odpovědi obou paní doktorek a v neposlední řadě taktéž velké poděkování i velmi ochotné a profesionální paní sestřičce. Její přístup velmi empatický, mile mne překvapilo, jak efektivní může být “pouhá” telefonická konzultace, pokud je na druhé straně někdo, kdo má zájem problém řešit. Děkuji”"
        }
      ]
    },
    "partners": "Partneři",
    "footer": {
      "list": [
        "Lidskost",
        "Nadšení",
        "Odbornost",
        "Inovace"
      ],
      "text": "Celý tým uLékaře.cz věří, že zdraví je vaše. Spojujeme lidský přístup s lékařskou odborností, pomáháme lidem řídit své zdraví a firmám s motivací zaměstnanců. Tým 350+ lékařů všech specializací pomáhá přibližně 15 tisícům lidí měsíčně. Naši doktoři online jsou k dispozici 24 hodin 7 dní v týdnu. uLékaře.cz najdete na webu i v mobilní aplikaci."
    },
    "issn": {
      "text": "© 2007-{currentYear} uLékaře.cz, s.r.o. | ISSN 1802-5544",
      "links": [
        {
          "text": "Podmínky užití",
          "link": "https://app.ulekare.cz/podminky-uziti"
        },
        {
          "text": "Zásady zpracování osobních údajů",
          "link": "https://app.ulekare.cz/zasady-zpracovani-osobnich-udaju"
        },
        {
          "text": "Prohlášení o cookies",
          "link": "https://app.ulekare.cz/cookies"
        },
        {},
        {
          "text": "Bezpečnost",
          "link": "https://app.ulekare.cz/security"
        },
        {
          "link": "https://app.ulekare.cz/career",
          "text": "Kariéra"
        },
        {
          "link": "https://app.ulekare.cz/kontakt",
          "text": "Kontakt"
        }
      ]
    }
  },
  "secondFactor": {
    "subtitleEmail": "Dvoufaktorové ověření e-mailem",
    "label": "Zadejte kód, který vám přišel pro ověření přihlášení.",
    "rememberDevice": "Na tomto zařízení nevyžadovat",
    "sendAgain": "Poslat kód znovu",
    "verify": "Ověřit kód",
    "subtitleSms": "Dvoufaktorové ověření prostřednictvím SMS",
    "error": {
      "input": "Zadejte kód.",
      "invalidCode": "Neplatný kód"
    }
  },
  "forms": {
    "Question": {
      "patient": {
        "title": "Základní informace",
        "whoisAsking": {
          "self": {
            "label": "Na sebe"
          },
          "other": {
            "label": "Na někoho jiného"
          },
          "label": "Na koho se ptáte?"
        },
        "firstName": {
          "self": {
            "label": "Jméno",
            "help": "Zadejte své skutečné jméno pro komunikaci se zdravotnickým zařízením."
          },
          "other": {
            "label": "Jméno jiné osoby",
            "help": "Zadejte skutečné jméno pro komunikaci se zdravotnickým zařízením."
          }
        },
        "lastName": {
          "self": {
            "label": "Příjmení",
            "help": "Zadejte své skutečné příjmení pro komunikaci se zdravotnickým zařízením."
          },
          "other": {
            "label": "Příjmení jiné osoby",
            "help": "Zadejte skutečné příjmení pro komunikaci se zdravotnickým zařízením."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Číslo pojištěnce",
            "help": "Číslo pojištěnce nám zjednoduší objednání v ordinaci."
          },
          "other": {
            "label": "Číslo pojištěnce",
            "help": "Číslo pojištěnce nám zjednoduší objednání v ordinaci."
          }
        },
        "birthDate": {
          "self": {
            "label": "Datum narození"
          },
          "other": {
            "label": "Datum narození tohoto člověka"
          }
        },
        "gender": {
          "self": {
            "label": "Pohlaví",
            "help": "Vyberte pohlaví"
          },
          "other": {
            "label": "Pohlaví",
            "help": "Vyberte pohlaví",
            "placeholder": "Vyberte pohlaví"
          }
        },
        "phone": {
          "self": {
            "label": "Telefonní číslo",
            "help": "V případě potřeby vám zavolá zdravotní sestra"
          },
          "other": {
            "label": "Telefonní číslo tohoto člověka",
            "help": "V případě potřeby vám zavolá zdravotní sestra."
          }
        },
        "address": {
          "self": {
            "label": "Adresa",
            "help": "Adresa nám pomůže najít vhodného lékaře."
          },
          "other": {
            "label": "Adresa",
            "help": "Adresa nám pomůže najít vhodného lékaře."
          }
        }
      },
      "questionBasic": {
        "title": "Popište zdravotní problém",
        "questionWhat": {
          "label": "Prosím popište zdravotní problém a všechny jeho projevy. Čím podrobněji ho popíšete, tím přesněji vám lékař odpoví."
        },
        "questionHowWhen": {
          "label": "Čím problém začal a kdy (datum)? Opakuje se? Jak se vyvíjí v čase?"
        },
        "questionPastExamination": {
          "label": "Proběhlo lékařské vyšetření a s jakým závěrem? Proběhla léčba, včetně domácí? Prosím popište, jaká a zda pomohla."
        },
        "healthIssueQuestion": {
          "label": "Na co se chcete zeptat? Položte lékaři otázku, která se týká popsaného problému."
        },
        "questionSolutionCountry": {
          "label": "Ve které zemi chcete pomoct?"
        },
        "attachments": {
          "label": "Přiložte fotografie, lékařské zprávy a případné výsledky vyšetření.",
          "help": "Jeden soubor může mít velikost max. 20 MB, všechny soubory celkem max. 100 MB. Prosíme o soubory ve formátech .jpg, .png, pdf, MP3, .avi nebo mp4."
        }
      },
      "questionAdditional": {
        "title": "Doplňující informace pro lékaře",
        "questionAnotherSickness": {
          "self": {
            "label": "Léčíte se s nějakým chronickým/dalším onemocněním?"
          },
          "other": {
            "label": "Léčí se s nějakým chronickým/dalším onemocněním?"
          }
        },
        "questionAnotherSicknessDetails": {
          "self": {
            "label": "Prosím napište, s kterým onemocněním se léčíte."
          },
          "other": {
            "label": "Prosím napište, s kterým onemocněním se léčí."
          }
        },
        "questionMedications": {
          "self": {
            "label": "Užíváte pravidelně nějaké léky nebo léčivé přípravky? Např. antikoncepci, inzulin, antidepresiva..."
          },
          "other": {
            "label": "Užívá pravidelně nějaké léky nebo léčivé přípravky? Např. antikoncepci, inzulin, antidepresiva...?"
          }
        },
        "questionMedicationsDetails": {
          "self": {
            "label": "Prosím vypište názvy a dávkování užívaných léků nebo léčivých přípravků, které užíváte."
          },
          "other": {
            "label": "Prosím vypište názvy a dávkování léků nebo léčivých přípravků, které užívá."
          }
        },
        "questionAllergies": {
          "self": {
            "label": "Máte nějakou alergii, zejména na léky nebo léčivé přípravky?"
          },
          "other": {
            "label": "Má nějakou alergii, zejména na léky nebo léčivé přípravky?"
          }
        },
        "questionAllergiesDetails": {
          "self": {
            "label": "Prosím napište, na co máte alergii a jak se projevuje."
          },
          "other": {
            "label": "Prosím napište, na co má alergii a jak se projevuje."
          }
        },
        "questionLifestyle": {
          "self": {
            "label": "Co může ovlivňovat váš zdravotní stav? Např. kouření, alkohol, nadváha, nezdravý životní styl, namáhavé povolání, stres..."
          },
          "other": {
            "label": "Co může ovlivňovat zdravotní stav tohoto člověka? Např. kouření, alkohol, nadváha, nezdravý životní styl, namáhavé povolání, stres..."
          }
        },
        "questionContact": {
          "label": "Pokud lékař doporučí osobní návštěvu, chcete, aby vás kontaktovala sestra s nabídkou pomoci s objednáním?",
          "yes": "Souhlasím, aby mě sestra kontaktovala.",
          "no": "Ne, nechci, aby sestra volala."
        }
      }
    },
    "Order": {
      "patient": {
        "title": "Základní informace",
        "whoisAsking": {
          "label": "Koho se objednání týká?",
          "self": {
            "label": "Pro mě"
          },
          "other": {
            "label": "Pro jinou osobu"
          }
        },
        "firstName": {
          "self": {
            "label": "Jméno",
            "help": "Zadejte své skutečné jméno pro komunikaci se zdravotnickým zařízením."
          },
          "other": {
            "label": "Jméno jiné osoby",
            "help": "Zadejte skutečné jméno pro komunikaci se zdravotnickým zařízením."
          }
        },
        "lastName": {
          "self": {
            "label": "Příjmení",
            "help": "Zadejte své skutečné příjmení pro komunikaci se zdravotnickým zařízením."
          },
          "other": {
            "label": "Příjmení jiné osoby",
            "help": "Zadejte skutečné příjmení pro komunikaci se zdravotnickým zařízením."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Číslo pojištěnce",
            "help": "Číslo pojištěnce nám zjednoduší objednání v ordinaci."
          },
          "other": {
            "label": "Číslo pojištěnce",
            "help": "Číslo pojištěnce nám zjednoduší objednání v ordinaci."
          }
        },
        "birthDate": {
          "self": {
            "label": "Datum narození"
          },
          "other": {
            "label": "Datum narození jiné osoby"
          }
        },
        "gender": {
          "self": {
            "label": "Pohlaví",
            "help": "Vyberte pohlaví"
          },
          "other": {
            "label": "Pohlaví",
            "help": "Vyberte pohlaví"
          }
        },
        "phone": {
          "self": {
            "label": "Telefonní číslo",
            "help": "V případě potřeby vám zavolá zdravotní sestra."
          },
          "other": {
            "label": "Telefonní číslo",
            "help": "V případě potřeby vám zavolá zdravotní sestra."
          }
        },
        "address": {
          "self": {
            "label": "Adresa",
            "help": "Adresa nám pomůže najít vhodného lékaře."
          },
          "other": {
            "label": "Adresa jiné osoby",
            "help": "Adresa nám pomůže najít vhodného lékaře."
          }
        },
        "orderHealthInsurance": {
          "self": {
            "label": "Zdravotní pojišťovna",
            "help": "Hledáme lékaře, který spolupracuje s touto pojišťovnou."
          },
          "other": {
            "label": "Pojišťovna",
            "help": "Hledáme lékaře, který spolupracuje s touto pojišťovnou."
          }
        }
      },
      "orderBasic": {
        "title": "Objednání k lékaři",
        "orderWhat": {
          "label": "S čím vám mohou sestřičky pomoct?",
          "placeholder": "Např. najít nového lékaře, objednat ke stávajícímu, poradit, kam se obrátit..."
        },
        "orderSpecialist": {
          "label": "Jaký typ lékaře nebo specialisty hledáte?"
        },
        "attachments": {
          "label": "Přiložte žádanku či lékařskou zprávu, pokud ji máte.",
          "help": "Jeden soubor může mít velikost max. 20 MB, všechny soubory celkem max. 100 MB. Prosíme o soubory ve formátech .jpg, .png, pdf, MP3, .avi nebo mp4."
        },
        "orderLocality": {
          "label": "V které lokalitě chcete vyhledat lékaře?"
        },
        "orderTimeAvailability": {
          "label": "Které dny a časy se vám hodí? Nebo naopak nehodí?"
        },
        "orderContact": {
          "label": "Jak chcete s objednáním pomoci?",
          "yes": "Preferuji celkové zajištění objednání.",
          "no": "Preferuji zaslání kontaktů."
        }
      }
    },
    "goPrev": "Předchozí",
    "goNext": "Dále",
    "submit": "Odeslat"
  },
  "getApp": "Stáhnout aplikaci",
  "healthbox": {
    "landing": {
      "hero": {
        "title": "První krok k lepšímu zdraví je za vámi. Ten další máte pod palcem.",
        "perex": "Pečujte o sebe chytře, kdykoliv a odkudkoliv."
      },
      "whySection": {
        "title": "Proč mít uLékaře.cz<br/><span class=\"darker\">vždy po ruce?</span>",
        "subtitle": "Spojte se s lékaři, sledujte své zdraví a mějte jistotu, že na to nejste sami. Pomůžeme vám pečovat o sebe i své blízké – v nemoci i v prevenci.",
        "items": [
          {
            "title": "Poradna",
            "perex": "Tým 350+ lékařů a specialistů je tu pro vás ve dne v noci, aby pomohl efektivně řešit jakýkoliv zdravotní problém. Ptát se můžete na tělo i duši."
          },
          {
            "title": "Prevence",
            "perex": "Co všechno proplácí vaše pojišťovna a kdy vás čeká další preventivní prohlídka?\nTo vše a ještě více najdete přehledně na jednom místě."
          },
          {
            "title": "Objevujte",
            "perex": "Aktuální články s ověřenými informacemi, napsané přímo lékaři a specialisty – prakticky a jasně, aby každý porozuměl svému tělu a zdraví."
          }
        ]
      },
      "healthTestsSection": {
        "title": "Zdraví je vaše.<br/><span class=\"darker\">Přesvědčte se sami.</span>",
        "subtitle": "Vyzkoušejte jeden z našich odborně připravených zdravotních testů a zjistěte, co aplikace uLékaře.cz umí.",
        "test": {
          "caption": "Online zdravotní test",
          "title": "Jak jste na tom s úzkostí?<br/>Vyplňte krátký test",
          "cta": "Spustit test"
        },
        "app": {
          "title": "Posuňte se blíž k delšímu životu ve zdraví.<br />Stáhněte si aplikaci zdarma."
        }
      }
    }
  },
  "orderForm": {
    "thankYou": {
      "title": "Objednávka byla zadána.",
      "perex": "Děkujeme za vaši objednávku, jakmile bude vyřízena, dostanete upozornění."
    }
  },
  "common": {
    "ok": "Pokračovat"
  },
  "medicalProcedures": {
    "prevention": [
      {
        "id": "1f4a68b9-205e-48ed-8382-e792dfa29341",
        "icon": "doctor",
        "title": "Praktický lékař",
        "perex": "Preventivní prohlídka u praktického lékaře je nejdůležitější součást zdravotní péče. Její rozsah a zaměření se odvíjí od vašeho věku, zdravotního stavu a rizikových faktorů.",
        "expectation": "Lékař orientačně vyšetří zrak, sluch a kůži, zkontroluje očkování, změří krevní tlak a obvod pasu, vyšetří srdce, plíce, štítnou žlázu, břicho a stav cév dolních končetin. Zjistí výskyt duševních a dědičných onemocnění v rodině, posoudí celkový zdravotní stav a rizikové faktory. Součástí prohlídky je vyšetření moči testačním papírkem. Při první prohlídce se také vyšetřuje lipoprotein(a). U mužů se provádí vyšetření per rectum (konečníkem). \n\nPo přechodu od pediatra se při preventivních prohlídkách každé 2 roky (nebo dle rizika) provádějí odběry krve na vyšetření cukru v krvi, tuků, funkce ledvin a srdečně-cévních rizik.\n\nEKG se provádí při přechodu od dětského praktika nebo při nové registraci. U osob se srdečně-cévním rizikem se vyšetření provádí od 30 let do 40 let každé 4 roky.\n\nOd 40 let se provádí EKG u osob se srdečně-cévními riziky každé 2 roky (u osob bez rizika každé 4 roky). Lékař sleduje účast ve screeningových programech vhodných pro tento věk a zdravotní stav (např. mamografie u žen od 45 let, screening prostaty či plic atd).\n\nOd 45 let se při přítomnosti rizikových faktorů kontroluje funkce jater (např. nadváha, curkovka atd) každé 2 roky. Dále se provádí test na skryté krvácení do stolice nebo kolonoskopie. \n\nOd 50 let se sleduje funkce ledvin. U žen po menopauze se vyšetřuje lipoprotein(a). U mužů ve věku 50–69 let provádí praktický lékař u nerizikových pacientů odběry na PSA. U osob s vyšším srdečně-cévním rizikem se dle individuálního rizika provádí vyšetření srdeční zátěže.\n\nPacienti starší 50 let s pozitivní rodinnou anamnézou srdečního selhání, obezitou, diabetem nebo jinými rizikovými faktory absolvují podle individuálního rizika jednou za dva roky laboratorní vyšetření hladiny NT-proBNP. Tento ukazatel se používá k včasné diagnostice srdečního selhání i sledování vývoje srdečního selhání.\n \nPro osoby 65–80 let se hodnotí riziko demence. U mužů v této věkové skupině se také provádí screening výduťe břišní aorty.",
        "preparation": "Před odběrem krve je nutné lačnit od půlnoci předchozího dne a ráno pít pouze čistou vodu. Odběr ranní moči lze provést doma, středním proudem do sterilní nádoby. Objednejte se předem, aby lékař mohl vystavit žádanky na odběr krve a případná další vyšetření. Na prohlídku si vyhraďte přibližně 30 minut.",
        "isItPaid": "Preventivní kontrola u praktického lékaře je plně hrazena z veřejného zdravotního pojištění. Na vyšetření se dochází 1× za 2 roky."
      },
      {
        "id": "891f7c68-bae0-4040-9907-333177a0ac1a",
        "icon": "tooth",
        "title": "Zubní lékař",
        "perex": "Preventivní zubní prohlídky jsou klíčové pro udržení zdravého chrupu. Pomáhají předcházet komplikacím, které jsou v počátečních stádiích často bez příznaků.",
        "expectation": "Zubní lékař zkontroluje stav chrupu, sliznic, dásní a parodontu. Zhodnotí úroveň ústní hygieny a v případě potřeby odstraní zubní kámen nebo doporučí profesionální dentální hygienu. K odhalení zubního kazu a dalších patologií se pořizuje RTG (skusový) snímek chrupu, případně 1× za 2 roky také OPG (panoramatický) snímek chrupu.",
        "preparation": "Před návštěvou zubaře si důkladně vyčistěte zuby, včetně mezizubních prostor. Na samotnou prohlídku si vyhraďte přibližně 15–30 minut.",
        "isItPaid": "Preventivní prohlídka u zubního lékaře je hrazena z veřejného zdravotního pojištění. Máte nárok na 1 vyšetření ročně. Pokud to váš zdravotní stav dle posouzení zubního lékaře vyžaduje, máte nárok i na druhé (orientační) vyšetření."
      },
      {
        "id": "0f1bf426-6f77-40d4-933b-f5a1ee275be8",
        "icon": "female-reproductive-system",
        "title": "Gynekologie",
        "perex": "Vyšetření, při kterém lékař zkontroluje pohlavní orgány ženy, zaznamená datum poslední menstruace a provede cytologické vyšetření.",
        "expectation": "Během prohlídky se provádí kontrola osobní i rodinné anamnézy a lékař obvykle požaduje datum poslední menstruace. Vyšetření zahrnuje kolposkopické vyšetření (speciálním mikroskopem), vyšetření na přítomnost virů či bakterií, cytologické vyšetření, preventivní vyšetření na viry HPV u žen ve věku 35, 45 a 55 let. \n\nSoučástí péče je i poučení o samovyšetření prsů, u žen s pozitivní rodinnou anamnézou vyšetření prsů. Gynekolog kontroluje účast na screeningových programech mammografie, screening rakoviny tlustého střeva. ",
        "preparation": "Před návštěvou lékaře je vhodné provést hygienu intimních partií. Na prohlídku si vyhraďte přibližně 20 minut.",
        "isItPaid": "Preventivní prohlídka u gynekologa je hrazena z veřejného zdravotního pojištění. Máte nárok na 1 prohlídku za rok."
      },
      {
        "id": "362e63be-2a2b-4e69-ba01-a2eb5397eb79",
        "icon": "breasts",
        "title": "Vyšetření prsů",
        "perex": "Vyšetření prsů a podpaží, které slouží ke včasnému odhalení nádorového onemocnění.",
        "expectation": "Vyšetření mamografem je bezpečná a efektivní metoda, která umožňuje pořízení vysoce kvalitních rentgenových snímků s minimální dávkou záření. Vyšetření probíhá vestoje; prsy jsou krátce stlačeny přístrojem, aby bylo možné zobrazit co největší množství tkáně. Průběh vyšetření vám vysvětlí laborantka, která snímky vyhotoví, a lékař je následně zkontroluje a vyhodnotí.\n\nJako doplňková metoda, zejména u mladších žen, u žen s plnými prsy, nebo při potřebě dalšího dovyšetření, se využívá ultrazvukové vyšetření prsů, podpaží a oblasti kolem klíčních kostí. Toto vyšetření je zcela bezpečné a bezbolestné. Výsledek je patrný ihned. Provádí se vleže a lékař při něm přejíždí ultrazvukovou sondou po prsech a sleduje zobrazení na monitoru.",
        "preparation": "Zvláštní příprava není nutná, doporučuje se však nepoužívat tělové krémy ani tuhé antiperspiranty. Vyšetření trvá přibližně 20 minut.",
        "isItPaid": "U žen do 45 let se doporučuje ultrazvukové vyšetření. Bez doporučení lékaře není hrazeno z veřejného zdravotního pojištění, nicméně zdravotní pojišťovny na něj mohou přispívat. Více informací naleznete v sekci Příspěvky pojišťovny. Cena vyšetření se může lišít.\n\nU žen nad 45 let je doporučovaným screeningovým testem mamografické vyšetření, ultrazvuk slouží jako doplňková diagnostická metoda. Je hrazeno zdravotní pojišťovnou a máte na něj nárok 1× za 2 roky."
      },
      {
        "id": "f129ba70-51b5-4820-bc79-6a89072d1ae4",
        "icon": "rectum",
        "title": "Kolonoskopie",
        "perex": "Jedná se o vyšetření tlustého střeva a konečníku pomocí endoskopického přístroje, který umožňuje také odběr vzorků ze sliznice.",
        "expectation": "Kolonoskopie je preventivní i léčebná metoda, která slouží k odhalení časných změn na sliznici tlustého střeva, k odběru vzorku tkáně pro podrobnější vyšetření a také k odstranění některých útvarů. Vyšetření se provádí pomocí endoskopu, který se zavádí konečníkem do tlustého střeva. Probíhá v soukromí a se zachováním důstojnosti pacienta.\n\nVyšetření může být pro někoho nepříjemné či mírně bolestivé, proto se obvykle před výkonem podávají léky na zklidnění; možné je i provedení v celkové anestezii. Po vyšetření zůstáváte ještě krátkou dobu ve zdravotnickém zařízení a neměli byste řídit, tudíž je vhodné zajistit si doprovod na cestu domů.",
        "preparation": "Je doporučena dieta týden před vyšetřením. Tři dny před výkonem se doporučuje pouze kašovitá strava, den před kolonoskopií pak jen tekutiny a projímavý roztok, který očistí střevo od zbytků stravy a stolice. \n\nJe potřeba vyšetřit krevní obraz a srážlivost krve, u pacientů užívajících léky na ředění krve je třeba tuto skutečnost probrat s ošetřujícím lékařem a léčbu upravit. Samotné vyšetření trvá přibližně 20–30 minut.",
        "isItPaid": "Na preventivní kolonoskopické vyšetření má nárok každý od 45 do 74 let. V případě, že je první kolonoskopie bez nálezu, následuje další bezplatné vyšetření za 10 let. V případě nálezu je další vyšetření indikované lékařem individuálně. Na vyšetření je potřeba žádanka, kterou vydává praktický lékař, u žen může také gynekolog."
      },
      {
        "id": "1b8fefd5-9ca2-4d5e-afd4-9dbe46c456d4",
        "icon": "eye",
        "title": "Oční vyšetření",
        "perex": "Při očním vyšetření se lékař zaměřuje především na odhalení závažných očních vad, které jsou často bezpříznakové a člověk o nich nemusí vědět.",
        "expectation": "Při vyšetření se kontroluje celé oko i struktury kolem něj, například spojivky a víčka. Lékař zkontroluje zrakovou ostrost, zjistí, zda nepotřebujete brýle, změří nitrooční tlak a vyšetří oční pozadí. Je nutné věnovat zvláštní pozornost osobám s vysokým krevním tlakem, cukrovkou nebo těm, kteří mají v rodině oční nemoci, například šedý či zelený zákal. Pomocí dalších přístrojů může lékař podrobněji zjistit refrakční vady a odhalit i jiná onemocnění očí. Vyšetření je bezbolestné a nenáročné.",
        "preparation": "Na vyšetření se není potřeba nijak připravovat. Samotné vyšetření trvá přibližně 30 minut.",
        "isItPaid": "Oční vyšetření je hrazeno z veřejného zdravotního pojištění v jakémkoliv věku – jak preventivní prohlídka, vyšetření v případě obtíží či na doporučení jiného lékaře, například praktického. Od 45 do 61 let praktický lékař doporučuje svým pacientům, kteří oční prohlídky zatím neabsolvují, aby prevenci nezanedbávali. Praktický lékař může vystavit žádanku na preventivní vyšetření u očního lékaře, a to každé 4 roky."
      },
      {
        "id": "467fff1e-a3fe-4403-ba24-670816ec556c",
        "icon": "testicles",
        "title": "Samovyšetření varlat",
        "perex": "Rakovina varlat se nejčastěji vyskytuje u mužů ve věku 15–35 let a nádory se mohou rychle vyviíjet a růst. Léčba je možná, ale pro její úspěch je zásadní včasné odhalení, proto je v tomto věku samovyšetření varlat obzvlášť důležité a neměli byste ho zanedbávat.",
        "how": "Varlata se nejlépe vyšetřují po teplé sprše, kdy je kůže šourku uvolněná. Prohlédněte je a poté opatrně prohmatejte. Sledujte změny velikosti, tvaru nebo vzhledu kůže a případné nové bulky. Každé varle prohmatejte zvlášť oběma rukama. Nezapomeňte také na nadvarlata, ta by měla být na obou stranách souměrná.",
        "when": "Samovyšetření varlat je vhodné provádět alespoň jednou měsíčně, obzvláště ve věku 15–35 let. Pro pravidelné vyšetření si zvolte jeden stálý den v měsíci.",
        "findConcerningQuestion": "Pokud zaznamenáte změny velikosti nebo barvy varlat, cítíte bolest, nahmatáte bulky či jiné neobvyklé změny, navštivte urologa nebo praktického lékaře."
      },
      {
        "id": "df6a924b-8b1f-44be-a564-c055c11b8a27",
        "icon": "breasts-self-care",
        "title": "Samovyšetření prsů",
        "perex": "Samovyšetření prsů je jednou z nejjednodušších metod, jak včas zachytit možný výskyt karcinomu. Vyšetření je snadné a zabere vám jen pár minut.",
        "how": "Při vyšetření se postavte před zrcadlo. U žen s většími prsy je někdy snazší provést vyšetření vleže. Zkontrolujte prsní tkáň zepředu, z boku i v předklonu a všímejte si případných odlišností.\n\nSamotné prohmatávání provádějte tak, že ruku na straně, kterou kontrolujete, zvednete nad hlavu, a druhou rukou prohmatejte prs – levá ruka kontroluje pravý prs a pravá ruka levý. Sledujte změny velikosti, tvaru a bradavek, jemně stiskněte a zkontrolujte případný výtok.\n\nPrsy prohmatejte postupně seshora dolů, pak od hrudní kosti do stran, krouživými pohyby a klínovitě od bradavky do všech stran. Nezapomeňte také na oblast pod klíční kostí a na podpaží.",
        "when": "Samovyšetření provádějte po skončení menstruačního cyklu, ideálně mezi pátým a desátým dnem. Pokud menstruaci nemáte, zvolte si pro pravidelné vyšetření jeden stálý den v měsíci.",
        "findConcerningQuestion": "Při sebemenších pochybnostech navštivte svého gynekologa, případně praktického lékaře."
      },
      {
        "id": "c109b192-3a5b-4bc3-9125-ddddcea8a822",
        "icon": "prostate",
        "title": "Vyšetření prostaty",
        "perex": "Vyšetření na zdraví prostaty může provádět praktický lékař či urolog. Cílené a podrobnější vyšetření provádí urolog, který zkontroluje mužské pohlavní orgány a zjistí rodinnou anamnézu. ",
        "expectation": "Lékař provádí vyšetření pohledem a poklepem na močový měchýř a v oblasti zad. Prostatu vyšetřuje přes konečník. Dále se kontroluje krev (na nádorový ukazatel PSA) a moč, případně také ejakulát či hladina testosteronu. Součástí urologické prohlídky může být i ultrazvukové vyšetření. Vyšetření může být mírně nepříjemné, ale není bolestivé.",
        "preparation": "Před návštěvou lékaře je vhodné provést hygienu intimních partií. Na samotnou prohlídku si vyhraďte přibližně 15–30 minut.",
        "isItPaid": "Preventivní vyšetření prostaty je hrazeno z veřejného zdravotního pojištění pro muže ve věku 50–69 let. Pro muže mimo tento program platí, že běžná preventivní urologická prohlídka prostaty není hrazena, ale některé pojišťovny mohou na vyšetření přispívat. Více informací najdete v sekci Příspěvky pojišťovny. Cena se liší, proto se informujte přímo v ordinaci urologa. Doporučuje se docházet na vyšetření 1× ročně, případně dříve při rizikových faktorech."
      },
      {
        "id": "ec177bfa-7bbf-40f2-a68c-22ab20737315",
        "icon": "dermatology",
        "title": "Vyšetření znamének",
        "perex": "Vyšetření provádí kožní lékař, který kontroluje znaménka pohledem a v případě potřeby i pomocí dermatoskopu. Při podezření na změny, které vyžadují další vyšetření, lékař odešle vzorek tkáně na histologické vyšetření pod mikroskopem.",
        "expectation": "Kožní lékař zkontroluje kůži celého těla, se zaměřením na znaménka. Podezřelá znaménka jsou vyšetřena speciálním optickým přístrojem, dermatoskopem, který funguje jako lupa a umožňuje snímání znamének ve větším rozměru. Dermatoskop může být propojen s počítačem, což umožňuje porovnávání snímků s minulými vyšetřeními.\n\nPokud lékař zjistí znaménko podezřelé na nádorové bujení, může ho vyříznout a odeslat na histologické vyšetření pod mikroskopem. Výsledky jsou obvykle k dispozici při další návštěvě, případně mohou být sděleny telefonicky.\n\nNěkdy se odstraňují i znaménka, která vadí z estetického hlediska nebo se nacházejí na místech častého dráždění, například pod páskem, ramínkem podprsenky a podobně.",
        "preparation": "Na vyšetření se není potřeba nijak připravovat. Samotné vyšetření trvá přibližně 20 minut. Při vyřezávání znamének může být návštěva delší.",
        "isItPaid": "Preventivní vyšetření znamének není hrazeno z veřejného zdravotního pojištění, ale některé pojišťovny mohou na něj přispívat. Více informací najdete v sekci Příspěvky pojišťovny. Cena vyšetření se liší – pro přesné informace se obraťte přímo na ordinaci dermatologa. Preventivní prohlídka se doporučuje 1× za rok."
      },
      {
        "id": "f268c41e-244e-42f6-a079-5d44d189b8bf",
        "icon": "brush",
        "title": "Dentální hygiena",
        "perex": "Dentální hygiena slouží k prevenci zubního kazu, zánětu dásní (parodontitidy) a infekcí v ústech. Během vyšetření se odstraňuje především zubní kámen, zubní plak a pigmentace na zubech.",
        "expectation": "Dentální hygienista zkontroluje stav chrupu, se zaměřením zejména na závěsný aparát zubů (paradont). Odstraní zubní plak a pigmentaci ze zubů i poddásňových prostor do hloubky 3 mm, odstraní zubní kámen, profesionálně zuby vyčistí, vyleští a případně aplikuje fluorid.\n\nSoučástí návštěvy je také kontrola, edukace a nácvik správného čištění zubů a používání dentálních pomůcek. Díky tomu se snižuje riziko vzniku nemocí dutiny ústní, zubů a dásní, včetně parodontitidy.",
        "preparation": "Před návštěvou si důkladně vyčistěte zuby, včetně mezizubních prostor. Doporučuje se také vzít s sebou dentální pomůcky, které používáte.\nNa prohlídku si vyhraďte přibližně 30–60 minut.",
        "isItPaid": "Dentální hygiena není hrazena z veřejného zdravotního pojištění, ale některé pojišťovny na ni mohou přispívat. Více informací najdete v sekci Příspěvky pojišťovny. Cena se může lišit. Pro přesné informace se obraťte přímo na ordinaci. Doporučuje se absolvovat dentální hygienu 2× za rok."
      }
    ],
    "vaccination": [
      {
        "id": "77812777-eb63-42d8-a61e-1006038a4bdc",
        "icon": "vaccine",
        "name": "Tetanus",
        "perex": "Tetanus neboli strnutí šíje je závažné onemocnění, které je častou příčinou úmrtí především v rozvojových zemích. Toto onemocnění způsobuje bakterie Clostridium tetani, jež se běžně vyskytuje ve střevě člověka a zvířat, především u hospodářských zvířat.\nV dnešní době už téměř vymizel díky proočkovanosti populace.",
        "prevention": "Účinnou prevencí proti onemocnění tetanem je očkování. První dávka se aplikuje dětem v rámci kombinované vakcíny. V dospělosti se přeočkovává do 59 let každých 10-15 let, od 60 let se doporučuje každých 10 let.",
        "vaccineChoice": "Doporučujeme vakcínu Vacteta, která je hrazena z veřejného zdravotního pojištění. Cena pro samoplátce je přibližně okolo 200–⁠500 Kč."
      },
      {
        "id": "39ee715f-b4d8-4f76-9cc8-14ff327c0d07",
        "icon": "vaccine",
        "name": "Černý kašel",
        "perex": "Černý kašel je vysoce nakažlivé onemocnění způsobené bakterií Bordetella pertussis. Můžeme se také setkat s názvem „dávivý kašel“ či „pertuse“. Vyskytuje se celosvětově. Nejrizikovější jsou neočkované děti do 6 let věku, ovšem nákaza se může objevit v kterémkoli věku.",
        "prevention": "Nejúčinnější prevence proti onemocnění černého kašle je očkování. Vakcinace spadá do povinného očkovacího kalendáře dětí. Očkuje se většinou v kombinované vakcíně, je doporučeno přeočkování alespoň jednou za život.",
        "vaccineChoice": "Doporučujeme vakcínu Adacel, která je u dětí hrazena z veřejného zdravotního pojištění. Cena pro samoplátce je přibližně okolo 1000 Kč. Některé pojišťovny mohou na očkování přispívat, v sekci Příspěvky pojišťovny se můžete dozvědět více."
      },
      {
        "id": "1c9d2dc9-bdd6-488d-968e-4626579aeb45",
        "icon": "vaccine",
        "name": "Chřipka",
        "perex": "Chřipka je nakažlivé virové onemocnění, které postihuje každoročně velkou část populace. Ohroženi jsou nejvíce starší lidé, děti a chronicky nemocní. Mezi symptomy patří velká únava, horečka, kašel, bolest těla, kloubů a hlavy. Chřipka se vyskytuje převážně v zimním období a léčí se zhruba 1–2 týdny. ",
        "prevention": "Ůčinnou prevencí onemocnění chřipkou, je posilovat vlastní imunitní systém pomocí vyvážené zdravé stravy, dostatečného přísunu vitamínu, pitný režim, přiměřený pohyb, kvalitní spánek, otužování a hygiena. Dopomáhá také každoroční očkování proti chřipce.",
        "vaccineChoice": "Doporučujeme vakcínu Vaxigrip Tetra, kterou si pacient hradí sám. Cena jedné vakcíny je přibližně 400–⁠600 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více."
      },
      {
        "id": "c9827908-b47c-4fe1-b4ad-fdaa154a74de",
        "icon": "vaccine",
        "name": "Klíšťová encefalitida",
        "perex": "Klíšťová encefalitida je virové onemocnění, které napadá nervový systém člověka. Česká republika je dle vysokého výskytu onemocnění považována za rizikovu.",
        "prevention": "Jako prevenci je vhodné se při pobytu v přírodě chránit vhodným oděvem, používat repelenty a provést po pobytu kontrolu těla, zda není klíště přisáté.\nÚčinnou prevencí proti onemocnění klíšťové encefalitidy je očkování. Ideálně se očkuje v zimním období, před nástupem jara. Očkování je ve 3 dávkách, poté následuje přeočkování po 3 a po 5 letech.\nProdělání nemoci zajišťuje imunitu, u mladších lidí však nemusí být imunita celožitovní, u starších se předpokládá, že je. Hladina protilátek se může zkontrolovat krevním odběrem. ",
        "vaccineChoice": "Doporučujeme vakcínu FSME-IMMUN, kterou si pacient hradí sám. Cena jedné vakcíny je přibližně 800-1200 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více. Od 50 let je očkování hrazeno z veřejného pojištění."
      },
      {
        "id": "d83a0b4c-ff51-40d6-8df4-8521e7c0055f",
        "icon": "vaccine",
        "name": "Pneumokok",
        "perex": "Pneumokokové onemocnění je velmi závažné. Bakterie Streptococcus pneumoniae může vyvolat zápal plic, infekci oraganismu, zánět mozkových blan nebo záněty středního ucha u dětí.",
        "prevention": "Účinnou prevencí proti onemocnění pneumokokem je očkování. Do 59 let se očkuje 1 dávka, 1 dávka se také očkuje v rozmezí 60–64 let, a po 65. roce se očkují 2 dávky.\nDoporučuje se také posilovat vlastní imunitní systém, dbát na zdravý životní styl a vyhýbat se větším kolektivům, především v době respiračních onemocnění. ",
        "vaccineChoice": "Doporučujeme vakcínu Prevenar 13, kterou si pacient hradí sám. Cena jedné vakcíny je okolo 1500 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více. Od 65 let je očkování hrazeno z veřejného pojištění."
      },
      {
        "id": "645eddeb-539d-4374-a300-234cd724bb94",
        "icon": "vaccine",
        "name": "Meningokok B",
        "perex": "Meningokokové onemocnění může způsobit zánět mozkových blan, sepsi organismu, vysoké hořečnaté onemocnění, až smrt. V České republice je výskyt nákazy nízký, ovšem úmrtnost vysoká. Riziko je především u dětí do 5 let věku a mladých lidí do 25 let věku. Celkově existuje 13 sérotypů meningokokového onemocnění.",
        "prevention": "Účinnou prevencí proti onemocnění meningokovou infekcí je očkování. Jedná se o dvoudávkovou vakcínu s intervalem alespoň jeden měsíc, přeočkování závisí na typu vakcíny.\nDoporučuje se také posilovat vlastní imunitní systém, dbát na zdravý životní styl, dostatek spánku a odpočinku, eliminovat stres, kouření a podobně.",
        "vaccineChoice": "Doporučujeme vakcínu Bexsero, kterou si pacient hradí sám. Cena jedné vakcíny je okolo 2000 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více."
      },
      {
        "id": "7a1affc9-805a-4935-9f52-6dc627bbf4c5",
        "icon": "vaccine",
        "name": "Meningokok A, C, Y, W-135",
        "perex": "Meningokokové onemocnění může způsobit zánět mozkových blan, sepsi organismu, vysoké hořečnaté onemocnění, až smrt. V České republice je výskyt nákazy nízký, ovšem úmrtnost vysoká. Riziko je především u dětí do 5 let a mladých lidí do 25 let. Celkově existuje 13 sérotypů meningokokového onemocnění.",
        "prevention": "Účinnou prevencí proti onemocnění meningokovou infekcí je očkování. Vakcína se podává v jedné dávce.\nDoporučuje se také posilovat vlastní imunitní systém, dbát na zdravý životní styl, dostatek spánku a odpočinku, eliminovat stres, kouření a podobně.",
        "vaccineChoice": "Doporučujeme vakcíny Menveo, nebo Nimenrix, které si pacient hradí sám. Cena jedné vakcíny je okolo 1200 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více."
      },
      {
        "id": "3b6bf48f-9cb6-4d9e-b2be-6b72b103d648",
        "icon": "vaccine",
        "name": "Virová žloutenka A ",
        "perex": "Virová žloutenka typu A je akutní infekční onemocnění jater způsobené virem, známé také pod názvem „nemoc špinavých rukou“. Vyskutuje se po celém světě, především v zemích s nízkým hygienickým standardem. V těchto zemích jsou rizikové hlavně děti, jež však bývají často bez příznaků. U dospělé populace je infekce významnějšího charakteru, onemocnění je však bez trvalých následků. ",
        "prevention": "Prevencí může být dostatečná osobní hygiena a kvalitní zdroje potravin a vody. Účinnou prevencí proti onemocnění žloutenky je očkování, podává se ve dvou dávkách s odstupem jednoho roku.\nLze očkovat i v kombinaci s vakcínou proti hepatitidě typu B, tedy A+B dohromady.",
        "vaccineChoice": "Doporučujeme vakcíny Havrix 1440, nebo Vaqta Adult, které si pacient hradí sám. Cena jedné vakcíny je přibližně 1200–⁠1600 Kč. \nPro očkování proti žloutence A + B doporučujeme vakcínu Twinrix Adult, kterou si pacient hradí sám. Cena jedné vakcíny je okolo 1900 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více. "
      },
      {
        "id": "6a17b093-b6a3-4f38-9b49-2435267d0101",
        "icon": "vaccine",
        "name": "Virová žloutenka B",
        "perex": "Virová žloutenka typu B je závažné infekční onemocnění jater způsobené virem. Onemocnění je chronické a může zapříčinit cirhózu jater či rakovinu. Virus hepatitidy typu B je mnohem nakažlivější než virus HIV. Výskyt onemocnění je po celém světě. Průběh nemoci je náročný a delší než u žloutenky typu A.",
        "prevention": "Účinnou prevencí proti onemocnění žloutenky typu B je očkování. První dávka se aplikuje již v novorozeneckém věku, další 2 dávky se očkují s odstupem 1 a 6 měsíců. Očkovat se mohou i dospělí, kteří v dětsví očkování nepodstoupili. Lze očkovat také v kombinaci s vakcínou proti hepatitidě typu A, tedy A + B dohromady.",
        "vaccineChoice": "Doporučujeme vakcínu Engerix B-20, která je hrazena z veřejného zdravotního pojištění. Cena pro samoplátce je okolo 1 000 Kč. \nPro očkování proti žloutence A + B doporučujeme vakcínu Twinrix Adult, kterou si pacient hradí sám. Cena jedné vakcíny je okolo 1 900 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více. "
      },
      {
        "id": "c0d340b9-8279-4cfa-a918-ca9f0b40db65",
        "icon": "vaccine",
        "name": "Spalničky, zarděnky, příušnice",
        "perex": "Spalničky, příušnice a zarděnky jsou velmi nakažlivá virová onemocnění.",
        "prevention": "Účinnou prevencí je očkování. Aplikuje se už v dětském věku v rámci povinného očkování, provádí se kombinovanou formou vakcíny proti spalničkám, příušnicím a zarděnkám. \nV dospělosti je možné přeočkování jednou dávkou, pokud jste v profesionálním riziku, cestujete nebo jste byli v kontaktu s nakaženým.",
        "vaccineChoice": "Doporučujeme vakcíny MMR nebo Priorix, které jsou u dětí hrazeny z veřejného zdravotního pojištění. Cena pro samoplátce je okolo 700–⁠900 Kč. Některé pojišťovny mohou na očkování přispívat, v sekci Příspěvky pojišťovny se můžete dozvědět více."
      },
      {
        "id": "d206f02a-78a5-4e55-abe9-699de87259f2",
        "icon": "vaccine",
        "name": "Plané neštovice",
        "perex": "Plané neštovice jsou infekční onemocnění, které je vysoce nakažlivé. Nemoc se objevuje nejčastěji v dětském věku a mívá obvykle mírnější průběh. U těhotných žen je však nákaza nebezpečná. \nNemoc se objevuje především v zimním období, v České republice je nejčastějším infekčním onemocněním.",
        "prevention": "Efektivní prevence proti planým neštovicím je očkování. Očkování může snížit pravděpodobnost vzniku pásového oparu během života. \nPodávají se dvě dávky s odstupem minimálně šest týdnů.",
        "vaccineChoice": "Doporučujeme vakcínu Varilix, kterou si pacient hradí sám. Cena jedné vakcíny je okolo 1 500–⁠1 700 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více."
      },
      {
        "id": "815351d8-b0ea-4c5c-832b-0c6ff3e36320",
        "icon": "vaccine",
        "name": "HPV infekce",
        "perex": "HPV infekce patří k nejrozšířenějším sexuálním nemocem. Je známo více než sto typů HPV virů, asi 40 z nich postihuje pohlavní orgány. Spoustu nakažených je téměř bez příznaků infekce, a tak snadno šíří virus dále.",
        "prevention": "Efektivní prevence proti HPV nákazám je dodržování zdravého životního stylu, eliminace stresu, kouření a nechráněného sexu. Dále je namístě vyhnout se střídání sexuálních partnerů a dlouhodobému užívání hormonální antikoncepce. \nÚčinnou prevencí je také očkování, které je určeno mužům i ženám. Ideální je vakcínu aplikovat ještě před zahájením sexuálního života. Očkování probíhá ve třech dávkách, a to i u dospělých, kteří nebyli očkovaní v dětství.",
        "vaccineChoice": "Doporučujeme vakcíny Gardasil nebo Gardasil 9, které si pacient hradí sám. Cena jedné vakcíny je přibližně 2 000–⁠3 900 Kč. Některé pojišťovny mohou přispívat na očkování, v sekci Příspěvky pojišťovny se můžete dozvědět více."
      },
      {
        "id": "94a7f086-8aee-418a-a1b4-5f6de0396aa1",
        "icon": "vaccine",
        "name": "COVID-19",
        "perex": "COVID-19 je vysoce nakažlivé onemocnění, způsobené novým typem koronaviru neboli SARS-CoV-2. Výskyt této nemoci je celosvětový. Onemocnění se u nakažených projevuje různě, u většiny probíhá vcelku mírně až se středním průběhem, bez nutnosti hospitalizace.",
        "prevention": "Efektivní prevencí před onemocněním COVID-19 je dostatečná hygiena rukou, vyhýbat se většímu kolektivu lidí, chránit se respirátorem a posilovat vlastní imunitní systém. K prevenci může pomoci i očkování, jež v případě nakažení může zmírnit průběh onemocnění. Očkuje se jednou až dvěma dávkami (v závislosti na typu vakcíny), třetí dávka je podávána s odstupem minimálně dalších pěti měsíců. Čtvrtá dávka se doporučuje hlavně osobám starším 60 let a rizikovým pacientům, a to s odstupem minimálně 4 měsíce od předchozí dávky.",
        "vaccineChoice": "Doporučejeme vakcíny Comirnaty, Spikevax, Janssen, Vaxzevria nebo Novavax. Vakcíny jsou hrazeny z veřejného zdravotního pojištění. Cena pro samoplátce se pohybuje okolo 400 Kč."
      }
    ]
  },
  "serviceNotAvailable": {
    "message": "Dne 4. 1. 2026 od 1:00 do 3:00 proběhne plánovaná údržba, během které nebudou dostupné služby ani aplikace uLékaře.cz"
  },
  "contactPage": {
    "hero": {
      "title": "Kontakt",
      "perex": "Máte dotaz ohledně fungování<br>služby? Rádi poradíme."
    },
    "questionFormCard": {
      "title": "Dotazy týkající se zdraví zodpovídáme pouze přes náš formulář.",
      "cta": "Otevřít formulář"
    },
    "customerService": {
      "title": "Zákaznická linka",
      "items": [
        {
          "country": "CZ",
          "email": "info@ulekare.cz",
          "phone": "+420 227 072 720",
          "workingHours": "Po - Pá 8 - 17 hod"
        },
        {
          "country": "SK",
          "email": "info@ulekara.sk",
          "phone": "+421 950 105 650",
          "workingHours": "Po - Pá 8 - 17 hod"
        }
      ]
    },
    "otherContacts": {
      "title": "Další kontakty",
      "items": [
        {
          "name": "Martin Pospíšil",
          "imagePath": "martin-pospisil",
          "position": "CEO uLékaře.cz, s.r.o.",
          "email": "info@ulekare.cz"
        },
        {
          "name": "Martin Čuba",
          "imagePath": "martin-cuba",
          "position": "Obchodní oddělení",
          "email": "partner@ulekare.cz",
          "phone": "+420 603 841 995"
        },
        {
          "name": "Michaela Hajzlerová",
          "imagePath": "michaela-hajzlerova",
          "position": "Personální oddělení",
          "email": "personalni@ulekare.cz"
        }
      ]
    },
    "invoiceData": [
      {
        "title": "Fakturační údaje",
        "content": "Bankovní spojení - Raiffeisenbank a.s.<br>Číslo účtu: 3295/5500  (neslouží pro platbu za službu jednotlivých uživatelů)<br>IBAN: CZ1255000000000000003295<br>BIC kód (SWIFT): RZBCCZPP<br>Adresa: Hvězdova 1716/2b, 140 78 Praha 4"
      },
      {
        "title": "uLékaře.cz",
        "content": "uLékaře.cz, s.r.o.<br>Českomoravská 2408/1a<br>190 00 Praha 9<br><br>IČ: 05341051<br>DIČ, plátce DPH: CZ05341051<br>DUNS: 495722579<br><br>Zapsaná v obchodním rejstříku vedeném u Městského soudu v Praze<br>(spisová značka C 262183)<br>Datová schránka: qsh2axq"
      }
    ],
    "findMore": {
      "title": "Zjistěte více<br>o naší firmě."
    },
    "getApp": {
      "title": "Jste už jen krůček od zdravějšího života. Stačí si stáhnout naší aplikaci."
    }
  },
  "carreerPage": {
    "positions": {
      "perex": "Pečujeme o zdraví jednotlivců, rodin i celých organizací. Od hlavy až k patě. Sledujeme trendy a inovace ve zdravotnictví a proměňujeme je v nové nápady a řešení. Láká vás vytvářet tak nejzdravější pracovní prostředí napříč střední Evropou? Pak možná hledáme právě vás.",
      "table": {
        "title": "Pozice",
        "type": "Typ spolupráce",
        "place": "místo",
        "officeLocation": "lokalita"
      }
    },
    "position": [
      {
        "name": "Praktická / Všeobecná sestra pro novou ordinaci uLékaře.cz Health Care - Praha 5 (Radlická)",
        "type": "full time",
        "place": "on site",
        "officeLocation": "Praha 5",
        "detail": {
          "perex": "Chcete být součástí online zdravotní péče, která mění způsob, jak lidé přistupují ke svému zdraví?",
          "about": {
            "title": "Proč se připojit uLékaře.cz Health Care?",
            "videoPerex": "Jak pečujeme o zdraví zaměstnanců se můžete podívat ve videu z naší konference pro HR profesionály, kterou každoročně pořádáme na různá témata:\nhttps://www.youtube.com/watch?v=3mCMme1B0hE",
            "paragraphs": [
              "Inovujeme zdravotní péči v ČR prostřednictvím moderních technologií a lidského přístupu. Jsme dceřiná společnost uLékaře.cz, kde spojujeme technologii, odbornou lékařskou péči a empatii, aby lidé mohli efektivně řídit své zdraví. Stejnou filozofii přinášíme i do „kamenné“ ordinace, kterou budujeme od roku 2020 a nyní rosteme a otevíráme naši druhou pobočku na Praze 5 !",
              "Naše služby využívá téměř 300 zaměstnavatelů, kterým pomáháme zvyšovat spokojenost a produktivitu zaměstnanců a tím i prosperitu firem.",
              "Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek - chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic."
            ]
          },
          "extra": {
            "list": [
              "Možnost zapojení již od dubna/května 2026 formou adaptace a zaučení v naší stávající ordinaci na Praze 4 - ordinace v centrále České spořitelny - Budějovická (metro C)",
              "Po otevření nové ordinace v červnu/červenci 2026 na Praze 5 se plynule přesunete na novou pobočku.",
              "Při zapojení od dubna/května 2026, možnost nastavení rozsahu spolupráce dle domluvy",
              "Spolupráci na HPP na plný úvazek do konce roku 2026 s možným předpokladem prodloužení dle dalšího rozvoje týmu a projektů.",
              "Službu uLékaře.cz pro vás i vaše nejbližší zcela zdarma.",
              "Možnost využít prémiovou lékařskou péči v naší ordinaci uLékaře.cz HealthCare blízko metra Budějovická.",
              "Každou středu čerstvé ovoce v kanceláři.",
              "Prostor pro vlastní nápady a seberealizaci. U nás máte možnost ovlivnit věci kolem sebe.",
              "Externí školení a rozvojové příležitosti, které vám pomohou růst.",
              "Teambuildingové akce, otevřenou komunikaci a fajn kolektiv motivovaných lidí, kteří se podporují a táhnou za jeden provaz.",
              "Místo výkonu práce v Praze s možností kombinace práce z kanceláře i z domova.",
              "Kanceláře uLékaře.cz najdete v Balabenka Office Building, kousek od tramvaje i metra. Máme tu vlastní velkou terasu, kde si dáváme oběd, pracujeme na sluníčku nebo občas hodíme něco na gril. OC Harfa i metro Českomoravská jsou doslova za rohem."
            ],
            "title": "Nástup a adaptace:"
          },
          "lookingFor": {
            "perex": "Hledáme praktickou / všeobecnou sestru do nově otevřené pobočky ordinace uLékaře.cz Health Care s.r.o. na Praze 5 (v bezprostřední blízkosti metra Radlická), který si vezme do péče stávající i nové pacienty ordinace ve spolupráci s našimi lékaři a další kolegyní/kolegou praktickou / všeobecnou sestrou.",
            "title": "Koho hledáme?"
          },
          "skills": {
            "list": [
              "Ukončené zdravotnické vzdělání (VŠ, VOŠ, SŠ)",
              "Praxi ve zdravotnictví včetně odběrů krve",
              "Zodpovědnost, samostatnost a týmovou spolupráci",
              "Trpělivost, empatii a proklientský přístup",
              "Ochotu vzdělávat se v moderních systémech a technologiích v ordinaci",
              "Příjemný projev osobně, po telefonu i písemně",
              "Velmi dobrou znalost práce s PC (práce s online nástroji a systémy) = papírovou byrokracii už u nás spíše nenajdete",
              "Flexibilitu a otevřenost",
              "Potvrzení o zdravotní způsobilosti a trestní bezúhonnosti",
              "Komunikativní znalost AJ"
            ],
            "title": "Hledáme Vás, protože máte:"
          },
          "waitingForYou": {
            "title": "Pracovní doba a úvazek:",
            "blocks": [
              {
                "list": [
                  "Péče o pacienty a komunikace s nimi",
                  "Sesterské a administrativní činnosti v ordinaci praktického lékaře",
                  "Organizace a příprava prohlídek, asistence lékaři při vyšetřeních",
                  "Práce se zdravotnickými přístroji, odběry krve, evidence biologického materiálu",
                  "Práce s našimi interními systémy, registrace nových pacientů, správa kartotéky, evidence pošty",
                  "Spolupráce s kolegy lékaři, zdravotní sestrou, manažerkou ordinace a administrativním týmem",
                  "Účast na poradách týmu",
                  "Občasná účast na klientských akcích mimo ordinaci (odběry, očkování apod., cca 10 % pracovní doby)",
                  "Občasný zástup v naší druhé ordinaci na Praze 4 - u metra Budějovická"
                ],
                "title": "Náplň práce:"
              },
              {
                "list": [
                  "Administrativa spojená s nástupem i výstupem zaměstnance, příprava smluv a nezbytných dokumentů.",
                  "Podpora onboardingového procesu a organizace welcome day.",
                  "Spolupráce na HR projektech a digitalizaci.",
                  "Reporting a práce s HR daty.",
                  "Podpora vzdělávání a rozvoje zaměstnanců.",
                  "Prostor přicházet s novými nápady napříč employee lifecycle.",
                  "Pracovat budete s nástroji Jira, Confluence a v prostředí Google Drive."
                ],
                "title": "V období nižší náborové aktivity:"
              }
            ],
            "paragraphs": [
              "Spolupráce na HPP na plný úvazek 40h/týdně",
              "Pracovní doba dle rozpisu ordinačních hodin:"
            ]
          },
          "workflow": {
            "list": [
              "Online pohovor s manažerkou ordinace, naší HR Terkou a zdravotní sestrou ordinace",
              "Nezávazná návštěva v ordinaci s naší manažerkou, abyste navnímal/a atmosféru",
              "Den na zkoušku v ordinaci",
              "Zaslání nabídky a domluva na startu spolupráce",
              "A pak už jen nabídka a vykročíte s námi pravou nohou ke zdraví."
            ],
            "title": "Jak probíhá výběrové řízení:"
          },
          "contact": {
            "paragraphs": [
              "Pošlete svůj životopis a pár slov o sobě na tereza.cihakova@ulekare.cz.",
              "Těšíme se na Vás!"
            ],
            "title": "Chcete vědět víc? Pojďte se potkat!",
            "afterParagraphs": [
              "těšíme se na Vás!"
            ],
            "blocks": [
              {
                "list": [
                  "online pohovor s HR a manažerkou našich lékařů",
                  "následně nabídka spolupráce"
                ],
                "title": "Co Vás čeká po zaslání životopisu:"
              }
            ]
          },
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů, a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti.",
          "benefits": {
            "list": [
              "Dovolenou 25 dní ročně",
              "Sick days, narozeninový a předvánoční den placeného volna",
              "Moderně vybavenou ordinaci: POCT CRP, TOKS, streptest, EKG, oxymetr, otoskop",
              "Příspěvek na další vzdělávání a profesního rozvoj",
              "Možnost čerpání studijního volna",
              "Prostor pro vlastní nápady a profesionální růst",
              "Přátelský kolektiv a teambuildingové akce"
            ],
            "title": "A co nabízíme:"
          },
          "hidePerexInDescription": "true"
        },
        "status": "otevřená pozice",
        "routeUrl": "sestra-ulhc-radlice",
        "hr": "tereza"
      },
      {
        "routeUrl": "sestra-ulhc-radlice-kombinace",
        "name": "Praktická / Všeobecná sestra pro novou ordinaci uLékaře.cz Health Care – Praha 5 (Radlická) - kombinace ordinace a online linky",
        "type": "full time",
        "place": "hybrid",
        "officeLocation": "Praha 5",
        "detail": {
          "perex": "Chcete být součástí online zdravotní péče, která mění způsob, jak lidé přistupují ke svému zdraví?",
          "about": {
            "title": "Proč se připojit uLékaře.cz Health Care?",
            "videoPerex": "Jak pečujeme o zdraví zaměstnanců se můžete podívat ve videu z naší konference pro HR profesionály, kterou každoročně pořádáme na různá témata:\nhttps://www.youtube.com/watch?v=3mCMme1B0hE",
            "paragraphs": [
              "Inovujeme zdravotní péči v ČR prostřednictvím moderních technologií a lidského přístupu. Jsme dceřiná společnost uLékaře.cz, kde spojujeme technologii, odbornou lékařskou péči a empatii, aby lidé mohli efektivně řídit své zdraví. Stejnou filozofii přinášíme i do „kamenné“ ordinace, kterou budujeme od roku 2020 a nyní rosteme a otevíráme naši druhou pobočku na Praze 5 !",
              "Naše služby využívá téměř 300 zaměstnavatelů, kterým pomáháme zvyšovat spokojenost a produktivitu zaměstnanců a tím i prosperitu firem.",
              "Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek - chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic."
            ]
          },
          "extra": {
            "list": [
              "Možnost zapojení již od dubna/května 2026 formou adaptace a zaučení v naší stávající ordinaci na Praze 4 - ordinace v centrále České spořitelny - Budějovická (metro C)",
              "Po otevření nové ordinace v červnu/červenci 2026 na Praze 5 se plynule přesunete na novou pobočku.",
              "Při zapojení od dubna/května 2026, možnost nastavení rozsahu spolupráce dle domluvy",
              "Spolupráci na HPP na plný úvazek na 1 rok s možným předpokladem prodloužení dle dalšího rozvoje týmu a projektů.",
              "Službu uLékaře.cz pro vás i vaše nejbližší zcela zdarma.",
              "Možnost využít prémiovou lékařskou péči v naší ordinaci uLékaře.cz HealthCare blízko metra Budějovická.",
              "Každou středu čerstvé ovoce v kanceláři.",
              "Prostor pro vlastní nápady a seberealizaci. U nás máte možnost ovlivnit věci kolem sebe.",
              "Externí školení a rozvojové příležitosti, které vám pomohou růst.",
              "Teambuildingové akce, otevřenou komunikaci a fajn kolektiv motivovaných lidí, kteří se podporují a táhnou za jeden provaz.",
              "Místo výkonu práce v Praze s možností kombinace práce z kanceláře i z domova.",
              "Kanceláře uLékaře.cz najdete v Balabenka Office Building, kousek od tramvaje i metra. Máme tu vlastní velkou terasu, kde si dáváme oběd, pracujeme na sluníčku nebo občas hodíme něco na gril. OC Harfa i metro Českomoravská jsou doslova za rohem."
            ],
            "title": "Nástup a adaptace:"
          },
          "lookingFor": {
            "perex": "Hledáme praktickou sestru do nově otevřené pobočky ordinace uLékaře.cz Health Care s.r.o. na Praze 5 (v bezprostřední blízkosti metra Radlická), která bude svou pracovní dobu kombinovat 50:50 mezi ordinací a naší online linkou (home office), a spolupracovat s našimi lékaři, kolegyní/kolegou praktickou / všeobecnou sestrou a s kolegyněmi na online lince.",
            "title": "Koho hledáme?"
          },
          "skills": {
            "list": [
              "Ukončené zdravotnické vzdělání (VOŠ, SŠ)",
              "Praxi ve zdravotnictví min. 2 roky, včetně odběrů krve",
              "Zodpovědnost, samostatnost a týmovou spolupráci",
              "Trpělivost, empatii a proklientský přístup",
              "Příjemný projev osobně, po telefonu i písemně",
              "Uživatelskou znalost práce s PC (práce s online nástroji a systémy)",
              "Flexibilitu a otevřenost",
              "Potvrzení o zdravotní způsobilosti a trestní bezúhonnosti",
              "Anglický jazyk výhodou, ne podmínkou",
              "Umíte komunikovat lidsky - to je pro nás klíčové."
            ],
            "title": "Hledáme Vás, protože máte:"
          },
          "waitingForYou": {
            "paragraphs": [
              "Spolupráce na HPP na plný úvazek 40h/týdně",
              "Pracovní doba dle rozpisu ordinačních hodin: bude upřesněno (po-pá) bez víkendů",
              "Návrh a vývoj frontendu, webová aplikace pro koncové uživatele, interní rozhraní pro lékaře, sestry a administrátory.",
              "Návrh a vývoj backendu, workflow a integrace pomocí REST a GraphQL API na systémy partnerů a interní systémy – poradnu, mobilní aplikaci, telefonní ústřednu a klientskou zónu na našem webu.",
              "Profesní rozvoj a předávání zkušeností v rámci týmu na interních S-COOL meetupech.",
              "Agilní způsob vývoje a tým, který nevyvíjí jen „kus kódu“, ale hodnotu pro uživatele."
            ],
            "title": "Pracovní doba a úvazek:",
            "blocks": [
              {
                "list": [
                  "Péče o pacienty a komunikace s nimi",
                  "Sesterské a administrativní činnosti v ordinaci praktického lékaře",
                  "Organizace a příprava prohlídek, asistence lékaři při vyšetřeních",
                  "Práce se zdravotnickými přístroji, odběry krve, evidence biologického materiálu",
                  "Práce na naší online lince formou home office (objednávky do ordinace, konzultace s pacientem, se zdravotnickými zařízeními a dalšími dodavateli)",
                  "Práce s našimi interními systémy, registrace nových pacientů, správa kartotéky, evidence pošty",
                  "Spolupráce s kolegy lékaři, zdravotní sestrou, manažerkou ordinace a administrativním týmem",
                  "Účast na poradách týmu",
                  "Občasná účast na klientských akcích mimo ordinaci (odběry, očkování apod., cca 10 % pracovní doby)",
                  "Občasný zástup v naší druhé ordinaci na Praze 4 - u metra Budějovická"
                ],
                "title": "Náplň práce:"
              },
              {
                "list": [
                  "Administrativa spojená s nástupem i výstupem zaměstnance, příprava smluv a nezbytných dokumentů.",
                  "Podpora onboardingového procesu a organizace welcome day.",
                  "Spolupráce na HR projektech a digitalizaci.",
                  "Reporting a práce s HR daty.",
                  "Podpora vzdělávání a rozvoje zaměstnanců.",
                  "Prostor přicházet s novými nápady napříč employee lifecycle.",
                  "Pracovat budete s nástroji Jira, Confluence a v prostředí Google Drive."
                ],
                "title": "V období nižší náborové aktivity:"
              }
            ]
          },
          "workflow": {
            "list": [
              "Online pohovor s manažerkou ordinace, naší HR Terkou a zdravotním bratrem ordinace",
              "Nezávazná návštěva v ordinaci s naší manažerkou, abyste navnímal/a atmosféru",
              "Den na zkoušku v ordinaci",
              "Zaslání nabídky a domluva na startu spolupráce",
              "A pak už jen nabídka a vykročíte s námi pravou nohou ke zdraví."
            ],
            "title": "Jak probíhá výběrové řízení:",
            "afterParagraphs": [
              "Vzdáleně si můžeš vyzkoušet naši mobilní aplikaci: Android/iOS nebo webovou klientskou zónu na www.ulekare.cz. Hlavní aplikaci, poradnu a její REST/GraphQL API Ti předvedeme osobně."
            ]
          },
          "benefits": {
            "afterParagraphs": [
              "A o dalších benefitech si řekneme osobně…"
            ],
            "list": [
              "Dovolenou 25 dní ročně",
              "Sick days, narozeninový a předvánoční den placeného volna",
              "Částečný home office",
              "Moderně vybavenou ordinaci: POCT CRP, TOKS, streptest, EKG, oxymetr, otoskop",
              "Příspěvek na další vzdělávání a profesního rozvoj",
              "Možnost čerpání studijního volna",
              "Prostor pro vlastní nápady a profesionální růst",
              "Přátelský kolektiv a teambuildingové akce"
            ],
            "title": "A co nabízíme:"
          },
          "contact": {
            "paragraphs": [
              "Pošlete svůj životopis a pár slov o sobě na tereza.cihakova@ulekare.cz.",
              "Těšíme se na Vás!",
              "Těšíme se na tebe!"
            ],
            "title": "Chcete vědět víc? Pojďte se potkat!"
          },
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů, a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti.",
          "team": {
            "list": [
              "Tým, který se chce rozvíjet – technologický rozvoj, ale i agilní přístup k vývoji, komunikace v týmu i mezitýmová apod.",
              "Tým, který chce zlepšovat produkt.",
              "Tým, který se nebojí převzít zodpovědnost.",
              "Tým, který umí pracovat samostatně bez mikromanagementu.",
              "Tým, který zná produkt, který vyvíjí, a úzce spolupracuje s produktovým týmem."
            ],
            "title": "Jaký máme tým?"
          }
        },
        "status": "otevřená pozice",
        "hr": "tereza"
      },
      {
        "name": "Lékař/ka pro ordinaci uLékaře.cz Health Care - Praha 4 (Budějovická) – pondělní směny 8h",
        "officeLocation": "Praha 4",
        "place": "on site",
        "routeUrl": "doctor-ulhc-budejovicka",
        "type": "part time",
        "detail": {
          "about": {
            "title": "Proč se připojit k uLékaře.cz Health Care?",
            "paragraphs": [
              "Inovujeme poskytování zdravotní péče v ČR za použití nejnovějších technologií a trendů. Jsme dceřiná společnost uLékaře.cz, kde prostřednictvím technologie, lidského přístupu a lékařské expertízy pomáháme lidem řídit si své zdraví. Stejnou filozofii a hodnoty aplikujeme i v „kamenné“ zdravotní péči, jejíž základy jsme položili v roce 2020.",
              "Hledáme praktického lékaře/ku pro moderně vybavenou ordinaci praktického lékaře na Praze 4 (blízko metra Budějovická), který/á pokryje ordinační dobu v PONDĚLÍ od 9:00-14:00. Zbylé 3 hodiny jsou věnovány administraci a profesnímu rozvoji."
            ],
            "videoPerex": "Podívej se, jak pečujeme o zdraví zaměstnanců: https://www.youtube.com/watch?v=ifReJiQ9Is4 Video zachycuje jednu z našich HR snídaní, které pořádáme pravidelně v průběhu roku na různá témata."
          },
          "skills": {
            "list": [
              "Máte lékařské vzdělání a specializovanou způsobilost v oboru všeobecné praktické lékařství (L3)",
              "Disponujete lidským přístupem, odpovědností, samostatností a schopností týmové spolupráce",
              "Vynikáte příjemným projevem, komunikativností, empatií a proklientským přístupem",
              "Jste flexibilní a ochotní pracovat v dopoledních a příležitostně (dle domluvy v odpoledních hodinách)",
              "osobu, která se nebojí používat PC a online systémy"
            ],
            "title": "Hledáme Vás protože:"
          },
          "waitingForYou": {
            "paragraphs": [
              "Poskytovat léčebnou, preventivní a posudkovou péči v plném rozsahu odbornosti všeobecného praktického lékaře",
              "Spolupracovat se zdravotní sestrou a administrativním týmem",
              "Pracovat s moderními technologiemi (dedikovaná linka, telemedicína)",
              "Účastnit se porad týmu",
              "Možné sporadické zástupy dle domluvy v ordinaci na Praze 4 nebo nové ordinaci na Praze 5 (u metra Radlická)",
              "Agilní způsob vývoje a tým, který nevyvíjí jen „kus kódu“, ale hodnotu pro uživatele."
            ],
            "title": "Co budete dělat:",
            "blocks": [
              {
                "list": [
                  "HPP na zkrácený úvazek 8 h/týden",
                  "Pondělí 9:00–14:00, zbylé 3 hodiny příprava"
                ],
                "title": "Pracovní doba a úvazek"
              }
            ]
          },
          "benefits": {
            "list": [
              "Dovolenou na základě výše úvazku (při plném 25 dní)",
              "Sick days, narozeninový a předvánoční den placeného volna",
              "Příspěvek na další vzdělávání a profesní rozvoj",
              "Motivující finanční ohodnocení",
              "Možnost čerpání studijního volna",
              "Prostor pro vlastní nápady a profesionální růst",
              "Moderně vybavenou ordinaci: POCT CRP, TOKS, streptest, EKG, oxymetr, otoskop",
              "Možnost parkování v blízkosti ordinace",
              "Přátelský kolektiv a teambuildingové akce",
              "Prostor pro realizaci vlastních nápadů",
              "Místo výkonu práce v rámci celé ČR"
            ],
            "title": "Co nabízíme:",
            "afterParagraphs": [
              "A o dalších benefitech si řekneme osobně…"
            ]
          },
          "contact": {
            "paragraphs": [
              "Životopis a pár slov o sobě posílejte na: tereza.cihakova@ulekare.cz",
              "Pošli nám svůj životopis a napiš také něco o sobě na radmila.hrouzkova@ulekare.cz. :)",
              "Těšíme se na tebe!"
            ],
            "title": "Jak se přihlásit:",
            "afterParagraphs": [
              "těšíme se na Vás!"
            ],
            "blocks": [
              {
                "list": [
                  "online pohovor s HR a manažerkou našich lékařů",
                  "následně nabídka spolupráce"
                ],
                "title": "Co Vás čeká po zaslání životopisu:"
              }
            ]
          },
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti.",
          "perex": "Chcete být součástí online zdravotní péče, která mění způsob, jak lidé přistupují ke svému zdraví?",
          "hidePerexInDescription": "true",
          "workflow": {
            "list": [
              "První kolo – online pohovor s manažerkou ordinace, HR a garantem ordinace",
              "Druhé kolo – návštěva a den na zkoušku v ordinaci",
              "Zaslání nabídky a domluva na startu spolupráce",
              "Google Workspaces nám slouží pro organizaci práce a Slack pro komunikaci."
            ],
            "title": "Průběh výběrového řízení:",
            "afterParagraphs": [
              "Vzdáleně si můžeš vyzkoušet naši mobilní aplikaci: Android/iOS nebo webovou klientskou zónu na www.ulekare.cz. Hlavní aplikaci, poradnu a její REST/GraphQL API Ti předvedeme osobně."
            ]
          },
          "extra": {
            "list": [
              "Termín nástupu dle domluvy",
              "NodeJS, MongoDB",
              "Znalost práce se Symfony a Twig",
              "VUE framework"
            ],
            "title": "Nástup a adaptace:"
          },
          "lookingFor": {
            "list": [
              "Jste vývojář s produktovým přesahem.",
              "Nejste jen vykonavatelem zadání, ale partnerem při tvorbě řešení.",
              "Umíte se zadavateli mluvit o jejich skutečných potřebách.",
              "Dokážete spolupracovat napříč týmy i odděleními.",
              "Podílíte se na definici problému nebo hledání příležitostí a navrhujete smysluplná řešení s přidanou hodnotou pro uživatele.",
              "Své řešení nejen implementujete (nebo předáváte k realizaci dalším kolegům), ale také ho umíte srozumitelně představit.",
              "Přebíráte odpovědnost za výsledek od prvotního nápadu až po finální řešení."
            ],
            "title": "Koho hledáme?"
          },
          "team": {
            "list": [
              "Neustále se učíme a zlepšujeme - technologicky i v tom, jak spolupracujeme a komunikujeme.",
              "Záleží nám na produktu a chceme ho posouvat dál.",
              "Nebojíme se odpovědnosti a umíme si stát za svým řešením.",
              "Fungujeme samostatně, bez zbytečného mikromanagementu.",
              "Známe produkt, který vyvíjíme, a úzce spolupracujeme s produktovým týmem."
            ],
            "title": "Jaký máme tým?"
          }
        },
        "hr": "tereza",
        "status": "otevřená pozice"
      },
      {
        "detail": {
          "perex": "Rozšiřujeme náš HR tým a hledáme nového parťáka či parťačku - srdcaře, který nezkazí žádnou legraci, miluje práci s lidmi a bere nábor jako klíčovou misi firmy. Ideálně máte alespoň 2 roky zkušeností s recruitmentem a zvládnete samostatně řídit výběrová řízení. Pokud zrovna nebude plná hiring pipeline, zapojíte se i do širší HR agendy a přirozeně tak rozšířit svou roli směrem k HR Generalistovi.",
          "about": {
            "title": "Proč se připojit k uLékaře.cz?",
            "paragraphs": [
              "V uLékaře.cz máme jasnou misi - měníme způsob, jakým lidé přistupují ke svému zdraví. Jsme průkopníkem online péče o zdraví a dostupnosti lékařské péče v Česku, na Slovensku a v Maďarsku. Dnes jsme největší online lékařskou poradnou, nabízíme službu vyhledání a objednání k lékaři i nástroje pro management prevence.",
              "Naše služby využívá téměř 300 zaměstnavatelů, kterým pomáháme zvyšovat spokojenost a produktivitu zaměstnanců a tím i prosperitu firem.",
              "Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek - chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic."
            ],
            "videoPerex": "Jak pečujeme o zdraví zaměstnanců se můžete podívat ve videu z naší konference pro HR profesionály, kterou každoročně pořádáme na různá témata:\nhttps://www.youtube.com/watch?v=3mCMme1B0hE"
          },
          "skills": {
            "list": [
              "Máte minimálně 2 roky zkušeností v náboru (interní nebo agenturní), ideálně s různorodými typy pozic (oblast zdravotnictví výhodou a IT nezbytností).",
              "Umíte vést pohovor tak, aby byl profesionální a zároveň lidský a nedělá vám problém jej vést v anglickém jazyce.",
              "Máte zkušenost s aktivním sourcingem a nebojíte se oslovit kandidáta napřímo.",
              "Rozumíte základům HR administrativy a zákoníku práce (zkušenost na pozici HR Generalisty je velkou výhodou).",
              "Umíte si práci dobře zorganizovat a nastavit priority.",
              "Jste diskrétní a umíte udržet tajemství - co uslyšíte v HR, v HR taky zůstane 🙂",
              "Jste proaktivní a hledáte řešení.",
              "Máte týmového ducha a baví vás práce s lidmi.",
              "Je na vás spoleh, jste samostatný/á, pečlivý/á a empatický/á.",
              "Umíte komunikovat lidsky - to je pro nás klíčové."
            ],
            "title": "Hledáme vás, protože:"
          },
          "waitingForYou": {
            "paragraphs": [
              "5 developerů inhouse a jeden na mobilní aplikaci, 2 testeři.",
              "Vývoj služeb pro lidi, kteří se zajímají o zdraví, a pro ty, kteří je na jejich cestě ke zdraví podporují.",
              "Návrh a vývoj frontendu, webová aplikace pro koncové uživatele, interní rozhraní pro lékaře, sestry a administrátory.",
              "Návrh a vývoj backendu, workflow a integrace pomocí REST a GraphQL API na systémy partnerů a interní systémy – poradnu, mobilní aplikaci, telefonní ústřednu a klientskou zónu na našem webu.",
              "Profesní rozvoj a předávání zkušeností v rámci týmu na interních S-COOL meetupech.",
              "Agilní způsob vývoje a tým, který nevyvíjí jen „kus kódu“, ale hodnotu pro uživatele."
            ],
            "title": "Bude vás bavit:",
            "blocks": [
              {
                "list": [
                  "Kompletní zastřešení náborového procesu od A do Z.",
                  "Úzká spolupráce s hiring manažery - pochopení jejich potřeb a nastavení profilu ideálního kandidáta.",
                  "Aktivní vyhledávání kandidátů (LinkedIn, pracovní portály, direct search).",
                  "Vedení pohovorů a výběrových řízení.",
                  "Práce s ATS a budování talent poolu.",
                  "Zlepšování candidate experience - chceme, aby si každý kandidát odnesl skvělý dojem.",
                  "Podíl na budování employer brandingu."
                ],
                "title": "Nábor (hlavní část role):"
              },
              {
                "list": [
                  "Administrativa spojená s nástupem i výstupem zaměstnance, příprava smluv a nezbytných dokumentů.",
                  "Podpora onboardingového procesu a organizace welcome day.",
                  "Spolupráce na HR projektech a digitalizaci.",
                  "Reporting a práce s HR daty.",
                  "Podpora vzdělávání a rozvoje zaměstnanců.",
                  "Prostor přicházet s novými nápady napříč employee lifecycle.",
                  "Pracovat budete s nástroji Jira, Confluence a v prostředí Google Drive."
                ],
                "title": "V období nižší náborové aktivity:"
              }
            ]
          },
          "workflow": {
            "list": [
              "Dotazník a krátký call, kde si doladíme základní očekávání.",
              "Osobní pohovor s naše HR Generalist Terkou a HR manažerkou Míšou.",
              "Zpracování úkolu.",
              "Osobní pohovor s HR Generalist Terkou a COO Ivou.",
              "A pak už jen nabídka a vykročíte s námi pravou nohou ke zdraví."
            ],
            "title": "A jak vypadá průběh výběrka?",
            "afterParagraphs": [
              "Vzdáleně si můžeš vyzkoušet naši mobilní aplikaci: Android/iOS nebo webovou klientskou zónu na www.ulekare.cz. Hlavní aplikaci, poradnu a její REST/GraphQL API Ti předvedeme osobně."
            ]
          },
          "benefits": {
            "list": [
              "Možnost pracovat na plný úvazek na IČO.",
              "Flexibilní pracovní dobu a možnost home office.",
              "Podporu, loajalitu a otevřené férové jednání.",
              "Pomoc s nalezením vhodné zdravotní péče pro tebe i tvé blízké, kdykoliv to bude potřeba.",
              "Kanceláře uLékaře.cz v Balabenka Office Building hned u tramvajových zastávek. Máme blízko do OC Harfa společně s metrem Českomoravská nebo metrem Palmovka.",
              "příjemný kolektiv nadšených lidí",
              "Otevřenou komunikaci",
              "Možnost realizace v rychle rostoucí a expandující firmě",
              "Fajn kolektiv motivovaných lidí",
              "Prostor pro realizaci vlastních nápadů",
              "Místo výkonu práce v rámci celé ČR"
            ],
            "title": "Co dále nabízíme?",
            "afterParagraphs": [
              "A o dalších benefitech si řekneme osobně…"
            ]
          },
          "contact": {
            "paragraphs": [
              "Těšíme se, až se ozvete. Pošlete nám svůj životopis a pár slov o sobě.",
              "Těšíme se na vás!",
              "Těšíme se na tebe!"
            ],
            "afterParagraphs": [
              "těšíme se na Vás!"
            ],
            "blocks": [
              {
                "list": [
                  "online pohovor s HR a manažerkou našich lékařů",
                  "následně nabídka spolupráce"
                ],
                "title": "Co Vás čeká po zaslání životopisu:"
              }
            ],
            "title": "Chcete vědět víc? Pojďte se potkat!"
          },
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů, a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti.",
          "hidePerexInDescription": "true",
          "extra": {
            "list": [
              "Firemní notebook a mobilní telefon.",
              "Příspěvek na MultiSport kartu.",
              "Flexibilitu, práci z domova, hodinu sportu týdně v pracovní době, 25 dní dovolené, sick days, narozeninový a předvánoční den volna.",
              "Spolupráci na HPP na plný úvazek na 1 rok s možným předpokladem prodloužení dle dalšího rozvoje týmu a projektů.",
              "Službu uLékaře.cz pro vás i vaše nejbližší zcela zdarma.",
              "Možnost využít prémiovou lékařskou péči v naší ordinaci uLékaře.cz HealthCare blízko metra Budějovická.",
              "Každou středu čerstvé ovoce v kanceláři.",
              "Prostor pro vlastní nápady a seberealizaci. U nás máte možnost ovlivnit věci kolem sebe.",
              "Externí školení a rozvojové příležitosti, které vám pomohou růst.",
              "Teambuildingové akce, otevřenou komunikaci a fajn kolektiv motivovaných lidí, kteří se podporují a táhnou za jeden provaz.",
              "Místo výkonu práce v Praze s možností kombinace práce z kanceláře i z domova.",
              "Kanceláře uLékaře.cz najdete v Balabenka Office Building, kousek od tramvaje i metra. Máme tu vlastní velkou terasu, kde si dáváme oběd, pracujeme na sluníčku nebo občas hodíme něco na gril. OC Harfa i metro Českomoravská jsou doslova za rohem."
            ],
            "title": "A co nabízíme?"
          },
          "lookingFor": {
            "perex": "Hledáme fullstackáře, který si napíše API, napojí si ho z jedné strany na databázi a z druhé strany na button. Někoho, kdo aktivně pracuje na obou stranách barikády (backend/frontend webových aplikací).\n\nA pokud máte přece jen nějakou preferenci, i když umíte oboje, tak teď spíše uvítáme frontenďáka.\n\nZnalost cloudu (AWS) výhodou.",
            "title": "Koho hledáme?"
          },
          "team": {
            "list": [
              "Tým, který se chce rozvíjet – technologický rozvoj, ale i agilní přístup k vývoji, komunikace v týmu i mezitýmová apod.",
              "Tým, který chce zlepšovat produkt.",
              "Tým, který se nebojí převzít zodpovědnost.",
              "Tým, který umí pracovat samostatně bez mikromanagementu.",
              "Tým, který zná produkt, který vyvíjí, a úzce spolupracuje s produktovým týmem."
            ],
            "title": "Jaký máme tým?"
          }
        },
        "name": "HR Recruiter / HR Generalist (m/ž)",
        "officeLocation": "Praha (Balabenka Office Building)",
        "place": "hybrid",
        "routeUrl": "hr-recruiter-generalist",
        "type": "full time",
        "hr": "tereza",
        "status": "otevřená pozice"
      },
      {
        "detail": {
          "perex": "Přidej se k nám. Náš tým vyvíjí služby, které denně pomáhají podporovat firmy, zdraví jejich zaměstnanců a také jejich rodin.",
          "about": {
            "title": "Kdo jsme?",
            "videoPerex": "Podívej se, jak pečujeme o zdraví zaměstnanců: https://www.youtube.com/watch?v=ifReJiQ9Is4 Video zachycuje jednu z našich HR snídaní, které pořádáme pravidelně v průběhu roku na různá témata.",
            "perex": "V uLékaře.cz máme jasnou misi – měníme způsob, jakým lidé přistupují ke svému zdraví. Jsme průkopníkem online péče o zdraví a dostupnosti lékařské péče v Česku, na Slovensku a v Maďarsku. Dnes jsme největší online lékařskou poradnou, nabízíme službu vyhledání a objednání k lékaři i nástroje pro management prevence. Naše služby využívá už více než 200 zaměstnavatelů, kterým pomáháme zvyšovat spokojenost a produktivitu zaměstnanců a tím i prosperitu firem. Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek – chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic.",
            "paragraphs": [
              "Služba uLékaře.cz je od roku 2007 průkopníkem online péče o zdraví a zajišťování dostupnosti lékařské péče. Pomáháme již více než 250 zaměstnavatelům v Čechách a na Slovensku zvyšovat spokojenost a produktivitu jejich zaměstnanců, a tím i prosperitu firmy jako celku. Platforma uLékaře.cz zahrnuje největší online lékařskou poradnu v ČR a SR, službu vyhledání vhodného lékaře se zajištěním objednání k němu a management prevence. Naše služby jsou uživatelům k dispozici 24/7 na webu a v mobilní aplikaci, v několika jazycích.",
              "Za projektom uLékaře.cz stojí okrem iných aj MUDr. Tomáš Šebek – chirurg, autor kníh a humanitárny lekár z misií Lekárov bez hraníc."
            ]
          },
          "waitingForYou": {
            "paragraphs": [
              "Spolupráce s týmem vývojářů, specialistou na mobilní aplikaci i testery.",
              "Vývoj služeb pro lidi, kteří se zajímají o své zdraví, i pro ty, kteří je na jejich cestě ke zdravějšímu životu podporují.",
              "Návrh a vývoj frontendu, webová aplikace pro koncové uživatele, interní rozhraní pro lékaře, sestry a administrátory.",
              "Návrh a vývoj backendu, workflow a integrace pomocí REST a GraphQL API na systémy partnerů a interní systémy – poradnu, mobilní aplikaci, telefonní ústřednu a klientskou zónu na našem webu.",
              "Profesní rozvoj a předávání zkušeností v rámci týmu na interních S-COOL meetupech.",
              "Agilní způsob vývoje a tým, který nevyvíjí jen „kus kódu“, ale hodnotu pro uživatele.",
              "Cestování za klienty – na týdenní bázi po celé ČR.",
              "Týmové porady a sdílení nápadů – jednou týdně v pražských kancelářích (v období adaptace i častěji)."
            ],
            "title": "Co vás u nás čeká?"
          },
          "skills": {
            "list": [
              "HTML, CSS a JavaScript",
              "PHP 8 a MySQL/MariaDB, návrh a implementaci REST/GraphQL API",
              "GIT",
              "týmového hráče, který zvládne organizovat si práci a udržet přehled",
              "osobu, která se nebojí používat PC a online systémy",
              "Si aktívny vodič/vodička s vlastným autom.",
              "Máš komunikatívnu angličtinu aspoň na úrovni B2 (výhodou).",
              "Jsi časově flexibilní, zároveň zodpovědný/á a umíš si efektivně organizovat svůj čas.",
              "Týmová práce tě baví. Umíš naslouchat, pomáhat ostatním a zároveň přinášet vlastní nápady, jak věci dělat lépe."
            ],
            "title": "Co bys měl/a umět?"
          },
          "extra": {
            "list": [
              "AWS - Lambda, Route 53, RDS, Fargate, ELS, Athena, SES, SQS, DynamoDB a další",
              "NodeJS, MongoDB",
              "Znalost práce se Symfony a Twig",
              "VUE framework",
              "Firemní notebook, mobilní telefon, příspěvek na MultiSport kartu.",
              "Prostor pro vlastní nápady a seberealizaci – u nás máš možnost ovlivnit věci kolem sebe.",
              "Spolupráci na zajímavých projektech, které mají skutečný dopad a smysl.",
              "Externí školení a rozvojové příležitosti, které ti pomohou růst.",
              "Teambuildingové akce, otevřenou komunikaci a fajn kolektiv motivovaných lidí, kteří se podporují a táhnou za jeden provaz."
            ],
            "title": "A co by se hodilo navíc?"
          },
          "footerPerex": "Zaujala tě tato příležitost a chceš spojit obchod s péčí o zdraví? Těšíme se, až se ozveš. Pošli nám svůj životopis a pár slov o sobě na radmila.hrouzkova@ulekare.cz.",
          "lookingFor": {
            "perex": "Baví tě pečovat o zákazníky a komunikace s nimi? Máš už nějaké zkušenosti v oblasti B2B péče nebo se v této oblasti chceš teprve rozvíjet? Hledáš různorodou práci? Pokud ano, přidej se k našemu týmu péče o B2B klienty.",
            "title": "Koho hledáme?",
            "list": [
              "Jste vývojář s produktovým přesahem.",
              "Nejste jen vykonavatelem zadání, ale partnerem při tvorbě řešení.",
              "Umíte se zadavateli mluvit o jejich skutečných potřebách.",
              "Dokážete spolupracovat napříč týmy i odděleními.",
              "Podílíte se na definici problému nebo hledání příležitostí a navrhujete smysluplná řešení s přidanou hodnotou pro uživatele.",
              "Své řešení nejen implementujete (nebo předáváte k realizaci dalším kolegům), ale také ho umíte srozumitelně představit.",
              "Přebíráte odpovědnost za výsledek od prvotního nápadu až po finální řešení."
            ]
          },
          "workflow": {
            "list": [
              "Využíváme GitLab včetně CI/CD pipelines.",
              "Používáme docker na běh vývojové verze.",
              "Máme Scrum a sprinty, na trackování požadavků používáme Jiru.",
              "Google Workspaces nám slouží pro organizaci práce a Slack pro komunikaci."
            ],
            "title": "Jak to v našem týmu funguje?",
            "afterParagraphs": [
              "Vzdáleně si můžeš vyzkoušet naši mobilní aplikaci: Android/iOS nebo webovou klientskou zónu na www.ulekare.cz. Hlavní aplikaci, poradnu a její REST/GraphQL API Ti předvedeme osobně."
            ]
          },
          "benefits": {
            "list": [
              "Možnost pracovat na plný úvazek na IČO.",
              "Flexibilní pracovní dobu a možnost home office.",
              "Podporu, loajalitu a otevřené férové jednání.",
              "Pomoc s nalezením vhodné zdravotní péče pro tebe i tvé blízké, kdykoliv to bude potřeba.",
              "Kanceláře uLékaře.cz v Balabenka Office Building hned u tramvajových zastávek. Máme blízko do OC Harfa společně s metrem Českomoravská nebo metrem Palmovka.",
              "Externí školení a teambuildingové akce",
              "Otevřenou komunikaci",
              "Možnost realizace v rychle rostoucí a expandující firmě",
              "Fajn kolektiv motivovaných lidí",
              "Prostor pro realizaci vlastních nápadů",
              "Místo výkonu práce v rámci celé ČR",
              "A motivated and friendly team",
              "Your work location will be within Slovakia or Hungary"
            ],
            "title": "Co dále nabízíme?",
            "afterParagraphs": [
              "A o dalších benefitech si řekneme osobně…"
            ]
          },
          "contact": {
            "paragraphs": [
              "Komunikovat s tebou bude Radka, naše HR.",
              "Pošli nám svůj životopis a napiš také něco o sobě na radmila.hrouzkova@ulekare.cz. :)",
              "Těšíme se na tebe!"
            ],
            "title": "Chceš vědět víc? Pojď se potkat!",
            "afterParagraphs": [
              "těšíme se na Vás!"
            ],
            "blocks": [
              {
                "list": [
                  "online pohovor s HR a manažerkou našich lékařů",
                  "následně nabídka spolupráce"
                ],
                "title": "Co Vás čeká po zaslání životopisu:"
              }
            ]
          },
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů, a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti.",
          "hidePerexInDescription": "true",
          "team": {
            "list": [
              "Neustále se učíme a zlepšujeme - technologicky i v tom, jak spolupracujeme a komunikujeme.",
              "Záleží nám na produktu a chceme ho posouvat dál.",
              "Nebojíme se odpovědnosti a umíme si stát za svým řešením.",
              "Fungujeme samostatně, bez zbytečného mikromanagementu.",
              "Známe produkt, který vyvíjíme, a úzce spolupracujeme s produktovým týmem."
            ],
            "title": "Jaký máme tým?"
          }
        },
        "name": "Fullstack Developer webových aplikací",
        "officeLocation": "Praha (Balabenka Office Building)",
        "place": "hybrid",
        "routeUrl": "fullstack-developer",
        "status": "otevřená pozice",
        "type": "full time",
        "hr": "radka"
      },
      {
        "detail": {
          "perex": "Chcete být součástí online zdravotní péče, která mění způsob, jak lidé přistupují ke svému zdraví?",
          "skills": {
            "list": [
              "ovládáte maďarštinu slovem i písmem a máte komunikační znalost češtiny nebo slovenštiny (angličtina je výhodou)",
              "absolvoval(a) jste interní kmen nebo kmen z praktického lékařství, případně máte atestace z výše uvedeného",
              "vlastníte PC nebo laptop s dobrým internetovým připojením",
              "máte čas spolupracovat alespoň pár hodin týdně",
              "osobu, která se nebojí používat PC a online systémy",
              "Si aktívny vodič/vodička s vlastným autom.",
              "Máš komunikatívnu angličtinu aspoň na úrovni B2 (výhodou).",
              "Jsi časově flexibilní, zároveň zodpovědný/á a umíš si efektivně organizovat svůj čas.",
              "Týmová práce tě baví. Umíš naslouchat, pomáhat ostatním a zároveň přinášet vlastní nápady, jak věci dělat lépe."
            ],
            "title": "Hledáme Vás, protože:"
          },
          "waitingForYou": {
            "paragraphs": [
              "odpovídání online na zdravotní dotazy uživatelů",
              "pomoc s jazykovou korekturou textů v maďarštině",
              "odborná korektura textů",
              "využití práce pro další týmy v rámci plnění cílů firmy a spolupráce na projektech",
              "práci v moderní online platformě s jednoduchým přístupem k pacientům a interním nástrojům",
              "Cestovať za klientmi nielen v rámci svojho regiónu.",
              "Cestování za klienty – na týdenní bázi po celé ČR.",
              "Týmové porady a sdílení nápadů – jednou týdně v pražských kancelářích (v období adaptace i častěji)."
            ],
            "title": "Co Vás bude bavit:"
          },
          "workflow": {
            "list": [
              "online pohovor s HR a manažerkou našich lékařů",
              "následně nabídka spolupráce",
              "A potom už len ponuka a vykročíš s nami pravou nohou za zdravím. 🚀"
            ],
            "title": "Co Vás čeká po zaslání životopisu:",
            "afterParagraphs": [
              {},
              "Cítíš, že tohle je přesně role pro tebe? Tak nám pošli CV nebo odkaz na LinkedIn a pár vět o sobě na radmila.hrouzkova@ulekare.cz. Těšíme se!"
            ]
          },
          "extra": {
            "list": [
              "Možnost spolupráce na plný úvazek HPP i IČO.",
              "Flexibilitu – práci z domova, hodinu sportu týdně, sick days i den volna k narozeninám i předvánoční den volna.",
              "Místo výkonu práce v Praze – s možností kombinace práce z kanceláře i z domova.",
              "Službu uLékaře.cz zdarma pro tebe i tvé blízké.",
              "Firemní notebook, mobilní telefon, příspěvek na MultiSport kartu.",
              "Prostor pro vlastní nápady a seberealizaci – u nás máš možnost ovlivnit věci kolem sebe.",
              "Spolupráci na zajímavých projektech, které mají skutečný dopad a smysl.",
              "Externí školení a rozvojové příležitosti, které ti pomohou růst.",
              "Teambuildingové akce, otevřenou komunikaci a fajn kolektiv motivovaných lidí, kteří se podporují a táhnou za jeden provaz."
            ],
            "title": "Co nabízíme:",
            "blocks": [
              {
                "list": [
                  "Možnost práce z domova, sick days a narozeninové volno",
                  "Jóga na pracovišti",
                  "Ovocné úterky a firemní terasa na grilovačky",
                  "Počítač a mobil k dispozici",
                  "Dog-friendly kancelář – ano, ale víme, že obchodníci spíš ocení výsledky :-)"
                ],
                "title": "A pár bonusů navíc:"
              }
            ]
          },
          "about": {
            "perex": "V uLékaře.cz máme jasnou misi – měníme způsob, jakým lidé přistupují ke svému zdraví. Jsme průkopníkem online péče o zdraví a dostupnosti lékařské péče v Česku, na Slovensku a v Maďarsku. Dnes jsme největší online lékařskou poradnou, nabízíme službu vyhledání a objednání k lékaři i nástroje pro management prevence. Naše služby využívá už více než 200 zaměstnavatelů, kterým pomáháme zvyšovat spokojenost a produktivitu zaměstnanců a tím i prosperitu firem. Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek – chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic.",
            "title": "Proč být součástí uLékaře.cz?",
            "videoPerex": "Ako sa staráme o zdravie našich zamestnancov, si môžeš pozrieť vo videu z našich raňajok pre HR profesionálov, ktoré pravidelne organizujeme počas roka na rôzne témy:\nhttps://www.youtube.com/watch?v=ifReJiQ9Is4",
            "paragraphs": [
              "Služba uLékaře.cz (www.ulekare.cz) funguje už 15 let a je průkopníkem online lékařské péče v ČR a SR. Pomáháme firmám i jednotlivcům zajistit dlouhý a zdravý život jejich zaměstnanců a klientů. Naše služby zahrnují největší online lékařskou poradnu v ČR a SR, vyhledání a objednání k lékaři a management prevence. Naši pacienti nás mohou kontaktovat 24/7 online a přes mobilní aplikaci.",
              "Za projektom uLékaře.cz stojí okrem iných aj MUDr. Tomáš Šebek – chirurg, autor kníh a humanitárny lekár z misií Lekárov bez hraníc."
            ]
          },
          "footerPerex": "Zaujala tě tato příležitost a chceš spojit obchod s péčí o zdraví? Těšíme se, až se ozveš. Pošli nám svůj životopis a pár slov o sobě na radmila.hrouzkova@ulekare.cz.",
          "lookingFor": {
            "perex": "Baví tě pečovat o zákazníky a komunikace s nimi? Máš už nějaké zkušenosti v oblasti B2B péče nebo se v této oblasti chceš teprve rozvíjet? Hledáš různorodou práci? Pokud ano, přidej se k našemu týmu péče o B2B klienty.",
            "title": "Hledáme tebe, protože:"
          },
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti.",
          "benefits": {
            "list": [
              "spolupráci na DPP",
              "motivující finanční ohodnocení",
              "práci online odkudkoliv v rámci ČR i zahraničí, při bydlišti v Praze je možnost i pracovat v kanceláři v případě zájmu",
              "plně flexibilní pracovní dobu – možnost rozvrhnout si hodiny podle sebe a kombinovat s jinou praxí, výukou či rodinou",
              "časovou náročnost podle Vašich možností – ideální pro rodiče na rodičovské, lékaře v důchodu nebo ty, kdo hledají práci mimo ordinaci",
              "příjemný kolektiv nadšených lidí",
              "Otevřenou komunikaci",
              "Možnost realizace v rychle rostoucí a expandující firmě",
              "Fajn kolektiv motivovaných lidí",
              "Prostor pro realizaci vlastních nápadů",
              "Místo výkonu práce v rámci celé ČR",
              "A motivated and friendly team",
              "Your work location will be within Slovakia or Hungary"
            ],
            "title": "A co nabízíme?"
          },
          "contact": {
            "paragraphs": [
              "Napište na e-mail tereza.cihakova@ulekare.cz nebo volejte na +420 778 725 239.",
              "Těšíme se na Tebe!",
              "We’re looking forward to hearing from you!"
            ],
            "title": "Chcete vědět víc? Pojďte se potkat!",
            "afterParagraphs": [
              "těšíme se na Vás!"
            ],
            "blocks": [
              {
                "list": [
                  "online pohovor s HR a manažerkou našich lékařů",
                  "následně nabídka spolupráce"
                ],
                "title": "Co Vás čeká po zaslání životopisu:"
              }
            ]
          },
          "hidePerexInDescription": "true"
        },
        "name": "Lékař/ka pro online poradnu – maďarsky hovořící",
        "officeLocation": "ČR i zahraničí (možnost kanceláře Praha)",
        "place": "remote",
        "routeUrl": "doctor-hu",
        "status": "otevřená pozice",
        "type": "part time",
        "hr": "tereza"
      },
      {
        "detail": {
          "about": {
            "perex": "V uLékaře.cz máme jasnou misi – měníme způsob, jakým lidé přistupují ke svému zdraví. Jsme průkopníkem online péče o zdraví a dostupnosti lékařské péče v Česku, na Slovensku a v Maďarsku. Dnes jsme největší online lékařskou poradnou, nabízíme službu vyhledání a objednání k lékaři i nástroje pro management prevence. Naše služby využívá už více než 200 zaměstnavatelů, kterým pomáháme zvyšovat spokojenost a produktivitu zaměstnanců a tím i prosperitu firem. Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek – chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic.",
            "title": "Prečo sa pridať k uLékaře.cz?",
            "videoPerex": "Ako sa staráme o zdravie našich zamestnancov, si môžeš pozrieť vo videu z našich raňajok pre HR profesionálov, ktoré pravidelne organizujeme počas roka na rôzne témy:\nhttps://www.youtube.com/watch?v=ifReJiQ9Is4",
            "paragraphs": [
              "V uLékaře.cz máme jasné poslanie – meníme spôsob, akým ľudia pristupujú k svojmu zdraviu. Sme najväčšia online lekárska poradňa v Českej republike a prinášame dôveryhodnú lekársku podporu jednotlivcom aj firmám. S tímom viac ako 350 lekárov všetkých špecializácií a skúsených sestier zabezpečujeme konzultácie pre akútnu, chronickú aj preventívnu starostlivosť.",
              "Za projektom uLékaře.cz stojí okrem iných aj MUDr. Tomáš Šebek – chirurg, autor kníh a humanitárny lekár z misií Lekárov bez hraníc."
            ]
          },
          "extra": {
            "list": [
              "Možnost spolupráce na plný úvazek HPP i IČO.",
              "Flexibilitu – práci z domova, hodinu sportu týdně, sick days i den volna k narozeninám i předvánoční den volna.",
              "Místo výkonu práce v Praze – s možností kombinace práce z kanceláře i z domova.",
              "Službu uLékaře.cz zdarma pro tebe i tvé blízké.",
              "Firemní notebook, mobilní telefon, příspěvek na MultiSport kartu.",
              "Prostor pro vlastní nápady a seberealizaci – u nás máš možnost ovlivnit věci kolem sebe.",
              "Spolupráci na zajímavých projektech, které mají skutečný dopad a smysl.",
              "Externí školení a rozvojové příležitosti, které ti pomohou růst.",
              "Teambuildingové akce, otevřenou komunikaci a fajn kolektiv motivovaných lidí, kteří se podporují a táhnou za jeden provaz.",
              "Team-building events",
              "Open and transparent communication",
              "A motivated and friendly team",
              "Your work location will be within Slovakia or Hungary"
            ],
            "title": "Co nabízíme:",
            "blocks": [
              {
                "list": [
                  "Možnost práce z domova, sick days a narozeninové volno",
                  "Jóga na pracovišti",
                  "Ovocné úterky a firemní terasa na grilovačky",
                  "Počítač a mobil k dispozici",
                  "Dog-friendly kancelář – ano, ale víme, že obchodníci spíš ocení výsledky :-)"
                ],
                "title": "A pár bonusů navíc:"
              }
            ]
          },
          "footerPerex": "Zaujala tě tato příležitost a chceš spojit obchod s péčí o zdraví? Těšíme se, až se ozveš. Pošli nám svůj životopis a pár slov o sobě na radmila.hrouzkova@ulekare.cz.",
          "lookingFor": {
            "perex": "Baví tě pečovat o zákazníky a komunikace s nimi? Máš už nějaké zkušenosti v oblasti B2B péče nebo se v této oblasti chceš teprve rozvíjet? Hledáš různorodou práci? Pokud ano, přidej se k našemu týmu péče o B2B klienty.",
            "title": "Hledáme tebe, protože:"
          },
          "perex": "Chceš byť súčasťou biznisu, ktorý má skutočný dopad na zdravie ľudí?Baví ťa obchod, rozvoj zmysluplných vzťahov a hľadáš pestrú prácu, ktorá ťa posunie ďalej?Dohovoríš sa po slovensky alebo po maďarsky?Ak áno, pridaj sa k nášmu obchodnému tímu! V rámci zahraničnej expanzie rozširujeme službu uLékaře.cz na Slovensko aj do Maďarska – hľadáme kolegu alebo kolegyňu, ktorí nám pomôžu rásť.",
          "skills": {
            "list": [
              "Hovoríš plynule po slovensky alebo po maďarsky.",
              "Máš skúsenosti z B2B obchodu.",
              "Si samostatný/á, pozitívny/á a vieš hľadať riešenia, nie výhovorky.",
              "Baví ťa aktívny kontakt s ľuďmi, dokážeš veci dotiahnuť do konca a službu prezentovať zrozumiteľne a presvedčivo.",
              "Práca s dátami, reporting ani príprava prezentácií ťa neodradí.",
              "Si aktívny vodič/vodička s vlastným autom.",
              "Máš komunikatívnu angličtinu aspoň na úrovni B2 (výhodou).",
              "Jsi časově flexibilní, zároveň zodpovědný/á a umíš si efektivně organizovat svůj čas.",
              "Týmová práce tě baví. Umíš naslouchat, pomáhat ostatním a zároveň přinášet vlastní nápady, jak věci dělat lépe."
            ],
            "title": "Hľadáme práve teba, ak:"
          },
          "waitingForYou": {
            "paragraphs": [
              "Aktívne vyhľadávať a oslovovať nových firemných klientov na slovenskom alebo maďarskom trhu – najmä HR manažérov a ľudí na rozhodujúcich pozíciách.",
              "Viesť celý obchodný proces od prvého kontaktu až po podpis zmluvy – predstavovať riešenie, pripravovať ponuky a kalkulácie, vyjednávať podmienky a uzatvárať spolupráce.",
              "Budovať a rozvíjať vzťahy s novými aj kľúčovými partnermi – osobne, online aj na odborných podujatiach, konferenciách či firemných stretnutiach.",
              "Pracovať efektívne s dátami a CRM systémom – mať prehľad, dôsledne reportovať a využívať dáta na zlepšovanie obchodných výsledkov.",
              "Spolupracovať v tíme, zdieľať skúsenosti a vedieť si vypýtať podporu, keď je to potrebné.",
              "Cestovať za klientmi nielen v rámci svojho regiónu.",
              "Cestování za klienty – na týdenní bázi po celé ČR.",
              "Týmové porady a sdílení nápadů – jednou týdně v pražských kancelářích (v období adaptace i častěji)."
            ],
            "title": "Čo ťa bude baviť:"
          },
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti.",
          "workflow": {
            "afterParagraphs": [
              {},
              "Cítíš, že tohle je přesně role pro tebe? Tak nám pošli CV nebo odkaz na LinkedIn a pár vět o sobě na radmila.hrouzkova@ulekare.cz. Těšíme se!"
            ],
            "list": [
              "Online rozhovor s Radkou z HR, ktorá ti predstaví pozíciu, tím aj to, ako u nás fungujeme.",
              "Stretnutie so Šimonom, ktorý má na starosti zahraničnú expanziu – porozprávate sa o úlohe aj o tom, kam môžeme spoločne rásť.",
              "A potom už len ponuka a vykročíš s nami pravou nohou za zdravím. 🚀"
            ],
            "title": "A čo ťa čaká po odoslaní CV?"
          },
          "benefits": {
            "list": [
              "Spoluprácu na živnosť (plný úväzok).",
              "Flexibilitu – prácu z domu, sick days aj voľno k narodeninám a predvianočný deň volna.",
              "Službu uLékaře.cz zadarmo pre teba aj tvojich blízkych.",
              "Motivujúce odmeňovanie – fixná mzda doplnená o variabilnú zložku podľa výsledkov.",
              "Moderné vybavenie – firemný notebook a mobilný telefón.",
              "Príležitosť byť súčasťou rýchlo rastúceho projektu, ktorý má skutočný dopad a zmysel.",
              "Skvelý tím, ktorý ťahá za jeden povraz, navzájom sa podporuje a vie sa aj zasmiať.",
              "Room for your own ideas",
              "External training opportunities",
              "Team-building events",
              "Open and transparent communication",
              "A motivated and friendly team",
              "Your work location will be within Slovakia or Hungary"
            ],
            "title": "Čo ponúkame:"
          },
          "contact": {
            "afterParagraphs": [
              "těšíme se na Vás!"
            ],
            "blocks": [
              {
                "list": [
                  "online pohovor s HR a manažerkou našich lékařů",
                  "následně nabídka spolupráce"
                ],
                "title": "Co Vás čeká po zaslání životopisu:"
              }
            ],
            "paragraphs": [
              "Zaujala ťa táto príležitosť a chceš spojiť obchod so starostlivosťou o zdravie?",
              "Tešíme sa, keď sa nám ozveš! Pošli svoj životopis a krátky motivačný list na radmila.hrouzkova@ulekare.cz.",
              "We’re looking forward to hearing from you!"
            ],
            "title": "Chcete vědět víc? Pojďte se potkat!"
          },
          "hidePerexInDescription": "true"
        },
        "hr": "radka",
        "name": "Sales Consultant pro SK/HU trh",
        "officeLocation": "Slovensko / Maďarsko + cestování",
        "place": "remote",
        "routeUrl": "sales-consultant-sk-hu",
        "status": "otevřená pozice",
        "type": "full time"
      },
      {
        "detail": {
          "about": {
            "perex": "V uLékaře.cz máme jasnou misi – měníme způsob, jakým lidé přistupují ke svému zdraví. Jsme průkopníkem online péče o zdraví a dostupnosti lékařské péče v Česku, na Slovensku a v Maďarsku. Dnes jsme největší online lékařskou poradnou, nabízíme službu vyhledání a objednání k lékaři i nástroje pro management prevence. Naše služby využívá už více než 200 zaměstnavatelů, kterým pomáháme zvyšovat spokojenost a produktivitu zaměstnanců a tím i prosperitu firem. Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek – chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic.",
            "title": "Why join uLékaře.cz?",
            "videoPerex": "Check out how we support employee health in a video from our HR Breakfast event series, which we regularly host on various topics:\nhttps://www.youtube.com/watch?v=ifReJiQ9Is4",
            "paragraphs": [
              "Since 2007, uLékaře.cz has been a pioneer in online healthcare and improving access to medical care. We currently help over 200 employers across CZ and SK increase employee satisfaction and productivity, which in turn boosts overall company performance.",
              "We offer the largest online medical advisory service in CZ and SK, doctor search & booking services, and preventive care management. Our services are available 24/7 via our website and mobile app."
            ]
          },
          "extra": {
            "list": [
              "Možnost spolupráce na plný úvazek HPP i IČO.",
              "Flexibilitu – práci z domova, hodinu sportu týdně, sick days i den volna k narozeninám i předvánoční den volna.",
              "Místo výkonu práce v Praze – s možností kombinace práce z kanceláře i z domova.",
              "Službu uLékaře.cz zdarma pro tebe i tvé blízké.",
              "Firemní notebook, mobilní telefon, příspěvek na MultiSport kartu.",
              "Prostor pro vlastní nápady a seberealizaci – u nás máš možnost ovlivnit věci kolem sebe.",
              "Spolupráci na zajímavých projektech, které mají skutečný dopad a smysl.",
              "Externí školení a rozvojové příležitosti, které ti pomohou růst.",
              "Teambuildingové akce, otevřenou komunikaci a fajn kolektiv motivovaných lidí, kteří se podporují a táhnou za jeden provaz.",
              "Team-building events",
              "Open and transparent communication",
              "A motivated and friendly team",
              "Your work location will be within Slovakia or Hungary"
            ],
            "title": "Co nabízíme:",
            "blocks": [
              {
                "list": [
                  "Možnost práce z domova, sick days a narozeninové volno",
                  "Jóga na pracovišti",
                  "Ovocné úterky a firemní terasa na grilovačky",
                  "Počítač a mobil k dispozici",
                  "Dog-friendly kancelář – ano, ale víme, že obchodníci spíš ocení výsledky :-)"
                ],
                "title": "A pár bonusů navíc:"
              }
            ]
          },
          "lookingFor": {
            "perex": "Baví tě pečovat o zákazníky a komunikace s nimi? Máš už nějaké zkušenosti v oblasti B2B péče nebo se v této oblasti chceš teprve rozvíjet? Hledáš různorodou práci? Pokud ano, přidej se k našemu týmu péče o B2B klienty.",
            "title": "Hledáme tebe, protože:"
          },
          "perex": "Do you want to be part of a business that makes a real impact on people’s health?Do you enjoy sales, client care, and building meaningful relationships?Can you speak Slovak OR Hungarian and are looking for a diverse, growth-oriented role?If your answer is YES, don’t wait—join our B2B sales team! As part of our international expansion, we’re bringing uLékaře.cz to Slovakia and Hungary.",
          "skills": {
            "list": [
              "You speak fluent Slovak (Hungarian is a plus, not a must) and are comfortable presenting in public",
              "You have experience in B2B sales, corporate client care, or a consultancy role",
              "You’re independent, positive, and solution-oriented",
              "You enjoy active client contact and can present services clearly and persuasively",
              "You’re not discouraged by working with data, reporting, and preparing presentations",
              "You’re an active driver with your own car",
              "English is a plus",
              "Jsi časově flexibilní, zároveň zodpovědný/á a umíš si efektivně organizovat svůj čas.",
              "Týmová práce tě baví. Umíš naslouchat, pomáhat ostatním a zároveň přinášet vlastní nápady, jak věci dělat lépe."
            ],
            "title": "You’re the right fit if:"
          },
          "waitingForYou": {
            "paragraphs": [
              "Acquisition – reaching out to new corporate clients in the Slovak or Hungarian market, mainly HR managers and key decision-makers",
              "Creating proposals and pricing, negotiating terms, and preparing materials for internal employee communication",
              "Relationship building – with both existing and new clients, including participation in events and conferences",
              "CRM work",
              "Client visits (You won’t be covering the entire country. Your portfolio will be tailored to your location.)",
              "Práce se zpětnou vazbou – sdílení úspěchů, ale i aktivní řešení připomínek či stížností.",
              "Cestování za klienty – na týdenní bázi po celé ČR.",
              "Týmové porady a sdílení nápadů – jednou týdně v pražských kancelářích (v období adaptace i častěji)."
            ],
            "title": "What you'll enjoy:"
          },
          "workflow": {
            "list": [
              "Online call s Radkou z HR, která ti představí pozici, tým i to, jak u nás fungujeme.",
              "Setkání s Magdou Blažkovou, která vede tým, a společně si popovídáte o roli i o tom, jak můžeme společně růst.",
              "A pak už jen nabídka a vykročíš s námi pravou nohou ke zdraví."
            ],
            "title": "A co tě čeká po zaslání CV?",
            "afterParagraphs": [
              {},
              "Cítíš, že tohle je přesně role pro tebe? Tak nám pošli CV nebo odkaz na LinkedIn a pár vět o sobě na radmila.hrouzkova@ulekare.cz. Těšíme se!"
            ]
          },
          "footerPerex": "Zaujala tě tato příležitost a chceš spojit obchod s péčí o zdraví? Těšíme se, až se ozveš. Pošli nám svůj životopis a pár slov o sobě na radmila.hrouzkova@ulekare.cz.",
          "benefits": {
            "list": [
              "Full-time cooperation on either employment contract (HPP) or freelance basis (IČO)",
              "Company mobile phone and laptop",
              "MultiSport card",
              "Free access to uLékaře.cz services for you and your loved ones",
              "Flexible working hours",
              "Home office, sick days, and a birthday day off",
              "Opportunity to work on interesting projects",
              "Room for your own ideas",
              "External training opportunities",
              "Team-building events",
              "Open and transparent communication",
              "A motivated and friendly team",
              "Your work location will be within Slovakia or Hungary"
            ],
            "title": "What we offer:"
          },
          "contact": {
            "paragraphs": [
              "You’ll be working with Adéla Hloušková, our Sales Director. You’ll be in touch with Radka from our HR team.",
              "Besides sending your CV, we’d love it if you could write us a few words about yourself at: radmila.hrouzkova@ulekare.cz",
              "We’re looking forward to hearing from you!"
            ],
            "title": "Curious to learn more? Let’s meet!"
          },
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti."
        },
        "hr": "radka",
        "name": "Sales Consultant for the SK/HU Market (en)",
        "officeLocation": "Slovakia / Hungary",
        "place": "remote",
        "routeUrl": "sales-consultant-sk-hu-2",
        "status": "otevřená pozice",
        "type": "full time"
      },
      {
        "detail": {
          "about": {
            "perex": "V uLékaře.cz máme jasné poslanie – meníme spôsob, akým ľudia pristupujú k svojmu zdraviu. Sme najväčšia online lekárska poradňa v Českej republike a prinášame dôveryhodnú lekársku podporu jednotlivcom aj firmám. S tímom viac ako 350 lekárov všetkých špecializácií a skúsených sestier zabezpečujeme konzultácie pre akútnu, chronickú aj preventívnu starostlivosť. Za projektom uLékaře.cz stojí okrem iných aj MUDr. Tomáš Šebek – chirurg, autor kníh a humanitárny lekár z misií Lekárov bez hraníc.",
            "title": "Prečo sa pridať k uLékaře.cz?",
            "videoPerex": "Ako sa staráme o zdravie našich zamestnancov, si môžeš pozrieť vo videu z našich raňajok pre HR profesionálov, ktoré pravidelne organizujeme počas roka na rôzne témy: https://www.youtube.com/watch?v=ifReJiQ9Is4"
          },
          "extra": {
            "list": [
              "Velmi zajímavé provize bez stropu – kolik si vyděláš, záleží jen na tobě.",
              "Spolupráci na IČO - fixní základ + bonusy z uzavřených smluv.",
              "Práce, která dává smysl – pomáháš lidem i firmám měnit přístup ke zdraví.",
              "Služba uLékaře.cz zdarma pro tebe i tvé blízké.",
              "Podpora růstu – pravidelné obchodní akademie a sdílení know-how.",
              "Príležitosť byť súčasťou rýchlo rastúceho projektu, ktorý má skutočný dopad a zmysel.",
              "Skvelý tím, ktorý ťahá za jeden provaz, navzájom sa podporuje a vie sa aj zasmiať.",
              "Room for your own ideas",
              "External training opportunities",
              "Team-building events",
              "Open and transparent communication",
              "A motivated and friendly team",
              "Your work location will be within Slovakia or Hungary"
            ],
            "title": "Co za to?",
            "blocks": [
              {
                "list": [
                  "Možnost práce z domova, sick days a narozeninové volno",
                  "Jóga na pracovišti",
                  "Ovocné úterky a firemní terasa na grilovačky",
                  "Počítač a mobil k dispozici",
                  "Dog-friendly kancelář – ano, ale víme, že obchodníci spíš ocení výsledky :-)"
                ],
                "title": "A pár bonusů navíc:"
              }
            ]
          },
          "lookingFor": {
            "perex": "Baví ťa obchod, rozvoj zmysluplných vzťahov a hľadáš pestrú prácu, ktorá ťa posunie ďalej? Dohovoríš sa po slovensky alebo po maďarsky? Ak áno, pridaj sa k nášmu obchodnému tímu! V rámci zahraničnej expanzie rozširujeme službu uLékaře.cz na Slovensko aj do Maďarska – hľadáme kolegu alebo kolegyňu, ktorí nám pomôžu rásť.",
            "title": "Hľadáme práve teba, ak:"
          },
          "perex": "Chceš být součástí businessu, který má reálný dopad na zdraví lidí? Hledáš obchodní roli, která má smysl, potenciál k růstu a zároveň ti nechá prostor pracovat chytře a samostatně? Chceš být v týmu, který táhne za jeden provaz, má tah na branku a buduje službu, která mění trh zdravotní péče? Pokud jsi komunikativní, baví tě jednat s lidmi, dotahovat obchody a nechceš prodávat věci, kterým sám nevěříš – pak jsi ten, koho hledáme! Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek – chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic. Naše online lékařská poradna je největší v Česku a pomáháme lidem i firmám přistupovat ke zdraví zodpovědně a srozumitelně.",
          "skills": {
            "list": [
              "Máš zkušenosti s B2B obchodem a nebojíš se jednat s HR a vedením firem.",
              "Obchod tě baví – umíš vytrvat, jednat s klienty a dotahovat věci do konce.",
              "Rád/a pracuješ samostatně, ale zároveň se zapojíš do týmu a pomůžeš, kde je třeba.",
              "Domluvíš se anglicky – občas budeš komunikovat s cizojazyčnými klienty.",
              "Jsi aktivní řidič s vlastním vozem.",
              "Máš zájem o technologie, inovace a chceš pracovat na službě, která pomáhá.",
              "Máš komunikatívnu angličtinu aspoň na úrovni B2 (výhodou)."
            ],
            "title": "Koho hledáme?"
          },
          "waitingForYou": {
            "paragraphs": [
              "Aktivně vyhledávat a oslovovat nové firemní klienty – především HR manažery, s využitím moderních nástrojů a přístupů, které šetří čas a zvyšují efektivitu.",
              "Vést celý prodejní proces od prvního kontaktu až po podpis smlouvy – prezentovat řešení, připravit nabídky a kalkulace, vyjednávat podmínky a uzavírat spolupráce.",
              "Budovat a rozvíjet vztahy s firmami a klíčovými stakeholdery – nejen při schůzkách a online jednáních, ale i na konferencích a dalších relevantních akcích.",
              "Pracovat chytře s CRM a dalšími nástroji, které zjednodušují administrativu – pečlivě reportovat a využívat data k lepším výsledkům.",
              "Být aktivní součástí týmu a umět si říct o podporu – spolupracovat, sdílet zkušenosti a táhnout s ostatními za jeden provaz.",
              "Cestovať za klientmi nielen v rámci svojho regiónu."
            ],
            "title": "Co budeš dělat?"
          },
          "workflow": {
            "list": [
              "Online call s Radkou z HR – seznámí tě s pozicí i firmou",
              "Setkání s Martinem, naším CEO",
              "Nabídka a můžeš začít"
            ],
            "title": "Co tě čeká dál?",
            "afterParagraphs": [
              {},
              "Cítíš, že tohle je přesně role pro tebe? Tak nám pošli CV nebo odkaz na LinkedIn a pár vět o sobě na radmila.hrouzkova@ulekare.cz. Těšíme se!"
            ]
          },
          "footerPerex": "Zaujala ťa táto príležitosť a chceš spojiť obchod so starostlivosťou o zdravie? Tešíme sa, keď sa nám ozveš! Pošli svoj životopis a krátky motivačný list na radmila.hrouzkova@ulekare.cz.",
          "legalPerex": "Poskytnutím svých osobních údajů v profesním životopise a motivačním dopise dáváte společnosti uLékaře.cz, s.r.o., souhlas, aby je v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a zákonem č. 110/2019 Sb., o zpracování osobních údajů, zpracovávala v rozsahu potřebném pro účely výběrového řízení. Udělený souhlas, který vždy stvrzujete samostatně a informovaně při zasílání životopisu a motivačního dopisu, můžete kdykoliv odvolat e-mailem nebo dopisem zaslaným na adresu společnosti."
        },
        "hr": "radka",
        "name": "Sales Consultant pro B2B (m/ž)",
        "officeLocation": "Praha + cestování po ČR",
        "place": "hybrid",
        "routeUrl": "sales-consultant-b2b",
        "status": "otevřená pozice",
        "type": "full time"
      },
      {
        "detail": {
          "about": {
            "perex": "Since 2007, uLékaře.cz has been a pioneer in online healthcare and improving access to medical care. We currently help over 200 employers across CZ and SK increase employee satisfaction and productivity, which in turn boosts overall company performance. We offer the largest online medical advisory service in CZ and SK, doctor search & booking services, and preventive care management. Our services are available 24/7 via our website and mobile app.",
            "title": "Why join uLékaře.cz?",
            "videoPerex": "Check out how we support employee health in a video from our HR Breakfast event series, which we regularly host on various topics. https://www.youtube.com/watch?v=ifReJiQ9Is4"
          },
          "extra": {
            "list": [
              "Full-time cooperation on either employment contract (HPP) or freelance basis (IČO)",
              "Company mobile phone and laptop",
              "MultiSport card",
              "Free access to uLékaře.cz services for you and your loved ones",
              "Flexible working hours",
              "Home office, sick days, and a birthday day off",
              "Opportunity to work on interesting projects",
              "Room for your own ideas",
              "External training opportunities",
              "Team-building events",
              "Open and transparent communication",
              "A motivated and friendly team",
              "Your work location will be within Slovakia or Hungary"
            ],
            "title": "What we offer:"
          },
          "footerPerex": "Curious to learn more? Let’s meet! You’ll be working with Adéla Hloušková, our Sales Director. You’ll be in touch with Radka from our HR team.",
          "lookingFor": {
            "perex": "Do you enjoy sales, client care, and building meaningful relationships? Can you speak Slovak OR Hungarian and are looking for a diverse, growth-oriented role? If your answer is YES, don’t wait—join our B2B sales team! As part of our international expansion, we’re bringing uLékaře.cz to Slovakia and Hungary.",
            "title": "You’re the right fit if:"
          },
          "perex": "Do you want to be part of a business that makes a real impact on people’s health?",
          "skills": {
            "list": [
              "You speak fluent Slovak (Hungarian is a plus, not a must) and are comfortable presenting in public",
              "You have experience in B2B sales, corporate client care, or a consultancy role",
              "You’re independent, positive, and solution-oriented",
              "You enjoy active client contact and can present services clearly and persuasively",
              "You’re not discouraged by working with data, reporting, and preparing presentations",
              "You’re an active driver with your own car",
              "English is a plus"
            ],
            "title": "Requirements:"
          },
          "waitingForYou": {
            "paragraphs": [
              "Acquisition – reaching out to new corporate clients in the Slovak or Hungarian market, mainly HR managers and key decision-makers",
              "Creating proposals and pricing, negotiating terms, and preparing materials for internal employee communication",
              "Relationship building – with both existing and new clients, including participation in events and conferences",
              "CRM work",
              "Client visits (You won’t be covering the entire country. Your portfolio will be tailored to your location.)"
            ],
            "title": "What you'll enjoy:"
          },
          "workflow": {
            "list": [
              "Online call s Radkou z HR – seznámí tě s pozicí i firmou",
              "Setkání s Martinem, naším CEO",
              "Nabídka a můžeš začít"
            ],
            "title": "Co tě čeká dál?"
          }
        },
        "hr": "radka",
        "name": "Sales Consultant for the SK/HU Market (en)",
        "officeLocation": "Slovakia / Hungary",
        "place": "remote",
        "routeUrl": "sales-consultant-sk-hu-2",
        "status": "otevřená pozice",
        "type": "full time"
      },
      {
        "detail": {
          "about": {
            "perex": "Hledáš obchodní roli, která má smysl, potenciál k růstu a zároveň ti nechá prostor pracovat chytře a samostatně? Chceš být v týmu, který táhne za jeden provaz, má tah na branku a buduje službu, která mění trh zdravotní péče? Za projektem uLékaře.cz stojí mimo jiné MUDr. Tomáš Šebek – chirurg, autor knih, humanitární lékař z misí Lékařů bez hranic. Naše online lékařská poradna je největší v Česku a pomáháme lidem i firmám přistupovat ke zdraví zodpovědně a srozumitelně.",
            "title": "Hledáš obchodní roli, která má smysl?"
          },
          "extra": {
            "list": [
              "Velmi zajímavé provize bez stropu – kolik si vyděláš, záleží jen na tobě.",
              "Spolupráci na IČO - fixní základ + bonusy z uzavřených smluv.",
              "Práce, která dává smysl – pomáháš lidem i firmám měnit přístup ke zdraví.",
              "Služba uLékaře.cz zdarma pro tebe i tvé blízké.",
              "Podpora růstu – pravidelné obchodní akademie a sdílení know-how.",
              "Možnost práce z domova, sick days a narozeninové volno.",
              "Ovocné úterky a firemní terasa na grilovačky.",
              "Počítač a mobil k dispozici.",
              "Dog-friendly kancelář – ano, ale víme, že obchodníci spíš ocení výsledky :-)"
            ],
            "title": "Co za to?"
          },
          "lookingFor": {
            "perex": "Pokud jsi komunikativní, baví tě jednat s lidmi, dotahovat obchody a nechceš prodávat věci, kterým sám nevěříš – pak jsi ten, koho hledáme!",
            "title": "Koho hledáme?"
          },
          "perex": "Chceš být součástí businessu, který má reálný dopad na zdraví lidí?",
          "skills": {
            "list": [
              "Máš zkušenosti s B2B obchodem a nebojíš se jednat s HR a vedením firem.",
              "Obchod tě baví – umíš vytrvat, jednat s klienty a dotahovat věci do konce.",
              "Rád/a pracuješ samostatně, ale zároveň se zapojíš do týmu a pomůžeš, kde je třeba.",
              "Domluvíš se anglicky – občas budeš komunikovat s cizojazyčnými klienty.",
              "Jsi aktivní řidič s vlastním vozem.",
              "Máš zájem o technologie, inovace a chceš pracovat na službě, která pomáhá."
            ],
            "title": "Naše očekávání:"
          },
          "waitingForYou": {
            "paragraphs": [
              "Aktivně vyhledávat a oslovovat nové firemní klienty – především HR manažery, s využitím moderních nástrojů a přístupů, které šetří čas a zvyšují efektivitu.",
              "Vést celý prodejní proces od prvního kontaktu až po podpis smlouvy – prezentovat řešení, připravit nabídky a kalkulace, vyjednávat podmínky a uzavírat spolupráce.",
              "Budování a rozvíjení vztahů s firmami a klíčovými stakeholdery – nejen při schůzkách a online jednáních, ale i na konferencích a dalších relevantních akcích.",
              "Pracovat chytře s CRM a dalšími nástroji, které zjednodušují administrativu – pečlivě reportovat a využívat data k lepším výsledkům.",
              "Být aktivní součástí týmu a umět si říct o podporu – spolupracovat, sdílet zkušenosti a táhnout s ostatními za jeden provaz."
            ],
            "title": "Co budeš dělat?"
          },
          "workflow": {
            "list": [
              "Online call s Radkou z HR – seznámí tě s pozicí i firmou",
              "Setkání s Martinem, naším CEO",
              "Nabídka a můžeš začít"
            ],
            "title": "Co tě čeká dál?"
          }
        },
        "hr": "radka",
        "name": "Sales Consultant pro B2B (m/ž)",
        "officeLocation": "Praha + cestování po ČR",
        "place": "hybrid",
        "routeUrl": "sales-consultant-b2b",
        "status": "otevřená pozice",
        "type": "full time"
      }
    ],
    "meetTheCompany": {
      "coloredPart": "Poznejte uLékaře.cz",
      "normalPart": "a jeho DNA"
    },
    "values": {
      "title": "Hodnoty, které nás spojují",
      "value": [
        {
          "number": "01",
          "title": "Lidskost",
          "perex": "Vážíme si lidskosti, férového jednání  a respektu se kterým přistupujeme nejen k sobě navzájem, ale přenášíme jej také do vztahu s našimi zákazníky a do péče  o naše uživatele."
        },
        {
          "perex": "Jsme zapálení, vytrvalí a houževnatí při doručování té nejlepší služby jak sobě navzájem, tak našim uživatelům. Máme radost z naší práce a dovedeme se vzájemně pochválit.",
          "title": "Nadšení",
          "number": "02"
        },
        {
          "perex": "Naše služby a práce stojí na profesionalitě a odbornosti jak zdravotníků, tak každého člena týmu. Posilováním těchto dovedností vytváříme důvěru u našich klientů i uvnitř týmu.",
          "title": "Odbornost",
          "number": "03"
        },
        {
          "perex": "Máme odvahu sdílet zpětnou vazbu a zároveň ji s pokorou přijímat. Díky ní se zlepšujeme a rozvíjíme nejen naše schopnosti, ale také kvalitu našich produktů a služeb.",
          "title": "Inovace",
          "number": "04"
        }
      ]
    },
    "veterans": {
      "coloredPart": "A jak to vidí",
      "normalPart": "naši „primáři“?"
    },
    "workDetails": {
      "colored": "Zní to jako vaše",
      "normal": "krevní skupina?",
      "perex": "Prozkoumejte naše volné pozice a ozvěte se nám. Pokud teď žádná není, znamená to, že náš tým je kompletní. Třeba se však brzy objeví nová příležitost. V případě dotazů se obraťte na náš HR tým: hr@ulekare.cz.",
      "cta": "Zpět na seznam pozic"
    },
    "tryOurApp": {
      "title": "Vyzkoušejte produkt, který tvoříme."
    },
    "detail": {
      "apply": {
        "cta": "Chci se přihlásit"
      },
      "details": {
        "title": "Náplň práce",
        "subtitle": "O nás",
        "requirements": "Požadavky",
        "additional": "Ještě by se hodilo"
      },
      "whatWeOffer": {
        "title": "Co nabízíme",
        "list": {
          "item": [
            "Flexibilní pracovní dobu a možnost home office.",
            "Podporu, loajalitu a otevřené férové jednání.",
            "Možnost dalšího vzdělávání a profesního růstu.",
            "Firemní akce a teambuildingové aktivity.",
            "Moderní pracovní prostředí a vybavení.",
            "Práce s nejnovějšími technologiemi a postupy."
          ]
        }
      }
    },
    "meetCompany": {
      "title": "Týmová fotka z teambuildingu\nv Berchtoldu",
      "perex": "Celá firma pohromadě. Ideální příležitost lépe poznat kolegy z dalších týmů a neformálně si popovídat. To nás baví."
    },
    "details": {
      "knowMore": {
        "colored": "Chcete vědět víc?",
        "normal": "Pojďme se potkat!",
        "perex": "Komunikovat s vámi bude {hrName}.\nPošlete nám svůj životopis a napište něco o sobě.",
        "email": "radmila.hrouzkova@ulekare.cz",
        "boxes": {
          "heading": "Další pozice",
          "perex": "Nesedí vám tato pozice?\nPodívejte na další volné pozice\nv naší nabídce.",
          "link": "career"
        }
      },
      "getInTouch": {
        "name": "Radka Hrouzková",
        "description": "HR, uLékaře.cz"
      }
    }
  },
  "selfReactivated": {
    "title": "Vítejte zpět!",
    "perex": "Váš účet je opět aktivní a máme radost, že s námi zůstáváte ve zdraví. Pokud budete cokoliv potřebovat, naše zákaznická péče vás ráda vyslechne na <a href=\"mailto: info@ulekare.cz\">info@ulekare.cz</a> nebo <a href=\"tel:00420227072720\">+420 227 072 720</a>.",
    "primaryButtonText": "Pokračovat s uLékaře.cz"
  },
  "careerPage": {
    "veterans": {
      "veteran": [
        {
          "name": "Martin Pospíšil",
          "position": "CEO",
          "perex": "Quisque venenatis laoreet aliquet lectus massa. Ornare velit viverra ac egestas malesuada egestas mauris potenti massa. In pellentesque quisque quis bibendum urna consectetur. Quisque venenatis laoreet aliquet lectus massa. Ornare velit viverra ac egestas malesuada.",
          "photo": "martin.png"
        },
        {
          "name": "Michaela Hajzlerová",
          "position": "HR uLékaře.cz",
          "perex": "V uLékaře.cz věříme, že zdraví a wellbeing zaměstnanců nejsou benefit navíc, ale základ všeho, co děláme, a snažíme se tím opravdu žít i uvnitř firmy. Flexibilita, možnost práce odkudkoliv a moderní benefity jsou pro nás samozřejmostí. To nejcennější ale tvoří lidé – jejich lidskost, nadšení a vzájemný respekt. Jako HR manažerka vnímám právě atmosféru a přístup kolegů jako důvod, proč se tu pracuje dobře. Lidskost u nás není jen slovo, ale hodnota, která se promítá do každodenní spolupráce.",
          "photo": "martin.png"
        },
        {
          "name": "Martin Pospíšil",
          "position": "opět martin",
          "perex": "Quisque venenatis laoreet aliquet lectus massa. Ornare velit viverra ac egestas malesuada egestas mauris potenti massa. In pellentesque quisque quis bibendum urna consectetur. Quisque venenatis laoreet aliquet lectus massa. Ornare velit viverra ac egestas malesuada.",
          "photo": "martin.png"
        }
      ]
    },
    "hero": {
      "title": "Kariéra"
    },
    "video": {
      "slug": "Pomáháme firmám pečovat o zdraví svých zaměstnanců díky chytrému plánování zdravotní péče. Už od roku 2018 se o naše klienty stará sehraný tým odborníků – od kvalifikovaných sester a lékařů, přes specialisty na firemní klienty až po vývojáře, kteří posouvají naše digitální služby vpřed."
    }
  },
  "hr": {
    "tereza": {
      "name": "Tereza Čiháková",
      "email": "tereza.cihakova@ulekare.cz",
      "image": "tereza.png"
    },
    "radka": {
      "name": "Radka Hrouzková",
      "email": "radmila.hrouzkova@ulekare.cz",
      "image": "radka.png"
    }
  },
  "ePrescription": {
    "title1": "Jak funguje vystavení",
    "perex": "Lékař v rámci vašeho dotazu zhodnotí váš zdravotní stav. Na základě toho může doporučit zprostředkování eReceptu. Nárok na eRecept nevzniká automaticky – lékař jej vystaví, jen pokud je to bezpečné a vhodné. Služba uLékaře.cz eRecepty přímo nevystavuje, ale propojíme vás s poskytovatelem zdravotních služeb, který může eRecept vystavit.\nPřed samotným vystavením eReceptu vám zavolá zdravotní sestra, aby ověřila potřebné údaje.",
    "disclaimer": {
      "b2b": "Lékař může navrhnout zprostředkování eReceptu. Pro získání je nutný hovor se sestrou. Na vystavení nevzniká nárok. {disclaimerLink}",
      "b2c": "Lékař z poradny může navrhnout zprostředkování eReceptu. Pro jeho získání je nutný hovor se sestrou. Na vystavení nevzniká nárok. {disclaimerLink}"
    },
    "disclaimerLink": "Více",
    "list": [
      {
        "title": "Kdy eRecept nedostanete",
        "subtitle": "Například pokud:",
        "body": [
          "V dotazu chybí informace o vašem zdravotním stavu potřebné pro zprostředkování eReceptu.",
          "Je nutné osobní vyšetření lékařem.",
          "Případ je složitější nebo nestandardní.",
          "Předepsání léku vyžaduje lékaře jiné specializace než praktického lékaře.",
          "Neproběhne potřebné ověření údajů.",
          "Žádost se týká někoho dalšího (eRecept nelze žádat pro partnera, rodiče, dítě ani jinou osobu)."
        ]
      },
      {
        "title": "Jak to probíhá",
        "body": [
          "Položíte dotaz ve svém účtu (můžete napsat, že máte zájem o zprostředkování eReceptu).",
          "Lékař posoudí informace, které jste uvedli.",
          "Pokud je to vhodné, doporučí zprostředkování eReceptu.",
          "Před vystavením eReceptu vás kontaktuje zdravotní sestra kvůli ověření údajů.",
          "Není-li vystavení eReceptu možné, dostanete doporučení, co dál – například navštívit praktického lékaře či specialistu."
        ]
      },
      {
        "title": "Co to pro vás znamená",
        "body": [
          "V naší poradně existuje možnost zprostředkování eReceptu.",
          "Nelze jej získat automaticky – lékař musí vždy posoudit, zda je vhodné jej vystavit.",
          "eRecept neobdržíte obratem – počítejte s krátkou dobou na zpracování.",
          "Chceme vám pomoci co nejlépe, ale nikdy na úkor správné a bezpečné péče."
        ]
      },
      {
        "title": "Jak je to s eReceptem v zahraničí",
        "subtitle": [
          "Český eRecept lze uplatnit v některých zemích EU: Polsko, Chorvatsko, Španělsko, Řecko, Estonsko, Finsko, Litva a Lotyšsko.",
          "Pro vyzvednutí léků budete potřebovat:"
        ],
        "body": [
          "platný doklad totožnosti (občanský průkaz nebo pas),",
          "identifikátor eReceptu."
        ],
        "footer": "Léky se v zahraničí hradí v plné výši. O případné proplacení můžete požádat svou zdravotní pojišťovnu."
      }
    ],
    "title2": "eReceptu v uLékaře.cz",
    "questionDisclaimer": {
      "b2b": "Lékař může navrhnout zprostředkování eReceptu. Pro získání je nutný hovor se sestrou. Na vystavení nevzniká nárok. {disclaimerLink}",
      "b2c": "Lékař z poradny může navrhnout zprostředkování eReceptu. Pro jeho získání je nutný hovor se sestrou. Na vystavení nevzniká nárok. {disclaimerLink}"
    },
    "orderDisclaimer": {
      "b2b": "E-recept můžeme zprostředkovat na základě doporučení lékaře v naší poradně. V rámci služby objednání to možné není. {disclaimerLink}",
      "b2c": "E-recept můžeme zprostředkovat na základě doporučení lékaře v naší poradně. V rámci služby objednání to možné není. {disclaimerLink}"
    },
    "questionDisclaimerLink": "Více",
    "orderDisclaimerLink": "Zeptat se lékaře",
    "title": "Jak funguje vystavení eReceptu v uLékaře.cz"
  },
  "tallyTest": {
    "latestTest": {
      "pill": "Nový test"
    }
  },
  "dashboardPreferences": {
    "description": "Vyberte, které sekce chcete zobrazit na hlavní stránce.",
    "groups": {
      "main": "Hlavní sekce",
      "services": "Služby"
    },
    "sections": {
      "appointments": "Objednání k lékaři",
      "articles": "Články z magazínu",
      "news": "Novinky a pozvánky",
      "questions": "Zodpovězené dotazy",
      "serviceAssistLine": "Asistenční linka",
      "serviceLabOnline": "Laboratorní testy",
      "serviceOrder": "Objednání",
      "servicePrevention": "Prevence",
      "serviceQuestion": "Poradna",
      "serviceThematicCounselling": "Tematické poradny",
      "serviceVideoCall": "Videohovor s lékařem",
      "serviceVideoTherapy": "Videohovor s terapeutem",
      "thematicCounseling": "Sekce tematických poraden"
    },
    "title": "Přizpůsobení přehledu"
  },
  "questionPriceInfo": {
    "b2b": "Za položení dotazu zaplatíte {price} {currency}, odpověď lékaře obdržíte do {hours} h.",
    "b2bDiscount": "Za položení dotazu zaplatíte {price} {currency} (sleva {discountPercent} % od {partnerName}), odpověď lékaře obdržíte do {hours} h.",
    "b2c": "Za položení dotazu zaplatíte {price} {currency}, odpověď lékaře obdržíte do {hours} h. {termsLink}",
    "b2cLink": "Podrobné informace"
  },
  "vitalSigns": {
    "boxTitle": "Skener zdraví",
    "boxSubtitle": "měření životních funkcí",
    "boxText": "Rychlý sken obličeje a historická data.",
    "boxBadge": "Nové",
    "page": {
      "title": "Skener zdraví",
      "comingSoon": {
        "title": "Připravujeme",
        "text": "Funkce měření životních funkcí se připravuje. Brzy ji budete moci vyzkoušet."
      },
      "subtitle": "S pravidelným měřením máte své zdraví přehledně pod kontrolou.",
      "tabs": {
        "newMeasurement": "Nové měření",
        "overview": "Historie měření"
      },
      "measure": {
        "idle": {
          "startButton": "Začít měření"
        },
        "inProgress": {
          "loading": "Načítání kamery a měřicího modulu…",
          "cancel": "Zrušit měření"
        },
        "results": {
          "title": "Výsledky měření",
          "disclaimer": "Hodnoty jsou orientační a nenahrazují lékařskou diagnózu. V případě zdravotních obtíží vyhledejte lékaře.",
          "saveFailed": "Něco se pokazilo při ukládání. Pokud chcete mít výsledky měření uložené, zkuste to prosím znovu.",
          "saveBasic": "Uložit výsledky",
          "completeProfile": "Chci vědět více",
          "measureAgain": "Změřit znovu",
          "backToDashboard": "Zobrazit historii měření",
          "basicGroupTitle": "Základní měření",
          "advancedGroupTitle": "Doplňující měření"
        },
        "errors": {
          "no-camera": "Kamera není dostupná. Povolte přístup k kameře a zkuste to znovu.",
          "unsupported": "Váš prohlížeč nepodporuje měření vitálních funkcí.",
          "license": "Měření je dočasně nedostupné. Zkuste to prosím později.",
          "network": "Výsledek se nepodařilo uložit. Zkontrolujte připojení a zkuste to znovu.",
          "unknown": "Nastala neočekávaná chyba. Zkuste to prosím znovu.",
          "retry": "Zkusit znovu"
        }
      },
      "overview": {
        "categoryTitle": "Název kategorie",
        "categoryDescription": "Informace o kategorii",
        "cardSubtitle": "Přehled výsledků měření",
        "ranges": {
          "month": "Měsíc",
          "week": "Týden",
          "year": "Rok"
        },
        "openInfo": "Zobrazit popis úrovní",
        "closeInfo": "Zavřít popis",
        "prevMonth": "Předchozí měsíc",
        "nextMonth": "Následující měsíc",
        "emptyTitle": "Zatím žádná data",
        "emptyDescription": "Začněte prvním měřením v záložce Nové měření. Po několika měřeních se zde objeví grafy.",
        "prevPeriod": "Předchozí období",
        "nextPeriod": "Následující období"
      }
    },
    "disclaimer": {
      "line1": "Služba využívá AI ke zpracování údajů včetně zdravotních. Více o podmínkách, ochraně dat a omezeních {tocLink}.",
      "tocLink": "zde",
      "line2": "uLékaře.cz nenahrazuje záchrannou službu. Při život ohrožujících stavech vždy volejte 155. {emergencyLink}",
      "emergencyLink": "Kdy vyhledat pohotovost?"
    },
    "healthRisksForm": {
      "title": "Doplňující údaje",
      "description": "Vyplňte prosím základní údaje o sobě, abychom mohli vypočítat rozšířené zdravotní hodnoty.",
      "yes": "Ano",
      "no": "Ne",
      "placeholder": {
        "choose": "Vyberte"
      },
      "gender": {
        "question": "Jaké je vaše pohlaví?",
        "male": "Muž",
        "female": "Žena",
        "other": "Jiné"
      },
      "age": {
        "question": "Kolik je vám let?"
      },
      "bodyHeight": {
        "question": "Kolik měříte?"
      },
      "bodyWeight": {
        "question": "Kolik vážíte?"
      },
      "isSmoker": {
        "question": "Kouříte?"
      },
      "physicalActivity": {
        "question": "Kolikrát týdně cvičíte?",
        "sedentary": "Necvičím",
        "lightlyActive": "1–2× týdně",
        "moderately": "3–4× týdně",
        "veryActive": "5–6× týdně",
        "extraActive": "Denně"
      },
      "hypertensionTreated": {
        "question": "Léčíte se s vysokým krevním tlakem?"
      },
      "hasDiabetes": {
        "question": "Léčíte se s cukrovkou?"
      },
      "cholesterol": {
        "question": "Jaký je váš celkový cholesterol?",
        "hint": "Vyplňte, pouze pokud znáte hodnotu (mmol/L)."
      },
      "cholesterolHdl": {
        "question": "Jaký je váš HDL cholesterol?",
        "hint": "Vyplňte, pouze pokud znáte hodnotu (mmol/L)."
      },
      "submit": "Vypočítat a uložit",
      "cancel": "Zpět na výsledky",
      "validation": {
        "required": "Odpovězte, prosím.",
        "age": "Zadejte svůj věk.",
        "bodyHeight": "Zadejte svoji výšku v cm.",
        "bodyWeight": "Zadejte svoji hmotnost v kg.",
        "cholesterol": "Zadejte hodnotu v mmol/L (rozmezí 0,5–20)."
      },
      "formHeading": "Doplňující údaje pro výpočet rizik",
      "descriptionToggle": "Zobrazit nápovědu"
    },
    "charts": {
      "heartRate": {
        "title": "Srdeční tep (bpm)"
      },
      "hrvSdnn": {
        "title": "Srdeční variabilita (ms)"
      },
      "breathingRate": {
        "title": "Dechová frekvence (/min)"
      },
      "bloodPressure": {
        "title": "Krevní tlak (mmHg)"
      },
      "wellnessScore": {
        "title": "Kondice organismu (%)"
      },
      "physicalConditionScore": {
        "title": "AI index fyzických proporcí"
      },
      "waistToHeightRatio": {
        "title": "Poměr pasu a výšky"
      },
      "vascularAge": {
        "title": "Vaskulární věk"
      },
      "cvdRisk": {
        "title": "Kardiovaskulární riziko (%)"
      }
    },
    "metrics": {
      "heartRate": {
        "label": "Srdeční tep",
        "unit": "bpm",
        "levels": {
          "1": {
            "status": "Optimální",
            "description": "Ukazuje na velmi dobrou kondici a zdravou srdeční činnost. Riziko obtíží je nízké a srdce funguje úsporně a silně.",
            "range": "50–70 bpm"
          },
          "2": {
            "status": "V normě, ale vyšší",
            "description": "Srdeční tep je stále v normálním rozmezí, ale srdce už pracuje rychleji, než by bylo ideální. Pokud je Váš tep dlouhodobě vyšší, může to souviset s menší kondicí, stresem či únavou.",
            "range": "71–85 bpm"
          },
          "3": {
            "status": "Vysoký",
            "description": "Tep je na horní hranici normy, což ukazuje, že srdce je více zatížené. Riziko zdravotních potíží se zvyšuje, pokud tento stav trvá delší dobu.",
            "range": "86–100 bpm"
          },
          "4": {
            "status": "Rizikový",
            "description": "Hodnoty mimo normální rozmezí mohou naznačovat vážnější problém. Je důležité tento stav sledovat a v případě přetrvávajících obtíží konzultovat s lékařem.",
            "range": "<50 / >100 bpm"
          },
          "5": {
            "status": "Urgentní stav",
            "description": "Srdeční tep je mimo bezpečné rozmezí a může naznačovat vážný zdravotní problém. Je nutné co nejdříve vyhledat lékařskou pomoc, aby bylo možné zjistit příčinu a předejít možným komplikacím.",
            "range": "<40 / >120 bpm"
          }
        }
      },
      "hrvSdnn": {
        "label": "Srdeční variabilita",
        "unit": "ms",
        "levels": {
          "1": {
            "status": "Vysoká variabilita",
            "description": "Ukazuje na zdravý autonomní nervový systém a dobrou schopnost těla přizpůsobit se. Riziko stresu a přetížení je nízké.",
            "range": ">70 ms"
          },
          "2": {
            "status": "Střední variabilita",
            "description": "Váš autonomní nervový systém zvládá běžné zátěže, ale odolnost vůči stresu není maximální. Je zde prostor pro zlepšení životního stylu.",
            "range": "40–70 ms"
          },
          "3": {
            "status": "Nízká variabilita",
            "description": "Ukazuje, že autonomní nervový systém může být vyčerpaný a adaptabilita těla je oslabená. Riziko stresu, únavy a přetížení je zvýšené.",
            "range": "20–40 ms"
          },
          "4": {
            "status": "Velmi nízká variabilita",
            "description": "Autonomní nervový systém může být silně přetížený a tělo může být v dlouhodobém stresu. Pokud by byla variabilita srdečního tepu dlouhodobě velmi nízká, může hrozit vyčerpání a zdravotní komplikace.",
            "range": "<20 ms"
          },
          "5": {
            "status": "Urgentní stav",
            "description": "Variabilita srdečního tepu je extrémně nízká, což může znamenat akutní přetížení organismu nebo vážné narušení rovnováhy nervového systému. Doporučujeme co nejdříve vyhledat lékařskou konzultaci.",
            "range": "<10 ms"
          }
        }
      },
      "breathingRate": {
        "label": "Dechová frekvence",
        "unit": "/min",
        "levels": {
          "1": {
            "status": "Optimální",
            "description": "Dýchání je zdravé, pravidelné a tělo má dostatek kyslíku. To ukazuje na dobrou kondici a klidný nervový systém.",
            "range": "12–16 /min"
          },
          "2": {
            "status": "Mírně zvýšená",
            "description": "Dechová frekvence je sice v rámci normy, ale ukazuje na vyšší aktivitu organismu – může souviset s únavou, stresem či lehkým neklidem.",
            "range": "17–20 /min"
          },
          "3": {
            "status": "Zvýšená",
            "description": "Dýchání je rychlejší, než je zdravé v klidovém stavu. Organismus může být přetížený, vystresovaný nebo ne zcela odpočatý. Dlouhodobější zrychlený dech může být také známkou některých nemocí.",
            "range": "21–24 /min"
          },
          "4": {
            "status": "Riziková",
            "description": "Příliš pomalé nebo příliš rychlé dýchání může být známkou zdravotního problému a vyžaduje pozornost, zejména pokud je dlouhodobé.",
            "range": "≤11 / ≥25 /min"
          },
          "5": {
            "status": "Urgentní stav",
            "description": "Dechová frekvence je mimo bezpečné rozmezí a může znamenat vážné selhání dýchacího systému nebo akutní přetížení organismu. Je nutné co nejdříve vyhledat lékařskou pomoc, aby se předešlo možným komplikacím.",
            "range": "<8 / >30 /min"
          }
        }
      },
      "bloodPressure": {
        "label": "Krevní tlak",
        "unit": "mmHg",
        "levels": {
          "1": {
            "status": "Optimální",
            "description": "Hodnoty ukazují optimální tlak s minimálním zatížením cév i srdce. Riziko komplikací je nejnižší.",
            "range": "SYS <120 a DIA <80"
          },
          "2": {
            "status": "V normě, ale vyšší",
            "description": "Váš tlak je v pořádku, jen naznačuje prostor pro malé vylepšení. S trochou pohybu a klidu ho udržíte dlouhodobě zdravý.",
            "range": "SYS 120–129 a DIA 80–84"
          },
          "3": {
            "status": "Vysoký",
            "description": "Hodnoty jsou stále pod hranicí hypertenze, ale ukazují na vyšší zátěž. Riziko přechodu do vysokého tlaku je zvýšené.",
            "range": "SYS 130–139 a DIA 85–89"
          },
          "4": {
            "status": "Hypertenze",
            "description": "Hodnoty ukazují na hypertenzi, která dlouhodobě výrazně zatěžuje srdce a cévy. Riziko zdravotních komplikací je vysoké.",
            "range": "SYS ≥140 nebo DIA ≥90"
          },
          "5": {
            "status": "Urgentní – závažná hypertenze",
            "description": "Krevní tlak je výrazně zvýšený a může znamenat závažnou hypertenzi. Tento stav dlouhodobě ohrožuje srdce, cévy i další orgány. Je nutné co nejdříve vyhledat lékařskou pomoc, aby se zjistila příčina a tlak se dostal pod kontrolu.",
            "range": "SYS ≥160 nebo DIA ≥100"
          }
        }
      },
      "wellnessScore": {
        "label": "Kondice organismu",
        "unit": "/100",
        "levels": {
          "1": {
            "status": "Výborný stav",
            "description": "Výsledek ukazuje, že tělo i mysl fungují v harmonii. Energie, zdraví i psychická pohoda jsou na velmi dobré úrovni.",
            "range": "80–100 %"
          },
          "2": {
            "status": "Udržitelný stav",
            "description": "Výsledek ukazuje dobrý zdravotní a psychický stav, ale s občasnými výkyvy. Je zde prostor pro drobná vylepšení v životním stylu.",
            "range": "60–79 %"
          },
          "3": {
            "status": "Rizikový stav",
            "description": "Výsledek ukazuje častější únavu, stres nebo nedostatek rovnováhy. Je to varovný signál, že tělo i psychika potřebují více péče.",
            "range": "40–59 %"
          },
          "4": {
            "status": "Kritický stav",
            "description": "Zdá se, že Vaše tělo i psychika jsou dlouhodobě přetížené a vyčerpané. Riziko zdravotních i psychických komplikací je vysoké.",
            "range": "0–39 %"
          }
        }
      },
      "physicalConditionScore": {
        "label": "AI index fyzických proporcí",
        "unit": "",
        "levels": {
          "1": {
            "status": "Optimální váha",
            "description": "AIFP ukazuje, že vaše tělesná hmotnost odpovídá dobrému zdraví. Riziko komplikací je nízké a organismus má potřebnou rovnováhu.",
            "range": "18,5–24,9"
          },
          "2": {
            "status": "Nadváha",
            "description": "AIFP naznačuje mírné zvýšení hmotnosti, které zatím není kritické, ale může časem zatěžovat tělo. Je to signál k menším úpravám.",
            "range": "25–29,9"
          },
          "3": {
            "status": "Obezita",
            "description": "AIFP ukazuje vyšší míru nadváhy, která může zvyšovat riziko zdravotních komplikací. Je potřeba vědomá a systematická změna životního stylu.",
            "range": "30–34,9"
          },
          "4": {
            "status": "Těžká obezita",
            "description": "AIFP ukazuje vysoké riziko zdravotních komplikací. Je nezbytné přizpůsobit životní styl a často i vyhledat odbornou pomoc.",
            "range": "≥35"
          }
        }
      },
      "waistToHeightRatio": {
        "label": "Poměr pasu a výšky",
        "unit": "",
        "levels": {
          "1": {
            "status": "Optimální poměr",
            "description": "Ukazuje zdravé rozložení tělesného tuku a nízké riziko kardiovaskulárních a metabolických onemocnění.",
            "range": "≤0,50"
          },
          "2": {
            "status": "Zvýšené riziko",
            "description": "Signál, že máte větší množství tuku v oblasti břicha, což mírně zvyšuje zdravotní rizika.",
            "range": "0,51–0,59"
          },
          "3": {
            "status": "Vysoké riziko",
            "description": "Ukládání břišního tuku už výrazně zvyšuje riziko metabolických a kardiovaskulárních onemocnění.",
            "range": "0,60–0,69"
          },
          "4": {
            "status": "Velmi vysoké riziko",
            "description": "Extrémně vysoký podíl břišního tuku, který představuje vážné zdravotní riziko a vyžaduje péči.",
            "range": "≥0,70"
          }
        }
      },
      "vascularAge": {
        "label": "Vaskulární věk",
        "unit": "roky",
        "levels": {
          "1": {
            "status": "Optimální",
            "description": "Cévy mají dobrou pružnost a zdravý stav. Riziko kardiovaskulárních onemocnění je nízké.",
            "range": "vasc ≤ kalen"
          },
          "2": {
            "status": "Mírně zvýšený",
            "description": "Cévy jsou mírně zatížené, což naznačuje začínající zhoršování elasticity. Je vhodná prevence, aby se zpomalilo stárnutí cév.",
            "range": "o 1–5 let vyšší"
          },
          "3": {
            "status": "Zvýšený",
            "description": "Cévy ztrácí pružnost a jsou více zatížené. Riziko kardiovaskulárních potíží se začíná zvyšovat.",
            "range": "o 6–10 let vyšší"
          },
          "4": {
            "status": "Vysoký",
            "description": "Cévy jsou zřetelně ztuhlé a oslabené, což výrazně zvyšuje riziko onemocnění srdce a cév. Tento stav vyžaduje kroky ke zlepšení stavu a zabránění zhoršování stavu cév.",
            "range": "o >10 let vyšší"
          }
        }
      },
      "cvdRisk": {
        "label": "Kardiovaskulární riziko",
        "unit": "%",
        "levels": {
          "1": {
            "status": "Nízké riziko",
            "description": "Rizikové faktory jsou buď žádné, nebo velmi nízké. Krevní tlak, hmotnost, životní styl i další ukazatele jsou v normě.",
            "range": "<5 %"
          },
          "2": {
            "status": "Mírně zvýšené riziko",
            "description": "Některé ukazatele (např. krevní tlak, váha, či nedostatek pohybu) začínají ukazovat na vyšší zátěž pro srdce. Riziko je zatím malé, ale nelze ho přehlížet.",
            "range": "5–7 %"
          },
          "3": {
            "status": "Zvýšené riziko",
            "description": "Hodnoty ukazují na vyšší zátěž – krevní tlak, cholesterol, nadváha nebo kouření už výrazně ovlivňují zdraví cév. Riziko onemocnění je reálné.",
            "range": "7,5–19,9 %"
          },
          "4": {
            "status": "Vysoké riziko",
            "description": "Rizikové faktory se kumulují – vysoký tlak, cholesterol, nadváha, kouření nebo cukrovka výrazně zvyšují hrozbu srdečně-cévních onemocnění.",
            "range": "≥20 %"
          }
        }
      }
    }
  },
  "vitalSignsAgreement": {
    "title": "Souhlas s podmínkami užití",
    "perex": "Prosím seznamte se s novým textem Podmínek užití, ve kterém najdete informace o této službě využívající technologie AI.",
    "dataProcessing": "Informujeme vás také, že vaše osobní údaje zpracováváme v souladu se {privacyLink}.",
    "termsLinkText": "Podmínkami užití",
    "privacyLinkText": "Zásadami ochrany osobních údajů",
    "agreeCheckbox": "Souhlasím s {termsLink}",
    "confirmButton": "Rozumím"
  },
  "jobka": {
    "intro": {
      "item": [
        {
          "icon": "icons/chat.svg",
          "title": "Poradna 24/7",
          "text": "Lékaře máte nonstop v kapse. Ptát se můžete na tělo i duši, na zdraví své i vašich blízkých."
        },
        {
          "icon": "icons/date-7.svg",
          "title": "Objednání",
          "text": "Naše sestřičky vám pomohou s objednáním k lékaři jakékoliv specializace. Po celé ČR i SR."
        },
        {
          "icon": "icons/shield.svg",
          "title": "Prevence",
          "text": "Chytrý kalendář pro vaše zdravotní prohlídky, benefity zdravotní pojišťovny i tipy od lékařů."
        }
      ],
      "headingPrimary": "Pečujte o své zdraví",
      "headingSecondary": "Kdykoliv a odkudkoliv"
    }
  },
  "security": {
    "title": "Zajištění bezpečnosti informací ve společnosti",
    "content": [
      {
        "title": "Certifikace a audity",
        "text": "Jsme držitelem certifikace ISO/IEC 27001, která potvrzuje, že náš systém řízení bezpečnosti informací splňuje mezinárodně uznávané standardy. Tato certifikace nám pomáhá zajistit důvěrnost, integritu a dostupnost našich informací. Kromě toho procházíme pravidelným externím auditem, který nezávisle ověřuje dodržování našich bezpečnostních postupů a politik."
      },
      {
        "title": "Ukládání a šifrování dat",
        "text": "Naše společnost bere bezpečnost dat velmi vážně a používá širokou škálu opatření k ochraně dat našich zákazníků. Vaše data jsou uložena na serverech Amazon Web Services (AWS) v regionu Frankfurt, což nám umožňuje využívat robustní bezpečnostní infrastrukturu jedné z předních světových cloudových platforem. Data při přenosu k uživateli jsou šifrovaná pomocí TLS protkolu. Uložená data jsou šifrovaná pomocí AES-256. Data zákazníků jsou uložena na šifrovaných serverech, kam není možný přístup z vnějšího světa. Používáme VPC (Virtual Private Cloud), kde k nim mají přístup pouze části aplikace, které jsou ve stejné interní síti (VPC) a data tak nejsou přenášena veřejným internetem."
      },
      {
        "title": "Penetrační testy",
        "text": "Pravidelné penetrační testy jsou prováděny nezávislou externí společností, což nám umožňuje objektivně identifikovat a odstraňovat potenciální zranitelnosti v našich systémech. Tyto testy simulují reálné útoky a přispívají ke kontinuálnímu zlepšování naší ochrany proti bezpečnostním hrozbám."
      },
      {
        "title": "Zálohování",
        "text": "Pravidelné zálohování našich dat je klíčovou součástí naší strategie pro zajištění jejich dostupnosti a integrity. Data jsou primárně hostována v našem datovém centru v AWS, přičemž jejich zálohy jsou ukládány v rámci jiného datového centra AWS v EU. Tímto způsobem jsme schopni obnovit data v případě jejich ztráty nebo poškození."
      },
      {
        "title": "Monitoring",
        "text": "IT systémy jsou monitorované online a o případných problémech jsou naši správci ihned informováni. K dispozici máme i logy, které nám případně pomohou odhalit problém, který nastal."
      },
      {
        "title": "Kód",
        "text": "Každý řádek kódu na produkci prochází kontrolou dalšími programátory, abychom věděli, že je funkční a bezpečný. Používané knihovny pravidelně auditujeme a aktualizujeme. Pro případnou kontrolu změn používáme verzovací systém GIT. "
      },
      {
        "title": "Dvoufaktorová autentizace (2FA)",
        "text": "Pro přístup k citlivým údajům v našich aplikacích využíváme dvoufaktorovou autentizaci (2FA), která kromě standardního hesla vyžaduje i další ověřovací faktor. Tím je výrazně posílena bezpečnost přístupu a sníženo riziko neoprávněného přístupu. Uživatelé služby mají zároveň možnost aktivovat 2FA ve své klientské zóně, čímž mohou dále zvýšit úroveň zabezpečení svého účtu."
      },
      {
        "title": "Platební informace",
        "text": "Neuchováváme žádné platební informace ani čísla karet. Pro provádění plateb využíváme externí dodavatele, kteří disponují certifikací PCI DSS (Payment Card Industry Data Security Standard). Tím je zajištěno, že všechny transakce probíhají v souladu s nejvyššími bezpečnostními standardy."
      },
      {
        "title": "Soulad s GDPR",
        "text": "Uchováváme data v souladu s obecným nařízením o ochraně osobních údajů (GDPR). Tento právní rámec zajišťuje, že osobní údaje našich uživatelů jsou zpracovávány zákonně, korektně a transparentně. Podmínky užití jsou součástí každé poskytované služby, uživatel je má k dispozici a explicitně je odsouhlasuje před použitím služby. Stejně tak jsou uživatelům na našich stránkách poskytnuty Zásady zpracování osobních údajů, které detailně popisují, jakým způsobem jsou jejich data zpracovávána a chráněna. Implementovali jsme všechny potřebné procesy a opatření, aby byla zajištěna ochrana práv našich uživatelů a aby naše činnosti byly v souladu s těmito předpisy."
      },
      {
        "title": "Školení pracovníků",
        "text": "Pravidelně školíme naše pracovníky na téma bezpečnosti informací a GDPR. Tato školení zahrnují aktuální postupy a best practices v oblasti ochrany dat a jsou zaměřena na zvyšování povědomí o možných bezpečnostních rizicích a způsobech jejich předcházení. Zaměstnanci jsou také seznámeni s postupy pro správné zpracování a ochranu osobních údajů, aby byly naše činnosti vždy v souladu s právními požadavky a standardy. Tímto způsobem zajišťujeme, že každý člen našeho týmu je vybaven znalostmi a dovednostmi potřebnými pro udržení vysoké úrovně bezpečnosti informací."
      },
      {
        "title": "Použití AI nástrojů a soulad s předpisy",
        "text": "Ve společnosti využíváme moderní nástroje umělé inteligence pouze způsobem, který je v souladu s požadavky AI Act a platnou legislativou. Při jejich použití klademe maximální důraz na bezpečnost informací, ochranu osobních údajů a důvěrnost dat. Žádný nástroj AI se nepoužívá tak, aby docházelo k jejich učení na datech klientů nebo interních citlivých informacích bez řádného zabezpečení a kontroly."
      }
    ],
    "note": "Pro nahlášení bezpečnostní slabiny nebo případné dotazy, nás kontaktujte na <strong>security@ulekare.cz.</strong>"
  },
  "insuranceBenefits": {
    "items": [
      {
        "slug": "vzp",
        "updateDate": "30.3.2026",
        "companyBenefitsLink": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "15",
            "benefits": [
              {
                "type": "Pohybové aktivity a dentální hygiena",
                "icon": "move",
                "benefit": "Až 500 Kč na pohybové aktivity a sportovní aktivity nebo dentální hygienu od 18 do 65 let",
                "description": "Příspěvek je určen na pravidelnou pohybovou a zároveň sportovní aktivitu dlouhodobého charakteru nebo poskytnutou fyzioterapeutem a dentální hygienu (ošetření a instruktáž). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/dospely"
              },
              {
                "type": "Rehabilitační procedury",
                "benefit": "Příspěvek do max. výše 1 000 Kč pro pojištěnce (nad 18 let)",
                "description": "Příspěvek je na rehabilitační a rekondiční aktivity lázeňského typu nehrazené z v.z.p. Jedná se například o masáže, saunu, plavání, solné jeskyně, kryokomory nebo kneippovy chodníky. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/rehabilitacni-procedury"
              },
              {
                "type": "Očkování",
                "benefit": "Až 14 900 Kč na různé druhy očkování",
                "description": "Příspěvek je poskytován na očkování, která nejsou hrazena z veřejného zdravotního pojištění, tj., kde si pojištěnec plně platí vakcínu i její aplikaci. Příspěvek se nevztahuje na úhradu případného doplatku rozdílu mezi úhradou z veřejného zdravotního pojištění a platbou u lékaře.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani/dospely"
              },
              {
                "type": "Podpora při nemoci diabetes mellitus",
                "benefit": "Až 6 000 Kč pro diabetiky",
                "description": "Jedná se o příspěvek na na edukační pobyty, na přístrojové ošetření nohou a 1 vybrané rehabilitační procedury/terapie lázeňského typu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus"
              },
              {
                "type": "Speciální diety",
                "benefit": "Až 8 000 Kč na bezlepkovou dietu a až 12 000 Kč na nízkobílkovinnou dietu pro pojištěnce do 26 let",
                "description": "Příspěvek na bezlepkové potraviny nebo na platbu bezlepkových obědů ve školní jídelně nebo na nízkobílkovinné, bezlaktózové nebo bezlepkové potraviny. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "zdravy-talir",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety"
              },
              {
                "type": "Podpora při onkologické léčbě nebo alopecii",
                "benefit": "Příspěvek do max. výše 2 000 Kč pojištěncům bez omezení věku při onkologické léčbě nebo alopecii",
                "description": "Příspěvěk lze využít na zakoupení paruky, příčesku a úhradu ceny za využití chladicí čepice při chemoterapii.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 2 500 Kč v rámci prevence kardiovaskulárních a dalších závažných onemocnění můžete získat příspěvek na odvykání kouření",
                "description": "Příspěvek na léčivý přípravek Champix, který je předepisován lékařem na recept, nebo na volně prodejné léčivé přípravky (např. Defumoxan) zakoupené v lékárně (tj. na náhradní léčbu nikotinem v následujících formách: náplasti, pastilky, orodispergovatelný film, ústní spreje, žvýkačky).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/odvykani-koureni"
              },
              {
                "type": "Vyšetření kožních znamének",
                "benefit": "Až 500 Kč na vyšetření kožních znamének dermatoskopem v ordinaci praktického lékaře nebo dermatologa",
                "description": "Příspěvek na prevenci onkologického onemocnění kůže (melanomu) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek"
              },
              {
                "type": "Ultrazvukové vyšetření prsou",
                "benefit": "Až 500 Kč na ultrazvukové vyšetření prsu (sonografii)",
                "description": "Příspěvek je na ultrazvukové vyšetření prsu (sonografii), které musí být provedeno výhradně v akreditovaném mamografickém screeningovém centru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/ultrazvukove-vysetreni-prsou"
              },
              {
                "type": "Prevence onkologických onemocnění",
                "benefit": "Až 3 000 Kč na komplexní onkologickou preventivní prohlídku",
                "description": "Příspěvek na komplexní onkologickou preventivní prohlídku absolvovanou v Komplexních onkologických centrech. Příspěvek je určen pro pojištěnce VZP ve věku od 35 let, bez horní věkové hranice.\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/komplexni-onkologicka-prohlidka"
              },
              {
                "type": "Pro aktivní dárce krve",
                "benefit": "Až 3 000 Kč na rehabilitační/rekondiční aktivity a až 1 000 Kč na dentální hygienu",
                "description": "Příspěvek až 3 000 Kč na rehabilitační/rekondiční aktivity a až 1 000 Kč na dentální hygienu (ošetření a instruktáž).  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve"
              },
              {
                "type": "Pro neaktivní dárce krve",
                "benefit": "Až 500 Kč na rehabilitační/rekondiční aktivity",
                "description": "Příspěvek až 500 Kč na rehabilitační/rekondiční aktivity.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve"
              },
              {
                "type": "Psychosociální podpora",
                "benefit": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného terapeuta",
                "description": "Příspěvek je určen pojištěncům ve věku od 7 let na sezení u vybraného terapeuta dle zveřejněného seznamu v max. počtu 10 sezení. \n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/"
              },
              {
                "type": "Trénink/testování paměti pro seniory\n",
                "benefit": "Až 500 Kč na kognitivní pomůcky nebo testování paměti",
                "description": "Pokud je vám více než 65 let, můžete využít příspěvek: na kognitivní pomůcky doporučené Českou alzheimerovskou společností pro trénink paměti nebo testování paměti ve vybrané síti lékáren. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpurne-programy/trenink-testovani-pameti-pro-seniory"
              },
              {
                "type": "Psychosociální podpora pro válečné uprchlíky z Ukrajiny",
                "benefit": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného poskytovatele terapeutických služeb zařazeného do projektu",
                "description": "Příspěvek je poskytován na maximálně 10 sezení v maximální výši 500 Kč na jedno sezení ve věku od 7 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "18",
            "benefits": [
              {
                "type": "Pohybové aktivity a dentální hygiena",
                "benefit": "Až 500 Kč na pohybové aktivity a sportovní aktivity nebo dentální hygienu od 18 do 65 let",
                "description": "Příspěvek je určen na pravidelnou pohybovou a zároveň sportovní aktivitu dlouhodobého charakteru nebo poskytnutou fyzioterapeutem a dentální hygienu (ošetření a instruktáž).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/dospely"
              },
              {
                "type": "Rehabilitační procedury",
                "benefit": "Příspěvek do max. výše 1 000 Kč pro pojištěnce (nad 18 let)",
                "description": "Příspěvek je na rehabilitační a rekondiční aktivity lázeňského typu nehrazené z v.z.p. Jedná se například o masáže, saunu, plavání, solné jeskyně, kryokomory nebo kneippovy chodníky. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/rehabilitacni-procedury"
              },
              {
                "type": "Očkování",
                "benefit": "Až 14 900 Kč na různé druhy očkování",
                "description": "Příspěvek je poskytován na očkování, která nejsou hrazena z veřejného zdravotního pojištění, tj., kde si pojištěnec plně platí vakcínu i její aplikaci. Příspěvek se nevztahuje na úhradu případného doplatku rozdílu mezi úhradou z veřejného zdravotního pojištění a platbou u lékaře.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani/dospely"
              },
              {
                "type": "Podpora při nemoci diabetes mellitus",
                "benefit": "Až 6 000 Kč pro diabetiky",
                "description": "Jedná se o příspěvek na na edukační pobyty, na přístrojové ošetření nohou a 1 vybrané rehabilitační procedury/terapie lázeňského typu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus"
              },
              {
                "type": "Speciální diety",
                "benefit": "Až 8 000 Kč na bezlepkovou dietu a až 12 000 Kč na nízkobílkovinnou dietu pro pojištěnce do 26 let",
                "description": "Příspěvek na bezlepkové potraviny nebo na platbu bezlepkových obědů ve školní jídelně nebo na nízkobílkovinné, bezlaktózové nebo bezlepkové potraviny. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "zdravy-talir",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety"
              },
              {
                "type": "Podpora při onkologické léčbě nebo alopecii",
                "benefit": "Příspěvek do max. výše 2 000 Kč pojištěncům bez omezení věku při onkologické léčbě nebo alopecii",
                "description": "Příspěvěk lze využít na zakoupení paruky, příčesku a úhradu ceny za využití chladicí čepice při chemoterapii.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 2 500 Kč v rámci prevence kardiovaskulárních a dalších závažných onemocnění můžete získat příspěvek na odvykání kouření",
                "description": "Příspěvek na léčivý přípravek Champix, který je předepisován lékařem na recept, nebo na volně prodejné léčivé přípravky (např. Defumoxan) zakoupené v lékárně (tj. na náhradní léčbu nikotinem v následujících formách: náplasti, pastilky, orodispergovatelný film, ústní spreje, žvýkačky).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/odvykani-koureni"
              },
              {
                "type": "Vyšetření kožních znamének",
                "benefit": "Až 500 Kč na vyšetření kožních znamének dermatoskopem v ordinaci praktického lékaře nebo dermatologa",
                "description": "Příspěvek na prevenci onkologického onemocnění kůže (melanomu) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek"
              },
              {
                "type": "Ultrazvukové vyšetření prsou",
                "benefit": "Až 500 Kč na ultrazvukové vyšetření prsu (sonografii)",
                "description": "Příspěvek je na ultrazvukové vyšetření prsu (sonografii), které musí být provedeno výhradně v akreditovaném mamografickém screeningovém centru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/ultrazvukove-vysetreni-prsou"
              },
              {
                "type": "Prevence onkologických onemocnění",
                "benefit": "Až 3 000 Kč na komplexní onkologickou preventivní prohlídku",
                "description": "Příspěvek na komplexní onkologickou preventivní prohlídku absolvovanou v Komplexních onkologických centrech. Příspěvek je určen pro pojištěnce VZP ve věku od 35 let, bez horní věkové hranice.\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence/komplexni-onkologicka-prohlidka"
              },
              {
                "type": "Pro aktivní dárce krve",
                "benefit": "Až 3 000 Kč na rehabilitační/rekondiční aktivity a až 1 000 Kč na dentální hygienu",
                "description": "Příspěvek až 3 000 Kč na rehabilitační/rekondiční aktivity a až 1 000 Kč na dentální hygienu (ošetření a instruktáž).  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve"
              },
              {
                "type": "Pro neaktivní dárce krve",
                "benefit": "Až 500 Kč na rehabilitační/rekondiční aktivity",
                "description": "Příspěvek až 500 Kč na rehabilitační/rekondiční aktivity.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/darci/darci-krve"
              },
              {
                "type": "Psychosociální podpora",
                "benefit": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného terapeuta",
                "description": "Příspěvek je určen pojištěncům ve věku od 7 let na sezení u vybraného terapeuta dle zveřejněného seznamu v max. počtu 10 sezení. \n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/"
              },
              {
                "type": "Pro těhotné ženy a maminky",
                "benefit": "Až 5 000 Kč na vybrané služby a pomůcky",
                "description": "V době těhotenství a následně až do 12 měsíců po porodu můžete svůj finanční příspěvek na vybrané služby jako: screening, kurz přípravy k porodu, pomůcky ke kojení, monitor dechu, a jiné.\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/tehotne-do-12-mesicu"
              },
              {
                "type": "Příspěvek pro nedonošené miminko",
                "benefit": "Až 3 000 Kč na nákup umělé výživy, nákup mateřského mléka z banky, rehabilitační péči pro tyto děti",
                "description": "Na podporu zdravého vývoje dětí a prevence možných následků předčasně ukončeného nitroděložního vývoje je poskytován příspěvek pro nedonošené novorozence s porodní váhou do 1 500 g. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/nedonosene"
              },
              {
                "type": "Příspěvek pro miminko s rozštěpem rtu",
                "benefit": "Až 4 500 Kč na nákup nostril v lékárně nebo v nemocnici",
                "description": "Příspěvek pro miminko do 12 měsíců na nákup nostril v lékárně nebo v nemocnici.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/novorozenec-s-rozstepem-rtu"
              },
              {
                "type": "Trénink/testování paměti pro seniory\n",
                "benefit": "Až 500 Kč na kognitivní pomůcky nebo testování paměti",
                "description": "Pokud je vám více než 65 let, můžete využít příspěvek: na kognitivní pomůcky doporučené Českou alzheimerovskou společností pro trénink paměti nebo testování paměti ve vybrané síti lékáren. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpurne-programy/trenink-testovani-pameti-pro-seniory"
              },
              {
                "type": "Psychosociální podpora pro válečné uprchlíky z Ukrajiny",
                "benefit": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného poskytovatele terapeutických služeb zařazeného do projektu",
                "description": "Příspěvek je poskytován na maximálně 10 sezení v maximální výši 500 Kč na jedno sezení ve věku od 7 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "11",
            "benefits": [
              {
                "type": "Pohybové aktivity a dentální hygiena",
                "benefit": "Až 2 000 Kč na pohybové aktivity pro děti ve věku 0-18 let.",
                "description": "Příspěvěk pro děti ve věku 0-18 let roku, např. plavání kojenců a vaničkování organizované v kroužcích, spolcích, klubech, na pravidelné pohybové a zároveň sportovní aktivity dlouhodobého charakteru organizované v kroužcích, spolcích, sportovních klubech, apod., např. aerobic, atletika, florbal, fotbal, hokej, gymnastika, lyžařský kurz pořádaný školou apod. Příspěvek lze využít také na dentální hygienu (1-18 let).\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/odmena-za-prevenci/pohyb-a-dentalni-hygiena/deti"
              },
              {
                "type": "Podpora při nemoci diabetes mellitus",
                "benefit": "Až 3 000 Kč pro diabetiky",
                "description": "Jedná se o příspěvek na na edukační pobyty, vybrané rehabilitační procedury/terapie lázeňského typu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/diabetes-mellitus"
              },
              {
                "type": "Očkování",
                "benefit": "Až 9 500 Kč na různé druhy očkování",
                "description": "Příspěvek je poskytován na očkování, která nejsou hrazena z veřejného zdravotního pojištění, tj., kde si pojištěnec plně platí vakcínu i její aplikaci. Příspěvek se nevztahuje na úhradu případného doplatku rozdílu mezi úhradou z veřejného zdravotního pojištění a platbou u lékaře.\n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/ockovani"
              },
              {
                "type": "Speciální diety",
                "benefit": "Až 8 000 Kč na bezlepkovou dietu a až 12 000 Kč na nízkobílkovinnou dietu pro pojištěnce do 26 let",
                "description": "Příspěvek na bezlepkové potraviny nebo na platbu bezlepkových obědů ve školní jídelně nebo na nízkobílkovinné, bezlaktózové nebo bezlepkové potraviny. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "zdravy-talir",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/specialni-diety"
              },
              {
                "type": "Příspěvek na odlehčené sádry a fixace pro děti",
                "benefit": "Až 1 500 Kč na odlehčené a lehké sádry",
                "description": "Příspěvek je určen pro děti do 18 let věku na odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "person-happy",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/odlehcene-sadry-a-fixace"
              },
              {
                "type": "Vyšetření kožních znamének",
                "benefit": "Až 500 Kč na vyšetření kožních znamének dermatoskopem v ordinaci praktického lékaře nebo dermatologa",
                "description": "Příspěvek na prevenci onkologického onemocnění kůže (melanomu) Více informací se dozvíte na stránkách zdravotní pojišťovny zde:  odkaz.",
                "icon": "skin",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/prevence-onemocneni/vysetreni-koznich-znamenek"
              },
              {
                "type": "Příspěvek na pomůcky při onkologické léčbě nebo alopecii",
                "benefit": "Až 2 000 Kč na pomůcky",
                "description": "Příspěvek pacientům, kteří podstoupili onkologickou léčbu nebo i pojištěncům s diagnózou alopecie. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/podpora-pri-nemoci/prispevek-na-pomucky-pri-onkologicke-lecbe-nebo-alopecii"
              },
              {
                "type": "Příspěvek pro nedonošené miminko",
                "benefit": "Až 3 000 Kč na nákup umělé výživy, nákup mateřského mléka z banky, rehabilitační péči pro tyto děti",
                "description": "Na podporu zdravého vývoje dětí a prevence možných následků předčasně ukončeného nitroděložního vývoje je poskytován příspěvek pro nedonošené novorozence s porodní váhou do 1 500 g. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/nedonosene"
              },
              {
                "type": "Příspěvek pro miminko s rozštěpem rtu",
                "benefit": "Až 4 500 Kč na nákup nostril v lékárně nebo v nemocnici",
                "description": "Příspěvek pro miminko do 12 měsíců na nákup nostril v lékárně nebo v nemocnici.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.vzp.cz/pojistenci/vyhody-a-prispevky/k-porodu-a-po-porodu/novorozenec-s-rozstepem-rtu"
              },
              {
                "type": "Psychosociální podpora",
                "benefit": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného terapeuta",
                "description": "Příspěvek je určen pojištěncům ve věku od 7 let na sezení u vybraného terapeuta dle zveřejněného seznamu v max. počtu 10 sezení. \n\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku/"
              },
              {
                "type": "Psychosociální podpora pro válečné uprchlíky z Ukrajiny",
                "benefit": "Až 5 000 Kč na zvýšení dostupnosti psychosociální podpory u vybraného poskytovatele terapeutických služeb zařazeného do projektu",
                "description": "Příspěvek je poskytován na maximálně 10 sezení v maximální výši 500 Kč na jedno sezení ve věku od 7 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://dusevnizdravi.vzp.cz/informace-o-prispevku-ua/"
              }
            ]
          }
        ]
      },
      {
        "slug": "zpmv",
        "updateDate": "27.1.2026",
        "companyBenefitsLink": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "31",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 2 000 Kč na očkování",
                "description": "Přispíváme až 2 000 Kč na všechna očkování, která nejsou hrazena z veřejného zdravotního pojištění (nebo mimo věkovou hranici, kdy hrazena jsou).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-dospele"
              },
              {
                "type": "Sportovní pohybové aktivity pro dospělé\n",
                "benefit": "Až 500 Kč na sportovní aktivity",
                "description": "Přispíváme až 500 Kč na sportovní aktivity určené pro dospělé. Jedná se o aktivity a sporty dlouhodobého charakteru, rozvíjející sílu, koordinaci, flexibilitu, posílení středu těla, napomáhající ke zlepšení či podpoře kondice.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-dospele"
              },
              {
                "type": "Sportovní preventivní prohlídka",
                "benefit": "Až 500 Kč sportovcům na preventivní prohlídku",
                "description": "Přispíváme dospělým až 500 Kč na preventivní prohlídku, kterou vyžadují sportovní kluby a svazy. Obsahem prohlídky je zpravidla základní interní vyšetření, základní anamnéza, zhodnocení rozboru krve a vyšetření moči, základní vyšetření pohybového aparátu, antropometrie, popř. klidová spirometrie; určení tělesné skladby bioimpedanční metodou, klidové i zátěžové EKG (na běžeckém pásu nebo cyklotrenažeru).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka"
              },
              {
                "type": "Prevence nadváhy a obezity\n",
                "benefit": "Až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou",
                "description": "Přispíváme až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity"
              },
              {
                "type": "Prevence karcinomu tlustého střeva a konečníku\n",
                "benefit": "Až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku",
                "description": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku, aby byla šance na vyléčení co největší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-tlusteho-streva-a-konecniku"
              },
              {
                "type": "Prevence karcinomu kůže\n",
                "benefit": "Až 500 Kč na vyšetření dermatoskopem",
                "description": "Přispíváme až 500 Kč na vyšetření dermatoskopem, které slouží k včasnému zachycení kožního zhoubného nádoru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze"
              },
              {
                "type": "Zdravotnické prostředky\n",
                "benefit": "Až 500 Kč nad rámec ostatních preventivních programů na nákup zdravotnických prostředků",
                "description": "Přispíváme až 500 Kč na nákup zdravotnických prostředků, které souvisejí s chronickým onemocněním a nejsou hrazeny z veřejného zdravotního pojištění. Např. Diabetes mellitus (cukrovka), Onemocnění respiračního systému (astma), Chronické onemocnění trávicího a močového systému a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky"
              },
              {
                "type": "Specifické diety\n",
                "benefit": "Až 2 000 Kč na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci",
                "description": "Přispíváme dospělým s potravinovou intolerancí až 2 000 Kč nad rámec ostatních preventivních programů na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci. Napři: při celiakii, fenylketonurii a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety"
              },
              {
                "type": "Sestavení jídelníčku nutričním terapeutem\n",
                "benefit": "Až 500 Kč na službu nutričního terapeuta ",
                "description": "Přispíváme až 500 Kč na službu nutričního terapeuta, který sestaví jídelníček pro dosažení a udržení zdravé hmotnosti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem"
              },
              {
                "type": "Dentální hygiena pro dospělé\n",
                "benefit": "Až 500 Kč na dentální hygienu",
                "description": "Přispíváme až 500 Kč na dentální hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-dospele"
              },
              {
                "type": "Komplexní onkologické vyšetření\n",
                "benefit": "Až 2 000 Kč na preventivní onkologické prohlídky ",
                "description": "Přispíváme až 2 000 Kč na preventivní onkologické prohlídky v rámci nabídky Komplexních onkologických center. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni"
              },
              {
                "type": "Telemonitoring",
                "benefit": "Až 2 000 Kč pojištěncům zapojených do programů telemonitoringu",
                "description": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních programů pojištěncům zapojeným do programů telemonitoringu. Např. Telemonitoring pro pojištěnce s chronickým srdečním selháním, Telemonitoring pro pojištěnce s podezřením na poruchy srdečního rytmu nebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "register",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/telemonitoring"
              },
              {
                "type": "Klinická psychologie - dospělí\n",
                "benefit": "Až 4 000 Kč na vyšetření v oboru klinické psychologie",
                "description": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické psychologie, která nejsou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především pomoc se zvládáním stresu a z něj pocházejících psychických problémů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-dospeli"
              },
              {
                "type": "Klinická logopedie - dospělí\n",
                "benefit": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
                "description": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-dospeli"
              },
              {
                "type": "Paruky, podprsenky a další prostředky pro onkologické pacienty\n",
                "benefit": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
                "description": "Přispíváme až 2 000 Kč dospělým, kteří podstupují nebo podstoupili protinádorovou léčbu (chemoterapii), ozařování nebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty"
              },
              {
                "type": "Edukační pobyty pro klienty s diabetem II. typu\n",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty, které jsou organizované pacientskými organizacemi, např. členy Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu"
              },
              {
                "type": "Vyšetření kognitivních funkcí a pomůcky pro trénování paměti\n",
                "benefit": "Až 500 Kč na vyšetření, jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby nebo dalších forem demence",
                "description": "Přispíváme až 500 Kč na následující vyšetření, která nejsou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby nebo dalších forem demence. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-kognitivnich-funkci-a-pomucky-pro-trenovani-pameti"
              },
              {
                "type": "Dopravně psychologické vyšetření\n",
                "benefit": "Až 500 Kč na vyšetření u dopravního psychologa",
                "description": "Přispíváme až 500 Kč na vyšetření u dopravního psychologa.\nDopravně psychologické vyšetření je povinné pro některé skupiny řidičských oprávnění, popřípadě si jej může vyžádat praktický lékař. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dopravne-psychologicke-vysetreni"
              },
              {
                "type": "Kurz pro rodiče - péče o dětské zuby\n",
                "benefit": "Až 500 Kč na úhradu kurzu pro rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů",
                "description": "Přispíváme až 500 Kč na úhradu kurzu pro rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů.\nKurz musí být veden odborníkem, tj. zubním lékařem, zubní hygienistkou, zdravotní sestrou apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/kurz-pro-rodice-pece-o-detske-zuby"
              },
              {
                "type": "Nutriční poradenství v souvislosti se specifickou dietou\n",
                "benefit": "Až 2 000 Kč na sestavení jídelníčku s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii",
                "description": "Přispíváme až 2 000 Kč na konzultaci u nutričního terapeuta klientům, kteří potřebují sestavit jídelníček s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou"
              },
              {
                "type": "Edukačně-rekondiční pobyty pro klienty s roztroušenou sklerózou\n",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou"
              },
              {
                "type": "Edukační pobyty pro klienty s diabetem I. typu\n",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty ",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu"
              },
              {
                "type": "Podpora screeningových vyšetření\n",
                "benefit": "Až 500 Kč na ambulantní rehabilitaci ",
                "description": "Přispíváme až 500 Kč na ambulantní rehabilitaci. Příspěvek je možné čerpat po ověření absolvování alespoň jednoho ze screeningových vyšetření od 1. ledna 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-screeningovych-vysetreni"
              },
              {
                "type": "Psychoterapie\n",
                "benefit": "Až 4 000 Kč u psychoterapeuta",
                "description": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie"
              },
              {
                "type": "Edukační pobyty pro klienty s poruchou autistického spektra\n",
                "benefit": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty ",
                "description": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo neziskovými organizacemi.Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra"
              },
              {
                "type": "Edukační kurz pro klienty s obezitou",
                "benefit": "Až 2 000 Kč na edukační kurz či pobyt ",
                "description": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou"
              },
              {
                "type": "Rekondiční pobyty pro klienty s revmatoidní artritidou\n",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni"
              },
              {
                "type": "Podpora léčby obezity\n",
                "benefit": "Až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity",
                "description": "Přispíváme až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity u smluvního poskytovatele zdravotních služeb nebo nutričního terapeuta, na další léčbu, případně další redukci hmotnosti pod dohledem zdravotníka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-lecby-obezity"
              },
              {
                "type": "Program pro dárce ",
                "benefit": "Až 10 000 Kč pro dárce krve, kostní dřeně a orgánů",
                "description": "Přispíváme až 10 000 Kč pro dárce krve nebo jejích součástí, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-pro-darce-krve-nebo-jejich-soucasti-kostni-drene-a-organu"
              },
              {
                "type": "Program na podporu profesí - zaměstnanci bezpečnostních sborů",
                "benefit": "Až 1 000 Kč pojištěncům, kteří jsou zaměstnáni u bezpečnostních sborů",
                "description": "Přispíváme až 1 000 Kč pojištěncům, kteří jsou zaměstnáni u HZS ČR, PČR, Vězeňské služby ČR nebo Celní správy ČR, na preventivní vyšetření a jiné zdravotně prospěšné aktivity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "siren",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-na-podporu-profesi-zamestnanci-bezpecnostnich-sboru"
              },
              {
                "type": "Prevence karcinomu prsu",
                "benefit": "Až 500 Kč na vyšetření karcinomu prsu",
                "description": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru prsu, aby byla šance na vyléčení co největší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-prsu"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "43",
            "benefits": [
              {
                "type": "Vyšetření v těhotenství",
                "benefit": "Až 3 000 Kč pojištěnkám na vyšetření v těhotenství",
                "description": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na vyšetření, která nejsou hrazena z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-v-tehotenstvi"
              },
              {
                "type": "Očkování",
                "benefit": "Až 2 000 Kč na očkování",
                "description": "Přispíváme až 2 000 Kč na všechna očkování, která nejsou hrazena z veřejného zdravotního pojištění (nebo mimo věkovou hranici, kdy hrazena jsou).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n",
                "icon": "vaccine",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-dospele"
              },
              {
                "type": "Sportovní pohybové aktivity pro dospělé\n",
                "benefit": "Až 500 Kč na sportovní aktivity",
                "description": "Přispíváme až 500 Kč na sportovní aktivity určené pro dospělé. Jedná se o aktivity a sporty dlouhodobého charakteru, rozvíjející sílu, koordinaci, flexibilitu, posílení středu těla, napomáhající ke zlepšení či podpoře kondice.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-dospele"
              },
              {
                "type": "Genetické vyšetření při užívání hormonální antikoncepce pro ženy od 19 let\n",
                "benefit": "Až 500 Kč na preventivní vyšetření rizika tromboembolické nemoci (TEN)",
                "description": "Přispíváme až 500 Kč na preventivní vyšetření rizika tromboembolické nemoci (TEN) při užívání hormonální antikoncepce nebo hormonální substituce. Jedná se o vyšetření na trombofilní mutace, Leidenskou mutaci, mutace FII. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/geneticke-vysetreni-pro-zeny-od-19-let"
              },
              {
                "type": "Předporodní kurz",
                "benefit": "Až 3 000 Kč pojištěnkám na předporodní kurz",
                "description": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na předporodní kurz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/predporodni-kurz"
              },
              {
                "type": "Vitamíny a minerály pro těhotné nebo ženy po porodu\n",
                "benefit": "Až 1 000 Kč pojištěnkám na vitamíny a minerály pro těhotné nebo ženy po porodu",
                "description": "Přispíváme až 1 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na vitamíny a minerály. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vitaminy-a-mineraly-pro-tehotne-nebo-zeny-po-porodu"
              },
              {
                "type": "Pomůcky pro kojení",
                "benefit": "Až 3 000 Kč pojištěnkám na pomůcky pro kojení",
                "description": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na pomůcky pro kojení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/pomucky-pro-kojeni"
              },
              {
                "type": "Služby laktační poradkyně, analýza a nákup mateřského mléka",
                "benefit": "Až 3 000 Kč pojištěnkám na služby laktační poradkyně, analýza a nákup mateřského mléka",
                "description": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na služby laktační poradkyně, nákup mateřského mléka, analýzu mateřského mléka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sluzby-laktacni-poradkyne-analyza-a-nakup-materskeho-mleka"
              },
              {
                "type": "Sportovní preventivní prohlídka",
                "benefit": "Až 500 Kč sportovcům na preventivní prohlídku",
                "description": "Přispíváme dospělým až 500 Kč na preventivní prohlídku, kterou vyžadují sportovní kluby a svazy. Obsahem prohlídky je zpravidla základní interní vyšetření, základní anamnéza, zhodnocení rozboru krve a vyšetření moči, základní vyšetření pohybového aparátu, antropometrie, popř. klidová spirometrie; určení tělesné skladby bioimpedanční metodou, klidové i zátěžové EKG (na běžeckém pásu nebo cyklotrenažeru).\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka"
              },
              {
                "type": "Prevence nadváhy a obezity",
                "benefit": "Až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou",
                "description": "Přispíváme až 500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity"
              },
              {
                "type": "Prevence karcinomu prsu\n",
                "benefit": "Až 500 Kč na vyšetření karcinomu prsu",
                "description": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru prsu, aby byla šance na vyléčení co největší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-prsu"
              },
              {
                "type": "Prevence karcinomu tlustého střeva a konečníku",
                "benefit": "Až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku",
                "description": "Přispíváme až 500 Kč na vyšetření, které má za účel včasné zachycení zhoubného nádoru tlustého střeva a konečníku, aby byla šance na vyléčení co největší. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-tlusteho-streva-a-konecniku"
              },
              {
                "type": "Prevence karcinomu kůže\n",
                "benefit": "Až 500 Kč na vyšetření dermatoskopem",
                "description": "Přispíváme až 500 Kč na vyšetření dermatoskopem, které slouží k včasnému zachycení kožního zhoubného nádoru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze"
              },
              {
                "type": "Zdravotnické prostředky\n",
                "benefit": "Až 500 Kč nad rámec ostatních preventivních programů na nákup zdravotnických prostředků",
                "description": "Přispíváme až 500 Kč na nákup zdravotnických prostředků, které souvisejí s chronickým onemocněním a nejsou hrazeny z veřejného zdravotního pojištění. Např. Diabetes mellitus (cukrovka), Onemocnění respiračního systému (astma), Chronické onemocnění trávicího a močového systému a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky"
              },
              {
                "type": "Specifické diety\n",
                "benefit": "Až 2 000 Kč na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci",
                "description": "Přispíváme dospělým s potravinovou intolerancí až 2 000 Kč nad rámec ostatních preventivních programů na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci. Napři: při celiakii, fenylketonurii a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety"
              },
              {
                "type": "Sestavení jídelníčku nutričním terapeutem ",
                "benefit": "Až 500 Kč na službu nutričního terapeuta ",
                "description": "Přispíváme až 500 Kč na službu nutričního terapeuta, který sestaví jídelníček pro dosažení a udržení zdravé hmotnosti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem"
              },
              {
                "type": "Dentální hygiena pro dospělé\n",
                "benefit": "Až 500 Kč na dentální hygienu",
                "description": "Přispíváme až 500 Kč na dentální hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-dospele"
              },
              {
                "type": "Cvičení pro těhotné a ženy po porodu\n",
                "benefit": "Až 3 000 Kč pojištěnkám na cvičení pro těhotné ženy a ženy po porodu",
                "description": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na cvičení pro ženy po porodu. Akceptujeme i on-line kurzy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/cviceni-pro-tehotne-a-zeny-po-porodu"
              },
              {
                "type": "Komplexní onkologické vyšetření",
                "benefit": "Až 2 000 Kč na preventivní onkologické prohlídky ",
                "description": "Přispíváme až 2 000 Kč na preventivní onkologické prohlídky v rámci nabídky Komplexních onkologických center. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/komplexni-onkologicke-vysetreni"
              },
              {
                "type": "Telemonitoring\n",
                "benefit": "Až 2 000 Kč pojištěncům zapojených do programů telemonitoringu",
                "description": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních programů pojištěncům zapojeným do programů telemonitoringu. Např. Telemonitoring pro pojištěnce s chronickým srdečním selháním, Telemonitoring pro pojištěnce s podezřením na poruchy srdečního rytmu nebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "register",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/telemonitoring"
              },
              {
                "type": "Klinická psychologie - dospělí",
                "benefit": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
                "description": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-dospeli"
              },
              {
                "type": "Klinická logopedie - dospělí",
                "benefit": "Až 4 000 Kč na různá vyšetření v oboru klinické logopedie",
                "description": "Přispíváme až 4 000 Kč na různá vyšetření v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-dospeli"
              },
              {
                "type": "Prevence karcinomu děložního hrdla\n",
                "benefit": "Až 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nejlépe již prekancerózních stavů",
                "description": "Přispíváme až 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nejlépe již prekancerózních stavů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-delozniho-hrdla"
              },
              {
                "type": "Masáž pro těhotné",
                "benefit": "Až 3 000 Kč pojištěnkám na masáž pro těhotné",
                "description": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na masáž pro těhotné.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/masaz-pro-tehotne"
              },
              {
                "type": "Podpora vícerčat",
                "benefit": "Až 500 Kč navíc na každého novorozence z vícečetného těhotenství na různé pomůcky ",
                "description": "Přispíváme až 500 Kč navíc na každého novorozence z vícečetného těhotenství narozeného od 1. ledna do 31. prosince 2026, jednou v roce na pomůcky na kojení, nákup mateřského mléka nebo nákup monitoru dechu.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-vicercat"
              },
              {
                "type": "Dentální hygiena pro těhotné\n",
                "benefit": "Až 3 000 Kč pojištěnkám na dentální hygienu ",
                "description": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na dentální hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
                "icon": "tooth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-tehotne"
              },
              {
                "type": "Paruky, podprsenky a další prostředky pro onkologické pacienty",
                "benefit": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
                "description": "Přispíváme až 2 000 Kč dospělým, kteří podstupují nebo podstoupili protinádorovou léčbu (chemoterapii), ozařování nebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty"
              },
              {
                "type": "Edukační pobyty pro klienty s diabetem II. typu",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty, které jsou organizované pacientskými organizacemi, např. členy Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu"
              },
              {
                "type": "Vyšetření kognitivních funkcí a pomůcky pro trénování paměti\n",
                "benefit": "Až 500 Kč na vyšetření, jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby nebo dalších forem demence",
                "description": "Přispíváme až 500 Kč na následující vyšetření, která nejsou hrazena z veřejného zdravotního pojištění, a jejichž účelem je především včasná diagnostika poruch paměti v důsledku Alzheimerovy choroby nebo dalších forem demence. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/vysetreni-kognitivnich-funkci-a-pomucky-pro-trenovani-pameti"
              },
              {
                "type": "Dopravně psychologické vyšetření",
                "benefit": "Až 500 Kč na vyšetření u dopravního psychologa",
                "description": "Přispíváme až 500 Kč na vyšetření u dopravního psychologa.\nDopravně psychologické vyšetření je povinné pro některé skupiny řidičských oprávnění, popřípadě si jej může vyžádat praktický lékař. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dopravne-psychologicke-vysetreni"
              },
              {
                "type": "Kurz pro rodiče - péče o dětské zuby\n",
                "benefit": "Až 500 Kč na úhradu kurzu pro rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů",
                "description": "Přispíváme až 500 Kč na úhradu kurzu pro rodiče zaměřeného na péči o dětské zuby, a to včetně on-line kurzů.\nKurz musí být veden odborníkem, tj. zubním lékařem, zubní hygienistkou, zdravotní sestrou apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/kurz-pro-rodice-pece-o-detske-zuby"
              },
              {
                "type": "Nutriční poradenství v souvislosti se specifickou dietou\n",
                "benefit": "Až 2 000 Kč na sestavení jídelníčku s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii",
                "description": "Přispíváme až 2 000 Kč na konzultaci u nutričního terapeuta klientům, kteří potřebují sestavit jídelníček s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou"
              },
              {
                "type": "Edukačně-rekondiční pobyty pro klienty s roztroušenou sklerózou",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou"
              },
              {
                "type": "Edukační pobyty pro klienty s diabetem I. typu",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty ",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu"
              },
              {
                "type": "Podpora absolvování screeningového vyšetření",
                "benefit": "Až 500 Kč na ambulantní rehabilitaci ",
                "description": "Přispíváme až 500 Kč na ambulantní rehabilitaci. Příspěvek je možné čerpat po ověření absolvování alespoň jednoho ze screeningových vyšetření od 1. ledna 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-screeningovych-vysetreni"
              },
              {
                "type": "Psychoterapie\n",
                "benefit": "Až 4 000 Kč u psychoterapeuta",
                "description": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie"
              },
              {
                "type": "Edukační pobyty pro klienty s poruchou autistického spektra",
                "benefit": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty ",
                "description": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo neziskovými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra"
              },
              {
                "type": "Edukační kurz pro klienty s obezitou",
                "benefit": "Až 2 000 Kč na edukační kurz či pobyt ",
                "description": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou"
              },
              {
                "type": "Rekondiční pobyty pro klienty s revmatoidní artritidou",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/rekondicni-pobyty-pro-klienty-s-revmatoidni-artritidou"
              },
              {
                "type": "Třetí čtení mamografického snímku umělou inteligencí\n",
                "benefit": "Až 100 Kč na vyhodnocení mamografického snímku umělou inteligencí",
                "description": "Přispíváme  až 100 Kč na vyhodnocení mamografického snímku umělou inteligencí, našim klientkám ve věku od 40 do 45 let.\nJedná se o využití umělé inteligence (AI) pro dodatečné vyhodnocení snímku z mamografického vyšetření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "register",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/treti-cteni-mamografickeho-snimku-umelou-inteligenci"
              },
              {
                "type": "Podpora léčby obezity\n",
                "benefit": "Až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity",
                "description": "Přispíváme až 2 000 Kč klientům, kteří úspěšně absolvují dlouhodobou léčbu obezity u smluvního poskytovatele zdravotních služeb nebo nutričního terapeuta, na další léčbu, případně další redukci hmotnosti pod dohledem zdravotníka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/podpora-lecby-obezity"
              },
              {
                "type": "Doprovod k porodu",
                "benefit": "Přispíváme až 3 000 Kč pojištěnkám na službu doprovodu k porodu",
                "description": "Přispíváme až 3 000 Kč pojištěnkám, které jsou v roce 2026 těhotné, nebo od 1. ledna 2026 do 31. prosince 2026 porodily (do 6 měsíců po porodu), na službu doprovodu k porodu. Jedná se o nehrazenou službu, kterou poskytuje pojištěnkou zvolená porodní asistentka. Musí se jednat o registrovanou porodní asistentku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/doprovod-k-porodu"
              },
              {
                "type": "Program pro dárce ",
                "benefit": "Až 10 000 Kč pro dárce krve, kostní dřeně a orgánů",
                "description": "Přispíváme až 10 000 Kč pro dárce krve nebo jejích součástí, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-pro-darce-krve-nebo-jejich-soucasti-kostni-drene-a-organu"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "33",
            "benefits": [
              {
                "type": "Očkování pro děti",
                "benefit": "Až 2 000 Kč na očkování pro děti",
                "description": "Přispíváme v součtu až 2 000 Kč na všechna očkování, která nejsou hrazena z veřejného zdravotního pojištění (nebo mimo věkovou hranici, kdy hrazena jsou). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ockovani-pro-deti"
              },
              {
                "type": "Masáž pro novorozence a kojence do 1 roku, kurz první pomoci pro dítě",
                "benefit": "Až 1 500 Kč na masáž pro novorozence a kojence nebo kurz první pomoci pro dítě",
                "description": "Přispíváme až 1 500 Kč na masáž pro novorozence a kojence. Pomáhá proti bolestem bříška a přispívá celkovému zklidnění a zlepšení spánku. Na platebním dokladu musí být uvedeno, že se jedná o masáž pro novorozence nebo kojence. Přispíváme také na kurz první pomoci pro dítě organizovaný zdravotníkem (včetně online formy). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/masaz-pro-novorozence-a-kojence-do-1-roku-kurz-prvni-pomoci"
              },
              {
                "type": "Pomůcky pro novorozence a kojence do 1 roku\n",
                "benefit": "Až 1 500 Kč pro novorozence a kojence",
                "description": "Přispíváme až 1 500 Kč na nákup pomůcek pro bezpečí, sledování zdravého vývoje a pro zdravé prostředí novorozenců a kojenců. Zejména na následující položky: Teploměr, odsávačka hlenů, polohovací polštář pro kojení, chůvička, váha, monitor dechu, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/pomucky-pro-novorozence-a-kojence-do-1-roku"
              },
              {
                "type": "Sportovní pohybové aktivity pro děti\n",
                "benefit": "Až 1 000 Kč na pohybové aktivity pro děti",
                "description": "Přispíváme dětem od dvou let věku ročně až 1 000 Kč na organizované sportovní a pohybové aktivity určené pro děti. Zejména na následující aktivity: Organizované cvičení pro děti, Sportovní kroužky a kurzy, Cvičení dětí s rodiči, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-pohybove-aktivity-pro-deti"
              },
              {
                "type": "Ozdravný nebo sportovní pobyt pro děti\n",
                "benefit": "Až 500 Kč na ozdravný nebo sportovní pobyt pro děti",
                "description": "Přispíváme dětem až 500 Kč na pobytové aktivity. Jako třeba školu a školku v přírodě (pobyt spojený s aktivním pohybem v přírodě organizovaný školou nebo školkou), sportovní soustředění, lyžařský výcvik. Pobyt musí trvat nejméně 4 dny. Neakceptujeme: poznávací, vědomostní, vzdělávací, umělecký, zájmový, jazykový pobyt atd. - bez pohybového zaměření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/ozdravny-nebo-sportovni-pobyt-pro-deti"
              },
              {
                "type": "Screeningové vyšetření tupozrakosti\n",
                "benefit": "Až 1 500 Kč dětem od 6 měsíců do 10 let na vyšetření, které slouží k včasnému záchytu tupozrakosti",
                "description": "Přispíváme až 1 500 Kč dětem od 6 měsíců do 10 let na vyšetření, které slouží k včasnému záchytu tupozrakosti, přístrojem PlusOptix u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/screeningove-vysetreni-tupozrakosti"
              },
              {
                "type": "Fixní nebo snímatelná rovnátka zubů\n",
                "benefit": "Až 1 500 Kč na rovnátka zubů",
                "description": "Přispíváme až 1 500 Kč dětem do 18 let na fixní i snímatelná rovnátka zubů. Příspěvek je možné čerpat jednou za dva roky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "braces",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/fixni-nebo-snimatelna-rovnatka-zubu"
              },
              {
                "type": "Sportovní preventivní prohlídka pro děti\n",
                "benefit": "Až 1 500 Kč dětem sportovcům na preventivní prohlídku",
                "description": "Přispíváme až 1500 Kč dětem sportovcům na preventivní prohlídku, kterou vyžadují sportovní kluby a svazy. Obsahem prohlídky je zpravidla základní interní vyšetření, základní anamnéza, zhodnocení rozboru krve a vyšetření moči, základní vyšetření pohybového aparátu, antropometrie, popř. klidová spirometrie; určení tělesné skladby bioimpedanční metodou, klidové i zátěžové EKG (na běžeckém pásu nebo cyklotrenažeru). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sportovni-preventivni-prohlidka-pro-deti"
              },
              {
                "type": "Prevence nadváhy a obezity u dětí\n",
                "benefit": "Až 1500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou",
                "description": "Přispíváme až 1500 Kč na vyšetření, které zahrnuje analýzu složení těla, zejména bioelektrickou impedanční metodou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-nadvahy-a-obezity-u-deti"
              },
              {
                "type": "Zdravotnické prostředky\n",
                "benefit": "Až 1 500 Kč na nákup zdravotnických prostředků",
                "description": "Přispíváme až 1 500 Kč na nákup zdravotnických prostředků, které souvisejí s chronickým onemocněním a nejsou hrazeny z veřejného zdravotního pojištění. Např. Diabetes mellitus (cukrovka), Onemocnění respiračního systému (astma), a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/zdravotnicke-prostredky"
              },
              {
                "type": "Specifické diety\n",
                "benefit": "Až 2 000 Kč na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci",
                "description": "Přispíváme dětem s potravinovou intolerancí až 2 000 Kč nad rámec ostatních preventivních programů na nákup speciálních potravin a obědů vhodných při alergii nebo intoleranci. Napři: při celiakii, fenylketonurii a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specificke-diety"
              },
              {
                "type": "Organizované cvičení nebo plavání s kojencem do 1 roku\n",
                "benefit": "Až 1 500 Kč na pohybové aktivity i pro ty nejmenší",
                "description": "Přispíváme až 1 500 Kč na pohybové aktivity i pro ty nejmenší: Organizované plavání s kojencem, včetně vaničkování, organizované cvičení s kojencem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/organizovane-cviceni-nebo-plavani-s-kojencem-do-1-roku"
              },
              {
                "type": "Genetické vyšetření při užívání hormonální antikoncepce pro dívky od 12 let\n",
                "benefit": "Až 1 500 Kč na preventivní genetické vyšetření rizika tromboembolické nemoci (TEN)",
                "description": "Přispíváme až 1 500 Kč na preventivní genetické vyšetření rizika tromboembolické nemoci (TEN) při užívání hormonální antikoncepce dívkám od 12 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/geneticke-vysetreni-pro-divky-od-12-let"
              },
              {
                "type": "Sestavení jídelníčku nutričním terapeutem pro děti\n",
                "benefit": "Až 1 500 Kč na službu nutričního terapeuta ",
                "description": "Přispíváme až 1500 Kč na službu nutričního terapeuta, který sestaví jídelníček pro dosažení a udržení zdravé hmotnosti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/sestaveni-jidelnicku-nutricnim-terapeutem-pro-deti"
              },
              {
                "type": "Dětské sportovní léto\n",
                "benefit": "Až 500 Kč na letní sportovně pohybový pobyt",
                "description": "Přispíváme dětem ve věku od 6 do 15 let až 500 Kč na letní sportovně pohybový pobyt konaný v červenci a srpnu 2026, a to v délce minimálně 4 po sobě jdoucích dní (nocleh není podmínkou). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/detske-sportovni-leto-0"
              },
              {
                "type": "Klinická psychologie - děti\n",
                "benefit": "Až 4 000 Kč na vyšetření v oboru klinické psychologie, která nejsou hrazena z veřejného zdravotního pojištění",
                "description": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické psychologie, která nejsou hrazena z veřejného zdravotního pojištění, a jejichž účelem je zejména včas diagnostikovat např. poruchy autistického spektra (PAS), případně poruchy chování nebo učení, které mohou mít za následek problémy se vzděláváním nebo začleněním do kolektivu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-psychologie-deti"
              },
              {
                "type": "Klinická logopedie - děti",
                "benefit": "Až 4 000 Kč na vyšetření v oboru klinické logopedie",
                "description": "Přispíváme až 4 000 Kč na až 10 vyšetření (tedy až 400 Kč na jedno vyšetření) v oboru klinické logopedie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/klinicka-logopedie-deti"
              },
              {
                "type": "Speciální výživa pro nedonošené děti\n",
                "benefit": "Až 2 000 Kč na nákup výživy (umělého mléka) pro nedonošené děti - novorozence do 1 roku s porodní váhou do 1 500 g",
                "description": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních programů na nákup výživy (umělého mléka) pro nedonošené děti - novorozence do 1 roku s porodní váhou do 1 500 g. Výživa musí být zakoupena v lékárně nebo internetové lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/specialni-vyziva-pro-nedonosene-deti"
              },
              {
                "type": "Paruky, podprsenky a další prostředky pro onkologické pacienty\n",
                "benefit": "Až 2 000 Kč na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod.",
                "description": "Přispíváme až 2 000 Kč dospělým, kteří podstupují nebo podstoupili protinádorovou léčbu (chemoterapii), ozařování nebo operaci, na nákup paruky, případně šátku, léčivé přípravky obsahující pantenol na léčbu popálenin po ozařování (radioterapii), apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/paruky-podprsenky-a-dalsi-prostredky-pro-onkologicke-pacienty"
              },
              {
                "type": "Edukační pobyty pro klienty s diabetem II. typu",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus II. typu na edukační pobyty, které jsou organizované pacientskými organizacemi, např. členy Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "suitcase",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-ii-typu"
              },
              {
                "type": "Nutriční poradenství v souvislosti se specifickou dietou\n",
                "benefit": "Až 2 000 Kč na sestavení jídelníčku s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii",
                "description": "Přispíváme až 2 000 Kč na konzultaci u nutričního terapeuta klientům, kteří potřebují sestavit jídelníček s ohledem na např. nově zjištěnou potravinovou intoleranci nebo alergii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/nutricni-poradenstvi-v-souvislosti-se-specifickou-dietou"
              },
              {
                "type": "Edukačně-rekondiční pobyty pro klienty s roztroušenou sklerózou\n",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním roztroušená skleróza na edukačně-rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacne-rekondicni-pobyty-pro-klienty-s-roztrousenou"
              },
              {
                "type": "Edukační pobyty pro klienty s diabetem I. typu",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty ",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním diabetes mellitus I. typu na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované pacientskými organizacemi, jako např. Sdružení rodičů a přátel diabetických dětí a Aliance pacientů s diabetem ČR, z.s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-diabetem-i-typu"
              },
              {
                "type": "Psychoterapie\n",
                "benefit": "Až 4 000 Kč u psychoterapeuta",
                "description": "Přispíváme až 4 000 Kč na až 10 sezení (konzultací) u psychoterapeuta (tedy až 400 Kč na jedno sezení). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/psychoterapie"
              },
              {
                "type": "Edukační pobyty pro klienty s poruchou autistického spektra",
                "benefit": "Až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty ",
                "description": "Přispíváme až 2 000 Kč pojištěncům s diagnostikovanou poruchou autistického spektra na edukační pobyty v trvání minimálně 3 dny (2 noci), které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo neziskovými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-pobyty-pro-klienty-s-poruchou-autistickeho-spektra"
              },
              {
                "type": "Edukační kurz pro klienty s obezitou",
                "benefit": "Až 2 000 Kč na edukační kurz či pobyt ",
                "description": "Přispíváme až 2 000 Kč našim pojištěncům na edukační kurz či pobyt v trvání alespoň 3 dny (2 noci), který je určen ke zlepšení zdravotního stavu - zhubnutí a udržení zdravé hmotnosti a změny životního stylu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/edukacni-kurz-pro-klienty-s-obezitou"
              },
              {
                "type": "Prevence komplikací spojených s obezitou",
                "benefit": "Až 4 000 Kč dětem od 12 let, kteří úspěšně absolvují dlouhodobou léčbu obezity",
                "description": "Přispíváme až 4 000 Kč dětem od 12 let, kteří úspěšně absolvují dlouhodobou léčbu obezity u smluvního poskytovatele zdravotních služeb nebo nutričního terapeuta, na další léčbu, případně další redukci hmotnosti pod dohledem zdravotníka. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-komplikaci-spojenych-s-obezitou"
              },
              {
                "type": "Rekondiční pobyty pro klienty s revmatoidní artritidou",
                "benefit": "Až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty",
                "description": "Přispíváme až 2 000 Kč pojištěncům s onemocněním revmatoidní artritida na rekondiční pobyty, které jsou organizované ve spolupráci s odbornými společnostmi, klinickými pracovišti nebo nadacemi, v trvání minimálně 3 dny (2 noci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "briefcase",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/rekondicni-pobyty-pro-klienty-s-revmatoidni-artritidou"
              },
              {
                "type": "Dentální hygiena pro děti\n",
                "benefit": "Až 1 500 Kč na dentální hygienu",
                "description": "Přispíváme dětem až 1 500 Kč na dentální hygienu včetně nácviku (instruktáž) správného čištění chrupu v rámci nehrazené služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/dentalni-hygiena-pro-deti"
              },
              {
                "type": "Prevence karcinomu kůže pro děti\n",
                "benefit": "Až 1 500 Kč dětem na vyšetření dermatoskopem",
                "description": "Přispíváme dětem až 1 500 Kč na vyšetření dermatoskopem, které slouží k včasnému zachycení kožního zhoubného nádoru. Na dokladu musí být uvedeno, že se jedná o vyšetření dermatoskopem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-kuze-pro-deti"
              },
              {
                "type": "Prevence karcinomu děložního hrdla pro dívky od 15 let\n",
                "benefit": "Až 1 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nejlépe již prekancerózních stavů",
                "description": "Přispíváme až 1 500 Kč na preventivní nehrazené vyšetření, které slouží k včasnému záchytu nejlépe již prekancerózních stavů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/prevence-karcinomu-delozniho-hrdla-od-15-let"
              },
              {
                "type": "Logopedické pomůcky",
                "benefit": "Až 2 000 Kč na logopedické pomůcky předepsané klinickým logopedem",
                "description": "Přispíváme až 2 000 Kč na logopedické pomůcky předepsané klinickým logopedem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "chat",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/logopedicke-pomucky"
              },
              {
                "type": "Telemedicína",
                "benefit": "Až 2 000 Kč pojištěncům zapojených do programů telemonitoringu",
                "description": "Přispíváme až 2 000 Kč nad rámec ostatních preventivních programů pojištěncům zapojeným do programů telemonitoringu. Např. Telemonitoring pro pojištěnce s chronickým srdečním selháním, Telemonitoring pro pojištěnce s podezřením na poruchy srdečního rytmu nebo léčenou srdeční arytmií a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "register",
                "url": "https://www.zpmvcr.cz/pojistenci/prispevky-z-fondu-prevence/program-telemedicina"
              }
            ]
          }
        ]
      },
      {
        "slug": "cpzp",
        "updateDate": "28.1.2026",
        "companyBenefitsLink": "https://www.cpzp.cz/preventivni-programy",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "27",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 1 000 Kč na různé druhy očkování",
                "description": "Přispíváme až 1 000 Kč pro všechna očkování proti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. Příspěvek je poskytován na kteroukoliv dávku/vakcínu očkovacího cyklu. Příspěvek se nevztahuje na doplatky za očkovací vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.cpzp.cz/preventivni-program/14"
              },
              {
                "type": "Pravidelný pohyb",
                "benefit": "Až 700 Kč na pohybové aktivity ve věku od 18 let",
                "description": "Přispíváme až 700 Kč na pravidelnou pohybovou aktivitu v rámci prevence kardiovaskulárních chorob a obezity pojištěncům od 18 let. Možnosti čerpání: Pravidelná pohybová aktivita, vč. plavání (netýká se lyžování, masáží, sauny, solária a jiných regeneračních aktivit). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.cpzp.cz/preventivni-program/36"
              },
              {
                "type": "Sportovní prohlídka",
                "benefit": "Až 500 Kč na sportovní prohlídku",
                "description": "Přispíváme až 500 Kč na úhradu sportovní lékařské prohlídky provedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz ",
                "icon": "sport",
                "url": "https://www.cpzp.cz/preventivni-program/22"
              },
              {
                "type": "Vyšetření zrakového nervu",
                "benefit": "Až 300 Kč na vyšetření zrakového nervu",
                "description": "Přispíváme až 300 Kč na vyšetření zrakového nervu, a to na: GDx – analyzátoru nervových vláken, HRT – Heidelberg Retina Tomograf, OCT – Optical Coherent Tomograf. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/18"
              },
              {
                "type": "Prevence rakoviny kůže\n",
                "benefit": "Až 500 Kč na vyšetření pigmentových skvrn",
                "description": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.cpzp.cz/preventivni-program/17"
              },
              {
                "type": "Zdraví 65+\n",
                "benefit": "Až 500 Kč pojištěncům od 65 let na nákup doplňků stravy a vitaminů v lékárně",
                "description": "Přispíváme až 500 Kč pojištěncům od 65 let na nákup doplňků výživy a vitaminů v lékárně. Příspěvek je možno uplatnit především na podporu imunity, k prevenci zhoršení stavu kloubů a na paměť. Akceptujeme pouze nákup v lékárně (popř. v e-shopu lékárny). Příspěvek lze uplatnit pouze na přípravky, které se užívají orálně (tzn. nelze uplatnit např. na podání vitaminů formou injekcí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/33"
              },
              {
                "type": "Laserové operace očí",
                "benefit": "Až 1000 Kč na laserové operace očí",
                "description": "Přispíváme až 1 000 Kč na laserové operace očí - odstranění krátkozrakosti a dalekozrakosti a na laserovou operaci katarakty (šedý zákal). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/21"
              },
              {
                "type": "Vysoký krevní tlak",
                "benefit": "Až 500 Kč příspěvek na zakoupení pažního tlakoměru",
                "description": "Přispíváme až 500 Kč svým pojištěncům na zakoupení pažního tlakoměru. Příspěvek je určen chronicky nemocným pacientům s diagnózou \"hypertenze\" . Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.cpzp.cz/preventivni-program/54"
              },
              {
                "type": "Cholesterol",
                "benefit": "Až 200 Kč na koupi doplňku stravy obsahující Omega 3 mastné kyseliny ",
                "description": "Přispíváme až 200 Kč svým chronicky nemocným pojištěncům s diagnózou \"hyperlipidemie\" na koupi doplňku stravy obsahující Omega 3 mastné kyseliny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/55"
              },
              {
                "type": "Prevence rakoviny tlustého střeva\n",
                "benefit": "Až 500 Kč na prevenci rakoviny tlustého střeva",
                "description": "Přispíváme až 500 Kč na prevenci rakoviny tlustého střeva - vyšetření provedené u poskytovatele zdravotních služeb. Příspěvek se vztahuje na všechny metody nehrazené z veřejného zdravotního pojištění (např. Septin9). Příspěvek není určen na testy na domácí použití zakoupené v lékárně, ani na výplach Hydrocolon. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.cpzp.cz/preventivni-program/24"
              },
              {
                "type": "Erektilní dysfunkce\n",
                "benefit": "Až 500 Kč na léky s léčivou látkou: Avanafil, Sildenafil, Tadalafil, Vardenafil",
                "description": "Přispíváme až 500 Kč na léky na lékařský předpis s léčivou látkou: Avanafil, Sildenafil, Tadalafil, Vardenafil. Léky musí být zakoupeny v lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/51"
              },
              {
                "type": "Prevence rakoviny prostaty",
                "benefit": "Až 500 Kč na vyšetření PSA - mužům ve věku od 40 let na prevenci onemocnění rakovinou prostat",
                "description": "Přispíváme až 500 Kč mužům ve věku od 40 let na prevenci onemocnění rakovinou prostaty, a to na vyšetření PSA - v případě, kdy není hrazeno z prostředků veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "testicles",
                "url": "https://www.cpzp.cz/preventivni-program/52"
              },
              {
                "type": "Rázová vlna",
                "benefit": "Až 500 Kč příspěvek na terapii rázovou vlnou ",
                "description": "Přispíváme až 500 Kč na terapii rázovou vlnou provedenou u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/69"
              },
              {
                "type": "Prevence obezity",
                "benefit": "Až 500 Kč příspěvek na prevenci obezity ",
                "description": "Přispíváme až 500 Kč na prevenci obezity. Příspěvek je možno využít na: úhradu nákladů u obezitologa, dietologa, praktického lékaře nebo nutričního terapeuta, za účelem snížení nadváhy a obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.cpzp.cz/preventivni-program/71"
              },
              {
                "type": "Dentální hygiena",
                "benefit": "Až 500 Kč na dentální hygienu",
                "description": "Přispíváme až 500 Kč na dentální hygienu provedenou stomatologem nebo zdravotnickým pracovníkem s odbornou způsobilostí k výkonu dentální hygieny. Příspěvek je poskytován do vyčerpání finančního limitu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "brush",
                "url": "https://www.cpzp.cz/preventivni-program/80"
              },
              {
                "type": "Lehká sádra",
                "benefit": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
                "description": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb nebo zakoupené v prodejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "osteoporosis",
                "url": "https://www.cpzp.cz/preventivni-program/81"
              },
              {
                "type": "Ortopedické vložky",
                "benefit": "Až 500 Kč na nákup ortopedických vložek ",
                "description": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, prodejně zdravotnických potřeb, ve specializované prodejně nebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/82"
              },
              {
                "type": "Krok pro zdraví",
                "benefit": "Až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu",
                "description": "Přispíváme až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu. Příspěvek motivuje pojištěnce ČPZP k pravidelné pohybové aktivitě – chůzi. Program je založen na využití krokoměru v aplikaci Zdraví v mobilu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/68"
              },
              {
                "type": "Diabetes",
                "benefit": "Až 1 000 kč na na prevenci zhoršení diabetes.",
                "description": "Přispíváme až 1 000 Kč na prevenci zhoršení diabetes. Příspěvek je určen na jednu z vybraných služeb nebo pomůcek jako např.: jehly k inzulinovým perům, testovací a diagnostické proužky, příslušenství k inzulínové pumpě, atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/32"
              },
              {
                "type": "Celiakie, dědičné metabolické poruchy",
                "benefit": "Až 1 000 Kč celiakům na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro pojištěnce s dědičnými metabolickými poruchami",
                "description": "Přispíváme až 1 000 Kč pojištěncům nemocným celiakií příspěvek na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro pojištěnce s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/70"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 2 000 Kč na odvykání kouření",
                "description": "Přispíváme až 2 000 Kč pojištěncům na odvykání kouření. Příspěvek je určen na: nákup volně prodejných léčivých a podpůrných přípravků, zakoupených v lékárně a léčiva na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.cpzp.cz/preventivni-program/35"
              },
              {
                "type": "Příspěvek na paruku",
                "benefit": "Až 2 000 Kč na paruku",
                "description": "Přispíváme až 2 000 Kč na zakoupení paruky pro onkologicky nemocné pacienty, kteří podstupují nebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pro pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/59"
              },
              {
                "type": "Program onkologické prevence\n",
                "benefit": "Až 2 000 Kč na komplexní onkologickou preventivní prohlídku",
                "description": "Příspíváme až 2 000 Kč pojištěncům od 35 let na komplexní onkologickou preventivní prohlídku provedenou na specializovaných pracovištích, ve kterých je možné absolvovat preventivní onkologickou prohlídku. Vyšetření zahrnuje laboratorní a další výkony potřebné k odhalení případného karcinomu. Rozsah a cenu vyšetření stanovují jednotlivá pracoviště. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.cpzp.cz/preventivni-program/57"
              },
              {
                "type": "Bonus plus",
                "benefit": "Až 500 Kč v doplňkovém preventivním programu na vybrané aktivity",
                "description": "Přispíváme až 500 Kč ročně v doplňkovém programu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, sportovní ochranné pomůcky a další. Cílem programu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
                "icon": "shield",
                "url": "https://www.cpzp.cz/preventivni-program/29"
              },
              {
                "type": "Příspěvek na duševní zdraví",
                "benefit": "Až 6 000 Kč na duševní zdraví",
                "description": "Přispíváme až 6 000 Kč pojištěncům na program pro zvýšení dostupnosti psychosociální podpory. Příspěvek je určen pojištěncům na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/73"
              },
              {
                "type": "BabyGen",
                "benefit": "Až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím",
                "description": "Přispíváme až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím. Jedná se o genetickou analýzu závažných dědičných onemocnění, která vede k odhalení a minimalizaci rizik narození dítěte s těmito nemocemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.cpzp.cz/preventivni-program/77"
              },
              {
                "type": "Program pro dárce ",
                "benefit": "Až 6 000 Kč pro dárce krve a kostní dřeně",
                "description": "Přispíváme až 6 000 Kč pro dárce krve a kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-programy/4"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "30",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 1 000 Kč na různé druhy očkování",
                "description": "Přispíváme až 1 000 Kč pro všechna očkování proti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. Příspěvek je poskytován na kteroukoliv dávku/vakcínu očkovacího cyklu. Příspěvek se nevztahuje na doplatky za očkovací vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.cpzp.cz/preventivni-program/14"
              },
              {
                "type": "Pravidelný pohyb",
                "benefit": "Až 700 Kč na pohybové aktivity ve věku od 18 let",
                "description": "Přispíváme až 700 Kč na pravidelnou pohybovou aktivitu v rámci prevence kardiovaskulárních chorob a obezity pojištěncům od 18 let. Možnosti čerpání: Pravidelná pohybová aktivita, vč. plavání (netýká se lyžování, masáží, sauny, solária a jiných regeneračních aktivit). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.cpzp.cz/preventivni-program/36"
              },
              {
                "type": "Sportovní prohlídka",
                "benefit": "Až 500 Kč na sportovní prohlídku",
                "description": "Přispíváme až 500 Kč na úhradu sportovní lékařské prohlídky provedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz \n",
                "icon": "sport",
                "url": "https://www.cpzp.cz/preventivni-program/36"
              },
              {
                "type": "Prevence rakoviny prsu",
                "benefit": "Až 500 Kč na prevenci rakoviny prsu",
                "description": "Přispíváme až 500 Kč na prevenci rakoviny prsu, a to: pro ženy ve věku od 30 - 40 let na mamografické vyšetření nebo ultrasonografické vyšetření. Vyšetření musí být provedeno na některém z pracovišť, která jsou k tomuto účelu akreditována. Seznam aktuálních vybraných zdravotnických zařízení je k dispozici na internetových stránkách Asociace mamodiagnostiků ČR www.mamo.cz. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "breasts",
                "url": "https://www.cpzp.cz/preventivni-program/15"
              },
              {
                "type": "Vyšetření zrakového nervu",
                "benefit": "Až 300 Kč na vyšetření zrakového nervu",
                "description": "Přispíváme až 300 Kč na vyšetření zrakového nervu, a to na: GDx – analyzátoru nervových vláken, HRT – Heidelberg Retina Tomograf, OCT – Optical Coherent Tomograf. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/18"
              },
              {
                "type": "Prevence rakoviny kůže",
                "benefit": "Až 500 Kč na vyšetření pigmentových skvrn",
                "description": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.cpzp.cz/preventivni-program/17"
              },
              {
                "type": "Zdraví 65+\n",
                "benefit": "Až 500 Kč pojištěncům od 65 let na nákup doplňků stravy a vitaminů v lékárně",
                "description": "Přispíváme až 500 Kč pojištěncům od 65 let na nákup doplňků výživy a vitaminů v lékárně. Příspěvek je možno uplatnit především na podporu imunity, k prevenci zhoršení stavu kloubů a na paměť. Akceptujeme pouze nákup v lékárně (popř. v e-shopu lékárny). Příspěvek lze uplatnit pouze na přípravky, které se užívají orálně (tzn. nelze uplatnit např. na podání vitaminů formou injekcí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/33"
              },
              {
                "type": "Laserové operace očí",
                "benefit": "Až 1 000 Kč na laserové operace očí",
                "description": "Přispíváme až 1 000 Kč na laserové operace očí - odstranění krátkozrakosti a dalekozrakosti a na laserovou operaci katarakty (šedý zákal). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/21"
              },
              {
                "type": "Vysoký krevní tlak",
                "benefit": "Až 500 Kč příspěvek na zakoupení pažního tlakoměru",
                "description": "Přispíváme až 500 Kč svým pojištěncům na zakoupení pažního tlakoměru. Příspěvek je určen chronicky nemocným pacientům s diagnózou \"hypertenze\" . Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.cpzp.cz/preventivni-program/54"
              },
              {
                "type": "Cholesterol",
                "benefit": "Až 200 Kč na koupi doplňku stravy obsahující Omega 3 mastné kyseliny  ",
                "description": "Přispíváme až 200 Kč svým chronicky nemocným pojištěncům s diagnózou \"hyperlipidemie\" na koupi doplňku stravy obsahující Omega 3 mastné kyseliny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/55"
              },
              {
                "type": "Prevence rakoviny tlustého střeva",
                "benefit": "Až 500 Kč na prevenci rakoviny tlustého střeva",
                "description": "Přispíváme až 500 Kč na prevenci rakoviny tlustého střeva - vyšetření provedené u poskytovatele zdravotních služeb. Příspěvek se vztahuje na všechny metody nehrazené z veřejného zdravotního pojištění (např. Septin9). Příspěvek není určen na testy na domácí použití zakoupené v lékárně, ani na výplach Hydrocolon. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "rectum",
                "url": "https://www.cpzp.cz/preventivni-program/24"
              },
              {
                "type": "Rázová vlna",
                "benefit": "Až 500 Kč příspěvek na terapii rázovou vlnou ",
                "description": "Přispíváme až 500 Kč na terapii rázovou vlnou provedenou u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/69"
              },
              {
                "type": "Prevence obezity",
                "benefit": "Až 500 Kč příspěvek na prevenci obezity",
                "description": "Přispíváme až 500 Kč na prevenci obezity. Příspěvek je možno využít na: úhradu nákladů u obezitologa, dietologa, praktického lékaře nebo nutričního terapeuta, za účelem snížení nadváhy a obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.cpzp.cz/preventivni-program/71"
              },
              {
                "type": "Dentální hygiena",
                "benefit": "Až 500 Kč na dentální hygienu",
                "description": "Přispíváme až 500 Kč na dentální hygienu provedenou stomatologem nebo zdravotnickým pracovníkem s odbornou způsobilostí k výkonu dentální hygieny. Příspěvek je poskytován do vyčerpání finančního limitu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "brush",
                "url": "https://www.cpzp.cz/preventivni-program/80"
              },
              {
                "type": "Lehká sádra",
                "benefit": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
                "description": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb nebo zakoupené v prodejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "osteoporosis",
                "url": "https://www.cpzp.cz/preventivni-program/81"
              },
              {
                "type": "Ortopedické vložky",
                "benefit": "Až 500 Kč na nákup ortopedických vložek ",
                "description": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, prodejně zdravotnických potřeb, ve specializované prodejně nebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/82"
              },
              {
                "type": "Porod +",
                "benefit": "Až 500 Kč na nadstandardní služby související s porodem hrazené u poskytovatele zdravotních služeb.",
                "description": "Přispíváme až 500 Kč těhotným ženám na nadstandardní služby související s porodem hrazené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.cpzp.cz/preventivni-program/85"
              },
              {
                "type": "Krok pro zdraví",
                "benefit": "Až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu",
                "description": "Přispíváme až 1 000 Kč za nachozené kroky v aplikaci Zdraví v mobilu. Příspěvek motivuje pojištěnce ČPZP k pravidelné pohybové aktivitě – chůzi. Program je založen na využití krokoměru v aplikaci Zdraví v mobilu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/68"
              },
              {
                "type": "Diabetes",
                "benefit": "Až 1 000 kč na na prevenci zhoršení diabetes.",
                "description": "Přispíváme až 1 000 Kč na prevenci zhoršení diabetes. Příspěvek je určen na jednu z vybraných služeb nebo pomůcek jako např.: jehly k inzulinovým perům, testovací a diagnostické proužky, příslušenství k inzulínové pumpě, atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/32"
              },
              {
                "type": "Celiakie, dědičné metabolické poruchy",
                "benefit": "Až 1 000 Kč celiakům na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro pojištěnce s dědičnými metabolickými poruchami",
                "description": "Přispíváme až 1 000 Kč pojištěncům nemocným celiakií příspěvek na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro pojištěnce s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/70"
              },
              {
                "type": "Manažerka mateřství/Těhotenství +",
                "benefit": "Až 3 000 Kč na mateřství a těhotenství",
                "description": "Přispíváme až 3 000 Kč těhotným ženám na klidné mateřství a těhotenství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "pregnant",
                "url": "https://www.cpzp.cz/preventivni-program/38"
              },
              {
                "type": "Žena po porodu\n",
                "benefit": "Až 1 000 Kč po porodu",
                "description": "Přispíváme až 1 000 Kč ženám po porodu. Příspěvek je určen ženám po porodu miminka do 1 roku věku dítěte, u služby laktačních poradkyň do 6 měsíců po porodu. V případě vícečetného porodu nelze příspěvek navýšit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.cpzp.cz/preventivni-program/37"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 2 000 Kč na odvykání kouření",
                "description": "Přispíváme až 2 000 Kč pojištěncům na odvykání kouření. Příspěvek je určen na: nákup volně prodejných léčivých a podpůrných přípravků, zakoupených v lékárně a léčiva na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.cpzp.cz/preventivni-program/35"
              },
              {
                "type": "Příspěvek na paruku",
                "benefit": "Až 2 000 Kč na paruku",
                "description": "Přispíváme až 2 000 Kč na zakoupení paruky pro onkologicky nemocné pacienty, kteří podstupují nebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pro pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/59"
              },
              {
                "type": "Program onkologické prevence\n\n",
                "benefit": "Až 2 000 Kč na komplexní onkologickou preventivní prohlídku",
                "description": "Příspíváme až 2 000 Kč pojištěncům od 35 let na komplexní onkologickou preventivní prohlídku provedenou na specializovaných pracovištích, ve kterých je možné absolvovat preventivní onkologickou prohlídku. Vyšetření zahrnuje laboratorní a další výkony potřebné k odhalení případného karcinomu. Rozsah a cenu vyšetření stanovují jednotlivá pracoviště. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
                "icon": "ribbon",
                "url": "https://www.cpzp.cz/preventivni-program/57"
              },
              {
                "type": "Jedeme dál",
                "benefit": "Až 2 000 Kč na zakoupení protetické podprsenky, plavky, epitézy nebo na rekondiční pobyt ",
                "description": "Až 2 000 Kč ženám, které se léčí se zhoubným onemocněním prsu a je určen na zakoupení protetické podprsenky ve specializované prodejně nebo na rekondiční pobyt pořádaný pacientskými organizacemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/72"
              },
              {
                "type": "Bonus plus",
                "benefit": "Až 500 Kč v doplňkovém preventivním programu na vybrané aktivity",
                "description": "Přispíváme až 500 Kč ročně v doplňkovém programu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, sportovní ochranné pomůcky a další. Cílem programu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
                "icon": "shield",
                "url": "https://www.cpzp.cz/preventivni-program/29"
              },
              {
                "type": "Příspěvek na duševní zdraví",
                "benefit": "Až 6 000 Kč na duševní zdraví",
                "description": "Přispíváme až 6 000 Kč pojištěncům na program pro zvýšení dostupnosti psychosociální podpory. Příspěvek je určen pojištěncům na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/73"
              },
              {
                "type": "BabyGen",
                "benefit": "Až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím",
                "description": "Přispíváme až 4 000 Kč na genetické vyšetření před plánovaným těhotenstvím/rodičovstvím. Jedná se o genetickou analýzu závažných dědičných onemocnění, která vede k odhalení a minimalizaci rizik narození dítěte s těmito nemocemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.cpzp.cz/preventivni-program/77"
              },
              {
                "type": "Program pro dárce ",
                "benefit": "Až 6 000 Kč pro dárce krve a kostní dřeně",
                "description": "Přispíváme až 6 000 Kč pro dárce krve a kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-programy/4"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "20",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 1 500 Kč na různé druhy očkování",
                "description": "Přispíváme až 1 500 Kč pro všechna očkování proti infekčním onemocněním nehrazená z veřejného zdravotního pojištění. ČPZP poskytuje zákonným zástupcům dětí a mládeže ve věku do 17 let včetně příspěvek na preventivní očkování v rámci preventivních programů pro děti a mládež. Příspěvek je poskytován na kteroukoliv dávku/vakcínu očkovacího cyklu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.cpzp.cz/preventivni-program/30"
              },
              {
                "type": "Letní tábory",
                "benefit": "Až 1 500 Kč na letní tábory",
                "description": "Přispíváme až 1 500 Kč na letní táboty pro děti od 3 let. Příspěvek bude uznán jen v případě jeho trvání v délce minimálně 4 kalendářní dny, a lze jej uplatnit na tábory pořádané v období letních prázdnin. Příspěvek se vztahuje i na příměstské tábory. Příspěvek lze poskytnout jen na tábory konané na území ČR. Příspěvek bude realizován až po absolvování letního tábora. O příspěvek je možné požádat pouze do 30.9.2026 včetně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.cpzp.cz/preventivni-program/3"
              },
              {
                "type": "Školky a školy v přírodě, lyžařské výcviky",
                "benefit": "Až 500 Kč na školky a školy v přírodě, lyžařské výcviky\n",
                "description": "Přispíváme až 500 Kč zákonným zástupcům dětí na školky a školy v přírodě. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.cpzp.cz/preventivni-program/2"
              },
              {
                "type": "Sportovní kroužky",
                "benefit": "Až 700 Kč na sportovní pohybové kroužky, sportovní kurzy a členství ve sportovních klubech a oddílech",
                "description": "Přispíváme až 700 Kč na sportovní pohybové kroužky (organizované školami i jinými subjekty), sportovní kurzy a členství ve sportovních klubech a oddílech pro děti a mládež od 3 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.cpzp.cz/preventivni-program/56"
              },
              {
                "type": "Ochranná přilba",
                "benefit": "Až 500 Kč na ochrannou přilbu",
                "description": "Přispíváme až 500 Kč zákonným zástupcům dětí na nákup ochranné přilby pro děti. Příspěvek se vztahuje na ochrannou přilbu na sport zakoupenou v kamenné prodejně, popř. e-shopu prodejny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "helmet",
                "url": "https://www.cpzp.cz/preventivni-program/27"
              },
              {
                "type": "Zdravé dítě",
                "benefit": "Až 500 Kč na produkty pro zdravý rozvoj dítěte a cvičení pro děti do 2 let",
                "description": "Přispíváme až 500 Kč zákonným zástupcům dětí do 2 let včetně  na produkty pro zdravý rozvoj dítěte a cvičení pro děti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/7"
              },
              {
                "type": "Vyšetření zraku",
                "benefit": "Až 500 Kč na vyšetření zraku přístrojem Plusoptix",
                "description": "Přispíváme až 500 Kč zákonným zástupcům dětí na vyšetření zraku přístrojem Plusoptix u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.cpzp.cz/preventivni-program/6"
              },
              {
                "type": "Sportovní prohlídka",
                "benefit": "Až 500 Kč na úhradu sportovní lékařské prohlídky",
                "description": "Přispíváme až 500 Kč zákonným zástupcům dětí na úhradu sportovní lékařské prohlídky provedené u poskytovatele zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.cpzp.cz/preventivni-program/11"
              },
              {
                "type": "Prevence obezity",
                "benefit": "Až 500 Kč na prevenci obezity",
                "description": "Přispíváme až 500 Kč zákonným zástupcům dětí  na prevenci obezity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.cpzp.cz/preventivni-program/25"
              },
              {
                "type": "Prevence rakoviny kůže",
                "benefit": "Až 500 Kč na vyšetření pigmentových skvrn",
                "description": "Přispíváme až 500 Kč na vyšetření pigmentových skvrn. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.cpzp.cz/preventivni-program/13"
              },
              {
                "type": "Chůva 24",
                "benefit": "Až 500 Kč na monitor dechu a chůvičky pro děti do 2 let",
                "description": "Přispíváme až 500 Kč zákonným zástupcům dětí do 2 let na monitor dechu a chůvičky (příspěvek lze poskytnout i na zakoupení náhradní podložky k monitoru dechu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "phone",
                "url": "https://www.cpzp.cz/preventivni-program/63"
              },
              {
                "type": "Prevence trombózy",
                "benefit": "Až 1 000 Kč na prevenci trombózy pro dívky od 12 let ",
                "description": "Přispíváme až 1 000 Kč zákonným zástupcům dětí a mládeže na prevenci trombózy pro dívky od 12 let (příspěvek na genetické vyšetření DNA, které odhalí pravděpodobnost trombofilních komplikací - ve spojení zejména s užíváním hormonální antikoncepce). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/12"
              },
              {
                "type": "Lehká sádra",
                "benefit": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
                "description": "Přispíváme až 1 000 Kč na úhradu odlehčené a lehké sádry z plastů, pryskyřice a karbonových vláken (např. Opencast) u poskytovatele zdravotních služeb nebo zakoupené v prodejně zdravotnických potřeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "osteoporosis",
                "url": "https://www.cpzp.cz/preventivni-program/78"
              },
              {
                "type": "Ortopedické vložky",
                "benefit": "Až 500 Kč na nákup ortopedických vložek ",
                "description": "Přispíváme až 500 Kč pojištěncům s ortopedickými vadami nohou na nákup ortopedických vložek do bot v lékárně, prodejně zdravotnických potřeb, ve specializované prodejně nebo od výrobce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.cpzp.cz/preventivni-program/79"
              },
              {
                "type": "Diabetes",
                "benefit": "Až 2 000 Kč na prevenci zhoršení diabetes",
                "description": "Přispíváme až 2 000 Kč zákonným zástupcům dětí na produkty pro diabetiky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.cpzp.cz/preventivni-program/8"
              },
              {
                "type": "Celiakie, dědičné metabolické poruchy",
                "benefit": "Až 4 000 Kč na bezlepkovou dietu a na nízkobilkovinovou dietu pro děti s dědičnými metabolickými poruchami",
                "description": "Přispíváme až 4 000 Kč zákonným zástupcům dětí nemocných celiakií příspěvek na bezlepkovou dietu a příspěvek na nízkobilkovinovou dietu pro děti s dědičnými metabolickými poruchami. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.cpzp.cz/preventivni-program/9"
              },
              {
                "type": "Vitaminy pro děti",
                "benefit": "Zdarma. Tento produkt se nezapočítává do celkového limitu 1 500 Kč na preventivní programy pro děti a mládež",
                "description": "ČPZP poskytuje zákonným zástupcům dětí a mládeže ve věku 3 až 15 let včetně, vitaminy pro děti k odběru na pobočce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.cpzp.cz/preventivni-program/10"
              },
              {
                "type": "Příspěvek na paruku",
                "benefit": "Až 2 000 Kč na paruku",
                "description": "Přispíváme až 2 000 Kč na zakoupení paruky pro onkologicky nemocné pacienty, kteří podstupují nebo podstoupili v rámci onkologického onemocnění léčbu chemoterapií a pro pojištěnce s diagnózou alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/61"
              },
              {
                "type": "Bonus plus",
                "benefit": "Až 500 Kč v doplňkovém preventivním programu na vybrané aktivity",
                "description": "Přispíváme až 500 Kč ročně v doplňkovém programu \"Bonus Plus\" na vybrané aktivity, např. zdravotní služby absolvované ve zdravotnických zařízeních, přípravky na ústní hygienu, brýlové obruby, opalovací krémy, sportovní ochranné pomůcky a další. Cílem programu je motivovat pojištěnce ČPZP k ochraně a maximální péči o zdraví a odměňovat je i za věrnost k ČPZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. \n",
                "icon": "shield",
                "url": "https://www.cpzp.cz/preventivni-program/29"
              },
              {
                "type": "Příspěvek na duševní zdraví",
                "benefit": "Až 6 000 Kč na duševní zdraví pro děti od 7 let",
                "description": "Přispíváme až 6 000 Kč na duševní zdraví pro děti od 7 let .Příspěvek je určen pojištěncům od 7 let na psychosociální intervenci absolvovanou u vybraného odborníka - soukromého terapeuta s patřičnou kvalifikací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.cpzp.cz/preventivni-program/74"
              }
            ]
          }
        ]
      },
      {
        "slug": "ozp",
        "updateDate": "2.2.2026",
        "companyBenefitsLink": "https://www.ozp.cz/benefity/benefityozp",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "19",
            "benefits": [
              {
                "type": "Dentální hygiena",
                "benefit": "Až 1 000 Kč na dentální hygienu",
                "description": "Přispíváme až 1 000 Kč jednou za rok na dentální hygienu pro dospělé. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "brush",
                "url": "https://www.ozp.cz/benefity/benefityozp"
              },
              {
                "type": "Očkování proti chřipce (do 65 let)",
                "benefit": "Až 500 Kč na očkování proti chřipce, které není hrazené z veřejného zdravotního pojištění",
                "description": "Přispíváme až 500 Kč na očkování proti chřipce dospělým do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka"
              },
              {
                "type": "Ostatní očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Přispíváme až 1 000 Kč  na očkování, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani"
              },
              {
                "type": "STOP rakovině kůže",
                "benefit": "Až 800 Kč na preventivní vyšetření rakoviny kůže ",
                "description": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze"
              },
              {
                "type": "Nutriční poradenství pro vybrané chronicky nemocné klienty",
                "benefit": "Až 1 000 Kč na nutriční poradenství pro vybrané chronicky nemocné klienty",
                "description": "Přispíváme až 1 000 Kč na nutriční poradenství pro vybrané chronicky nemocné klienty.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/pece-o-vybrane-chronicky-nemocne-klienty"
              },
              {
                "type": "Příspěvek pro klienty s nízkobílkovinnou dietou",
                "benefit": "Až 5 000 Kč na nízkobílkovinnou dietou",
                "description": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou"
              },
              {
                "type": "Příspěvky pro onkologicky nemocné",
                "benefit": "Až 4 000 Kč pro onkologicky nemocné pojištěnce na vybrané pomůcky ",
                "description": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne"
              },
              {
                "type": "STOP kouření",
                "benefit": "Až 2 000 Kč na odvykání kouření",
                "description": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.ozp.cz/benefity/stop-koureni"
              },
              {
                "type": "STOP rakovině dutiny ústní",
                "benefit": "Až 700 Kč na preventivní vyšetření rakoviny dutiny ústní",
                "description": "Přispíváme až 700 Kč dospělým od 25 let na preventivní vyšetření rakoviny dutiny ústní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-dutiny-ustni"
              },
              {
                "type": "STOP infarktu",
                "benefit": "Až 1 200 Kč na preventivní vyšetření rizika infarktu ",
                "description": "Přispíváme až 1 200 Kč dospělým od 30 do 55 let na preventivní vyšetření rizika infarktu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart-attack",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-infarktu"
              },
              {
                "type": "STOP rakovině prostaty",
                "benefit": "Až 1 200 Kč na preventivní vyšetření rakoviny prostaty",
                "description": "Přispíváme až 1 200 Kč dospělím od 40 do 49 let na preventivní vyšetření rakoviny prostaty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "prostate",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-prostaty"
              },
              {
                "type": "STOP rakovině tlustého střeva a konečníku",
                "benefit": "Až 500 Kč na preventivní vyšetření rakoviny tlustho střeva a konečníku",
                "description": "Přispíváme až 500 Kč dospělím od 40 do 44 let na preventivní vyšetření rakoviny tlustého střeva a konečníku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-konecniku"
              },
              {
                "type": "Prevence Alzheimerovy nemoci",
                "benefit": "Až 500 Kč na prevenci Alzheimerovy nemoci",
                "description": "Přispíváme až 500 Kč dospělím od 40 let na prevenci Alzheimerovy nemoci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/prevence-alzheimerovy-nemoci"
              },
              {
                "type": "STOP rakovině ledvin a nádorům břišních orgánů",
                "benefit": "Až 1 150 Kč na preventivní vyřetření rakoviny ledvin a nádorům břišních orgánů ",
                "description": "Přispíváme až 1 150 Kč dospělím od 40 let na preventivní vyšetření rakoviny ledvin a nádorům břišních orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-nadorum-brisnich-organu"
              },
              {
                "type": "STOP osteoporóze",
                "benefit": "Až 1 000 Kč na prevenci osteoporózy",
                "description": "Přispíváme až 1 000 Kč dospělím od 50 let na prevenci osteoporózy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "osteoporosis",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-osteoporoze"
              },
              {
                "type": "Vitamíny pro seniory",
                "benefit": "Až 500 Kč na vitamíny pro seniory",
                "description": "Přispíváme až 500 Kč seniorům nad 70 let na vitamíny a léčivé doplňky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.ozp.cz/benefity/kupon-na-vitaminy"
              },
              {
                "type": "Pro dárce",
                "benefit": "Odměna až 3 000 Kč pro ty, kteří jsou solidární ke zdraví ostatních",
                "description": "Cílovou skupinou jsou dárci krve, dárci orgánů a dárci kostní dřeně. Za dárcovské úkony vám bude připsán kredit, který můžete následně čerpat na množství podpůrných programů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/pro-darce"
              },
              {
                "type": "Výhodné pojištění Vitalitas",
                "benefit": "Pro vás i vaše děti máme skvělé pojistné produkty",
                "description": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pro děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "suitcase",
                "url": "https://www.vitalitas.cz/"
              },
              {
                "type": "Další benefity",
                "benefit": "Objevte svět výhodných benefitů, které vám OZP nabízí",
                "description": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "20",
            "benefits": [
              {
                "type": "Dentální hygiena",
                "benefit": "Až 1 000 Kč na dentální hygienu",
                "description": "Přispíváme až 1 000 Kč jednou za rok na dentální hygienu pro dospělé. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.ozp.cz/benefity/benefityozp"
              },
              {
                "type": "Očkování proti chřipce (do 65 let)",
                "benefit": "Až 500 Kč na očkování proti chřipce, které není hrazené z veřejného zdravotního pojištění",
                "description": "Přispíváme až 500 Kč na očkování proti chřipce dospělým do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka"
              },
              {
                "type": "Ostatní očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Přispíváme až 1 000 Kč  na očkování, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani"
              },
              {
                "type": "STOP rakovině kůže",
                "benefit": "Až 800 Kč na preventivní vyšetření rakoviny kůže",
                "description": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze"
              },
              {
                "type": "Nutriční poradenství pro vybrané chronicky nemocné klienty",
                "benefit": "Až 1 000 Kč na nutriční poradenství pro vybrané chronicky nemocné klienty",
                "description": "Přispíváme až 1 000 Kč na nutriční poradenství pro vybrané chronicky nemocné klienty.  Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/pece-o-vybrane-chronicky-nemocne-klienty"
              },
              {
                "type": "Příspěvek pro klienty s nízkobílkovinnou dietou",
                "benefit": "Až 5 000 Kč na nízkobílkovinnou dietou",
                "description": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou"
              },
              {
                "type": "Příspěvky pro onkologicky nemocné",
                "benefit": "Až 4 000 Kč pro onkologicky nemocné pojištěnce na vybrané pomůcky",
                "description": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
                "icon": "ribbon",
                "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne"
              },
              {
                "type": "STOP kouření",
                "benefit": "Až 2 000 Kč na odvykání kouření",
                "description": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.ozp.cz/benefity/stop-koureni"
              },
              {
                "type": "STOP rakovině dutiny ústní",
                "benefit": "Až 700 Kč na preventivní vyšetření rakoviny dutiny ústní",
                "description": "Přispíváme až 700 Kč dospělým od 25 let na preventivní vyšetření rakoviny dutiny ústní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-dutiny-ustni"
              },
              {
                "type": "STOP infarktu",
                "benefit": "Až 1 200 Kč na preventivní vyšetření rizika infarktu",
                "description": "Přispíváme až 1 200 Kč dospělým od 30 do 55 let na preventivní vyšetření rizika infarktu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart-attack",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-infarktu"
              },
              {
                "type": "STOP rakovině prsu",
                "benefit": "Až 1 200 Kč na prevenci rakoviny prsu",
                "description": "Přispíváme až 1200 Kč ženám od 40 let na prevenci rakoviny prsu + 100 Kč příspěvek na vyhodnocení snímku pomocí AI. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "breasts",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-prsu"
              },
              {
                "type": "STOP rakovině tlustého střeva a konečníku",
                "benefit": "Až 500 Kč na preventivní vyšetření rakoviny tlustho střeva a konečníku",
                "description": "Přispíváme až 500 Kč dospělím od 40 do 44 let na preventivní vyšetření rakoviny tlustého střeva a konečníku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-konecniku"
              },
              {
                "type": "Prevence Alzheimerovy nemoci",
                "benefit": "Až 500 Kč na prevenci Alzheimerovy nemoci",
                "description": "Přispíváme až 500 Kč dospělím od 40 let na prevenci Alzheimerovy nemoci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/prevence-alzheimerovy-nemoci"
              },
              {
                "type": "STOP rakovině ledvin a nádorům břišních orgánů",
                "benefit": "Až 1 150 Kč na preventivní vyřetření rakoviny ledvin a nádorům břišních orgánů",
                "description": "Přispíváme až 1 150 Kč dospělím od 40 let na preventivní vyšetření rakoviny ledvin a nádorům břišních orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-nadorum-brisnich-organu"
              },
              {
                "type": "STOP osteoporóze",
                "benefit": "Až 1 000 Kč na prevenci osteoporózy",
                "description": "Přispíváme až 1 000 Kč dospělím od 50 let na prevenci osteoporózy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "osteoporosis",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-osteoporoze"
              },
              {
                "type": "Vitamíny pro seniory",
                "benefit": "Až 500 Kč na vitamíny pro seniory",
                "description": "Přispíváme až 500 Kč seniorům nad 70 let na vitamíny a léčivé doplňky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.ozp.cz/benefity/kupon-na-vitaminy"
              },
              {
                "type": "Pro dárce",
                "benefit": "Odměna až 3 000 Kč pro ty, kteří jsou solidární ke zdraví ostatních",
                "description": "Cílovou skupinou jsou dárci krve, dárci orgánů a dárci kostní dřeně. Za dárcovské úkony vám bude připsán kredit, který můžete následně čerpat na množství podpůrných programů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/pro-darce"
              },
              {
                "type": "Výhodné pojištění Vitalitas",
                "benefit": "Pro vás i vaše děti máme skvělé pojistné produkty",
                "description": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pro děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "suitcase",
                "url": "https://www.vitalitas.cz/"
              },
              {
                "type": "Další benefity",
                "benefit": "Objevte svět výhodných benefitů, které vám OZP nabízí",
                "description": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace"
              },
              {
                "type": "Příspěvek pro těhotné a novorozence\n",
                "benefit": "Až 6 000 Kč nastávajícím maminkám a jejich miminkům",
                "description": "Přispíváme až 6 000 Kč nastávajícím maminkám a jejich miminkům. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.ozp.cz/benefity/maminky-a-novorozenci"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "13",
            "benefits": [
              {
                "type": "Dentální hygiena",
                "benefit": "Až 1 000 Kč na dentální hygienu",
                "description": "Přispíváme až 1 000 Kč dětem na dentální hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "brush",
                "url": "https://www.ozp.cz/benefity/kupon-na-dentalni-hygienu"
              },
              {
                "type": "Sportovní aktivity",
                "benefit": "Až 1 000 Kč pro děti od 6 do 14 let na sportovní aktivity",
                "description": "Přispíváme až 1 000 Kč dětem ve věku 6 - 14 let na sportovní aktivity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "muscle",
                "url": "https://www.ozp.cz/benefity/kupon-na-sportovni-aktivity"
              },
              {
                "type": "Očkování proti chřipce ",
                "benefit": "Až 500 Kč na očkování proti chřipce, které není hrazené z veřejného zdravotního pojištění",
                "description": "Přispíváme až 500 Kč dětem na očkování proti chřipce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani-chripka"
              },
              {
                "type": "Ostatní očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Přispíváme až 1 000 Kč  na očkování, které není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.ozp.cz/benefity/kupon-na-ockovani"
              },
              {
                "type": "Příspěvek pro klienty s nízkobílkovinnou dietou",
                "benefit": "Až 5000 Kč pro klienty s nízkobílkovinnou dietou",
                "description": "Program je zaměřený na podporu klientů OZP s nízkobílkovinnou dietou, tedy s dědičnou poruchou metabolismu, fenylketonurií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou"
              },
              {
                "type": "STOP rakovině kůže",
                "benefit": "Až 800 Kč na preventivní vyšetření rakoviny kůže",
                "description": "Přispíváme až 800 Kč na preventivní vyšetření rakoviny kůže. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.ozp.cz/benefity/zdravotne-preventivni-programy/stop-rakovine-kuze"
              },
              {
                "type": "Příspěvek na ozdravné pobyty pro děti",
                "benefit": "Až 10 000 Kč pro děti s chronickými respiračními a dermatologickými chorobami (LOP) nebo pro děti s obezitou",
                "description": "Přispíváme až 10 000 Kč na klimatický (přímořský/vysokohorský) nebo lázeňský léčebně ozdravný pobyt, (který není hrazen z veřejného zdravotního pojištění) s minimální délkou pobytu 15 dní (14 nocí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "suitcase",
                "url": "https://www.ozp.cz/benefity/ozdravne-pobyty-pro-deti"
              },
              {
                "type": "Příspěvek pro klienty s nízkobílkovinnou dietou",
                "benefit": "Až 5 000 Kč na nízkobílkovinnou dietou",
                "description": "Přispíváme až 5 000 Kč klientům s dědičnou poruchou metabolismu – fenylketonurií na potraviny s nízkým obsahem bílkovin. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.ozp.cz/benefity/prispevek-pro-klienty-s-nizkobilkovinnou-dietou"
              },
              {
                "type": "Příspěvky pro onkologicky nemocné",
                "benefit": "Až 4 000 Kč pro onkologicky nemocné pojištěnce na vybrané pomůcky",
                "description": "Přispíváme až 4 000 Kč onkologicky nemocným klientům na paruky, epitézy, lymfodrenáže po ablaci prsu, stomické pomůcky, inkontineční pomůcky, respirátory a roušky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.\n\n",
                "icon": "ribbon",
                "url": "https://www.ozp.cz/benefity/prispevky-pro-onkologicky-nemocne"
              },
              {
                "type": "Příspěvek pro děti s obezitou",
                "benefit": "Až 1 000 Kč pro děti s obezitou",
                "description": "Přispíváme až 1 000 Kč dětem s diagnózou E 66 – obezita, otylost můžete využít příspěvek - na služby specializované poradny pro děti s obezitou, pohybové aktivity dětí, speciální ozdravné pobyty (mimo léčbu v dětských ozdravovnách, která je hrazena z v.z.p.) či psychoterapeutické a psychologické podpůrné aktivity u PZS. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.ozp.cz/benefity/prispevky-na-prevenci/prispevek-pro-deti-s-obezitou"
              },
              {
                "type": "STOP kouření",
                "benefit": "Až 2 000 Kč na odvykání kouření",
                "description": "Přispíváme až 2 000 Kč na odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.ozp.cz/benefity/stop-koureni"
              },
              {
                "type": "Výhodné pojištění Vitalitas",
                "benefit": "Pro vás i vaše děti máme skvělé pojistné produkty",
                "description": "U pojišťovny VITALITAS můžete využít výhodného cestovního pojištění či úrazového pojištění pro děti Zvonek a Gina. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "suitcase",
                "url": "https://www.vitalitas.cz/"
              },
              {
                "type": "Další benefity",
                "benefit": "Objevte svět výhodných benefitů, které vám OZP nabízí",
                "description": "VITAKARTA - on-line přepážka, podání přehledu OSVČ on-line, atlas lékařů a další on-line služby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.ozp.cz/elektronicka-komunikace/informace/vitakarta-online-informace"
              }
            ]
          }
        ]
      },
      {
        "slug": "vozp",
        "updateDate": "29.1.2026",
        "companyBenefitsLink": "https://www.vozp.cz/prispevky-na-prevenci",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "15",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Přispíváme až 1 000 Kč pojištěncům od 18 let věku na kterékoli očkování nehrazené z veřejného zdravotního pojištění (s výjimkou očkování proti lidskému papilomaviru – HPV), a to na kteroukoli dávku očkovacího cyklu. Příspěvek nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "vaccine",
                "url": "https://www.vozp.cz/prispevek/ockovani-pro-dospele"
              },
              {
                "type": "Aplikace Kalorické Tabulky\n",
                "benefit": "Až 899 Kč na aplikaci Kalorické Tabulky",
                "description": "Přispíváme až 899 Kč Pojištěncům od 18 let na roční předplatné prémiové verze aplikace Kalorické Tabulky. Příspěvek lze poskytnout pouze na verzi Premium pro jednotlivce s min. roční platností (nikoli např. na měsíční předplatné nebo rodinné předplatné). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "phone",
                "url": "https://www.vozp.cz/prispevek/aplikace-kaloricke-tabulky"
              },
              {
                "type": "Dentální hygiena",
                "benefit": "Až 500 Kč na dentální hygienu",
                "description": "Přispíváme až 500 Kč všem pojištěncům na dentální hygienu (ošetření či instruktáž). Příspěvek se nevztahuje na zubní lékařskou prohlídku nebo na jiné než hygienické výkony ani na dentální pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.vozp.cz/prispevek/dentalni-hygiena"
              },
              {
                "type": "Pravidelný pohyb",
                "benefit": "Až 700 Kč na pravidelné pohybové aktivity",
                "description": "Příspíváme až 700 Kč pojištěncům od 18 let na pravidelné pohybové aktivity, jako jsou: kondiční cvičení, core trénink, fitness, aerobic, spinning, tabata, bodybuilding, bodyforming, hasičský sport, jóga, pilates, tai-či, kalanetika, zumba, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "move",
                "url": "https://www.vozp.cz/prispevek/pravidelny-pohyb"
              },
              {
                "type": "Plavání",
                "benefit": "Až 700 Kč na plavání",
                "description": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (příspěvek je v tomto případě určen pouze pro dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "water",
                "url": "https://www.vozp.cz/prispevek/plavani"
              },
              {
                "type": "Kloubní výživa pro seniory",
                "benefit": "Až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů",
                "description": "Přispíváme až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů a jejich správné funkce a k prevenci artrózy (přípravky s kolagenem, glukosamin sulfátem, chondroitin sulfátem, methylsulfonylmetanem – MSM apod.), které byly zakoupeny v lékárně. Příspěvek není určen na jiné než kloubní doplňky. Nelze jej tedy využít např. na přípravky k prevenci úbytku kostní hmoty (osteoporózy), vitamíny, hořčík apod. Příspěvek lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.vozp.cz/prispevek/kloubni-vyziva-pro-seniory"
              },
              {
                "type": "Prevence karcinomu prostaty",
                "benefit": "Až 300 Kč na prevenci rakoviny prostaty",
                "description": "Přispíváme až 300 Kč mužům od 40 let na preventivní vyšetření PSA z krve anebo ultrazvukové vyšetření prostaty, pokud není hrazeno z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "prostate",
                "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prostaty"
              },
              {
                "type": "Vyšetření kožních znamének",
                "benefit": "Až 400 Kč na vyšetření kožních znamének",
                "description": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek"
              },
              {
                "type": "Prevence kolorektálního karcinomu",
                "benefit": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
                "description": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku nebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu provedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 400 Kč na odvykání kouření",
                "description": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě anebo o ukončení léčby vystaveného centrem pro odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.vozp.cz/prispevek/odvykani-koureni"
              },
              {
                "type": "Prevence karcinomu prsu",
                "benefit": "Až 800 Kč na prevenci rakoviny prsu ",
                "description": "Přispíváme až 800 Kč mužům od 30 let na sonografické vyšetření. Jednou za 2 roky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "breasts",
                "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prsu"
              },
              {
                "type": "Paruka při onkologické léčbě/alopecii\n",
                "benefit": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
                "description": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili nebo podstupují léčbu onkologického onemocnění, nebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii"
              },
              {
                "type": "Prevence poruch paměti/kognitivních funkcí",
                "benefit": "Až 300 Kč na preventivní vyšetření poruch paměti/kognitivních funkcí ",
                "description": "Přispíváme až 300 Kč pojištěncům od 18 let na preventivní vyšetření poruch paměti/kognitivních funkcí (cílené psychiatrické či psychologické vyšetření dotazníky MMSE, AKT, MoCA), odborně vedený trénink paměti, kognitivní pomůcky doporučené Českou alzheimerovskou společností, terapie Feuersteinovou metodou instrumentálního obohacování pro osoby s poškozením mozku poskytovaná certifikovaným odborníkem – viz. seznam oprávněných osob (dostupný na webu www.cogito-centrum.cz v sekci tým – naši odborníci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brain",
                "url": "https://www.vozp.cz/prispevek/prevence-poruch-pameti"
              },
              {
                "type": "Terapeutické programy Mindwell",
                "benefit": "Bezplatný program",
                "description": "Při splnění podmínek pro zařazení do programu obdrží klient VoZP aktivační kód, který nahrazuje platbu při zakoupení programu na stránkách Mindwell. Program je určen pojištěncům VoZP starším 18 let a je vhodný pro osoby s lehkou až střední formou deprese či úzkostných stavů. Není vhodný pro osoby s akutními potížemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.vozp.cz/prispevek/mindwell"
              },
              {
                "type": "Pro dárce",
                "benefit": "Odměna až 5 000 Kč pro dárce krve a kostní dřeně",
                "description": "Cílovou skupinou jsou dárci krve a dárci kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/prispevky-pro-darce-krve-a-kostni-drene"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "18",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Přispíváme až 1 000 Kč pojištěncům od 18 let věku na kterékoli očkování nehrazené z veřejného zdravotního pojištění (s výjimkou očkování proti lidskému papilomaviru – HPV), a to na kteroukoli dávku očkovacího cyklu. Příspěvek nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "vaccine",
                "url": "https://www.vozp.cz/prispevek/ockovani-pro-dospele"
              },
              {
                "type": "Aplikace Kalorické Tabulky\n",
                "benefit": "Až 899 Kč na aplikaci Kalorické Tabulky",
                "description": "Přispíváme až 899 Kč Pojištěncům od 18 let na roční předplatné prémiové verze aplikace Kalorické Tabulky. Příspěvek lze poskytnout pouze na verzi Premium pro jednotlivce s min. roční platností (nikoli např. na měsíční předplatné nebo rodinné předplatné). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "phone",
                "url": "https://www.vozp.cz/prispevek/aplikace-kaloricke-tabulky"
              },
              {
                "type": "Dentální hygiena",
                "benefit": "Až 500 Kč na dentální hygienu",
                "description": "Přispíváme až 500 Kč všem pojištěncům na dentální hygienu (ošetření či instruktáž). Příspěvek se nevztahuje na zubní lékařskou prohlídku nebo na jiné než hygienické výkony ani na dentální pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.vozp.cz/prispevek/dentalni-hygiena"
              },
              {
                "type": "Prevence v těhotenství a po porodu",
                "benefit": "Až 2 000 Kč ženám v těhotenství a po porodu  ",
                "description": "Přispíváme až 2 000 Kč ženám v těhotenství a po porodu na různé kurzy, screening, dentální hygienu, služby laktační poradkyně, apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.vozp.cz/prispevek/prevence-v-tehotenstvi"
              },
              {
                "type": "Doplňky stravy pro těhotné",
                "benefit": "Až 500 Kč těhotným ženám na doplňky stravy ",
                "description": "Přispíváme 500 Kč těhotným ženám na doplňky stravy vhodné k užívání v těhotenství zakoupené v lékárně (vitamíny, multivitamíny, kyselina listová, železo, vláknina, probiotika – živé kultury apod.).Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.vozp.cz/prispevek/doplnky-stravy-pro-tehotne"
              },
              {
                "type": "Novorozenecký balíček",
                "benefit": "Balíček pro novorozence",
                "description": "Balíček pro každého novorozence, který je přihlášen k VoZP. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.vozp.cz/prispevek/novorozenecky-balicek"
              },
              {
                "type": "Péče o miminko",
                "benefit": "Až 2 000 Kč na různé pomůcky pro péči o miminko",
                "description": "Přispíváme až 2 000 Kč jednorázově každému dítěti od narození do šesti měsíců na následující produkty podle výběru zákonného zástupce. Např: pomůcky ke kojení a krmení dětí: kojící kloboučky, kojící polštářek, odsávačka mateřského mléka atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.vozp.cz/prispevek/pece-o-miminko"
              },
              {
                "type": "Pravidelný pohyb",
                "benefit": "Až 700 Kč na pravidelné pohybové aktivity",
                "description": "Příspíváme až 700 Kč pojištěncům od 18 let na pravidelné pohybové aktivity, jako jsou: kondiční cvičení, core trénink, fitness, aerobic, spinning, tabata, bodybuilding, bodyforming, hasičský sport, jóga, pilates, tai-či, kalanetika, zumba, a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "move",
                "url": "https://www.vozp.cz/prispevek/pravidelny-pohyb"
              },
              {
                "type": "Plavání",
                "benefit": "Až 700 Kč na plavání",
                "description": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (příspěvek je v tomto případě určen pouze pro dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "water",
                "url": "https://www.vozp.cz/prispevek/plavani"
              },
              {
                "type": "Kloubní výživa pro seniory",
                "benefit": "Až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů",
                "description": "Přispíváme až 500 Kč pojištěncům ve věku 65 a více let na výdaje při nákupu doplňků stravy určených výlučně k podpoře zdraví kloubů a jejich správné funkce a k prevenci artrózy (přípravky s kolagenem, glukosamin sulfátem, chondroitin sulfátem, methylsulfonylmetanem – MSM apod.), které byly zakoupeny v lékárně. Příspěvek není určen na jiné než kloubní doplňky. Nelze jej tedy využít např. na přípravky k prevenci úbytku kostní hmoty (osteoporózy), vitamíny, hořčík apod. Příspěvek lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.vozp.cz/prispevek/kloubni-vyziva-pro-seniory"
              },
              {
                "type": "Prevence karcinomu prsu\n",
                "benefit": "Až 800 Kč na prevenci rakoviny prsu ",
                "description": "Přispíváme až 800 Kč ženám od 30 let na sonografické nebo mamografické vyšetření (od 45 let je ženám vyšetření k prevenci rakoviny prsu hrazeno z veřejného zdravotního pojištění každý druhý rok, příspěvek je v tomto případě určen na roky v mezidobí). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "breasts",
                "url": "https://www.vozp.cz/prispevek/prevence-karcinomu-prsu"
              },
              {
                "type": "Vyšetření kožních znamének",
                "benefit": "Až 400 Kč na vyšetření kožních znamének",
                "description": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "skin",
                "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek"
              },
              {
                "type": "Prevence kolorektálního karcinomu",
                "benefit": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
                "description": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku nebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu provedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 400 Kč na odvykání kouření",
                "description": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě anebo o ukončení léčby vystaveného centrem pro odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.vozp.cz/prispevek/odvykani-koureni"
              },
              {
                "type": "Paruka při onkologické léčbě/alopecii",
                "benefit": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
                "description": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili nebo podstupují léčbu onkologického onemocnění, nebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii"
              },
              {
                "type": "Prevence poruch paměti/kognitivních funkcí",
                "benefit": "Až 300 Kč na preventivní vyšetření poruch paměti/kognitivních funkcí ",
                "description": "Přispíváme až 300 Kč pojištěncům od 18 let na preventivní vyšetření poruch paměti/kognitivních funkcí (cílené psychiatrické či psychologické vyšetření dotazníky MMSE, AKT, MoCA), odborně vedený trénink paměti, kognitivní pomůcky doporučené Českou alzheimerovskou společností, terapie Feuersteinovou metodou instrumentálního obohacování pro osoby s poškozením mozku poskytovaná certifikovaným odborníkem – viz. seznam oprávněných osob (dostupný na webu www.cogito-centrum.cz v sekci tým – naši odborníci). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brain",
                "url": "https://www.vozp.cz/prispevek/prevence-poruch-pameti"
              },
              {
                "type": "Terapeutické programy Mindwell",
                "benefit": "Bezplatný program",
                "description": "Při splnění podmínek pro zařazení do programu obdrží klient VoZP aktivační kód, který nahrazuje platbu při zakoupení programu na stránkách Mindwell. Program je určen pojištěncům VoZP starším 18 let a je vhodný pro osoby s lehkou až střední formou deprese či úzkostných stavů. Není vhodný pro osoby s akutními potížemi. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.vozp.cz/prispevek/mindwell"
              },
              {
                "type": "Pro dárce",
                "benefit": "Odměna až 5 000 Kč pro dárce krve a kostní dřeně",
                "description": "Cílovou skupinou jsou dárci krve a dárci kostní dřeně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/prispevky-pro-darce-krve-a-kostni-drene"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "20",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 2 000 Kč na očkování pro děti",
                "description": "Přispíváme až 2 000 Kč pojištěncům do dovršení 18 let věku na kterékoli očkování nehrazené z veřejného zdravotního pojištění (s výjimkou očkování proti lidskému papilomaviru HPV), a to na kteroukoli dávku očkovacího cyklu. Příspěvek nelze poskytnout na doplatek částečně hrazené vakcíny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vozp.cz/prispevek/ockovani-pro-deti"
              },
              {
                "type": "Dentální hygiena",
                "benefit": "Až 500 Kč na dentální hygienu",
                "description": "Přispíváme až 500 Kč všem pojištěncům na dentální hygienu (ošetření či instruktáž). Příspěvek se nevztahuje na zubní lékařskou prohlídku nebo na jiné než hygienické výkony ani na dentální pomůcky či jiné zboží. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.vozp.cz/prispevek/dentalni-hygiena"
              },
              {
                "type": "Dioptrické brýle pro děti",
                "benefit": "Až 500 Kč na dioptrické brýle pro děti",
                "description": "Přispíváme až 500 Kč pojištěncům od 6 do dovršení 16 let na dioptrické brýle (obroučky i skla). Příspěvek se nevztahuje na samostatně zakoupené příslušenství ani na kontaktní čočky nebo na sluneční brýle bez dioptrických skel. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "glasses",
                "url": "https://www.vozp.cz/prispevek/dioptricke-bryle-pro-deti"
              },
              {
                "type": "Zubní rovnátka pro děti",
                "benefit": "Až 1 500 Kč na zubní rovnátka pro děti\n",
                "description": "Přispíváme až 1 500 Kč pojištěncům do dovršení 18 let věku na nesnímatelný (fixní) i snímatelný ortodontický aparát (vč. foliového) nebo jeho rekonstrukci (doplnění součástí) v době aktivní i retenční fáze léčby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "braces",
                "url": "https://www.vozp.cz/prispevek/zubni-rovnatka-pro-deti"
              },
              {
                "type": "Očkování proti papilomaviru",
                "benefit": "Až 1 500 Kč na očkování proti lidskému papilomaviru (HPV) ",
                "description": "Přispíváme až 1 500 Kč Pojištěncům od 15 let do dovršení 18 let věku na očkování proti lidskému papilomaviru (HPV) podle doporučení lékaře (pojištěncům ve věku od 11 do dovršení 15 let je toto očkování hrazeno z veřejného zdravotního pojištění). Příspěvek nelze poskytnout na doplatek částečně hrazené vakcíny. íce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vozp.cz/prispevek/ockovani-proti-papilomaviru"
              },
              {
                "type": "Vitamíny pro děti",
                "benefit": "Až 300 Kč na vitamíny pro děti",
                "description": "Přispíváme až 300 Kč pojištěncům do dovršení 18 let na vitamínový či multivitamínový doplněk stravy přiměřený věku žadatele a zakoupený v lékárně (přípravek musí obsahovat alespoň jeden vitamín). Příspěvek lze čerpat pouze na doplňky stravy, nikoli na registrovaná léčiva (léčivé přípravky). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.vozp.cz/prispevek/prispevek-na-vitaminy"
              },
              {
                "type": "Prevence zubního kazu u dětí\n",
                "benefit": "Až 300 Kč na prevenci zubů pro děti",
                "description": "Přispíváme až 300 Kč Pojištěncům od 6 do dovršení 14 let věku na pečetění fisur, tedy na ryze preventivní výkon spočívající v utěsnění štěrbin mezi hrbolky na kousacích ploškách postranních zubů. Příspěvek se nevztahuje na žádné jiné stomatologické výkony (na žádný druh výplně – plomby). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "tooth-flawed",
                "url": "https://www.vozp.cz/prispevek/prevence-zubniho-kazu-u-deti"
              },
              {
                "type": "Pohybové aktivity pro děti",
                "benefit": "Až 1000 Kč na pohybové aktivity pro děti",
                "description": "Přispíváme až 1 000 Kč pojištěncům do dovršení 18 let na pravidelné pohybové a sportovní aktivity. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.vozp.cz/prispevek/pohybove-aktivity-pro-deti"
              },
              {
                "type": "Plavání",
                "benefit": "Až 700 Kč na plavání",
                "description": "Přispíváme až 700 Kč všem pojištěncům na plavání ve formě: Permanentní vstupenky (vč. dobití čipu či karty), Plaveckého kurzu, Kurzu plavání rodičů s dětmi (příspěvek je v tomto případě určen pouze pro dítě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz .",
                "icon": "water",
                "url": "https://www.vozp.cz/prispevek/plavani"
              },
              {
                "type": "Sportovní a ozdravné pobyty",
                "benefit": "Až 1 000 Kč na sportovní či ozdravný pobyt pro děti",
                "description": "Přispíváme až 1 000 Kč pojištěncům od 4 do dovršení 18 let na sportovní či ozdravný pobyt (lyžařský kurz, sportovní soustředění, škola v přírodě) nebo letní sportovně pohybový pobyt. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.vozp.cz/prispevek/sportovni-a-ozdravne-pobyty"
              },
              {
                "type": "Sportovní přilba pro děti",
                "benefit": "Až 500 Kč na sportovní ochrannou přilbu ",
                "description": "Přispíváme až 500 Kč pojištěncům do dovršení 16 let na sportovní ochrannou přilbu (helmu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.vozp.cz/prispevek/sportovni-prilba-pro-deti"
              },
              {
                "type": "Sportovní prohlídka pro děti",
                "benefit": "Až 500 Kč na lékařskou sportovní prohlídku ",
                "description": "Přispíváme až 500 Kč pojištěncům do dovršení 18 let na lékařskou prohlídku nutnou k členství ve sportovní organizaci, kroužku nebo klubu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.vozp.cz/prispevek/sportovni-prohlidka-pro-deti"
              },
              {
                "type": "Vyšetření kožních znamének",
                "benefit": "Až 400 Kč na vyšetření kožních znamének",
                "description": "Přispíváme až 400 Kč všem pojištěncům na dermatoskopické vyšetření kožních znamének. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "dermatology",
                "url": "https://www.vozp.cz/prispevek/vysetreni-koznich-znamenek"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 400 Kč na odvykání kouření",
                "description": "Přispíváme až 400 Kč pojištěncům od 16 let věku na základě potvrzení o léčbě anebo o ukončení léčby vystaveného centrem pro odvykání kouření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.vozp.cz/prispevek/odvykani-koureni"
              },
              {
                "type": "Paruka při onkologické léčbě/alopecii\n",
                "benefit": "Až 1 000 Kč na paruku při chemoterapii a autoimunitní alopecii",
                "description": "Přispíváme až 1 000 Kč pojištěncům, kteří podstoupili nebo podstupují léčbu onkologického onemocnění, nebo pojištěncům s diagnózou autoimunitní alopecie. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/paruka-pri-chemoterapii"
              },
              {
                "type": "Prevence kolorektálního karcinomu",
                "benefit": "Až 300 Kč na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku",
                "description": "Přispíváme až 300 Kč všem pojištěncům na zakoupení samoodběrového testu k prevenci rakoviny tlustého střeva a konečníku nebo pojištěncům do 45 let na screeningové vyšetření k prevenci kolorektálního karcinomu provedené ve zdravotnickém zařízení (od 45. roku života je již vyšetření hrazeno z veřejného zdravotního pojištění). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.vozp.cz/prispevek/prevence-kolorektalniho-karcinomu"
              },
              {
                "type": "Podpora rozvoje dětí a prevence duševních poruch",
                "benefit": "Až 1 000 Kč na podporu rozvoje dětí a prevenci duševních poruch",
                "description": "Přispíváme až 1 000 Kč pojištěncům od 1 roku do dovršení 18 let na některou z níže vyjmenovaných forem podpory rozvoje dětí a prevence duševních poruch nehrazenou z veřejného zdravotního pojištění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "chat-unrelated",
                "url": "https://www.vozp.cz/prispevek/podpora-rozvoje-deti-a-prevence-dusevnich-poruch"
              },
              {
                "type": "Produkt Simple Steps",
                "benefit": "Až 800 Kč dětem od 1 roku do dovršení 16 let, u kterých byla diagnostikována porucha autistického spektra ",
                "description": "Přispíváme až 800 Kč dětem od 1 roku do dovršení 16 let, u kterých byla diagnostikována porucha autistického spektra (nebo bylo vysloveno podezření na tuto diagnózu), pro které bude zakoupena on-line výuková platforma Simple Steps pro terapii autismu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/produkt-simple-steps"
              },
              {
                "type": "Terénní poradenství pro děti v předškolním a školním zařízení",
                "benefit": "Až 500 Kč na terénní služby klinického psychologa, dětského psychiatra nebo klinického logopeda",
                "description": "Přispíváme až 500 Kč pojištěncům od 3 do dovršení 20 let na terénní služby klinického psychologa, dětského psychiatra nebo klinického logopeda plně hrazené pojištěncem, které jsou zprostředkovány pedagogicko-psychologickou poradnou, případně speciálně pedagogickým centrem. Jde o vyžádané návštěvy klinického psychologa, dětského psychiatra nebo klinického logopeda plně hrazené pojištěncem, které jsou poskytovány výlučně v místě předškolního nebo školního vzdělávání pojištěnce (terénní služby). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/terenni-poradenstvi-pro-deti"
              },
              {
                "type": "Poradenství pro rodiče dětí s duševní poruchou",
                "benefit": "Až 500 Kč na poradenské nebo konzultační služby u dětského psychiatra, klinického psychologa nebo klinického logopeda",
                "description": "Přispíváme až 500 Kč pojištěncům do dovršení 18 let na poradenské nebo konzultační služby nehrazené z veřejného zdravotního pojištění u dětského psychiatra, klinického psychologa nebo klinického logopeda ohledně dalšího postupu u léčených dětí (příspěvek není určen na samotnou terapii ani vyšetření dítěte, pouze na konzultace s rodičem/zákonným zástupcem o postupu léčby). Příspěvek lze poskytnout na jednu nebo více služeb, avšak v maximální souhrnné výši 500 Kč. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vozp.cz/prispevek/poradenstvi-pro-rodice-deti-s-dusevni-poruchou"
              }
            ]
          }
        ]
      },
      {
        "slug": "rbp",
        "updateDate": "29.1.2026",
        "companyBenefitsLink": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "29",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkování nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkování pro cestovatele). Nevztahuje se na desenzibilizaci („očkování proti alergii“). Z dokladů musí být patrné druh očkovací látky a datum aplikace očkovací látky. Pro čerpání příspěvku doložte doklad o platbě vakcíny a ofocený očkovací průkaz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Celiakie",
                "benefit": "Až 1 000 Kč na bezlepkovou dietu pro klienty s celiakií ",
                "description": "Přispíváme až 1 000 Kč na bezlepkovou dietu pro pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Nízkobílkovinná dieta",
                "benefit": "Až 1 000 Kč na nízkobílkovinnou dietu",
                "description": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "nutrition",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na paruky - Alopecie ",
                "benefit": "Až 1 000 Kč na paruku pro klienty s alopecií",
                "description": "Přispíváme až 1 000 Kč pro klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Diabetici ",
                "benefit": "Až 1 000 Kč pro klienty s diabetem ",
                "description": "Přispíváme až 1 000 Kč klientům s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích proužků pro zjištění glukózy v moči, glukometru, diagnostických proužků a příslušenství k inzulínové pumpě, nákupu senzoru pro neinvazivní okamžité měření glukózy v krvi, prostředky pro lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) provedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace profesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "stamp",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Kryokomora",
                "benefit": "Až 700 Kč na návštěvu kryokomory",
                "description": "Přispíváme až 700 Kč pojištěncům na návštěvu kryokomory pro posílení imunitního systému a regeneraci vašeho těla. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sauna",
                "benefit": "Až 700 Kč na saunu",
                "description": "Přispíváme až 700 Kč na saunování v obdobích leden - duben a září - prosinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Uživatelé MY213",
                "benefit": "Až 700 Kč pro pojištěnce, kteří aktivně využívají aplikaci my213",
                "description": "Přispíváme až 700 Kč pro naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prostřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření nebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek pro registrované sportovce",
                "benefit": "Až 500 Kč pro registrované sportovce",
                "description": "Přispíváme až 500 Kč na sportovní prohlídku nebo registrační a členské poplatky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na speciální vyšetření",
                "benefit": "Až 500 Kč na speciální vyšetření",
                "description": "Přispíváme až 500 Kč na speciální vyšetření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 500 Kč na odvykání kouření",
                "description": "Přispíváme až 500 Kč na nákup volně prodejných léčivých a podpůrných přípravků, zakoupených v lékárně: náplastí, pastilek, ústního spreje, žvýkaček apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Přípravky na prostatu",
                "benefit": "Až 500 Kč na přípravky na prostatu",
                "description": "Přispíváme až 500 Kč mužům nad 45 let na nákup vybraných léčivých přípravků v lékárně při nezhoubnému zbytnění prostaty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "prostate",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Otec u porodu",
                "benefit": "Až 500 Kč pro otce u porodu",
                "description": "Přispíváme až 500 Kč na úhradu úkonů nebo služeb, které podporují psychickou pohodu matky během porodu a pobytu v porodnici, např. instruktáž otce u porodu, úhrada nadstandardního pokoje pro otce s matkou atd. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Bonus 90+",
                "benefit": "Až 1 500 Kč pro věrné pojištěnce 90+",
                "description": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na paruku pro onkologické pacienty",
                "benefit": "Až 3 000 Kč na paruku",
                "description": "Přispíváme až 3 000 Kč na paruky pro pojištěnce muže, kteří podstupují (podstoupili) v rámci onkologického onemocnění léčbu chemoterapií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Komplexní onkologická preventivní prohlídka",
                "benefit": "Až 4 000 Kč na komplexní onkologickou preventivní prohlídku",
                "description": "Přispíváme až 4 000 Kč na komplexní onkologickou preventivní prohlídku absolvovanou v některém z Komplexních onkologických center. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Geny213",
                "benefit": "Až 4 000 Kč na plánované těhotenství partnerky",
                "description": "Přispíváme až 4 000 Kč na úhradu vyšetření nejčastějších mutací v 5 genech (cystická fibróza, spinální muskulární atrofie, vrozená hluchota, fenylketonurie, syndrom lomivého-fragilního X chromozomu) pro klienty, kteří plánují rodičovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Psychohygiena-Mojra\n\n",
                "benefit": "Až 5 000 Kč na on-line psychologickou pomoc",
                "description": "Přispíváme až 5 000 Kč pojištěncům na online psychologickou pomoc psychologů a psychoterapeutů a je poskytován v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Duševní pohoda",
                "benefit": "Až 5 000 Kč na duševní pohodu",
                "description": "Přispíváme až 5 000 Kč pojištěncům na odbornou terapeutickou pomoc v náročných životních situacích (stres, trauma, konflikty). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Dárci krve a kostní dřeně",
                "benefit": "Až 6 500 Kč dárcům krve a kostní dřeně",
                "description": "Chcete pomáhat a zachraňovat život? Nebo tak již činíte a patříte mezi dárce krve a kostní dřeně? I vy můžete získat bonusové příspěvky za bezplatné dárcovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Lázeňský pobyt pro chronicky nemocné ",
                "benefit": "Až 10 000 Kč na lázeňský pobyt pro chronicky nemocné ",
                "description": "Přispíváme až 10 000 Kč na lázeňský pobyt, který je určen pro chronicky nemocné (pojištěnci s DM 1. typu, DM 2. typu nebo hypertenzí a současně s BMI nad 30), kteří v době podání žádosti dosáhnou věku minimálně 19 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sleva na cestovní pojištění",
                "benefit": "Až 30 % sleva na cestovní pojištění",
                "description": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "globus",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Plavání v bazénech zdarma nebo se slevou ",
                "benefit": "Vstup do vybraných plaveckých bazénů budete mít zdarma nebo za výhodnější cenu.",
                "description": "Vstup do vybraných bazénů po celé ČR budete mít zdarma nebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "water",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na implantát (věk 60+)",
                "benefit": "Až 1 000 Kč na úhradu implantátu",
                "description": "Přispíváme až 1 000 Kč na úhradu implantátu (nelze uplatnit na zubní náhrady, korunky atd.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Hezký úsměv (věk 60+)",
                "benefit": "Až 1 000 Kč na nákup fixačních a čisticích prostředků pro celkové zubní náhrady ",
                "description": "Přispíváme až 1 000 Kč na nákup fixačních a čisticích prostředků pro celkové zubní náhrady v lékárnách a úhradu doplatků na celkové zubní náhrady i jejich opravy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Dentální hygiena (věk 60+)",
                "benefit": "Až 700 Kč na dentální hygienu",
                "description": "Přispíváme až 700 Kč na dentální hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Lepší paměť (věk 60+)",
                "benefit": "Až 500 Kč na prevenci poruch duševního zdraví",
                "description": "Přispíváme až 500 Kč na prevenci poruch duševního zdraví (kurzy tréninku paměti, pomůcky pro trénink paměti doporučené Českou alzheimerovskou společností. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Permanentka na pohybové aktivity",
                "benefit": "Až 500 Kč permanentka na pohybové aktivity",
                "description": "Přispíváme až 500 Kč na permanentku na pohybové aktivity - příspěvek ve výši 50 % z ceny permanentky na plavání v krytých bazénech a fitness tj. spinning, posilovna, aktivní posilovací stroje, jóga, aerobik. Nehradí se solária, masáže, všechny typy tance, judo, karate, kick-box, jednodenní permanentky, permanentky na lyžování apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "muscle",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Léčivé přípravky (věk 60+)",
                "benefit": "Až 500 Kč na nákup kloubní výživy a vybraných léčivých přípravků při nezhoubném zbytnění prostaty",
                "description": "Přispíváme až 500 Kč na nákup kloubní výživy, vitamínů a léčivých přípravků při nezhoubném zbytnění prostaty v lékárnách. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pills",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "32",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkování nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkování pro cestovatele). Nevztahuje se na desenzibilizaci („očkování proti alergii“). Z dokladů musí být patrné druh očkovací látky a datum aplikace očkovací látky. Pro čerpání příspěvku doložte doklad o platbě vakcíny a ofocený očkovací průkaz. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Celiakie",
                "benefit": "Až 1 000 Kč na bezlepkovou dietu pro klienty s celiakií ",
                "description": "Přispíváme až 1 000 Kč na bezlepkovou dietu pro pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Nízkobílkovinná dieta",
                "benefit": "Až 1 000 Kč na nízkobílkovinnou dietu",
                "description": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "nutrition",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na paruky - Alopecie ",
                "benefit": "Až 1 000 Kč na paruku pro klienty s alopecií",
                "description": "Přispíváme až 1 000 Kč pro klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Diabetici ",
                "benefit": "Až 1 000 Kč pro klienty s diabetem ",
                "description": "Přispíváme až 1 000 Kč klientům s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích proužků pro zjištění glukózy v moči, glukometru, diagnostických proužků a příslušenství k inzulínové pumpě, nákupu senzoru pro neinvazivní okamžité měření glukózy v krvi, prostředky pro lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) provedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace profesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "stamp",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Kryokomora",
                "benefit": "Až 700 Kč na návštěvu kryokomory",
                "description": "Přispíváme až 700 Kč pojištěncům na návštěvu kryokomory pro posílení imunitního systému a regeneraci vašeho těla. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sauna",
                "benefit": "Až 700 Kč na saunu",
                "description": "Přispíváme až 700 Kč na saunování v obdobích leden - duben a září - prosinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Uživatelé MY213",
                "benefit": "Až 700 Kč pro pojištěnce, kteří aktivně využívají aplikaci my213",
                "description": "Přispíváme až 700 Kč pro naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prostřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření nebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek pro registrované sportovce",
                "benefit": "Až 500 Kč pro registrované sportovce",
                "description": "Přispíváme až 500 Kč na sportovní prohlídku nebo registrační a členské poplatky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "sport",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na speciální vyšetření",
                "benefit": "Až 500 Kč na speciální vyšetření",
                "description": "Přispíváme až 500 Kč na speciální vyšetření. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 500 Kč na odvykání kouření",
                "description": "Přispíváme až 500 Kč na nákup volně prodejných léčivých a podpůrných přípravků, zakoupených v lékárně: náplastí, pastilek, ústního spreje, žvýkaček apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "smoke",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Osteoporóza a menopauza",
                "benefit": "Až 500 Kč na přípravky na osteoporózu a menopauzu",
                "description": "Přispíváme až 500 Kč ženám nad 40 let na nákup vybraných hormonálních přípravků a nehormonálních přípravků na prevenci osteoporózy a negativních menopauzálních stavů, a to zakoupených pouze v lékárně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "pill",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Po porodu",
                "benefit": "Až 1 000 Kč na pomůcky po porodu",
                "description": "Přispíváme až 1 000 Kč na nákup pomůcek ke kojení do 1 roku po porodu (zakoupených v lékárně nebo speciální prodejně s kojícími potřebami lze uplatnit na nákup absorpční prsní vložky a speciální podprsenky včetně vložek do nich, chrániče a formovače bradavek, kojící kloboučky a polštářky, odsávačky mateřského mléka, nádoby na uchování mateřského mléka, ohřívačky a sterilizátory). Nákup hygienických vložek s obsahem nanostříbra. Cvičení pro ženy do 6 měsíců po porodu. Tento bonus mohou získat i ženy mladší 18 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Pro těhotné",
                "benefit": "Až 1 000 Kč pro těhotné",
                "description": "Přispíváme až 1 000 Kč na kurz psychoprofylaxe a těhotenského tělocviku, tj. přípravy ženy k porodu, na nákup vitamínů v lékárnách v době těhotenství, a další. Příspěvek mohou získat i ženy mladší 18 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "pregnant",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Pro vícerčata",
                "benefit": "Až 1213 Kč pro vícerčata",
                "description": "Přispíváme až 1 213 Kč maminkám vícerčat. Čerpát můžete pro každé dítě na kterýkoli preventivních programů/finančních příspěvků určených pro děti a mládež do 18 let. Bonus získáte kdykoli od narození vícerčat do jejich 18 roku věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Bonus 90+",
                "benefit": "Až 1 500 Kč pro věrné pojištěnce 90+",
                "description": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na paruku pro onkologické pacienty",
                "benefit": "Až 3 000 Kč na paruku",
                "description": "Přispíváme až 3 000 Kč na paruky pro pojištěnce muže, kteří podstupují (podstoupili) v rámci onkologického onemocnění léčbu chemoterapií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Komplexní onkologická preventivní prohlídka",
                "benefit": "Až 4 000 Kč na komplexní onkologickou preventivní prohlídku",
                "description": "Přispíváme až 4 000 Kč na komplexní onkologickou preventivní prohlídku absolvovanou v některém z Komplexních onkologických center. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Geny213 ",
                "benefit": "Až 4 000 Kč na plánované těhotenství ",
                "description": "Přispíváme až 4 000 Kč na úhradu vyšetření nejčastějších mutací v 5 genech (cystická fibróza, spinální muskulární atrofie, vrozená hluchota, fenylketonurie, syndrom lomivého-fragilního X chromozomu) pro klienty, kteří plánují rodičovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Očkování proti HPV ",
                "benefit": "Až 4 000 Kč na očkování proti HPV",
                "description": "Přispíváme až 4 000 Kč ženám do 30 let věku na očkování proti lidskému papilomaviru (prevence proti rakovině děložního čípku, genitálním bradavicím a análnímu karcinomu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Psychohygiena-Mojra\n\n",
                "benefit": "Až 5 000 Kč na on-line psychologickou pomoc",
                "description": "Přispíváme až 5 000 Kč pojištěncům na online psychologickou pomoc psychologů a psychoterapeutů a je poskytován v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Duševní pohoda",
                "benefit": "Až 5 000 Kč na duševní pohodu",
                "description": "Přispíváme až 5 000 Kč pojištěncům na odbornou terapeutickou pomoc v náročných životních situacích (stres, trauma, konflikty). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Dárci krve a kostní dřeně",
                "benefit": "Až 6 500 Kč dárcům krve a kostní dřeně",
                "description": "Chcete pomáhat a zachraňovat život? Nebo tak již činíte a patříte mezi dárce krve a kostní dřeně? I vy můžete získat bonusové příspěvky za bezplatné dárcovství. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Lázeňský pobyt pro chronicky nemocné ",
                "benefit": "Až 10 000 Kč na lázeňský pobyt pro chronicky nemocné ",
                "description": "Přispíváme až 10 000 Kč na lázeňský pobyt, který je určen pro chronicky nemocné (pojištěnci s DM 1. typu, DM 2. typu nebo hypertenzí a současně s BMI nad 30), kteří v době podání žádosti dosáhnou věku minimálně 19 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sleva na cestovní pojištění",
                "benefit": "Až 30 % sleva na cestovní pojištění",
                "description": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "globus",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Plavání v bazénech zdarma nebo se slevou ",
                "benefit": "Vstup do vybraných plaveckých bazénů budete mít zdarma nebo za výhodnější cenu.",
                "description": "Vstup do vybraných bazénů po celé ČR budete mít zdarma nebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "water",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na implantát (věk 60+)",
                "benefit": "Až 1 000 Kč na úhradu implantátu",
                "description": "Přispíváme až 1 000 Kč na úhradu implantátu (nelze uplatnit na zubní náhrady, korunky atd.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Hezký úsměv (věk 60+)",
                "benefit": "Až 1 000 Kč na nákup fixačních a čisticích prostředků pro celkové zubní náhrady ",
                "description": "Přispíváme až 1 000 Kč na nákup fixačních a čisticích prostředků pro celkové zubní náhrady v lékárnách a úhradu doplatků na celkové zubní náhrady i jejich opravy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Dentální hygiena (věk 60+)",
                "benefit": "Až 700 Kč na dentální hygienu",
                "description": "Přispíváme až 700 Kč na dentální hygienu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brush",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Lepší paměť (věk 60+)",
                "benefit": "Až 500 Kč na prevenci poruch duševního zdraví",
                "description": "Přispíváme až 500 Kč na prevenci poruch duševního zdraví (kurzy tréninku paměti, pomůcky pro trénink paměti doporučené Českou alzheimerovskou společností. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Permanentka na pohybové aktivity",
                "benefit": "Až 500 Kč permanentka na pohybové aktivity",
                "description": "Přispíváme až 500 Kč na permanentku na pohybové aktivity - příspěvek ve výši 50 % z ceny permanentky na plavání v krytých bazénech a fitness tj. spinning, posilovna, aktivní posilovací stroje, jóga, aerobik. Nehradí se solária, masáže, všechny typy tance, judo, karate, kick-box, jednodenní permanentky, permanentky na lyžování apod. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "muscle",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Léčivé přípravky (věk 60+)",
                "benefit": "Až 500 Kč na nákup kloubní výživy a vybraných léčivých přípravků při nezhoubném zbytnění prostaty",
                "description": "Přispíváme až 500 Kč na nákup kloubní výživy, vitamínů a léčivých přípravků při nezhoubném zbytnění prostaty v lékárnách. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pills",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "30",
            "benefits": [
              {
                "type": "Školka a škola v přírodě",
                "benefit": "Až 1000 Kč na školky a školy v přírodě",
                "description": "Přispíváme až 1 000 Kč dětem, které absolvují školku a školu až do ukončení povinné školní docházky. Na pobyty organizované školkou a školou mimo letní prázdniny, trvající minimálně 5 dní s noclehem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Dentální hygiena",
                "benefit": "Až 1 000 Kč na dentální hygienu",
                "description": "Přispíváme až 1 000 Kč dětem na provedení dentální hygieny a nelze uplatnit na nákup prostředků dentální hygieny (např. zubní a mezizubní kartáčky nebo dentální nitě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Přispíváme až 1 000 Kč na kterékoliv preventivní očkování nehrazené z veřejného zdravotního pojištění (např. břišní tyfus, pásový opar, chřipka, klíšťová encefalitida, pneumokokové nákazy, spalničky, vzteklina, meningitida, žloutenka, neštovice atd. včetně očkování pro cestovatele). Nevztahuje se na desenzibilizaci („očkování proti alergii“). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Celiakie",
                "benefit": "Až 1 000 Kč na bezlepkovou dietu pro klienty s celiakií ",
                "description": "Přispíváme až 1 000 Kč na bezlepkovou dietu pro pojištěnce s celiakií. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Nízkobílkovinná dieta",
                "benefit": "Až 1 000 Kč na nízkobílkovinnou dietu",
                "description": "Příspíváme až 1 000 Kč na nízkobílkovinnou dietu (fenylketonurie, nemoc javorového sirupu, homocystinurie, isovalerova acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1, poruchy cyklu močoviny). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "nutrition",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příspěvek na paruky - Alopecie ",
                "benefit": "Až 1 000 Kč na paruku pro klienty s alopecií",
                "description": "Přispíváme až 1 000 Kč pro klienty s alopecií na nákup paruky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Rovnátka",
                "benefit": "Až 1 000 Kč na rovnátka",
                "description": "Přispíváme až 1 000 Kč na zhotovení fixních nebo snímatelných aparátků včetně průběžných úprav a oprav. Příspěvek lze využít jen na výkony, které nejsou hrazeny z veřejného zdravotního pojištění a jsou v souladu se stanoveným léčebným plánem. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "braces",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Diabetici ",
                "benefit": "Až 1 000 Kč pro děti s diabetem ",
                "description": "Přispíváme až 1 000 Kč dětem s diabetem na nákup permanentky na pohybové aktivity (50 % z ceny), testovacích proužků pro zjištění glukózy v moči, glukometru, diagnostických proužků a příslušenství k inzulínové pumpě, nákupu senzoru pro neinvazivní okamžité měření glukózy v krvi, prostředky pro lepší fixaci senzorů (tejpy, samodržící obinadla) a na podiatrické ošetření (přístrojová pedikúra) provedené u poskytovatelů uvedených na stránkách České podiatrické společnosti, České podologické společnosti a Asociace profesionálních pedikérů a pedikérek. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "stamp",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Uživatelé MY213",
                "benefit": "Až 1 000 Kč pro pojištěnce, kteří aktivně využívají aplikaci my213",
                "description": "Přispíváme až 1 000 Kč pro naše pojištěnce, kteří aktivně využívají aplikaci my213 a žádost o úhradu preventivní péče z balíčku „Uživatelé my213“ podali výhradně jejím prostřednictvím nabízíme: permanentka na pohybové aktivity, diagnostické vyšetření nebo ošetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sauna",
                "benefit": "Až 700 Kč na saunování pro děti od 3 let",
                "description": "Přispíváme až 700 Kč a saunování pro děti od 3 let v obdobích leden - duben a září - prosinec. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Kurz plavání",
                "benefit": "Až 500 Kč na plavání",
                "description": "Přispíváme až 500 Kč na kurz plavání organizovaný školou nebo školkou pro všechny děti až do ukončení povinné školní docházky. Organizovaný kurz plavání pro děti do tří let věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "water",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Registrovaní sportovci",
                "benefit": "Až 500 Kč pro registrované sportovce",
                "description": "Příspíváme až 500 Kč na pravidelnou sportovní prohlídku nebo registrační a členské poplatky. Preferuje se registrace sportovce u sportovního svazu. Příspěvek lze poskytnout dětem od 3 let věku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "register",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Obezita",
                "benefit": "Až 500 Kč proti obezitě",
                "description": "Přispíváme až 500 Kč na aktivity v programu STOB. Konzultace snižování nadváhy a obezity u obezitologa, dietologa a nutričního terapeuta (ne výživový poradce). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Speciální vyšetření",
                "benefit": "Až 500 Kč na speciální vyšetření",
                "description": "Přispíváme až 500 Kč na vyšetření pigmentových změn kůže. Lze uplatnit jednou za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "doctor",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Trombóza",
                "benefit": "Až 500 na vyšetření rizika vzniku trombózy",
                "description": "Přispíváme až 500 Kč na genetické vyšetření rizika vzniku trombózy ke zjištění mutace v genech. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "care",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Odlehčená sádrá",
                "benefit": "Až 1 000 Kč na úhradu odlehčené a lehké sádry",
                "description": "Přispíváme až 1 000 Kč na odlehčené a lehké sádry z plastů, pryskyřic a karbonových vláken. Nevztahuje se na fixační ortézy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "osteoporosis",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Bonus 90+",
                "benefit": "Až 1 500 Kč pro věrné pojištěnce 90+",
                "description": "Pokud věnujete svému zdraví náležitou péči a jste věrnými pojištěnci RBP, dokážeme to ocenit. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Letní prázdninový pobyt",
                "benefit": "Až 1 500 Kč na letní prázdninový pobyt",
                "description": "Přispíváme až 1 500 Kč dětem od 3 let až do ukončení základní školní docházky přispějeme na letní prázdninový tábor na území ČR nebo SR. Pro rok 2026 lze uplatnit příspěvek na prázdninový pobyt konaný v období od 1. 7. do 31. 8. 2026. Musí trvat minimálně 7 dní a být organizován školkou, školou, sportovní nebo zájmovou organizací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Příměstský sportovní tábor",
                "benefit": "Až 1500 Kč na příměstský sportovní tábor",
                "description": "Přispíváme až 1 500 Kč dětem od 3 let až do ukončení základní školní docházky přispějeme na letní příměstský sportovně pohybový tábor. Pro rok 2026 lze uplatnit příspěvek na tábor konaný v období od 1. 7. do 31. 8. 2026 Musí trvat minimálně 5 po sobě jdoucích dnů a být organizován školkou, školou, sportovní nebo zájmovou organizací. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Miminka do jednoho roku",
                "benefit": "Až 2 000 Kč pro miminka do jednoho roku",
                "description": "Příspíváme až 2 000 Kč na nákup monitoru dechu pro děti do 6 měsíců věku (lze využít i na pronájem), pomůcek a potřeb určených pro vlastní potřebu miminka zakoupených v lékárnách - kojenecká mléka (nákup možný i u výrobce), dětské pleny, vlhčené ubrousky, probiotika, kapky proti nadýmání, krémy proti opruzeninám, pudry, vitamín D dle Seznamu přípravků do 1 roku věku, chůviček a kojeneckých potřeb - odsávačky hlenů a sterilizátor lahví. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Pro onkologické pacienty",
                "benefit": "Až 3 000 Kč pro onkologické pacienty",
                "description": "Přispíváme až 3 000 Kč na paruky pro děti a mládež, kteří podstupují (podstoupili) léčbu chemoterapií, příspěvek na mammární epitézu pro dívky po operačním odstranění prsu z důvodu nádorového onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Očkování proti HPV",
                "benefit": "Až 4 000 Kč na očkování proti HPV",
                "description": "Přispíváme až 4 000 Kč dívkám od 15 let (prevence proti rakovině děložního čípku, genitálním bradavicím a análnímu karcinomu) a pro chlapce od 15 let (prevence proti genitálním bradavicím a análnímu karcinomu). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
                "icon": "vaccine",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Psychohygiena-Mojra",
                "benefit": "Až 5 000 Kč na on-line psychologickou pomoc",
                "description": "Přispíváme až 5 000 Kč pojištěncům od 7 let na online psychologickou pomoc psychologů a psychoterapeutů a je poskytován v maximální výši 5 000 Kč/rok. Konzultace jsou pojištěncům nabízeny v 30 min. intervalech v objednaném počtu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Duševní pohoda",
                "benefit": "Až 5 000 Kč na duševní pohodu",
                "description": "Přispíváme až 5 000 Kč pojištěncům od 7 let na odbornou terapeutickou pomoc ve svízelných životních situacích po prožitém stresu, traumatu a nevyřešených konfliktech, které komplikují kvalitu života, mezilidské vztahy a harmonické soužití každého z nás, absolvovanou u klinického psychologa (odbornost 901), kterého je možné si ověřit v registru poskytovatelů zdravotních služeb zde nebo terapeuta, který je členem ČAP. U ostatních neuvedených specialistů - psychoterapeutů bude vyžadováno prokázání absolvování psychoterapeutického výcviku a nárok na příspěvek bude posuzován individuálně. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Lázeňský ozdravný pobyt",
                "benefit": "Až 10 000 Kč na lázeňský ozdravný pobyt",
                "description": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s onemocněním horních cest dýchacích, alergiemi a dermatózami. Jde o příspěvek na 14 denní ozdravný lázeňský pobyt. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Přímořský ozdravný pobyt",
                "benefit": "Až 10 000 Kč na přímořský ozdravný pobyt",
                "description": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s opakujícím se onemocněním horních cest dýchacích, alergiemi a dermatózami. Jde o příspěvek na 15 denní ozdravný přímořský pobyt ve výši maximálně 10 000 Kč. Pobyt může být individuální s cestovní kanceláří nebo organizovaný, např. letní tábor, případně individuální v doprovodu rodičů či blízké rodiny. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Vysokohorský ozdravný pobyt",
                "benefit": "Až 10 000 Kč na vysokohorský ozdravný pobyt",
                "description": "Přispíváme až 10 000 Kč dětem ve věku 6 až 15 let s opakujícími se recidivujícími onemocněními horních cest dýchacích a alergiemi. Pobyty jsou primárně určeny pro děti trpící dýchacím onemocněním. Pobyt může být individuální s cestovní kanceláří, nebo organizovaný, např. letní tábor, případně individuální v doprovodu rodičů či blízké osoby. Jde o příspěvek na 14 denní. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz",
                "icon": "payment",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Novorozenecký balíček",
                "benefit": "Drobnosti pro maminku a dítě ",
                "description": "Drobnosti pro maminku a dítě obdrží rodič jako pozornost při doložení dokladu novorozence na pobočce. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Sleva na cestovní pojištění",
                "benefit": "Až 30 % sleva na cestovní pojištění",
                "description": "Pojistěte se na cesty se slevou až 30 %. Cestovní pojištění léčebných výloh v zahraničí s limitem plnění do 100 milionů Kč sjednáte online. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "globus",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              },
              {
                "type": "Plavání v bazénech zdarma nebo se slevou ",
                "benefit": "Vstup do vybraných plaveckých bazénů budete mít zdarma nebo za výhodnější cenu",
                "description": "Vstup do vybraných bazénů po celé ČR budete mít zdarma nebo se slevou 50%. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "water",
                "url": "https://www.rbp213.cz/preventivni-a-bonusovy-program/a-5357/?tab=3"
              }
            ]
          }
        ]
      },
      {
        "slug": "skoda",
        "updateDate": "30.1.2026",
        "companyBenefitsLink": "https://www.zpskoda.cz/zdravotni-programy-2023",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "26",
            "benefits": [
              {
                "type": "Dentální hygienu",
                "benefit": "Až 700 Kč na dentální hygienu",
                "description": "Přispíváme až 700 Kč na úhradu provedených výkonů dentální hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth-flawed",
                "url": "https://www.zpskoda.cz/pece-o-chrup"
              },
              {
                "type": "Příspěvek SPORT",
                "benefit": "Až 700 Kč na pohybové aktivity",
                "description": "Přispíváme až 700 Kč na pravidelnou sportovní aktivitu včetně plavání a saunování, vyjma FBfit Mladá Boleslav, online kurzů, členských příspěvků a pronájmů sportovišť a aktivit hrazených MultiSport kartou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 1 000 Kč na odvykání kouření",
                "description": "Přispíváme až 2 x 500 Kč za rok, vždy po ukončení léčby, která probíhá min. 3 měsíce pouze na pracovištích, jejichž seznam naleznete na www.slzt.cz pod Centry pro závislé na tabáku; příspěvek lze proplatit po předložení zprávy o výsledku léčby a prokazatelného dokladu o zaplacení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.zpskoda.cz/odvykani-koureni"
              },
              {
                "type": "Moderní diagnostické a léčebné metody",
                "benefit": "Až 2 000 Kč na různé diagnostické a léčebné metody",
                "description": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/mdlm"
              },
              {
                "type": "Podpora péče duševního zdraví",
                "benefit": "Až 4 000 Kč na péči o duševní zdraví",
                "description": "Přispíváme až 4 000 Kč na absolvování psychologického nebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pro psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpskoda.cz/dusevni-zdravi"
              },
              {
                "type": "Podpora nutričního poradenství",
                "benefit": "Až 2 000 Kč příspěvek na sestavení jídelníčku ",
                "description": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 nebo pod 18,5, příspěvek na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem nebo výživovým poradcem s platným osvědčením o profesní kvalifikaci (možno využít i na program \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "cabbage",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
                "benefit": "Až 12 000 Kč na nízkobílkovinnou dietu",
                "description": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, nebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Celiakie",
                "benefit": "Až 5 000 Kč na bezlepkovou dietu",
                "description": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Korekční laserové operace",
                "benefit": "Až 4 000 Kč na laserovou operaci očí",
                "description": "Přispíváme až 4 000 Kč na laserovou operaci očí. 1x za rok. 2 000 Kč na každé oko. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Vyšetření přístrojem OCT",
                "benefit": "Až 800 Kč na vyšetření očí přístrojem OCT",
                "description": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Nitrooční operace",
                "benefit": "Až 2 000 Kč na operaci očí",
                "description": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s prodlouženým ohniskem, čočky pro korekci astigmatismu nebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Plastová sádra",
                "benefit": "Až 300 Kč na plastovou sádru",
                "description": "Přispíváme až 300 Kč na plastovou sádru. Příspěvek lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Příspěvek SPORT Senior",
                "benefit": "Až 700 Kč na pohybové aktivity, pomůcky pro prevenci úrazů při sportu aj.",
                "description": "Přispíváme až 700 Kč seniorům nad 65 let na pohybové aktivity včetně plavání a saunování, přístrojovou pedikúru pro diabetiky, pomůcky pro prevenci úrazů při sportu, hole Nordic Walking, na specifické pomůcky pro trénování paměti a prevenci rozvoje Alzheimerovy choroby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Očkování proti pásovému oparu",
                "benefit": "Až 4 000 Kč na očkování protí pásovému oparu",
                "description": "Příspíváme až 4 000 Kč na očkování proti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Balíček ostatních očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Příspíváme až 1 000 Kč na různá očkování, které nejsou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Meningokok",
                "benefit": "Až 3 600 Kč na očkování proti meningokoku",
                "description": "Přispíváme až 3 600 Kč na očkování proti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Hepatitida",
                "benefit": "Až 2 400 Kč na očkování",
                "description": "Přispíváme až 2 400 Kč na očkování proti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Klíšťová encefalitida",
                "benefit": "Až 2 100 Kč na očkování",
                "description": "Přispíváme až 2 100 Kč na očkování proti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Chřipka",
                "benefit": "Až 400 Kč na očkování",
                "description": "Přispíváme až 400 Kč na očkování proti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Prevence onemocnění štítné žlázy",
                "benefit": "Příspěvek 1x za rok",
                "description": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz. ",
                "icon": "shield-exclamation-marks",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Program pro zjišťování nádorů v oblasti dutiny břišní a ledvin",
                "benefit": "Příspěvek 1x za rok",
                "description": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, program je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Prevence karcinomu tlustého střeva a konečníku",
                "benefit": "Příspěvek 1x za rok",
                "description": "Přispíváme 1x za rok pojištěncům (od 35 do 45 let), na které se nevztahuje vyšetření na okultní krvácení v rámci preventivní prohlídky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Příspěvek pro onkologicky nemocné nebo jinak závažně nemocné",
                "benefit": "Až 4 000 Kč na paruku, nebo chladící čepici po chemoterapii ",
                "description": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (nebo pro jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, nebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Cestovní pojištění ZDARMA",
                "benefit": "Cestovní pojištění ZDARMA pro dárce krve s odběrem za posledních 12 měsíců",
                "description": "Cestovní pojištění pro dárce krve od našeho partnera VITALITAS pojišťovny a. s. platí na léčebné výlohy, celý svět a na 30 dnů. Podmínkou je kopie průkazu dárce krve s odběrem za posledních 12 měsíců. ",
                "icon": "briefcase",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              },
              {
                "type": "Ozdravný pobyt v ČR pro dárce kostní dřeně a dárce orgánů ",
                "benefit": "Až 10 000 Kč na ozdravný pobyt v některém ze smluvních lázeňských zařízení",
                "description": "Přispíváme až 10 000 Kč na ozdravný pobyt dárcům kostní dřeně a dárce životně důležitých orgánů k transplantaci v některém ze smluvních lázeňských zařízení dle výběru a po domluvě s referentem lázeňské péče. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              },
              {
                "type": "Pro dárce",
                "benefit": "Odměna až 5 000 Kč pro ty, kteří jsou solidární ke zdraví ostatních",
                "description": "Přispíváme až 5 000 Kč dárcům krve, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "36",
            "benefits": [
              {
                "type": "Dentální hygienu",
                "benefit": "Až 700 Kč na dentální hygienu",
                "description": "Přispíváme až 700 Kč na úhradu provedených výkonů dentální hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.) Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth-flawed",
                "url": "https://www.zpskoda.cz/pece-o-chrup"
              },
              {
                "type": "Podrobné morfologické vyšetření plodu",
                "benefit": "Až 1 000 Kč na vyšetření plodu ve 20. - 22. týdnu gravidity ",
                "description": "Přispíváme až 1 000 Kč na vyšetření plodu ve 20. - 22. týdnu gravidity - bez doporučení gynekologa. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Novorozenecký balíček",
                "benefit": "Novorozenecký balíček v hodnotě 2 500 Kč ",
                "description": "Krásný batůžek pro holčičky a kluky naplněný produkty od firmy SKIP HOP (lahvička se silikonovým brčkem, kalíšek na sušenky) a k tomu digitální teploměr Thermoval Baby, to vše v hodnotě 2 500 Kč. Na požádání také zdarma roční úrazové pojištění pro novorozence z programu Zvonek našeho partnera VITALITAS pojišťovna a. s. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Příspěvek po porodu",
                "benefit": "Až 1 600 Kč po porodu",
                "description": "Příspěvek až 1 600 Kč pro pobyt v porodnici na nadstandardním pokoji, autosedačku, přítomnost blízké osoby u porodu, laktační poradenství a pomůcky (kojící a absorpční podprsenky, kojící polštář..), pleny, vlhčené ubrousky, kojenecké plavání, monitor dechu. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Příspěvek v době těhotenství",
                "benefit": "Až 500 Kč na pohybové aktivity, různé produkty, masáže, vitamíny, předporodní kurzy a další ",
                "description": "Přispíváme až 500 Kč ttěhotným ženám na pohybové aktivity, vitamínové prostředky, doplňky stravy, prostředky proti striím, masáže, prostředky dentální hygieny, na ošetření provedené dentální hygienistkou, sluneční brýle s UV filtrem, ortopedickou obuv a vložky zakoupené v lékárně nebo prodejně zdrav. potřeb, opalovací krémy s UV filtrem, předporodní kurzy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Vyšetření štítné žlázy",
                "benefit": "Zcela hrazeno poskytovatelem zdravotních služeb",
                "description": "Příspěvek je určen těhotným ženám na vyšetření štítné žlázy a je zcela hrazen poskytovatelem zdravotních služeb. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Neinvazivní prenatální testování",
                "benefit": "Až 4 000 Kč na neinvazivní prenatální testování\n",
                "description": "Příspěvek je určen na testování (NIPT) v indikovaných případech, po doporučení gynekologa a genetika. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Prvotrimestrální screening",
                "benefit": "Až 1 200 Kč na prvotrimestrální screening ",
                "description": "Přispíváme až 1 200 Kč na prvotrimestrální screening – bez doporučení gynekologa, na specializovaném akreditovaném pracovišti. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.zpskoda.cz/maminky-deti"
              },
              {
                "type": "Podpora péče duševního zdraví",
                "benefit": "Až 4 000 Kč na péči o duševní zdraví",
                "description": "Přispíváme až 4 000 Kč na absolvování psychologického nebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pro psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpskoda.cz/dusevni-zdravi"
              },
              {
                "type": "Moderní diagnostické a léčebné metody",
                "benefit": "Až 2 000 Kč na různé diagnostické a léčebné metody",
                "description": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/mdlm"
              },
              {
                "type": "Odvykání kouření",
                "benefit": "Až 1 000 Kč na odvykání kouření",
                "description": "Přispíváme až 2 x 500 Kč za rok, vždy po ukončení léčby, která probíhá min. 3 měsíce pouze na pracovištích, jejichž seznam naleznete na www.slzt.cz pod Centry pro závislé na tabáku; příspěvek lze proplatit po předložení zprávy o výsledku léčby a prokazatelného dokladu o zaplacení. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "smoke",
                "url": "https://www.zpskoda.cz/odvykani-koureni"
              },
              {
                "type": "Korekční laserové operace",
                "benefit": "Až 4 000 Kč na laserovou operaci očí",
                "description": "Přispíváme až 4 000 Kč na laserovou operaci očí. 1x za rok. 2 000 Kč na každé oko. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Vyšetření přístrojem OCT",
                "benefit": "Až 800 Kč na vyšetření očí přístrojem OCT",
                "description": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Nitrooční operace",
                "benefit": "Až 2 000 Kč na operaci očí",
                "description": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s prodlouženým ohniskem, čočky pro korekci astigmatismu nebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Plastová sádra",
                "benefit": "Až 300 Kč na plastovou sádru",
                "description": "Přispíváme až 300 Kč na plastovou sádru. Příspěvek lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Příspěvek pro onkologicky nemocné nebo jinak závažně nemocné",
                "benefit": "Až 4 000 Kč na paruku, nebo chladící čepici po chemoterapii",
                "description": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (nebo pro jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, nebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Příspěvek SPORT",
                "benefit": "Až 700 Kč na pohybové aktivity",
                "description": "Přispíváme až 700 Kč na pravidelnou sportovní aktivitu včetně plavání a saunování, vyjma FBfit Mladá Boleslav, online kurzů, členských příspěvků a pronájmů sportovišť a aktivit hrazených MultiSport kartou. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Příspěvek SPORT Senior",
                "benefit": "Až 700 Kč na pohybové aktivity, pomůcky pro prevenci úrazů při sportu aj.",
                "description": "Přispíváme až 700 Kč seniorům nad 65 let na pohybové aktivity včetně plavání a saunování, přístrojovou pedikúru pro diabetiky, pomůcky pro prevenci úrazů při sportu, hole Nordic Walking, na specifické pomůcky pro trénování paměti a prevenci rozvoje Alzheimerovy choroby. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Očkování proti pásovému oparu",
                "benefit": "Až 4 000 Kč na očkování protí pásovému oparu",
                "description": "Příspíváme až 4 000 Kč na očkování proti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Balíček ostatních očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Příspíváme až 1 000 Kč na různá očkování, které nejsou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "HPV infekce",
                "benefit": "Až 4 000 Kč na očkování ",
                "description": "Přispíváme až 4 000 Kč na očkování pro ženy (do 45 let), u kterých bylo zahájeno očkování do 6 měsíců po konizaci děložního čípku pro prekancerózu, po ukončení očkovacího schématu v roce 2026. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Meningokok",
                "benefit": "Až 3 600 Kč na očkování proti meningokoku",
                "description": "Přispíváme až 3 600 Kč na očkování proti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Hepatitida",
                "benefit": "Až 2 400 Kč na očkování",
                "description": "Přispíváme až 2 400 Kč na očkování proti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Klíšťová encefalitida",
                "benefit": "Až 2 100 Kč na očkování",
                "description": "Přispíváme až 2 100 Kč na očkování proti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Chřipka",
                "benefit": "Až 400 Kč na očkování",
                "description": "Přispíváme až 400 Kč na očkování proti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Podpora nutričního poradenství",
                "benefit": "Až 2 000 Kč příspěvek na sestavení jídelníčku",
                "description": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 nebo pod 18,5, příspěvek na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem nebo výživovým poradcem s platným osvědčením o profesní kvalifikaci (možno využít i na program \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "cabbage",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
                "benefit": "Až 12 000 Kč na nízkobílkovinnou dietu",
                "description": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, nebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Celiakie",
                "benefit": "Až 5 000 Kč na bezlepkovou dietu",
                "description": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Prevence onemocnění štítné žlázy",
                "benefit": "Příspěvek 1x za rok",
                "description": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "shield-exclamation-marks",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Program pro zjišťování nádorů v oblasti dutiny břišní a ledvin",
                "benefit": "Příspěvek 1x za rok",
                "description": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, program je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Prevence karcinomu tlustého střeva a konečníku",
                "benefit": "Příspěvek 1x za rok",
                "description": "Přispíváme 1x za rok pojištěncům (od 35 do 45 let), na které se nevztahuje vyšetření na okultní krvácení v rámci preventivní prohlídky. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Prevence karcinomu prsu (SONO)\n",
                "benefit": "Až 800 Kč na sono prsou",
                "description": "Přispíváme až 800 Kč na ultrasonografické vyšetření prsů pro ženy nesplňující podmínky pro úhradu vyšetření z prostředků v. z. p., ženy absolvují vyšetření na vlastní žádost s doporučením ošetřujícího lékaře. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "breasts-sono",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Prevence karcinomu prsu (MAMOGRAF)",
                "benefit": "Až 1 000 Kč na mamografické vyšetření",
                "description": "Přispíváme až 1 000 Kč ženám (od 35 do 45 let), které nespadající věkem do programu celostátního mamografického screeningu hrazeného z prostředků v.z.p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "breasts-sono",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Cestovní pojištění ZDARMA",
                "benefit": "Cestovní pojištění ZDARMA pro dárce krve s odběrem za posledních 12 měsíců",
                "description": "Cestovní pojištění pro dárce krve od našeho partnera VITALITAS pojišťovny a. s. platí na léčebné výlohy, celý svět a na 30 dnů. Podmínkou je kopie průkazu dárce krve s odběrem za posledních 12 měsíců. ",
                "icon": "briefcase",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              },
              {
                "type": "Ozdravný pobyt v ČR pro dárce kostní dřeně a dárce orgánů",
                "benefit": "Až 10 000 Kč na ozdravný pobyt v některém ze smluvních lázeňských zařízení",
                "description": "Přispíváme až 10 000 Kč na ozdravný pobyt dárcům kostní dřeně a dárce životně důležitých orgánů k transplantaci v některém ze smluvních lázeňských zařízení dle výběru a po domluvě s referentem lázeňské péče. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              },
              {
                "type": "Pro dárce",
                "benefit": "Odměna až 5 000 Kč pro ty, kteří jsou solidární ke zdraví ostatních",
                "description": "Přispíváme až 5 000 Kč dárcům krve, kostní dřeně a orgánů. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.zpskoda.cz/pro-darce-krve"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "26",
            "benefits": [
              {
                "type": "Dentální hygiena pro děti",
                "benefit": "Až 1 000 Kč na dentální hygienu",
                "description": "Přispíváme až 1 000 Kč na úhradu provedených výkonů dentální hygieny a další stomatologické péče zaplacené nad rámec úhrad ze základního fondu veřejného zdravotního pojištění. (Nevztahuje se na estetické výkony, např. bělení zubů, ozdobné doplňky na zuby apod.). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.zpskoda.cz/pece-o-chrup"
              },
              {
                "type": "Rovnátka",
                "benefit": "Až 4 000 Kč na rovnátka",
                "description": "Přispíváme až 2 000 Kč  na každou čelist na fixní ortodontický aparát a neviditelná rovnátka. Nevztahuje se na deskové snímací aparáty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "braces",
                "url": "https://www.zpskoda.cz/pece-o-chrup"
              },
              {
                "type": "Podpora péče duševního zdraví",
                "benefit": "Až 4 000 Kč na péči o duševní zdraví",
                "description": "Přispíváme až 4 000 Kč na absolvování psychologického nebo psychoterapeutického poradenství certifikovaným specialistou v oblasti psychologie/psychoterapie zapsaným v České asociaci pro psychoterapii, mimo výkony hrazené z v. z. p. (včetně online poradenství). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.zpskoda.cz/dusevni-zdravi"
              },
              {
                "type": "Ozdravný pobyt pro pojištěnce s chronickým onemocněním kůže, dýchacích cest",
                "benefit": "Až 1 000 Kč na ozdravný pobyt",
                "description": "Přispíváme až 1 000 Kč na přímořský nebo vysokohorský ozdravný pobyt uskutečněný v roce 2026; pobyt musí být zabezpečen přes cestovní agenturu nebo cestovní kancelář; na doporučení pediatra nebo specialisty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bath",
                "url": "https://www.zpskoda.cz/ozdravne-pobyty"
              },
              {
                "type": "Ozdravný pobyt pro pojištěnce s neurologickým, onkologickým onemocněním, obezitou ",
                "benefit": "Až 5 000 Kč na ozdravný pobyt",
                "description": "Přispíváme až 5 000 Kč na ozdravný pobyt uskutečněný v roce 2026; pobyt musí být zabezpečen odborným lékařským dohledem; na doporučení pediatra nebo specialisty. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.zpskoda.cz/ozdravne-pobyty"
              },
              {
                "type": "Moderní diagnostické a léčebné metody",
                "benefit": "Až 2 000 Kč na různé diagnostické a léčebné metody",
                "description": "Přispíváme až 2 000 Kč na diagnostické a léčebné metody, např. Operace varixů - Laser, Endoskopická operace karpálního tunelu, Podologické vyšetření a další. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/mdlm"
              },
              {
                "type": "Příspěvek na zdravotní pomůcky pro pojištěnce s diabetem a na diabetickou dietu",
                "benefit": "Až 5 000 Kč na diabetickou dietu a pomůcky ",
                "description": "Přispíváme až 5 000 Kč 1x za rok, na diabetickou dietu a na pomůcky pro pojištěnce s diabetem nad rámec v.z.p. nutné předložit potvrzení ošetřujícího lékaře o nezbytné dietě (požadujeme pouze při prvním čerpání příspěvku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Vyšetření přístrojem OCT",
                "benefit": "Až 800 Kč na vyšetření očí přístrojem OCT",
                "description": "Přispíváme až 800 Kč na OCT vyšetření oči. Lze poskytnout 2x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Nitrooční operace",
                "benefit": "Až 2 000 Kč na operaci očí",
                "description": "Přispíváme až 2 000 Kč na nitrooční operaci s použitím multifokální čočky, čočky s prodlouženým ohniskem, čočky pro korekci astigmatismu nebo nitrooční čočky (1 000 Kč na každé oko). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Plastová sádra",
                "benefit": "Až 300 Kč na plastovou sádru",
                "description": "Přispíváme až 300 Kč na plastovou sádru. Příspěvek lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Příspěvek pro onkologicky nemocné nebo jinak závažně nemocné",
                "benefit": "Až 4 000 Kč na paruku, nebo chladící čepici po chemoterapii",
                "description": "Přispíváme až 4 000 Kč pojištěncům, kteří absolvovali aktivní onkologickou léčbu (nebo pro jiné systémové onemocnění) při které došlo ke ztrátě vlasů. Lze 1x za rok čerpat na paruku, nebo chladící čepici po chemoterapii. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Příspěvek SPORT Junior",
                "benefit": "Až 800 Kč na pohybové aktivity",
                "description": "Přispíváme až 800 Kč na pohybové aktivity, ochranné pomůcky pro prevenci úrazů, sportovní prohlídky, sportovní tábory, sportovní kroužky ve škole. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.zpskoda.cz/sport"
              },
              {
                "type": "Očkování proti pásovému oparu",
                "benefit": "Až 4 000 Kč na očkování protí pásovému oparu",
                "description": "Příspíváme až 4 000 Kč na očkování proti pásovému oparu (2 000 Kč na každou dávku). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Balíček ostatních očkování",
                "benefit": "Až 1 000 Kč na očkování",
                "description": "Příspíváme až 1 000 Kč na různá očkování, které nejsou hrazeny z v. z. p. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "HPV infekce",
                "benefit": "Až 4 000 Kč na očkování",
                "description": "Přispíváme až 4 000 Kč pro mladistvé od 15-18 let na očkování proti HPV infekci. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Rotavirové infekce",
                "benefit": "Až 3 000 Kč na očkování",
                "description": "Přispíváme až 3 000 Kč pro miminka do 1 roku na očkování proti rotaviru. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Meningokok",
                "benefit": "Až 3 600 Kč na očkování proti meningokoku",
                "description": "Přispíváme až 3 600 Kč na očkování proti meningokoku. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Hepatitida",
                "benefit": "Až 2 400 Kč na očkování",
                "description": "Přispíváme až 2 400 Kč na očkování proti žloutence (hepatitidě). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Klíšťová encefalitida",
                "benefit": "Až 2 100 Kč na očkování",
                "description": "Přispíváme až 2 100 Kč na očkování proti klíšťové encefalitidě klientům do 50 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Chřipka",
                "benefit": "Až 400 Kč na očkování",
                "description": "Přispíváme až 400 Kč na očkování proti chřipce klientům do 65 let. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.zpskoda.cz/ockovani"
              },
              {
                "type": "Vyšetření přístrojem Plusoptix",
                "benefit": "Až 200 Kč na vyšetření očí",
                "description": "Příspěvek na vyšetření přístrojem Plusoptix lze poskytnout 1x za rok. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.zpskoda.cz/ostatni"
              },
              {
                "type": "Podpora nutričního poradenství",
                "benefit": "Až 2 000 Kč příspěvek na sestavení jídelníčku",
                "description": "Přispíváme až 2 000 Kč pojištěncům s hodnotou BMI nad 30 nebo pod 18,5, příspěvek na sestavení jídelníčku nutričním terapeutem, obezitologem, diabetologem, praktickým lékařem nebo výživovým poradcem s platným osvědčením o profesní kvalifikaci (možno využít i na program \"Cukrovka bez obalu\"). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "cabbage",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Nízkobílkovinná dieta a další vzácné metabolické poruchy",
                "benefit": "Až 12 000 Kč na nízkobílkovinnou dietu",
                "description": "Přispíváme až 12 000 Kč pojištěncům, kteří mají z důvodu metabolického onemocnění indikovanou nízkobílkovinnou dietu, nebo specifickou diagnózu (nemoc javorového sirupu, homocystinurie, isovalerová acidurie, propionová a methylmalonová acidurie, tyrosinémie, glutarová acidurie typ 1., poruchy cyklu močoviny). Při prvním čerpání je nutno doložit potvrzení ošetřujícího lékaře, které zdůvodňuje nezbytnost indikace této diety. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Celiakie",
                "benefit": "Až 5 000 Kč na bezlepkovou dietu",
                "description": "Přispíváme až 5 000 Kč 1 x za rok, na bezlepkovu dietu nad rámec v. z. p., požadujeme vyjádření ošetřujícího lékaře o nezbytné dietě (pouze u prvního čerpání). Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.zpskoda.cz/zdrave-stravovani-metabolicke-poruchy"
              },
              {
                "type": "Prevence onemocnění štítné žlázy",
                "benefit": "Příspěvek 1x za rok",
                "description": "Přispíváme 1x za rok na odběr krve na vyšetření hormonů štítné žlázy. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "shield-exclamation-marks",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              },
              {
                "type": "Program pro zjišťování nádorů v oblasti dutiny břišní a ledvin",
                "benefit": "Příspěvek 1x za rok",
                "description": "Přispíváme 1x za rok na preventivní sonografické vyšetření horní a dolní poloviny břicha, program je určen zejména pojištěncům s pozitivní rodinnou onkologickou anamnézou či s rizikem tohoto onemocnění. Více informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "stop",
                "url": "https://www.zpskoda.cz/prevence-zavaznych-onemocneni"
              }
            ]
          }
        ]
      },
      {
        "slug": "union",
        "updateDate": "30.1.2026",
        "companyBenefitsLink": "https://www.union.sk/vyhody-pre-poistencov/",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "16",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Příspěvky ve výši 50 % až 100 % z ceny očkování",
                "description": "Našim pojištěncům proplácíme 50 % z ceny vakcíny při vícero dobrovolných očkováních. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.union.sk/ockovanie/"
              },
              {
                "type": "Příspěvek na umělé oplodnění",
                "benefit": "Až 1 200 EUR příspěvek na umělé oplodnění",
                "description": "Přispějeme vám na umělé oplodnění až do 1 200 EUR. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/umele-oplodnenie-union-family/"
              },
              {
                "type": "Příspěvek na poplatky za léky a dietní potraviny",
                "benefit": "Až 300 EUR vrátíme doplatky za léky a dietní potraviny",
                "description": "Každému, bez ohledu na věk či rodinný stav, vrátíme doplatky za léky a dietní potraviny až do výšky 300 EUR. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "zdravy-talir",
                "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-dospelych"
              },
              {
                "type": "Zrak",
                "benefit": "Až 150 EUR na vyšetření zraku",
                "description": "Přispějeme vám až 150 EUR na nadstandardní zdravotní péči ve vybraných očních klinikách a na nákup kvalitních brýlí.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.union.sk/ocny-balik/"
              },
              {
                "type": "Telefonická podpora weLive pro onkologické pacienty a jejich rodiny",
                "benefit": "Bezplatná telefonická podpora",
                "description": "V spolupráci s weLive vám přinášíme bezplatnou telefonickou podporu pro onkologické pacienty a jejich rodiny. Poraďte se o diagnóze a zorientujte se v možnostech a povinnostech. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "digitalni-zdravi",
                "url": "https://www.union.sk/benefit/telefonicka-podpora-welive-pre-onkologickych-pacientov-a-ich-rodiny/"
              },
              {
                "type": "Příspěvek na operaci kloubů",
                "benefit": "Až 3 000 Kč na operáci kloubů a kvalitní profesionální péči v zařízení Clinica Orthopedica",
                "description": "Pokud potřebujete operaci kyčelního nebo kolenního kloubu, dopřejete si nadstandard. Za naše pojištěnce hradíme 3 000 EUR za operaci kloubů a  kvalitní profesionální péči v zařízení Clinica Orthopedica.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "osteoporosis",
                "url": "https://www.union.sk/prispevok-na-operaciu-klbov/"
              },
              {
                "type": "Nadstandardní OCT vyšetření očí",
                "benefit": "Vyšetrení zdarma",
                "description": "Včasná návšteva očního lékaře dokáže zachránit zrak. U mnohých očních onemocněních platí, že jsou dobře léčitelná, pokud se diagnostikují včas. Nepodceňujte nastávající potíže. S námi budete mít speciální vyšetření OCT - optickou koherentní tomografii - ve vybraných klinikách zdarma.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.union.sk/opticka-koherentna-tomografia/"
              },
              {
                "type": "Slevy na vybraná komerční pojištění Union pojišťovny",
                "benefit": "Slevy až do výše 30 % na komerční pojištění Union pojišťovny",
                "description": "Pojištěnci a pojištěnky zdravotní pojišťovny Union mohou čerpat slevy až do výše 30 % na komerční pojištění pojišťovny Union. Využít je můžete ihned. Ať už jste pojištěnci, nebo jste pouze odeslali přihlášku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "globus",
                "url": "https://www.union.sk/zlavy-na-komercne-poistenia/"
              },
              {
                "type": "Příspěvek na komplexní vyšetření spermiogramu",
                "benefit": "Až 100 Kč EUR komplexní vyšetření spermiogramu",
                "description": "Zdravotní pojišťovna Union poskytuje na komplexní vyšetření spermiogramu příspěvek 100 EUR poskytovatelům zdravotnické péče – smluvním centrům asistované reprodukce. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "testicles",
                "url": "https://www.union.sk/spermiogram-komplexne-vysetrenie/"
              },
              {
                "type": "Příspěvek na mikromanipulační techniku ICSI",
                "benefit": "Příspěvek 200 EUR na mikromanipulační techniku ICSI",
                "description": "Zdravotní pojišťovna Union poskytuje na intracytoplazmatickou injekci spermie (ICSI) příspěvek 200 EUR poskytovatelům zdravotní péče – smluvním centrům asistované reprodukce.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/icsi-mikromanipulacna-technika/"
              },
              {
                "type": "Příspěvek na predimplantační genetickou diagnostiku",
                "benefit": "Příspěvek 900 EUR na predimplantační genetickou diagnostiku",
                "description": "Zdravotní pojišťovna Union poskytuje na predimplantační genetickou diagnostiku (PGD) příspěvek 900 EUR  poskytovatelům zdravotní péče – smluvním centrům asistované reprodukce.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/pgd-predimplantacna-geneticka-diagnostika/"
              },
              {
                "type": "Preventivní vyšetření rakoviny prostaty",
                "benefit": "Vyšetrení zdarma",
                "description": "Preventivní prohlídka u urologa pomáhá zachytit rakovinu prostaty v raném stádiu. U zdravotní pojišťovny Union máte preventivní prohlídku už od čtyřicátého roku života. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "prostate",
                "url": "https://www.union.sk/rakovina-prostaty/"
              },
              {
                "type": "Preventivní vyšetření rakoviny tlustého střeva a konečníku",
                "benefit": "Vyšetrení zdarma",
                "description": "Prevetivní vyšetření rakoviny tlustého střeva a konečníku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.union.sk/vysetrenie-hrube-crevo-konecnik/"
              },
              {
                "type": "Test mentálního zdraví jako prevence demence",
                "benefit": "Test mentálního zdraví zdarma",
                "description": "Mezi najzávažneější choroby, které ničí paměť a duševní zdraví, patří zejména Alzheimerova choroba. V rámci preventivní prohlídky máte nárok na test mentálního zdraví zadarmo. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.union.sk/test-mentalneho-zdravia-ako-prevencia-demencie/"
              },
              {
                "type": "Union slevy",
                "benefit": "Slevy až 1 000 EUR ročně",
                "description": "Díky exkluzivním slevám ušetříte až 1 000 EUR ročně, což vám usnadní péči o vaše zdraví i zdraví vašich blízkých.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/union-zlavy/#volnopredajne-lieky-a-vyzivove-doplnky"
              },
              {
                "type": "Další služby a výhody",
                "benefit": "Spoustu dalších služeb, výhod a slev",
                "description": "Zdravotní pojišťovna Union poskytuje spoustu dalších služeb, výhod a slev. \nUnion\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "18",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Příspěvky ve výši 50 % až 100 % z ceny očkování",
                "description": "Našim pojištěncům proplácíme 50 % z ceny vakcíny při vícero dobrovolných očkováních. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.union.sk/ockovanie/"
              },
              {
                "type": "Příspěvek na umělé oplodnění",
                "benefit": "Až 1 200 EUR příspěvek na umělé oplodnění",
                "description": "Přispějeme vám na umělé oplodnění až do 1 200 EUR. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/umele-oplodnenie-union-family/"
              },
              {
                "type": "Příspěvek na poplatky za léky a dietní potraviny",
                "benefit": "Až 300 EUR vrátíme doplatky za léky a dietní potraviny",
                "description": "Každému, bez ohledu na věk či rodinný stav, vrátíme doplatky za léky a dietní potraviny až do výšky 300 EUR. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-dospelych"
              },
              {
                "type": "Zrak",
                "benefit": "Až 150 EUR na vyšetření zraku",
                "description": "Přispějeme vám až 150 EUR na nadstandardní zdravotní péči ve vybraných očních klinikách a na nákup kvalitních brýlí.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.union.sk/ocny-balik/"
              },
              {
                "type": "Telefonická podpora weLive pro onkologické pacienty a jejich rodiny",
                "benefit": "Bezplatná telefonická podpora",
                "description": "V spolupráci s weLive vám přinášíme bezplatnou telefonickou podporu pro onkologické pacienty a jejich rodiny. Poraďte se o diagnóze a zorientujte se v možnostech a povinnostech. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "digitalni-zdravi",
                "url": "https://www.union.sk/benefit/telefonicka-podpora-welive-pre-onkologickych-pacientov-a-ich-rodiny/"
              },
              {
                "type": "Příspěvek na operaci kloubů",
                "benefit": "Až 3 000 Kč na operáci kloubů a kvalitní profesionální péči v zařízení Clinica Orthopedica",
                "description": "Pokud potřebujete operaci kyčelního nebo kolenního kloubu, dopřejete si nadstandard. Za naše pojištěnce hradíme 3 000 EUR za operaci kloubů a  kvalitní profesionální péči v zařízení Clinica Orthopedica.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "osteoporosis",
                "url": "https://www.union.sk/prispevok-na-operaciu-klbov/"
              },
              {
                "type": "Nadstandardní OCT vyšetření očí",
                "benefit": "Vyšetrení zdarma",
                "description": "Včasná návšteva očního lékaře dokáže zachránit zrak. U mnohých očních onemocněních platí, že jsou dobře léčitelná, pokud se diagnostikují včas. Nepodceňujte nastávající potíže. S námi budete mít speciální vyšetření OCT - optickou koherentní tomografii - ve vybraných klinikách zdarma.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.union.sk/opticka-koherentna-tomografia/"
              },
              {
                "type": "Slevy na vybraná komerční pojištění Union pojišťovny",
                "benefit": "Slevy až do výše 30 % na komerční pojištění Union pojišťovny",
                "description": "Pojištěnci a pojištěnky zdravotní pojišťovny Union mohou čerpat slevy až do výše 30 % na komerční pojištění pojišťovny Union. Využít je můžete ihned. Ať už jste pojištěnci, nebo jste pouze odeslali přihlášku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "globus",
                "url": "https://www.union.sk/zlavy-na-komercne-poistenia/"
              },
              {
                "type": "Příspěvek na mikromanipulační techniku ICSI",
                "benefit": "Příspěvek 200 EUR na mikromanipulační techniku ICSI",
                "description": "Zdravotní pojišťovna Union poskytuje na intracytoplazmatickou injekci spermie (ICSI) příspěvek 200 EUR poskytovatelům zdravotní péče – smluvním centrům asistované reprodukce.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/icsi-mikromanipulacna-technika/"
              },
              {
                "type": "Příspěvek na predimplantační genetickou diagnostiku",
                "benefit": "Příspěvek 900 EUR na predimplantační genetickou diagnostiku",
                "description": "Zdravotní pojišťovna Union poskytuje na predimplantační genetickou diagnostiku (PGD) příspěvek 900 EUR  poskytovatelům zdravotní péče – smluvním centrům asistované reprodukce.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/pgd-predimplantacna-geneticka-diagnostika/"
              },
              {
                "type": "Preventivní vyšetření rakoviny tlustého střeva a konečníku",
                "benefit": "Vyšetrení zdarma",
                "description": "Prevetivní vyšetření rakoviny tlustého střeva a konečníku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.union.sk/vysetrenie-hrube-crevo-konecnik/"
              },
              {
                "type": "Pomoc porodní asistentky u vás doma",
                "benefit": "Pomoc porodní asistentky u vás doma zcela zdarma",
                "description": "Zdravotní pojišťovna Union vám služby licencované asistentky proplatí v plné výši. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.union.sk/vyhody-porodna-asistencia/"
              },
              {
                "type": "Test mentálního zdraví jako prevence demence",
                "benefit": "Test mentálního zdraví zdarma",
                "description": "Mezi najzávažneější choroby, které ničí paměť a duševní zdraví, patří zejména Alzheimerova choroba. V rámci preventivní prohlídky máte nárok na test mentálního zdraví zadarmo. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.union.sk/test-mentalneho-zdravia-ako-prevencia-demencie/"
              },
              {
                "type": "Union slevy",
                "benefit": "Slevy až 1 000 EUR ročně",
                "description": "Díky exkluzivním slevám ušetříte až 1 000 EUR ročně, což vám usnadní péči o vaše zdraví i zdraví vašich blízkých.\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/union-zlavy/#volnopredajne-lieky-a-vyzivove-doplnky"
              },
              {
                "type": "BRCAscreen test na odhalení DNA predispozice rakoviny prsu",
                "benefit": "Test na odhalení predispozice rakoviny prsu v hodnotě 145 EUR",
                "description": "Proplatíme vám speciální test BRCAscreen, který spolehlivě odhalí predispozice pro rakovinu prsu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.union.sk/brcascreen-test-na-zistenie-dna-predispozicie-k-rakovine-prsnika/"
              },
              {
                "type": "Další služby a výhody",
                "benefit": "Spoustu dalších služeb, výhod a slev",
                "description": "Zdravotní pojišťovna Union poskytuje spoustu dalších služeb, výhod a slev. \nUnion\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/"
              },
              {
                "type": "Cytologické vyšetření metodou LBC jako prevence rakoviny děložního čípku",
                "benefit": "Vyšetrenie stěru metodou LBC jednou ročně",
                "description": "Cytologické vyšetření metodou LBC, které dokáže odhalit i raná stádia rakoviny děložního čípku, indikované u smluvního gynekologa jednou ročně bezplatně. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.union.sk/vysetrenie-lbc-bez-doplatku/"
              },
              {
                "type": "Příspěvek na monitoru dechu miminka",
                "benefit": "Až 30 EUR na zakoupení monitoru dechu miminka",
                "description": "Monitor dechu pohlídá spánek vašeho miminka i ve chvílích, kdy vy zaslouženě odpočíváte. Přispějeme vám 30 EUR na nákup vlastního zařízení na sledování dechu novorozence. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.union.sk/monitor-dychu/"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "11",
            "benefits": [
              {
                "type": "Očkování",
                "benefit": "Příspěvky ve výši 50 % až 100 % z ceny očkování",
                "description": "Našim pojištěncům proplácíme 50 % z ceny vakcíny při vícero dobrovolných očkováních. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.union.sk/ockovanie/"
              },
              {
                "type": "Zrak",
                "benefit": "Až 150 EUR na vyšetření zraku",
                "description": "Přispějeme vám až 150 EUR na nadstandardní zdravotní péči ve vybraných očních klinikách a na nákup kvalitních brýlí.\nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.union.sk/ocny-balik/"
              },
              {
                "type": "Příspěvek na dioptrické brýle pro děti",
                "benefit": "Až 70 EUR na dioptrické brýle pro děti",
                "description": "Zrak se u dětí neustále vyvíjí a včasné odhalení problémů či správná korekce jsou klíčové. Každoročně vám proto přispějeme na nákup brýlí pro dítě do 18 let částkou 70 EUR. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "glasses",
                "url": "https://www.union.sk/pomozeme-vam-s-doplatkom-na-okuliarove-ramy/"
              },
              {
                "type": "Sleva na nákup plen Pampers",
                "benefit": "Až 300 EUR na nákup plen Pampers",
                "description": "Sleva na plenky prémiové značky Pampers v celkové hodnotě 300 EUR.\nJe rozdělena na měsíční příspěvek ve výši 10–25 EUR na balení plen za měsíc. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/prispevok-na-plienky-pampers/"
              },
              {
                "type": "Příspěvek na kojenecké mléko, příkrmy a kosmetiku HiPP",
                "benefit": "Až 150 EUR na kojenecké mléko, příkrmy a kosmetiku HiPP",
                "description": "Dětem pojištěným v naší zdravotní pojišťovně Union přispějeme na kojenecké mléko, dětskou výživu, nápoje i kosmetiku značky HiPP částkou více než 150 Kč. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/prispevok-na-hipp/"
              },
              {
                "type": "Příspěvek na kurz plavání pro vaše miminko",
                "benefit": "Až 30 EUR na kurz plavání",
                "description": "Zdravotní pojišťovna Union vám přispěje až 30 EUR na kurz plavání pro vaše miminko. Více informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "move",
                "url": "https://www.union.sk/prispevok-babatka/"
              },
              {
                "type": "Doplatky za léky a dietní potraviny bez omezení",
                "benefit": "Vrátíme doplatky za léky a dietní potraviny bez omezení",
                "description": "Dětem do 18 let proplatíme doplatky za léky a dietní potraviny bez omezení. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.union.sk/vratenie-doplatkov-za-lieky-pre-deti/"
              },
              {
                "type": "Sleva v MamaClass.sk",
                "benefit": "Sleva 30 % v MamaClass.sk",
                "description": "Získejte větší sebevědomí v roli maminky a najděte spolehlivé odpovědi na všechny otázky týkající se těhotenství, porodu a péče o miminko. Na nákup přístupu do online kurzů na MamaClass.sk vám nabízíme slevu až 30 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.union.sk/materstvo-online-informacie-premamicky-na-portali-mamaclass/"
              },
              {
                "type": "Kniha Naše dieťatko",
                "benefit": "Památníček na první společné vzpomínky",
                "description": "Kniha Naše dieťatko je památník, který vám pomůže zaznamenat všechny důležité okamžiky v životě vašeho miminka. Jako dárek ji dostane každá těhotná žena. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "child-photo",
                "url": "https://www.union.sk/registracia-knizka-nase-dietatko/"
              },
              {
                "type": "Slevy na letní pobyty pro děti s poruchami držení těla",
                "benefit": "Sleva až 100 % na letní pobyty pro děti s poruchami držení těla",
                "description": "Naši dětscí pojištěnci mají až stoprocentní slevu z doplatku za týdenní letní rekreační pobyt a slevu 35 EUR z doplatku za denní rekreační pobyt. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tent",
                "url": "https://www.union.sk/pobyty-pre-deti-s-poruchami-drzania-tela/"
              },
              {
                "type": "Další služby a výhody",
                "benefit": "Spoustu dalších služeb, výhod a slev",
                "description": "Zdravotní pojišťovna Union poskytuje spoustu dalších služeb, výhod a slev. \nUnion\nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.union.sk/spolocne-za-zdravie-poistencov/"
              }
            ]
          }
        ]
      },
      {
        "slug": "dovera",
        "updateDate": "2.2.2026",
        "companyBenefitsLink": "https://www.dovera.sk/poistenec/preco-byt-v-dovere",
        "gendersCount": "3",
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "26",
            "benefits": [
              {
                "type": "Podpora duševního zdraví",
                "benefit": "Až 40 EUR na online konzultace s psychologem",
                "description": "Jednou za kalendářní rok můžete uplatnit slevový kupón na online konzultace v hodnotě 40 EUR. U partnera Mojra můžete navíc využít i 2x slevu 12 % na libovolné dvě sezení po uplatnění tohoto kupónu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia"
              },
              {
                "type": "Lékař na dálku",
                "benefit": "Konzultace s lékařem na dálku zdarma",
                "description": "Netravte hodiny v čekárně. S aplikací MEDDI můžete své zdravotní dotazy řešit pohodlně na dálku, i večer nebo o víkendu. Mějte aplikaci vždy po ruce, když potřebujete odbornou radu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku"
              },
              {
                "type": "Slevy na brýle a vyšetření zraku",
                "benefit": "Slevy v očních optikách FOKUS",
                "description": "Až 90 % všech vjemů získáváme díky zraku. Pomáháme vám pečovat o vaše oči. Dospělým pojištěncům nabízíme slevy na výrobu a opravu dioptrických brýlí a kompletní vyšetření zraku v očních optikách FOKUS. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "glasses",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-okuliare-a-vysetrenie-zraku"
              },
              {
                "type": "Online vyšetření kůže zdarma",
                "benefit": "Online vyšetření kůže zdarma",
                "description": "Máte akné nebo jiný kožní problém? Vyfoťte ho a rychle a bezpečně pošlete lékaři. Dermatolog stanoví diagnózu a doporučí léčbu do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "dermatology",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Fyzioterapeutické vyšetření online a zdarma",
                "benefit": "Fyzioterapeutické vyšetření online a zdarma",
                "description": "Bolesti zad, svalů nebo kloubů – to známe snad všichni. Nabízíme vám pomoc z pohodlí domova. Popište svůj problém a lékař vám doporučí léčbu nebo cvičení do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "running",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/fyzio-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Zdravé zuby",
                "benefit": "Dospělým přispějeme 2 x 30 € na dentální hygienu",
                "description": "Dospělým přispějeme 2 x 30 € na dentální hygienu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti"
              },
              {
                "type": "Příspěvek na dobrovolné očkování",
                "benefit": "Příspěvek na různé typy očkování",
                "description": "Pojištěncům proplácíme řadu dobrovolných očkování, například proti chřipce, klíšťatům nebo HPV. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispejeme-vam-na-dobrovolne-ockovanie#tabpanel-ockovanie_1"
              },
              {
                "type": "Sleva na laserovou operaci očí",
                "benefit": "Příspěvek 500 EUR na laserovou operaci očí",
                "description": "Chcete si užívat život bez brýlí a kontaktních čoček? Vylepšete si zrak pomocí laserové operace očí metodou iLasik. Pojištěncům Dôvěry nabízíme možnost využít slevu 500 € na laserový zákrok v oční klinice VESELY. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-500-eur-na-laserovu-operaciu-oci"
              },
              {
                "type": "Přednostní objednání na MRI, RTG, ultrazvuk a mamografii",
                "benefit": "Přednostní objednání na MRI, RTG, ultrazvuk a mamografii",
                "description": "Potřebujete jít na vyšetření MRI, RTG, ultrazvuk nebo mamografii? Jako pojištěnec pojišťovny Dôvera můžete získat rychlý termín v Poliklinice Bezručova v Bratislavě. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "calendar-previous",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prednostne-objednanie-na-mr-rtg-sono-a-mamografiu"
              },
              {
                "type": "Doprava do Nemocnice Bory",
                "benefit": "Zajistíme vám bezplatnou dopravu k hospitalizaci do Nemocnice Bory v Bratislavě",
                "description": "Čeká vás operace nebo jiný zákrok a rádi byste je podstoupili v jedné z nejmodernějších nemocnic ve střední Evropě? Zajistíme vám bezplatnou dopravu k hospitalizaci do Nemocnice Bory v Bratislavě. Samozřejmostí je i bezplatná doprava zpět domů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "hospital",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/doprava-do-nemocnice-bory"
              },
              {
                "type": "Samodiagnostický nástroj",
                "benefit": "Samodiagnostický nástroj je pro pojištěnce Dôvery bezplatný",
                "description": "Necítíte se dobře, trpíte psychickými potížemi a lékař není nablízku? Vyzkoušejte  samodiagnostický nástroj, který je pro pojištěnce Dôvery zdarma. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj"
              },
              {
                "type": "Slevy na pobyty v lázních",
                "benefit": "Sleva až 70 % na pobyty v Moderních lázních Turčianske Teplice",
                "description": "Za relaxaci a lepší zdraví zaplatíte méně. Pro pojištěnce pojišťovny Dôvera máme vybrané lázeňské pobyty v Moderních lázních Turčianske Teplice se slevou až 70 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bath",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-pobyty-v-modernych-kupeloch-turcianske-teplice"
              },
              {
                "type": "Sleva na online terapii",
                "benefit": "Sleva na online terapii s Mojra, Hedepy a ksebe",
                "description": "Sleva na online terapii s Mojra, Hedepy a ksebe. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "phone-video",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia"
              },
              {
                "type": "Slevy na cestovní pojištění od Generali",
                "benefit": "Slevy až 30 % na cestovní pojištění od Generali",
                "description": "Slevy až 30 % na cestovní pojištění od Generali. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "suitcase",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-az-30-na-cestovne-poistenie"
              },
              {
                "type": "Příspěvek u nesmluvního lékaře",
                "benefit": "Vrátíme vám až 80 % za ošetření u nesmluvního lékaře",
                "description": "Potřebujete navštívit lékaře, který s námi nemá smlouvu? Vrátíme vám 80 % z obvyklé ceny, tedy z ceny, kterou bychom za dané vyšetření zaplatili smluvnímu lékaři. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "two-doctors",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispevok-az-80-u-nezmluvneho-lekara"
              },
              {
                "type": "Sleva na pobyty v lázních",
                "benefit": "Sleva až 13 % na pobyty v lázních",
                "description": "Odložte na chvíli starosti a odpočiňte si s Dôverou v lázních. S námi si užijete léčebný pobyt v nejvýznamnějších slovenských lázních se slevou až 13 %. Více informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bath",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lacnejsie-kupele"
              },
              {
                "type": "Vzdělávání pro osoby s chronickým onemocněním",
                "benefit": "Bezplatné vzdělávání pro osoby s chronickým onemocněním",
                "description": "Trpíte vysokým krevním tlakem, cukrovkou, nadváhou, obezitou nebo se léčíte se srdečním selháním? Zapojte se do programu a získejte bezplatné nelékařské vzdělávání. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "webinar",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/poradenstvo-a-vzdelavanie-zdarma"
              },
              {
                "type": "Sleva na online tréninkový program",
                "benefit": "Sleva 30 % na online tréninkový program",
                "description": "Pro příznivce zdravého životního stylu nebo pro ty, kteří chtějí pro své zdraví udělat něco navíc, máme zajímavou nabídku. Vyzkoušejte tréninkový program LIVE PLUS pod vedením profesionálního trenéra Janyho Landla a zdravé jídelníčky připravené na míru. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "muscle",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-30-na-online-treningovy-program"
              },
              {
                "type": "Sleva na DNA testy",
                "benefit": "Sleva až 800 EUR na DNA testy",
                "description": "Sleva až 800 EUR na DNA testy. Chtěli byste vědět více o fungování svého těla? Analýza DNA vám může pomoci odhalit případná zdravotní rizika, lépe pochopit fungování organismu nebo odhalit svůj sportovní potenciál. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "genes",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-az-do-800-eur-na-dna-testy"
              },
              {
                "type": "Bezplatné vyšetření rakoviny tlustého střeva",
                "benefit": "Test na zjištění okultního, tedy skrytého krvácení ve stolici zdarma",
                "description": "Test na okultní krvácení dokáže odhalit rakovinu ještě předtím, než skutečně propukne. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/bezplatne-vysetrenie-rakoviny-hrubeho-creva"
              },
              {
                "type": "Sleva na testy od Unilabs Slovensko",
                "benefit": "Sleva 20 % na testy od Unilabs Slovensko",
                "description": "Sleva 20 % na testy od Unilabs Slovensko. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-20-na-testy-od-unilabs-slovensko"
              },
              {
                "type": "Pomáháme k zdravému srdci",
                "benefit": "Dôvera pomáhá k zdravému srdci",
                "description": "Problémy se srdcem nás mohou postihnout v jakémkoli věku. Způsobují krátkodobé i dlouhodobé komplikace, ale správným životním stylem se dají léčit. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart",
                "url": "https://www.dovera.sk/srdce/uvod"
              },
              {
                "type": "Pomáháme s nadváhou a obezitou",
                "benefit": "Dôvera pomáhá s nadváhou",
                "description": "Změňte svůj životní styl a podpořte své zdraví. Pomůžeme vám zorientovat se ve změnách, které vás čekají, abyste dosáhli a udrželi svůj cíl. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.dovera.sk/nadvaha/uvod"
              },
              {
                "type": "Pomáháme diabetikům",
                "benefit": "Program DôveraPomáha pro diabetiky zdarma",
                "description": "Naši odborníci vás zdarma naučí, jak žít lepší život i s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.dovera.sk/lepsizivotscukrovkou/uvod"
              },
              {
                "type": "Slevy pro každého",
                "benefit": "Bohatá nabídka slev pro každého",
                "description": "Z naší bohaté nabídky slev si vybere každý. Senioři, rodiny i mladí lidé. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy"
              },
              {
                "type": "Výhody pro dárce krve",
                "benefit": "Vitamínové doplňky v hodnotě přibližně 20 € a slevy až 25 % na pobyt v lázních",
                "description": "Dárců krve si vážíme a staráme se o jejich zdraví. Každý z nich může získat dva vitamínové doplňky v hodnotě přibližně 20 € a slevy až do výše 25 % na pobyt v lázních. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/vyhody-pre-darcov-krvi"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "28",
            "benefits": [
              {
                "type": "Cytologické vyšetření LBC u gynekologa zdarma",
                "benefit": "Vyšetření zdarma",
                "description": "Pro všechny ženy, které absolvují pravidelnou preventivní prohlídku u gynekologa. Metoda LBC je zaměřena na odhalení rakoviny. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vulva",
                "url": "https://www.dovera.sk/poistenec/benefity/vsetky/cytologicke-vysetrenie-lbc-u-gynekologa-bezplatne"
              },
              {
                "type": "Sleva na laktační poradenství",
                "benefit": "Až 25% sleva na laktační poradenství",
                "description": "Využijte služeb laktační poradkyně a zdokonalte si techniku kojení. Odborníci z We Care Centra vám poradí se slevou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.dovera.sk/poistenec/benefity/rodina/zlava-na-laktacne-poradenstvo-vanickovanie-a-baby-masaze"
              },
              {
                "type": "Lékař na dálku",
                "benefit": "Konzultace s lékařem na dálku zdarma",
                "description": "Netravte hodiny v čekárně. S aplikací MEDDI můžete své zdravotní dotazy řešit pohodlně na dálku, i večer nebo o víkendu. Mějte aplikaci vždy po ruce, když potřebujete odbornou radu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku"
              },
              {
                "type": "Slevy na brýle a vyšetření zraku",
                "benefit": "Slevy v očních optikách FOKUS",
                "description": "Až 90 % všech vjemů získáváme díky zraku. Pomáháme vám pečovat o vaše oči. Dospělým pojištěncům nabízíme slevy na výrobu a opravu dioptrických brýlí a kompletní vyšetření zraku v očních optikách FOKUS. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "glasses",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-okuliare-a-vysetrenie-zraku"
              },
              {
                "type": "Online vyšetření kůže zdarma",
                "benefit": "Online vyšetření kůže zdarma",
                "description": "Máte akné nebo jiný kožní problém? Vyfoťte ho a rychle a bezpečně pošlete lékaři. Dermatolog stanoví diagnózu a doporučí léčbu do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "dermatology",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Fyzioterapeutické vyšetření online a zdarma",
                "benefit": "Fyzioterapeutické vyšetření online a zdarma",
                "description": "Bolesti zad, svalů nebo kloubů – to známe snad všichni. Nabízíme vám pomoc z pohodlí domova. Popište svůj problém a lékař vám doporučí léčbu nebo cvičení do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "running",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/fyzio-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Zdravé zuby",
                "benefit": "Dospělým přispějeme 2 x 30 € na dentální hygienu",
                "description": "Dospělým přispějeme 2 x 30 € na dentální hygienu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti"
              },
              {
                "type": "Příspěvek na dobrovolné očkování",
                "benefit": "Příspěvek na různé typy očkování",
                "description": "Pojištěncům proplácíme řadu dobrovolných očkování, například proti chřipce, klíšťatům nebo HPV. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispejeme-vam-na-dobrovolne-ockovanie#tabpanel-ockovanie_1"
              },
              {
                "type": "Sleva na laserovou operaci očí",
                "benefit": "Příspěvek 500 EUR na laserovou operaci očí",
                "description": "Chcete si užívat život bez brýlí a kontaktních čoček? Vylepšete si zrak pomocí laserové operace očí metodou iLasik. Pojištěncům Dôvěry nabízíme možnost využít slevu 500 € na laserový zákrok v oční klinice VESELY. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "eye",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-500-eur-na-laserovu-operaciu-oci"
              },
              {
                "type": "Přednostní objednání na MRI, RTG, ultrazvuk a mamografii",
                "benefit": "Přednostní objednání na MRI, RTG, ultrazvuk a mamografii",
                "description": "Potřebujete jít na vyšetření MRI, RTG, ultrazvuk nebo mamografii? Jako pojištěnec pojišťovny Dôvera můžete získat rychlý termín v Poliklinice Bezručova v Bratislavě. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "calendar-previous",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prednostne-objednanie-na-mr-rtg-sono-a-mamografiu"
              },
              {
                "type": "Doprava do Nemocnice Bory",
                "benefit": "Zajistíme vám bezplatnou dopravu k hospitalizaci do Nemocnice Bory v Bratislavě",
                "description": "Čeká vás operace nebo jiný zákrok a rádi byste je podstoupili v jedné z nejmodernějších nemocnic ve střední Evropě? Zajistíme vám bezplatnou dopravu k hospitalizaci do Nemocnice Bory v Bratislavě. Samozřejmostí je i bezplatná doprava zpět domů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "hospital",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/doprava-do-nemocnice-bory"
              },
              {
                "type": "Samodiagnostický nástroj",
                "benefit": "Samodiagnostický nástroj je pro pojištěnce Dôvery bezplatný",
                "description": "Necítíte se dobře, trpíte psychickými potížemi a lékař není nablízku? Vyzkoušejte  samodiagnostický nástroj, který je pro pojištěnce Dôvery zdarma. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj"
              },
              {
                "type": "Podpora duševního zdraví",
                "benefit": "Až 40 EUR na online konzultace s psychologem",
                "description": "Jednou za kalendářní rok můžete uplatnit slevový kupón na online konzultace v hodnotě 40 EUR. U partnera Mojra můžete navíc využít i 2x slevu 12 % na libovolné dvě sezení po uplatnění tohoto kupónu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia"
              },
              {
                "type": "Slevy na pobyty v lázních",
                "benefit": "Sleva až 70 % na pobyty v Moderních lázních Turčianske Teplice",
                "description": "Za relaxaci a lepší zdraví zaplatíte méně. Pro pojištěnce pojišťovny Dôvera máme vybrané lázeňské pobyty v Moderních lázních Turčianske Teplice se slevou až 70 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bath",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-na-pobyty-v-modernych-kupeloch-turcianske-teplice"
              },
              {
                "type": "Sleva na online terapii",
                "benefit": "Sleva na online terapii s Mojra, Hedepy a ksebe",
                "description": "Sleva na online terapii s Mojra, Hedepy a ksebe. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "phone-video",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/podpora-dusevneho-zdravia"
              },
              {
                "type": "Slevy na cestovní pojištění od Generali",
                "benefit": "Slevy až 30 % na cestovní pojištění od Generali",
                "description": "Slevy až 30 % na cestovní pojištění od Generali. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "suitcase",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlavy-az-30-na-cestovne-poistenie"
              },
              {
                "type": "Příspěvek u nesmluvního lékaře",
                "benefit": "Vrátíme vám až 80 % za ošetření u nesmluvního lékaře",
                "description": "Potřebujete navštívit lékaře, který s námi nemá smlouvu? Vrátíme vám 80 % z obvyklé ceny, tedy z ceny, kterou bychom za dané vyšetření zaplatili smluvnímu lékaři. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "two-doctors",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/prispevok-az-80-u-nezmluvneho-lekara"
              },
              {
                "type": "Sleva na pobyty v lázních",
                "benefit": "Sleva až 13 % na pobyty v lázních",
                "description": "Odložte na chvíli starosti a odpočiňte si s Dôverou v lázních. S námi si užijete léčebný pobyt v nejvýznamnějších slovenských lázních se slevou až 13 %. Více informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bath",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lacnejsie-kupele"
              },
              {
                "type": "Vzdělávání pro osoby s chronickým onemocněním",
                "benefit": "Bezplatné vzdělávání pro osoby s chronickým onemocněním",
                "description": "Trpíte vysokým krevním tlakem, cukrovkou, nadváhou, obezitou nebo se léčíte se srdečním selháním? Zapojte se do programu a získejte bezplatné nelékařské vzdělávání. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "webinar",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/poradenstvo-a-vzdelavanie-zdarma"
              },
              {
                "type": "Sleva na online tréninkový program",
                "benefit": "Sleva 30 % na online tréninkový program",
                "description": "Pro příznivce zdravého životního stylu nebo pro ty, kteří chtějí pro své zdraví udělat něco navíc, máme zajímavou nabídku. Vyzkoušejte tréninkový program LIVE PLUS pod vedením profesionálního trenéra Janyho Landla a zdravé jídelníčky připravené na míru. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "muscle",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-30-na-online-treningovy-program"
              },
              {
                "type": "Sleva na DNA testy",
                "benefit": "Sleva až 800 EUR na DNA testy",
                "description": "Sleva až 800 EUR na DNA testy. Chtěli byste vědět více o fungování svého těla? Analýza DNA vám může pomoci odhalit případná zdravotní rizika, lépe pochopit fungování organismu nebo odhalit svůj sportovní potenciál. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "genes",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-az-do-800-eur-na-dna-testy"
              },
              {
                "type": "Bezplatné vyšetření rakoviny tlustého střeva",
                "benefit": "Test na zjištění okultního, tedy skrytého krvácení ve stolici zdarma",
                "description": "Test na okultní krvácení dokáže odhalit rakovinu ještě předtím, než skutečně propukne. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/bezplatne-vysetrenie-rakoviny-hrubeho-creva"
              },
              {
                "type": "Sleva na testy od Unilabs Slovensko",
                "benefit": "Sleva 20 % na testy od Unilabs Slovensko",
                "description": "Sleva 20 % na testy od Unilabs Slovensko. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zlava-20-na-testy-od-unilabs-slovensko"
              },
              {
                "type": "Pomáháme k zdravému srdci",
                "benefit": "Dôvera pomáhá k zdravému srdci",
                "description": "Problémy se srdcem nás mohou postihnout v jakémkoli věku. Způsobují krátkodobé i dlouhodobé komplikace, ale správným životním stylem se dají léčit. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart",
                "url": "https://www.dovera.sk/srdce/uvod"
              },
              {
                "type": "Pomáháme s nadváhou a obezitou",
                "benefit": "Dôvera pomáhá s nadváhou",
                "description": "Změňte svůj životní styl a podpořte své zdraví. Pomůžeme vám zorientovat se ve změnách, které vás čekají, abyste dosáhli a udrželi svůj cíl. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.dovera.sk/nadvaha/uvod"
              },
              {
                "type": "Pomáháme diabetikům",
                "benefit": "Program DôveraPomáha pro diabetiky zdarma",
                "description": "Naši odborníci vás zdarma naučí, jak žít lepší život i s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.dovera.sk/lepsizivotscukrovkou/uvod"
              },
              {
                "type": "Slevy pro každého",
                "benefit": "Bohatá nabídka slev pro každého",
                "description": "Z naší bohaté nabídky slev si vybere každý. Senioři, rodiny i mladí lidé. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy"
              },
              {
                "type": "Výhody pro dárce krve",
                "benefit": "Vitamínové doplňky v hodnotě přibližně 20 € a slevy až 25 % na pobyt v lázních",
                "description": "Dárců krve si vážíme a staráme se o jejich zdraví. Každý z nich může získat dva vitamínové doplňky v hodnotě přibližně 20 € a slevy až do výše 25 % na pobyt v lázních. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/vyhody-pre-darcov-krvi"
              }
            ]
          },
          {
            "name": "Děti",
            "benefitsCount": "14",
            "benefits": [
              {
                "type": "Proplacení doplatků za léky",
                "benefit": "Až 300 EUR na každého člena rodiny",
                "description": "Doplatky proplácíme za léky a dietní potraviny zařazené do příslušné kategorie, vydané na lékařský předpis, částečně hrazené ze zdravotního pojištění a vyúčtované pojišťovně. To znamená za léky, za které pacient doplatí. Patří sem: často předepisované léky, řada antibiotik, léky proti alergiím, očkovací vakcíny, dietní potraviny (tedy i umělé mléko). \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.dovera.sk/poistenec/benefity/vsetky/vratime-az-300-eur-za-lieky-rodicom-aj-detom"
              },
              {
                "type": "Nové brýle",
                "benefit": "Až 100 EUR na nové brýle",
                "description": "Dětem do 18 let přispíváme jednou ročně na dioptrické brýle. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "glasses",
                "url": "https://www.dovera.sk/poistenec/benefity/vsetky/detom-do-18-rokov-prispejeme-70-eur-na-nove-okuliare"
              },
              {
                "type": "Slevy pro každého",
                "benefit": "Bohatá nabídka slev pro každého",
                "description": "Z naší bohaté nabídky slev si vybere každý. Senioři, rodiny i mladí lidé. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/preco-byt-v-dovere/zlavy"
              },
              {
                "type": "Sleva na laktační poradenství",
                "benefit": "Až 25% sleva na laktační poradenství",
                "description": "Využijte služeb laktační poradkyně a zdokonalte si techniku kojení. Odborníci z We Care Centra vám poradí se slevou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.dovera.sk/poistenec/benefity/rodina/zlava-na-laktacne-poradenstvo-vanickovanie-a-baby-masaze"
              },
              {
                "type": "Dárek pro nejmenší    ",
                "benefit": "BabyBox plný kosmetiky a potřeb pro děti i maminky za 80 EUR",
                "description": "Dárkovou tašku věnujeme našim nejmenším pojištěncům do 2 let. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.dovera.sk/poistenec/benefity/vsetky/darcek-pre-najmensich-za-80-eur"
              },
              {
                "type": "Samodiagnostický nástroj",
                "benefit": "Samodiagnostický nástroj je pro pojištěnce Dôvery bezplatný",
                "description": "Necítíte se dobře, trpíte psychickými potížemi a lékař není nablízku? Vyzkoušejte  samodiagnostický nástroj, který je pro pojištěnce Dôvery zdarma. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/samodiagnosticky-nastroj"
              },
              {
                "type": "Lékař na dálku",
                "benefit": "Konzultace s lékařem na dálku zdarma",
                "description": "Netravte hodiny v čekárně. S aplikací MEDDI můžete své zdravotní dotazy řešit pohodlně na dálku, i večer nebo o víkendu. Mějte aplikaci vždy po ruce, když potřebujete odbornou radu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "doctor",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/lekar-na-dialku"
              },
              {
                "type": "Online vyšetření kůže zdarma",
                "benefit": "Online vyšetření kůže zdarma",
                "description": "Máte akné nebo jiný kožní problém? Vyfoťte ho a rychle a bezpečně pošlete lékaři. Dermatolog stanoví diagnózu a doporučí léčbu do 3 pracovních dnů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "dermatology",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/kozne-vysetrenie-online-a-zadarmo"
              },
              {
                "type": "Dětská výživa značek Hami a Nutrilon",
                "benefit": "Sleva na dětskou výživu značek Hami a Nutrilon",
                "description": "Kvalitní výživa je základem správného vývoje dítěte. Pro pojištěnce pojišťovny Dôvera máme slevu na nákup vybraných kojeneckých mlék, kaší a příkrmů značek Hami a Nutrilon. Slevu můžete uplatnit v e-shopu Dr. Max. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "child-photo",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-na-vyzivu-pre-deti-od-znaciek-hami-a-nutrilon"
              },
              {
                "type": "Sleva na produkty Sudocrem, Bepanthen a Kamistad",
                "benefit": "Sleva až 20 % na produkty Sudocrem, Bepanthen a Kamistad",
                "description": "Dětská pokožka vyžaduje citlivou péči. Pojištěnci pojišťovny Dôvera mohou využít slevu na nákup vybraných produktů značek Sudocrem, Bepanthen a Kamistad v e-shopu a v síti lékáren Dr. Max. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-do-20-na-produkty-sudocrem-bepanthen-a-kamistad"
              },
              {
                "type": "Sleva na produkty pro novorozence značky NUK",
                "benefit": "Sleva 20 % na produkty pro novorozence značky NUK",
                "description": "Každý den s miminkem je plný nových výzev. S kvalitní výbavou pro děti je zvládnete snáze. Pro pojištěnce pojišťovny Dôvera máme 20% slevu na všechny produkty značky NUK v e-shopu Dr. Max. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-20-na-produkty-pre-novorodencov-od-znacky-nuk"
              },
              {
                "type": "Sleva na nákup sportovního kočárku a autosedačky",
                "benefit": "Sleva 15 % na nákup sportovního kočárku a autosedačky",
                "description": "Až vaše miminko začne objevovat svět, nastane čas na výměnu autosedačky i kočárku. Naši pojištěnci je mohou zakoupit online nebo v kamenných prodejnách Feedo se slevou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-15-na-nakup-sportoveho-kocika-a-autosedacky"
              },
              {
                "type": "Sleva na nákup výbavy pro miminko",
                "benefit": "Sleva 15 % na nákup výbavy pro miminko",
                "description": "První kočárek, autosedačka, pomůcky na kojení. S příchodem miminka jsou spojeny i výdaje, kterým se nevyhnete. Pro bezpečnost dítěte a své pohodlí však rodiče potřebují mnohem více. Ve spolupráci se značkou Feedo nabízíme našim pojištěncům slevu na nákup první výbavy online i v kamenných prodejnách. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.dovera.sk/poistenec/benefity/babatko/zlava-15-na-nakup-vybavicky-pre-babatko"
              },
              {
                "type": "Zdravé zuby",
                "benefit": "Dětem přispějeme 5 x 30 € na lakování zubních zářezů, ošetření zubního kazu i na dentální hygienu",
                "description": "Dětem přispějeme 5 x 30 € na lakování zubních zářezů, ošetření zubního kazu i na dentální hygienu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.dovera.sk/poistenec/benefity/dospely/zdrave-zuby-pre-dospelych-aj-deti"
              }
            ]
          }
        ]
      },
      {
        "genders": [
          {
            "name": "Muži",
            "benefitsCount": "22",
            "benefits": [
              {
                "type": "Neviditelná rovnátka",
                "benefit": "Sleva 22 % na neviditelná rovnátka",
                "description": "Až 22% sleva na neviditelná rovnátka + Dental monitoring ve Family Dental Care – Ortho. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html"
              },
              {
                "type": "Slevy na brýle",
                "benefit": "Sleva až 35 % na brýle ve vybraných pobočkách    ",
                "description": "Až 35% sleva na brýle ve vybraných pobočkách. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "glasses",
                "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490"
              },
              {
                "type": "Protonová léčba pro onkologické pacienty",
                "benefit": "Léčba hrazená pojišťovnou",
                "description": "Protonová léčba se využívá zejména u nádorů mozku, hlavy a krku (nádory oka, vedlejších nosních dutin, příušní žlázy), nádorů prsu, prostaty, jater, slinivky břišní a nádorů u dětí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html"
              },
              {
                "type": "Test na okultní krvácení",
                "benefit": "Test na okultní krvácení zdarma již od 40 let",
                "description": "Preventivní vyšetření zaměřené na zjištění skrytého krvácení ve stolici, které může včas odhalit rakovinu tlustého střeva a konečníku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-okultne-krvacanie-od-40-rokov-zdarma.html"
              },
              {
                "type": "Vyšetření rizika vzniku cévní mozkové příhody",
                "benefit": "Vyšetření hrazené pojišťovnou",
                "description": "Vyšetření rizika vzniku cévní mozkové příhody hrazené pojišťovnou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brain",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/vysetrenie-rizika-vzniku-cievnej-mozgovej-prihody.html"
              },
              {
                "type": "Stanovení poměru krevního tlaku na noze a ruce – ABI index",
                "benefit": "Hradíme výkon 1x za 2 roky při preventivní prohlídce",
                "description": "Jedná se o důležité vyšetření z hlediska včasné diagnostiky ischemické choroby dolních končetin, která předpovídá pravděpodobnost vzniku infarktu myokardu nebo cévní mozkové příhody. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stanovenie-pomeru-krvneho-tlaku-nohe-aruke-abi-index.html"
              },
              {
                "type": "Péče o pacienty s vysokým krevním tlakem v ordinaci praktického lékaře",
                "benefit": "Péče přímo u praktického lékaře",
                "description": "Pacient nemusí čekat ani se objednávat k odbornému lékaři, diagnostiku i léčbu vybraných skupin pacientů s arteriální hypertenzí komplexně zajistí jeho praktický lékař. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/starostlivost-opacientov-svysokym-krvnym-tlakom-vambulancii-vseobecneho-lekara.html"
              },
              {
                "type": "Diagnostika a léčba poruch metabolismu tuků u praktického lékaře",
                "benefit": "Péče přímo u praktického lékaře        ",
                "description": "Praktický lékař našim klientům rovněž poskytuje diagnostiku a léčbu poruch metabolismu tuků bez nutnosti objednání u specialisty. \nVíce informací naleznete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "blood-fat",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/diagnostika-aliecbaporuchy-metabolizmu-tukov-vseobecneho-lekara.html"
              },
              {
                "type": "Preventivní urologické vyšetření pro muže od 40 let",
                "benefit": "Urologické vyšetření pro muže od 40 let zdarma",
                "description": "Ve VšZP se zaměřují na včasné odhalení onkologických onemocnění, kterým lze předejít, jako je například rakovina prostaty. Mužům ji hradí jednou za tři roky již od 40. roku života. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "prostate",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/preventivna-urologicka-prehliadka-muzov-od-40-rokov.html"
              },
              {
                "type": "Komplexní léčba morbidní obezity",
                "benefit": "Komplexní léčba pro pacienty s morbidní obezitou zdarma",
                "description": "Našim pojištěncům s morbidní obezitou hradíme komplexní léčbu, jejíž součástí je nejen chirurgický zákrok, ale i léčba u psychologa a dalších specialistů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexna-liecba-morbidnej-obezity.html"
              },
              {
                "type": "Očkování proti chřipce",
                "benefit": "Vakcíny proti chřipce hrazené v plné výši",
                "description": "Očkování proti chřipce je účinnou formou prevence, která pomáhá chránit před vážnými komplikacemi tohoto onemocnění. Je dostupné pro každého pojištěnce VZP s nárokem na plnou zdravotní péči. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html"
              },
              {
                "type": "Nastavení diabetika na inzulinovou pumpu v ambulanci",
                "benefit": "Ambulantní nastavení inzulinové pumpy zdarma",
                "description": "Pacient absolvuje několikahodinové zaškolení, bude mu nastavena pumpa a získá všechny informace potřebné pro praktický život s touto zdravotnickou pomůckou. Z ambulance odejde již s funkční pumpou, zavedeným senzorem a aplikací ve smartphonu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html"
              },
              {
                "type": "EKG vyšetření jako součást preventivní prohlídky od 40 let",
                "benefit": "EKG vyšetření u praktického lékaře, a to jako součást preventivní prohlídky",
                "description": "EKG vyšetření patří mezi základní vyšetření k odhalení rizika vzniku cévní mozkové příhody. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ekg-vysetrenie-ako-sucast-preventivnej-prehliadky-od-40-rokov.html"
              },
              {
                "type": "Test duševního zdraví pro včasné odhalení poruch paměti",
                "benefit": "Kognitivní test MoCA zdarma pro pacienty starší 60 let",
                "description": "Kognitivní test MoCA pomůže včas odhalit začínající problémy. Vyšetření je možné absolvovat u svého praktického lékaře a je hrazeno pacientům nad 60 let. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-mentalneho-zdravia-skore-odhalenie-poruch-spamatou.html"
              },
              {
                "type": "Testování na Covid-19 versus chřipku",
                "benefit": "Kompletní diferenciální diagnostika zdarma",
                "description": "Příznaky Covid-19 jsou prakticky totožné s příznaky chřipky. Výhodou této diagnostiky je včasná a účinná léčba pacienta s respiračními potížemi. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "danger",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html"
              },
              {
                "type": "Samoodběrové testy",
                "benefit": "Speciální testy pro vlastní odběr se slevou 5 EUR",
                "description": "Speciální testy pro vlastní odběr se slevou 5 EUR. Díky tomuto testu získáte výsledky z certifikované laboratoře již do 10 dnů od odeslání vzorku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ziskajte-kontrolu-nad-vlastnym-zdravim-vdaka-medistom.html"
              },
              {
                "type": "Bezlepkové potraviny YAMIS",
                "benefit": "Bezlepkové potraviny YAMIS se slevou 10 %",
                "description": "Navštivte e-shop YAMIS a objevte pestrou nabídku kvalitních bezlepkových potravin vhodných pro osoby s nesnášenlivostí lepku i pro příznivce zdravého životního stylu. Využijte 10% slevu a nakupujte pohodlně online. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html"
              },
              {
                "type": "Úvodní konzultace DIA FIT a jídelníček",
                "benefit": "Úvodní konzultace DIA FIT a jídelníček zdarma pro diabetiky",
                "description": "Zdravá strava a pohyb jsou při cukrovce klíčové. Program DIA FIT nabízí pojištěncům VšZP možnost absolvovat úvodní konzultaci a individuální jídelníček zcela zdarma pod vedením osobního trenéra Martina Tkáče, který již 27 let aktivně sportuje a žije s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "zdravy-talir",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html"
              },
              {
                "type": "Úrazové a životní pojištění SPIRIT v ČSOB",
                "benefit": "Úrazové a životní pojištění SPIRIT v ČSOB se slevou 15 %",
                "description": "Úrazové a životní pojištění SPIRIT v ČSOB se slevou 15 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "shield",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/poistenie-urazu-zivota-spirit-csob.html"
              },
              {
                "type": "Sleva na léky, doplňky stravy a kosmetiku",
                "benefit": "Až 15% sleva na léky, doplňky stravy a kosmetiku",
                "description": "V internetovém obchodě si můžete zakoupit volně prodejné léky, doplňky stravy, ale i kosmetiku. Lieky24.sk je ověřený obchod, který nabízí dopravu zdarma, zaručuje rychlé doručení zboží a nabízí široký sortiment produktů. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html"
              },
              {
                "type": "Extrakce zubů moudrosti a další zubní zákroky se slevou",
                "benefit": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %",
                "description": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20"
              },
              {
                "type": "Další výhody a slevy pro všechny",
                "benefit": "Výhody pro celou rodinu    ",
                "description": "Využijte další benefity a výhody, které vám pojišťovna nabízí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.vszp.sk/benefity/?"
              }
            ]
          },
          {
            "name": "Ženy",
            "benefitsCount": "24",
            "benefits": [
              {
                "type": "Neviditelná rovnátka",
                "benefit": "Sleva 22 % na neviditelná rovnátka",
                "description": "Až 22% sleva na neviditelná rovnátka + Dental monitoring ve Family Dental Care – Ortho. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html"
              },
              {
                "type": "Slevy na brýle",
                "benefit": "Sleva až 35 % na brýle ve vybraných pobočkách    ",
                "description": "Až 35% sleva na brýle ve vybraných pobočkách. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "glasses",
                "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490"
              },
              {
                "type": "Protonová léčba pro onkologické pacienty",
                "benefit": "Léčba hrazená pojišťovnou",
                "description": "Protonová léčba se využívá zejména u nádorů mozku, hlavy a krku (nádory oka, vedlejších nosních dutin, příušní žlázy), nádorů prsu, prostaty, jater, slinivky břišní a nádorů u dětí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html"
              },
              {
                "type": "Test na okultní krvácení",
                "benefit": "Test na okultní krvácení zdarma již od 40 let",
                "description": "Preventivní vyšetření zaměřené na zjištění skrytého krvácení ve stolici, které může včas odhalit rakovinu tlustého střeva a konečníku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "rectum",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-okultne-krvacanie-od-40-rokov-zdarma.html"
              },
              {
                "type": "Vyšetření rizika vzniku cévní mozkové příhody",
                "benefit": "Vyšetření hrazené pojišťovnou",
                "description": "Vyšetření rizika vzniku cévní mozkové příhody hrazené pojišťovnou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "brain",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/vysetrenie-rizika-vzniku-cievnej-mozgovej-prihody.html"
              },
              {
                "type": "Stanovení poměru krevního tlaku na noze a ruce – ABI index",
                "benefit": "Hradíme výkon 1x za 2 roky při preventivní prohlídce",
                "description": "Jedná se o důležité vyšetření z hlediska včasné diagnostiky ischemické choroby dolních končetin, která předpovídá pravděpodobnost vzniku infarktu myokardu nebo cévní mozkové příhody. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stanovenie-pomeru-krvneho-tlaku-nohe-aruke-abi-index.html"
              },
              {
                "type": "Péče o pacienty s vysokým krevním tlakem v ordinaci praktického lékaře",
                "benefit": "Péče přímo u praktického lékaře",
                "description": "Pacient nemusí čekat ani se objednávat k odbornému lékaři, diagnostiku i léčbu vybraných skupin pacientů s arteriální hypertenzí komplexně zajistí jeho praktický lékař. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/starostlivost-opacientov-svysokym-krvnym-tlakom-vambulancii-vseobecneho-lekara.html"
              },
              {
                "type": "Diagnostika a léčba poruch metabolismu tuků u praktického lékaře",
                "benefit": "Péče přímo u praktického lékaře        ",
                "description": "Praktický lékař našim klientům rovněž poskytuje diagnostiku a léčbu poruch metabolismu tuků bez nutnosti objednání u specialisty. \nVíce informací naleznete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "blood-fat",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/diagnostika-aliecbaporuchy-metabolizmu-tukov-vseobecneho-lekara.html"
              },
              {
                "type": "Komplexní léčba morbidní obezity",
                "benefit": "Komplexní léčba pro pacienty s morbidní obezitou zdarma",
                "description": "Našim pojištěncům s morbidní obezitou hradíme komplexní léčbu, jejíž součástí je nejen chirurgický zákrok, ale i léčba u psychologa a dalších specialistů. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "weight",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexna-liecba-morbidnej-obezity.html"
              },
              {
                "type": "Očkování proti chřipce",
                "benefit": "Vakcíny proti chřipce hrazené v plné výši",
                "description": "Očkování proti chřipce je účinnou formou prevence, která pomáhá chránit před vážnými komplikacemi tohoto onemocnění. Je dostupné pro každého pojištěnce VZP s nárokem na plnou zdravotní péči. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html"
              },
              {
                "type": "Očkování proti chřipce pro těhotné",
                "benefit": "Vakcíny proti chřipce hrazené v plné výši",
                "description": "Chřipka prodělaná v těhotenství může vážně ohrozit dítě. Těhotné pojištěnkyně Všeobecné zdravotní pojišťovny již nemusí kvůli očkování vyhledávat ordinaci praktického lékaře, na požádání je proti chřipce naočkuje i gynekolog během běžné prohlídky. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke-tehotne.html"
              },
              {
                "type": "Nastavení diabetika na inzulinovou pumpu v ambulanci",
                "benefit": "Ambulantní nastavení inzulinové pumpy zdarma",
                "description": "Pacient absolvuje několikahodinové zaškolení, bude mu nastavena pumpa a získá všechny informace potřebné pro praktický život s touto zdravotnickou pomůckou. Z ambulance odejde již s funkční pumpou, zavedeným senzorem a aplikací ve smartphonu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html"
              },
              {
                "type": "EKG vyšetření jako součást preventivní prohlídky od 40 let",
                "benefit": "EKG vyšetření u praktického lékaře, a to jako součást preventivní prohlídky",
                "description": "EKG vyšetření patří mezi základní vyšetření k odhalení rizika vzniku cévní mozkové příhody. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "heart-attack",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ekg-vysetrenie-ako-sucast-preventivnej-prehliadky-od-40-rokov.html"
              },
              {
                "type": "Test duševního zdraví pro včasné odhalení poruch paměti",
                "benefit": "Kognitivní test MoCA zdarma pro pacienty starší 60 let",
                "description": "Kognitivní test MoCA pomůže včas odhalit začínající problémy. Vyšetření je možné absolvovat u svého praktického lékaře a je hrazeno pacientům nad 60 let. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "happy",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/test-mentalneho-zdravia-skore-odhalenie-poruch-spamatou.html"
              },
              {
                "type": "Testování na Covid-19 versus chřipku",
                "benefit": "Kompletní diferenciální diagnostika zdarma",
                "description": "Příznaky Covid-19 jsou prakticky totožné s příznaky chřipky. Výhodou této diagnostiky je včasná a účinná léčba pacienta s respiračními potížemi. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "danger",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html"
              },
              {
                "type": "Samoodběrové testy",
                "benefit": "Speciální testy pro vlastní odběr se slevou 5 EUR",
                "description": "Speciální testy pro vlastní odběr se slevou 5 EUR. Díky tomuto testu získáte výsledky z certifikované laboratoře již do 10 dnů od odeslání vzorku. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "bloodtest",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ziskajte-kontrolu-nad-vlastnym-zdravim-vdaka-medistom.html"
              },
              {
                "type": "Bezlepkové potraviny YAMIS",
                "benefit": "Bezlepkové potraviny YAMIS se slevou 10 %",
                "description": "Navštivte e-shop YAMIS a objevte pestrou nabídku kvalitních bezlepkových potravin vhodných pro osoby s nesnášenlivostí lepku i pro příznivce zdravého životního stylu. Využijte 10% slevu a nakupujte pohodlně online. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "gluten",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html"
              },
              {
                "type": "Úvodní konzultace DIA FIT a jídelníček",
                "benefit": "Úvodní konzultace DIA FIT a jídelníček zdarma pro diabetiky",
                "description": "Zdravá strava a pohyb jsou při cukrovce klíčové. Program DIA FIT nabízí pojištěncům VšZP možnost absolvovat úvodní konzultaci a individuální jídelníček zcela zdarma pod vedením osobního trenéra Martina Tkáče, který již 27 let aktivně sportuje a žije s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "zdravy-talir",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html"
              },
              {
                "type": "Úrazové a životní pojištění SPIRIT v ČSOB",
                "benefit": "Úrazové a životní pojištění SPIRIT v ČSOB se slevou 15 %",
                "description": "Úrazové a životní pojištění SPIRIT v ČSOB se slevou 15 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "shield",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/poistenie-urazu-zivota-spirit-csob.html"
              },
              {
                "type": "Sleva na léky, doplňky stravy a kosmetiku",
                "benefit": "Až 15% sleva na léky, doplňky stravy a kosmetiku",
                "description": "V internetovém obchodě si můžete zakoupit volně prodejné léky, doplňky stravy, ale i kosmetiku. Lieky24.sk je ověřený obchod, který nabízí dopravu zdarma, zaručuje rychlé doručení zboží a nabízí široký sortiment produktů. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html"
              },
              {
                "type": "Extrakce zubů moudrosti a další zubní zákroky se slevou",
                "benefit": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %",
                "description": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20"
              },
              {
                "type": "Další výhody a slevy pro všechny",
                "benefit": "Výhody pro celou rodinu    ",
                "description": "Využijte další benefity a výhody, které vám pojišťovna nabízí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.vszp.sk/benefity/?"
              },
              {
                "type": "Čtvrté ultrazvukové vyšetření pro těhotné",
                "benefit": "Čtvrté ultrazvukové vyšetření zdarma",
                "description": "Pojištěnkyně VšZP od nás získají čtvrté ultrazvukové vyšetření zdarma, nad rámec veřejného zdravotního pojištění. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/stvrte-sonograficke-vysetrenie-tehotne.html"
              },
              {
                "type": "Prenatální a poporodní poradenství",
                "benefit": "Bezplatné prenatální, poporodní a laktační poradenství",
                "description": "Bezplatné prenatální, poporodní a laktační poradenství, které mohou maminky využívat pět dní v týdnu. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pregnant",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/bezplatne-predporodne-poporodne-poradenstvo.html"
              }
            ]
          },
          {
            "benefits": [
              {
                "type": "Neviditelná rovnátka",
                "benefit": "Sleva 22 % na neviditelná rovnátka",
                "description": "Až 22% sleva na neviditelná rovnátka + Dental monitoring ve Family Dental Care – Ortho. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/zlava-neviditelny-zubny-strojcek-vo-family-dental-care-ortho.html"
              },
              {
                "type": "Extrakce zubů moudrosti a další zubní zákroky se slevou",
                "benefit": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %",
                "description": "Extrakce zubů moudrosti a další zubní zákroky se slevou až 50 %. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/?checked0=494&docId=6949&count=20"
              },
              {
                "type": "U zubaře šetrně a bez bolesti",
                "benefit": "Anestezie u zubaře pro děti do 10 let",
                "description": "Lokální anestezie je určena všem dětem do 10 let, lze ji použít i u menších dětí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/u-zubara-bez-bolesti-hradime-anesteziu-detom-do-10-rokov.html"
              },
              {
                "type": "Protonová léčba pro onkologické pacienty",
                "benefit": "Léčba hrazená pojišťovnou",
                "description": "Protonová léčba se využívá zejména u nádorů mozku, hlavy a krku (nádory oka, vedlejších nosních dutin, příušní žlázy), nádorů prsu, prostaty, jater, slinivky břišní a nádorů u dětí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "ribbon",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/protonova-liecba-onkologickych-pacientov.html"
              },
              {
                "type": "Komplexní vstupní stomatologické vyšetření s rentgenovým snímkem a OPG snímkem",
                "benefit": "Hrazeno pojišťovnou",
                "description": "Komplexní vstupní stomatologické vyšetření s rentgenovým snímkem a OPG snímkem hrazeno pojišťovnou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "tooth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/komplexne-vstupne-stomatologicke-vysetrenie-rontgenovou-opg-snimkou.html"
              },
              {
                "icon": "danger",
                "type": "Bezlepkové potraviny YAMIS",
                "benefit": "Bezlepkové potraviny YAMIS se slevou 10 %",
                "description": "Navštivte e-shop YAMIS a objevte pestrou nabídku kvalitních bezlepkových potravin vhodných pro osoby s nesnášenlivostí lepku i pro příznivce zdravého životního stylu. Využijte 10% slevu a nakupujte pohodlně online. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/potraviny-bez-lepku-yamis.html"
              },
              {
                "type": "Úvodní konzultace DIA FIT a jídelníček",
                "benefit": "Úvodní konzultace DIA FIT a jídelníček zdarma pro diabetiky",
                "description": "Zdravá strava a pohyb jsou při cukrovce klíčové. Program DIA FIT nabízí pojištěncům VšZP možnost absolvovat úvodní konzultaci a individuální jídelníček zcela zdarma pod vedením osobního trenéra Martina Tkáče, který již 27 let aktivně sportuje a žije s cukrovkou. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "zdravy-talir",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/konzultacia-jedalnicek-diafit-programu-diabetikov.html"
              },
              {
                "type": "Slevy na brýle",
                "benefit": "Sleva až 35 % na brýle ve vybraných pobočkách    ",
                "description": "Až 35% sleva na brýle ve vybraných pobočkách. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "glasses",
                "url": "https://www.vszp.sk/benefity/?dospeli&checked0=490"
              },
              {
                "type": "Podpora prevence obezity a léčba obezity u dětí",
                "benefit": "Bezplatná podpora prevence obezity",
                "description": "Cílem podpory prevence je včasné odhalení rizikových faktorů různých onemocnění, která nejsou běžně hrazena z veřejného zdravotního pojištění. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "care",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/podpora-prevencie-obezity-amanazovanie-obezity-udeti.html"
              },
              {
                "type": "Léčba poruch příjmu potravy u dětí",
                "benefit": "Léčba na specializovaném pracovišti zdarma",
                "description": "Léčba je určena dětem do 18 let s těžkými formami anorexie a bulimie, které nelze řešit ambulantně. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "nutrition",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/liecba-poruch-prijmu-potravy-deti-nad-ramec-zdravotneho-poistenia.html"
              },
              {
                "type": "Nastavení diabetika na inzulinovou pumpu v ambulanci",
                "benefit": "Ambulantní nastavení inzulinové pumpy zdarma",
                "description": "Pacient absolvuje několikahodinové zaškolení, bude nastaven na pumpu a získá všechny informace potřebné pro praktický život s touto zdravotnickou pomůckou. Z ambulance odejde již s funkční pumpou, zavedeným senzorem a aplikací ve smartphonu. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "diabetes",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/nastavenie-diabetika-inzulinovu-pumpu-vambulancii.html"
              },
              {
                "type": "Balíček pro novorozence plný překvapení",
                "benefit": "Dárkový kufřík pro miminka",
                "description": "Ve většině porodnic na Slovensku dostanou maminky zdarma dárkový kufřík. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "birth",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/balicek-novorodencov-plny-prekvapen.html"
              },
              {
                "type": "Očkování proti chřipce",
                "benefit": "Vakcíny proti chřipce hrazené v plné výši",
                "description": "Očkování proti chřipce je účinnou formou prevence, která pomáhá chránit před vážnými komplikacemi tohoto onemocnění. Je dostupné pro každého pojištěnce VZP s nárokem na plnou zdravotní péči. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "vaccine",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/ockovanie-proti-chripke.html"
              },
              {
                "type": "Další výhody a slevy pro všechny",
                "benefit": "Výhody pro celou rodinu    ",
                "description": "Využijte další benefity a výhody, které vám pojišťovna nabízí. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "payment",
                "url": "https://www.vszp.sk/benefity/?"
              },
              {
                "type": "Sleva na léky, doplňky stravy a kosmetiku",
                "benefit": "Až 15% sleva na léky, doplňky stravy a kosmetiku",
                "description": "V internetovém obchodě si můžete zakoupit volně prodejné léky, doplňky stravy, ale i kosmetiku. Lieky24.sk je ověřený obchod, který nabízí dopravu zdarma, zaručuje rychlé doručení zboží a nabízí široký sortiment produktů. \nVíce informací se dozvíte na stránkách zdravotní pojišťovny zde: odkaz.",
                "icon": "pill",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/e-shop-lieky24-sk.html"
              },
              {
                "description": "Příznaky Covid-19 jsou prakticky totožné s příznaky chřipky. Výhodou této diagnostiky je včasná a účinná léčba pacienta s respiračními potížemi. \nVíce informací najdete na stránkách zdravotní pojišťovny zde: odkaz.",
                "type": "Testování na Covid-19 versus chřipku",
                "benefit": "Kompletní diferenciální diagnostika zdarma",
                "icon": "danger",
                "url": "https://www.vszp.sk/benefity/zoznam-benefitov/pre-poistencov/testovanie-covid-19-versus-chripka.html"
              }
            ],
            "name": "Děti",
            "benefitsCount": "16"
          }
        ],
        "slug": "vzp-sk",
        "updateDate": "3.2.2026",
        "companyBenefitsLink": "https://www.vszp.sk/benefity/",
        "gendersCount": "3"
      }
    ]
  },
  "conferencePromo": {
    "title": "Potkáme se na konferenci<br/>\nZdravé firmy, zdravé Česko?",
    "perex": "Přijďte si poslechnout inspirativní přednášky<br/>\na diskuze o zdraví ve firmách a potkat odborníky</br> \ni HR profesionály z různých oborů. <br/>\nV pražském PernerKarlín už 11. 6. 2026 od 8:30.",
    "label": "Co vás čeká?",
    "content": [
      {
        "icon": "care",
        "text": "Zóna zdraví, kde vám během přestávek zkontrolujeme znaménka i zrak, protáhnete se ve virtuální realitě<br/>nebo zajdete na masáž."
      },
      {
        "icon": "two-doctors",
        "text": "Diskuze s Petrem Havlíčkem o vlivu<br/>stravy na onemocnění srdce a cév. \nPřednáška o tom, jak AI mění medicínu<br/>s Tomášem Šebkem."
      },
      {
        "icon": "confetti",
        "text": "Možnost zapojit se do soutěže<br/>o nejzdravější firmu a vyhrát<br/> hodnotné ceny."
      }
    ],
    "primaryButtonText": "Chci vstupenku"
  }
}